(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clean-careers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (scope) => {
      scope.querySelectorAll('[data-clean-careers]').forEach((root) => {
        if (root.dataset.cleanReady) return;
        root.dataset.cleanReady = 'true';
        const dialog = root.querySelector('dialog');
        const form = root.querySelector('[data-clean-form]');
        const status = root.querySelector('[data-clean-status]');
        const verificationStatus = root.querySelector('[data-clean-verification-status]');
        const verifyButton = root.querySelector('[data-clean-verify]');
        const submit = form.querySelector('[type="submit"]');
        const success = root.querySelector('[data-clean-success]');
        const field = (name) => form.elements.namedItem(name);
        const sitekey = root.dataset.cleanSiteKey;
        if (root.dataset.cleanEnabled !== 'true') {
          root.querySelector('[data-clean-availability]').textContent =
            'Applications will open soon. Please check back.';
          return;
        }
        let endpoint;
        try {
          endpoint = new URL(root.dataset.cleanEndpoint);
        } catch (_) {
          return;
        }
        if (
          !/^https:\/\/script\.google\.com\/macros\/s\/[A-Za-z0-9_-]+\/exec$/.test(endpoint.href) ||
          !sitekey ||
          !dialog.showModal
        )
          return;
        root.querySelector('[data-clean-availability]').hidden = true;
        let opener,
          busy = false,
          delivered = false,
          token = '',
          widget,
          loading = false;
        const drawerViewport = window.matchMedia('(max-width: 989px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let viewportFrame, closeTimer;
        const clearDrawerPosition = () => {
          dialog.style.removeProperty('--clean-careers-drawer-bottom');
          dialog.style.removeProperty('--clean-careers-drawer-height');
        };
        const positionDrawer = () => {
          if (!dialog.open) return;
          if (!drawerViewport.matches) {
            clearDrawerPosition();
            return;
          }
          const viewport = window.visualViewport;
          const height = viewport?.height || window.innerHeight;
          const top = viewport?.offsetTop || 0;
          const inset = Math.max(0, window.innerHeight - height - top);
          dialog.style.setProperty('--clean-careers-drawer-bottom', `${inset}px`);
          dialog.style.setProperty('--clean-careers-drawer-height', `${Math.max(0, height - 16)}px`);
          if (
            dialog
              .getAnimations()
              .some(
                (animation) =>
                  animation.animationName === 'clean-careers-drawer-enter' && animation.playState === 'running',
              )
          )
            return;
          const active = document.activeElement;
          if (!(active instanceof HTMLElement) || !dialog.contains(active)) return;
          const bounds = dialog.getBoundingClientRect();
          const fieldBounds = active.getBoundingClientRect();
          const visibleTop = Math.max(top, bounds.top) + 12;
          const visibleBottom = Math.min(top + height, bounds.bottom) - 12;
          // Scroll only this drawer; leave the underlying storefront in place.
          if (fieldBounds.top < visibleTop) dialog.scrollTop += fieldBounds.top - visibleTop;
          else if (fieldBounds.bottom > visibleBottom) dialog.scrollTop += fieldBounds.bottom - visibleBottom;
        };
        const queueDrawerPosition = () => {
          if (viewportFrame) cancelAnimationFrame(viewportFrame);
          viewportFrame = requestAnimationFrame(() => {
            viewportFrame = undefined;
            positionDrawer();
          });
        };
        const startDrawerPositioning = () => {
          document.documentElement.classList.add('clean-careers-open');
          positionDrawer();
          window.addEventListener('resize', queueDrawerPosition, { passive: true });
          window.visualViewport?.addEventListener('resize', queueDrawerPosition, { passive: true });
          window.visualViewport?.addEventListener('scroll', queueDrawerPosition, { passive: true });
          dialog.addEventListener('focusin', queueDrawerPosition);
        };
        const stopDrawerPositioning = () => {
          window.removeEventListener('resize', queueDrawerPosition);
          window.visualViewport?.removeEventListener('resize', queueDrawerPosition);
          window.visualViewport?.removeEventListener('scroll', queueDrawerPosition);
          dialog.removeEventListener('focusin', queueDrawerPosition);
          if (viewportFrame) cancelAnimationFrame(viewportFrame);
          viewportFrame = undefined;
          clearDrawerPosition();
          document.documentElement.classList.remove('clean-careers-open');
        };
        const finishClose = () => {
          clearTimeout(closeTimer);
          delete dialog.dataset.cleanDrawerClosing;
          dialog.close();
        };
        const closeDialog = () => {
          if (busy || !dialog.open || dialog.hasAttribute('data-clean-drawer-closing')) return;
          if (!drawerViewport.matches || reducedMotion.matches) {
            finishClose();
            return;
          }
          dialog.dataset.cleanDrawerClosing = 'true';
          closeTimer = setTimeout(finishClose, 200);
        };
        dialog.addEventListener('animationend', (event) => {
          if (event.target === dialog && event.animationName === 'clean-careers-drawer-exit') finishClose();
          if (event.target === dialog && event.animationName === 'clean-careers-drawer-enter') queueDrawerPosition();
        });
        let requestId = crypto.randomUUID();
        const updateSubmit = () => {
          submit.disabled = busy || !token || !bridgeReady;
        };
        const connectionStatus = root.querySelector('[data-clean-connection-status]');
        const connectionRetry = root.querySelector('[data-clean-connection-retry]');
        let bridgeFrame,
          bridgeWindow,
          bridgeOrigin = '',
          bridgeChannel = '',
          bridgeReady = false,
          bridgeTimer,
          pendingAttempt;
        const bridgeFailed = () => {
          clearTimeout(bridgeTimer);
          bridgeReady = false;
          updateSubmit();
          if (pendingAttempt) {
            const pending = pendingAttempt;
            pendingAttempt = null;
            clearTimeout(pending.timer);
            pending.reject(
              new Error(
                'The connection failed before delivery was confirmed. Your details are kept here. Please reconnect and retry.',
              ),
            );
          }
          connectionStatus.textContent =
            'The application connection is unavailable. Your details are kept here. Please retry the connection.';
          connectionRetry.hidden = false;
        };
        const receiveBridgeMessage = (event) => {
          const message = event.data;
          if (
            !bridgeFrame ||
            !message ||
            message.protocol !== 1 ||
            message.channel !== bridgeChannel ||
            !/^https:\/\/(?:script\.google\.com|script\.googleusercontent\.com|[a-z0-9-]+-script\.googleusercontent\.com)$/.test(
              event.origin,
            )
          )
            return;
          // The fresh private nonce binds Google's nested sandbox to this iframe.
          // After its first readiness reply, pin both exact WindowProxy and origin.
          if (bridgeWindow && (event.source !== bridgeWindow || event.origin !== bridgeOrigin)) return;
          if (message.type === 'clean-careers:ready' && !bridgeWindow) {
            bridgeWindow = event.source;
            bridgeOrigin = event.origin;
            clearTimeout(bridgeTimer);
            const result = message.result;
            bridgeReady = result?.protocol === 1 && result.configured === true && result.applicationsEnabled === true;
            connectionStatus.textContent = bridgeReady
              ? ''
              : result?.configured === true
                ? 'Applications will open soon. Please check back.'
                : 'Online applications are temporarily unavailable. Please try again later.';
            connectionRetry.hidden = bridgeReady;
            updateSubmit();
            return;
          }
          if (message.type === 'clean-careers:connection-error') {
            bridgeFailed();
            return;
          }
          if (
            message.type === 'clean-careers:result' &&
            pendingAttempt &&
            message.requestId === pendingAttempt.requestId
          ) {
            const pending = pendingAttempt;
            pendingAttempt = null;
            clearTimeout(pending.timer);
            pending.resolve(message.result);
          }
        };
        window.addEventListener('message', receiveBridgeMessage);
        const loadBridge = () => {
          if (busy || bridgeReady) return;
          clearTimeout(bridgeTimer);
          bridgeFrame?.remove();
          bridgeWindow = null;
          bridgeOrigin = '';
          bridgeChannel = crypto.randomUUID();
          bridgeReady = false;
          connectionStatus.textContent = 'Connecting the application form…';
          connectionRetry.hidden = true;
          updateSubmit();
          const url = new URL(endpoint.href);
          url.searchParams.set('parentOrigin', window.location.origin);
          url.searchParams.set('channel', bridgeChannel);
          bridgeFrame = document.createElement('iframe');
          bridgeFrame.className = 'clean-careers__bridge';
          bridgeFrame.title = 'Secure application connection';
          bridgeFrame.setAttribute('aria-hidden', 'true');
          bridgeFrame.tabIndex = -1;
          bridgeFrame.referrerPolicy = 'no-referrer';
          bridgeFrame.src = url.href;
          bridgeFrame.addEventListener('error', bridgeFailed);
          bridgeTimer = setTimeout(bridgeFailed, 30000);
          root.append(bridgeFrame);
        };
        connectionRetry.addEventListener('click', loadBridge);
        const sendApplication = (payload) =>
          new Promise((resolve, reject) => {
            if (!bridgeReady || !bridgeWindow || pendingAttempt) {
              reject(new Error('Reconnect the application form before retrying.'));
              return;
            }
            const timer = setTimeout(() => {
              pendingAttempt = null;
              reject(
                new Error(
                  'Delivery was not confirmed in time. Your details and résumé are kept here. Please retry this same application.',
                ),
              );
            }, 120000);
            pendingAttempt = { resolve, reject, timer, requestId: payload.requestId };
            try {
              bridgeWindow.postMessage(
                { type: 'clean-careers:submit', protocol: 1, channel: bridgeChannel, payload },
                bridgeOrigin,
              );
            } catch (_) {
              clearTimeout(timer);
              pendingAttempt = null;
              bridgeFailed();
              reject(new Error('The application connection failed. Please reconnect and retry.'));
            }
          });
        const fileBase64 = (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.slice(reader.result.indexOf(',') + 1));
            reader.onerror = () => reject(new Error('The résumé could not be read. Please select the file again.'));
            reader.readAsDataURL(file);
          });
        const challengeFailed = () => {
          token = '';
          loading = false;
          updateSubmit();
          verificationStatus.textContent = 'The security check is unavailable or expired. Please retry the check.';
          verifyButton.hidden = false;
        };
        const renderChallenge = () => {
          if (!root.isConnected) return;
          loading = false;
          const container = root.querySelector('[data-clean-challenge]');
          try {
            if (widget !== undefined) {
              window.turnstile.reset(widget);
              return;
            }
            widget = window.turnstile.render(container, {
              sitekey,
              action: 'clean-careers',
              size: 'flexible',
              theme: 'light',
              'response-field': false,
              callback: (value) => {
                token = value;
                verificationStatus.textContent = '';
                verifyButton.hidden = true;
                updateSubmit();
              },
              'error-callback': challengeFailed,
              'expired-callback': challengeFailed,
              'timeout-callback': challengeFailed,
            });
          } catch (_) {
            challengeFailed();
          }
        };
        const loadChallenge = () => {
          if (loading) return;
          token = '';
          updateSubmit();
          verifyButton.hidden = true;
          verificationStatus.textContent = 'Loading security check…';
          if (window.turnstile) {
            renderChallenge();
            return;
          }
          loading = true;
          let script = document.querySelector('script[data-clean-turnstile]');
          if (script?.dataset.cleanFailed) {
            script.remove();
            script = null;
          }
          const fresh = !script;
          if (fresh) {
            script = document.createElement('script');
            script.dataset.cleanTurnstile = 'true';
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
          }
          const timeout = setTimeout(() => {
            script.dataset.cleanFailed = 'true';
            challengeFailed();
          }, 15000);
          script.addEventListener(
            'load',
            () => {
              clearTimeout(timeout);
              if (window.turnstile) renderChallenge();
              else challengeFailed();
            },
            { once: true },
          );
          script.addEventListener(
            'error',
            () => {
              clearTimeout(timeout);
              script.dataset.cleanFailed = 'true';
              challengeFailed();
            },
            { once: true },
          );
          if (fresh) document.head.append(script);
        };
        verifyButton.addEventListener('click', loadChallenge);
        root.querySelectorAll('[data-clean-apply]').forEach((button) => {
          button.disabled = false;
          button.addEventListener('click', () => {
            opener = button;
            if (delivered) {
              form.reset();
              requestId = crypto.randomUUID();
              delivered = false;
              success.hidden = true;
              form.hidden = false;
              status.textContent = '';
            }
            if (field('position').value !== button.dataset.cleanApply) requestId = crypto.randomUUID();
            field('position').value = button.dataset.cleanApply;
            dialog.showModal();
            dialog.scrollTop = 0;
            startDrawerPositioning();
            field('name').focus({ preventScroll: true });
            queueDrawerPosition();
            loadBridge();
            loadChallenge();
          });
        });
        root.querySelectorAll('[data-clean-close]').forEach((button) => button.addEventListener('click', closeDialog));
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeDialog();
        });
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom
          )
            closeDialog();
        });
        dialog.addEventListener('close', () => {
          clearTimeout(closeTimer);
          delete dialog.dataset.cleanDrawerClosing;
          stopDrawerPositioning();
          opener?.focus();
        });
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const controls = Array.from(
            dialog.querySelectorAll('button, input, textarea, a[href], iframe, [tabindex="0"]'),
          ).filter((control) => !control.disabled && control.tabIndex >= 0 && control.getClientRects().length);
          const first = controls[0],
            last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
        form.addEventListener('input', (event) => {
          event.target.removeAttribute('aria-invalid');
          if (event.target.name !== 'cf-turnstile-response') requestId = crypto.randomUUID();
          if (event.target.name === 'resume') event.target.setCustomValidity('');
        });
        const resumeError = 'Choose a valid, nonempty PDF, DOC, or DOCX résumé up to 5 MB.';
        const validateFile = async () => {
          const input = field('resume');
          input.setCustomValidity('');
          const file = input.files[0];
          const types = {
            pdf: 'application/pdf',
            doc: 'application/msword',
            docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          };
          const extension = file?.name.toLowerCase().match(/\.(pdf|doc|docx)$/)?.[1];
          let valid =
            input.files.length === 1 &&
            types[extension] &&
            file.size > 0 &&
            file.size <= 5 * 1024 * 1024 &&
            file.name.length <= 180 &&
            (!file.type || file.type === types[extension] || file.type === 'application/octet-stream');
          if (valid) {
            const bytes = new Uint8Array(await file.slice(0, 8).arrayBuffer());
            const signatures = {
              pdf: [37, 80, 68, 70, 45],
              doc: [208, 207, 17, 224, 161, 177, 26, 225],
              docx: [80, 75, 3, 4],
            };
            valid = signatures[extension].every((value, i) => bytes[i] === value);
          }
          if (!valid) {
            input.setCustomValidity(resumeError);
            input.setAttribute('aria-invalid', 'true');
            throw new Error(resumeError);
          }
        };
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (busy || dialog.hasAttribute('data-clean-drawer-closing') || !form.reportValidity()) return;
          if (!token) {
            challengeFailed();
            return;
          }
          busy = true;
          updateSubmit();
          root.querySelectorAll('[data-clean-close]').forEach((button) => {
            button.disabled = true;
          });
          status.textContent = 'Checking your résumé…';
          form.setAttribute('aria-busy', 'true');
          let attempted = false;
          try {
            await validateFile();
            if (!bridgeReady) throw new Error('Reconnect the application form before retrying.');
            const file = field('resume').files[0];
            const data = Object.fromEntries(new FormData(form));
            delete data.resume;
            data.source = '/pages/careers';
            data.sourcePage = window.location.origin + '/pages/careers';
            data.requestId = requestId;
            data.turnstileToken = token;
            data.consent = field('consent').checked ? 'true' : 'false';
            data.resumeName = file.name;
            data.resumeMimeType = file.type;
            data.resumeSize = file.size;
            // Keep input values fixed until this attempt resolves, including its retry ID.
            Array.from(form.elements).forEach((control) => {
              control.disabled = true;
            });
            status.textContent = 'Sending your application…';
            attempted = true;
            data.resumeBase64 = await fileBase64(file);
            const result = await sendApplication(data);
            if (!result || result.success !== true || result.requestId !== requestId) {
              if (result?.fieldErrors) {
                Object.keys(result.fieldErrors).forEach((name) => {
                  field(name)?.setAttribute('aria-invalid', 'true');
                });
                throw new Error(Object.values(result.fieldErrors).join(' '));
              }
              throw new Error(
                result?.error ||
                  'The mail service could not confirm delivery. Your details are kept here. Please retry.',
              );
            }
            delivered = true;
            form.hidden = true;
            success.hidden = false;
            success.focus();
          } catch (error) {
            status.textContent =
              attempted && (error.name === 'TypeError' || error.name === 'TimeoutError' || error.name === 'SyntaxError')
                ? 'The connection failed before delivery was confirmed. Your details and résumé are kept here. Please retry.'
                : error.message;
            status.focus();
          } finally {
            busy = false;
            form.removeAttribute('aria-busy');
            Array.from(form.elements).forEach((control) => {
              control.disabled = false;
            });
            root.querySelectorAll('[data-clean-close]').forEach((button) => {
              button.disabled = false;
            });
            submit.textContent = attempted && !delivered ? 'Retry application' : 'Submit application';
            if (attempted) {
              token = '';
              if (!delivered) loadChallenge();
            }
            updateSubmit();
          }
        });
        // Each Shopify section instance owns its dialog and vendor widget.
        root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
          clearTimeout(closeTimer);
          if (dialog.open) dialog.close();
          stopDrawerPositioning();
          window.removeEventListener('message', receiveBridgeMessage);
          clearTimeout(bridgeTimer);
          bridgeFrame?.remove();
          if (pendingAttempt) {
            clearTimeout(pendingAttempt.timer);
            pendingAttempt.reject(new Error('The application form was closed.'));
            pendingAttempt = null;
          }
          if (widget !== undefined && window.turnstile) window.turnstile.remove(widget);
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-cart-page"]) return;
  try {
    
  (() => {
    if (!document.querySelector('clean-cart-page') || customElements.get('clean-cart-page')) return;
    class CleanCartPage extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.lifecycle = new AbortController();
        this.uncertain = this.dataset.cleanCpageUncertain === 'true';
        this.queue = Promise.resolve();
        this.pending = 0;
        this.aliases = new Map();
        this.wanted = new Map();
        this.personalDefinitions = new Map();
        this.personalNativeFields = new WeakMap();
        this.personalMedia = matchMedia('(max-width: 749px)');
        this.state = this.read(this, 'state');
        this.initialCart = this.state;
        this.config = this.read(this, 'config');
        this.cartURL = new URL(this.dataset.cleanCpageUrl, location.origin);
        this.sectionURL = new URL(this.cartURL);
        if (new URLSearchParams(location.search).get('view') === 'clean')
          this.sectionURL.searchParams.set('view', 'clean');
        this.dialog = this.querySelector('[data-clean-cpage-dialog]');
        this.querySelectorAll('noscript').forEach((node) => node.remove());
        this.setAttribute('data-clean-cpage-ready', '');
        const listen = (target, type, handler, options = {}) =>
          target.addEventListener(type, handler, { ...options, signal: this.lifecycle.signal });
        listen(this, 'click', (event) => this.click(event));
        listen(this, 'submit', (event) => this.submit(event));
        listen(this, 'input', (event) => {
          if (event.target.closest('[data-clean-cpage-personal-fields]')) this.personalProgress();
          if (event.target.name === 'quantity') this.quantityButtons(event.target.closest('form'));
        });
        listen(this.personalMedia, 'change', () => this.personalLayout());
        listen(this.dialog, 'cancel', (event) => {
          if (this.personalSession?.saving || this.deliverySession?.saving) event.preventDefault();
        });
        listen(this.dialog, 'keydown', (event) => {
          if (!this.deliverySession || event.key !== 'Tab') return;
          const fields = [...this.dialog.querySelectorAll('button, input, select, a[href]')].filter(
            (node) => !node.disabled && node.type !== 'hidden' && node.getClientRects().length,
          );
          const edge = event.shiftKey ? fields[0] : fields.at(-1);
          if (document.activeElement === edge) {
            event.preventDefault();
            (event.shiftKey ? fields.at(-1) : fields[0])?.focus();
          }
        });
        listen(window, 'resize', () => this.deliveryViewport());
        if (window.visualViewport) {
          listen(window.visualViewport, 'resize', () => this.deliveryViewport());
          listen(window.visualViewport, 'scroll', () => this.deliveryViewport());
        }
        listen(this, 'change', (event) => {
          const input = event.target;
          if (input.name === 'quantity' && input.closest('[data-clean-cpage-form]')) {
            const quantity = this.clampQuantity(input, Number(input.value));
            if (quantity === null) return;
            input.value = quantity;
            this.quantityButtons(input.closest('form'));
            this.quantity(input.closest('form'), quantity);
          }
        });
        listen(this.dialog, 'close', () => {
          if (!this.dialog.open) this.finishDialog();
        });
        listen(this.dialog, 'click', (event) => {
          if (event.target === this.dialog) this.closeDialog();
        });
        listen(window, 'pageshow', (event) => {
          if (event.persisted) this.recover();
        });
        listen(document, 'clean:visitor-country-detected', (event) => {
          this.visitorCountry = event.detail?.country;
        });
        listen(window, 'gokwikLoaded', () => this.bindCheckoutClose());
        listen(document, 'clean:cart-checkout-closed', () => {
          if (!this.checkoutHandedOff) return;
          this.checkoutClosed = true;
          if (!this.checkoutPending) this.recover();
        });
        this.bindCheckoutClose();
        listen(document, 'shopify:section:unload', (event) => {
          if (event.target.contains(this)) this.cleanup();
        });
        const capture = () => {
          if (!this.viewed && window['clean-commerce'] && Array.isArray(this.state?.items)) {
            this.viewed = true;
            window['clean-commerce'].viewCart(this.initialCart, 'clean-cart-page');
            this.initialCart = null;
          }
        };
        listen(document, 'clean:commerce:ready', capture);
        listen(document, 'DOMContentLoaded', capture, { once: true });
        capture();
        try {
          const query = new URLSearchParams(location.search);
          if (
            query.get('utm_source')?.toLowerCase() === 'whatsapp' ||
            query.get('utm_medium')?.toLowerCase() === 'tellephant' ||
            query.get('storefront') === 'true' ||
            query.get('wa_cart_customize') === '1'
          )
            sessionStorage.setItem('wa_cart_customize', '1');
          this.recoveryFlow = sessionStorage.getItem('wa_cart_customize') === '1';
        } catch {}
        this.sync();
        this.normalizeMinimums();
        this.queue.then(() => this.refreshDeliveryDates());
        this.scheduleClarity(listen);
      }
      disconnectedCallback() {
        this.cleanup();
      }
      cleanup() {
        if (this.pending) this.dataset.cleanCpageUncertain = 'true';
        if (this.toolHome && this.toolForm) this.toolHome.append(this.toolForm);
        this.toolHome = this.toolForm = null;
        this.lifecycle?.abort();
        this.personalSession?.read?.abort();
        this.personalSession = null;
        this.deliverySession?.controller.abort();
        this.deliverySession = null;
        document.body.classList.remove('clean-cpage-delivery-open');
        document.body.style.removeProperty('--clean-cpage-scrollbar');
        this.dialog?.removeAttribute('data-clean-cpage-delivering');
        this.dialog?.removeAttribute('data-clean-cpage-personalizing');
        this.dialog?.querySelectorAll('[data-clean-cpage-close]').forEach((node) => {
          node.disabled = false;
        });
        if (this.idle) window.cancelIdleCallback?.(this.idle);
        clearTimeout(this.clarityTimer);
        this.dialog?.close();
        this.lifecycle = null;
        this.deliveryDates = null;
      }
      read(root, name) {
        return JSON.parse(root.querySelector(`[data-clean-cpage-${name}]`)?.textContent || 'null');
      }
      status(message = '', quiet = false) {
        const node = this.querySelector('[data-clean-cpage-status]');
        node.textContent = message;
        node.hidden = !message;
        node.classList.toggle('clean-cpage-status--quiet', quiet);
        this.querySelector('[data-clean-cpage-dialog-status]').textContent = quiet ? '' : message;
      }
      fee(line) {
        return (
          Number(line.product_id || line.product?.id) === 10059690017015 ||
          this.config.feeIds.includes(Number(line.variant_id || line.id))
        );
      }
      resolve(key) {
        const visited = new Set();
        while (this.aliases.has(key) && !visited.has(key)) {
          visited.add(key);
          key = this.aliases.get(key);
        }
        return this.state.items.find((line) => line.key === key);
      }
      quantityRules(line) {
        const row = [...this.querySelectorAll('[data-clean-cpage-row]')].find(
          (node) => node.dataset.cleanCpageRow === line.key,
        );
        return {
          min: Number(row?.dataset.cleanCpageMin || line.properties?._minimum_quantity || 1),
          step: Number(row?.dataset.cleanCpageStepSize || 1),
          max: Number(row?.dataset.cleanCpageMax || Infinity),
        };
      }
      validQuantity(line, quantity) {
        const { min, step, max } = this.quantityRules(line);
        return Number.isSafeInteger(quantity) && quantity >= min && quantity <= max && (quantity - min) % step === 0;
      }
      clampQuantity(input, quantity) {
        const min = Number(input.min || 1),
          step = Number(input.step || 1),
          max = Number(input.max || Infinity);
        const highest = min + Math.floor((max - min) / step) * step;
        if (highest < min) {
          this.status('The minimum quantity is unavailable. Remove this item to continue.');
          return null;
        }
        return Math.min(
          highest,
          min + Math.ceil((Math.max(min, Number.isFinite(quantity) ? quantity : min) - min) / step) * step,
        );
      }
      quantityButtons(form) {
        const input = form?.elements.quantity;
        if (!input) return;
        const value = Number(input.value),
          step = Number(input.step || 1);
        form.querySelector('[data-clean-cpage-step="-1"]').disabled = value <= Number(input.min || 1);
        form.querySelector('[data-clean-cpage-step="1"]').disabled = !!input.max && value + step > Number(input.max);
      }
      minimumPlan() {
        const operations = [],
          groups = new Set();
        for (const line of this.state.items) {
          if (this.fee(line)) continue;
          const group = line.properties?._hamper_id;
          if (group) {
            if (groups.has(group)) continue;
            groups.add(group);
            const lines = this.state.items.filter((part) => part.properties?._hamper_id === group);
            if (lines.every((part) => this.validQuantity(part, part.quantity))) continue;
            const host = lines.find((part) => String(part.properties?._hamper_host) === 'true') || lines[0];
            const start = Math.max(
              host.quantity,
              ...lines.map((part) => Math.ceil((this.quantityRules(part).min * host.quantity) / part.quantity)),
            );
            const limit = Math.min(
              9999,
              ...lines.map((part) => Math.floor((this.quantityRules(part).max * host.quantity) / part.quantity)),
            );
            let target = start;
            while (
              target <= limit &&
              !lines.every((part) => this.validQuantity(part, (part.quantity * target) / host.quantity))
            )
              target++;
            if (target > limit)
              throw new Error('This hamper cannot meet its minimum quantities. Remove it to continue.');
            operations.push({
              kind: 'update',
              payload: {
                updates: Object.fromEntries(lines.map((part) => [part.key, (part.quantity * target) / host.quantity])),
              },
              lines,
            });
          } else if (line.quantity < this.quantityRules(line).min) {
            const { min, max } = this.quantityRules(line);
            if (min > max) throw new Error('The minimum quantity is unavailable. Remove this item to continue.');
            operations.push({ kind: 'change', payload: { id: line.key, quantity: min }, lines: [line] });
          }
        }
        return operations;
      }
      normalizeMinimums() {
        if (this.uncertain) return;
        let operations;
        try {
          operations = this.minimumPlan();
        } catch (error) {
          this.status(error.message);
          return;
        }
        if (!operations.length) return;
        this.enqueue(async () => {
          for (const operation of operations) {
            const lines = operation.lines.map((line) => this.resolve(line.key));
            if (lines.some((line) => !line)) return false;
            if (operation.kind === 'change') operation.payload.id = lines[0].key;
            else
              operation.payload.updates = Object.fromEntries(
                operation.lines.map((line, index) => [lines[index].key, operation.payload.updates[line.key]]),
              );
            if (
              !(await this.write(
                operation.kind,
                operation.payload,
                lines.map((line) => line.variant_id || line.id),
              ))
            )
              return false;
          }
          return true;
        });
      }
      propertySignature(properties) {
        return JSON.stringify(
          Object.entries(properties || {})
            .filter(([, value]) => value !== '' && value != null)
            .sort(([a], [b]) => a.localeCompare(b)),
        );
      }
      signature(cart) {
        return JSON.stringify([
          cart.total_price,
          cart.note || '',
          this.propertySignature(cart.attributes),
          cart.items
            .map((line) => [line.key, line.quantity, line.final_line_price, this.propertySignature(line.properties)])
            .sort(),
        ]);
      }
      sync() {
        const busy = !!(this.pending || this.checkoutPending || this.checkoutHandedOff || this.uncertain);
        this.setAttribute('aria-busy', String(!!this.pending));
        this.querySelectorAll('[data-clean-cpage-checkout]').forEach((button) => {
          button.disabled = busy;
        });
        this.querySelectorAll('[data-clean-cpage-delivery]').forEach((button) => {
          button.disabled = busy;
        });
        this.querySelector('[data-clean-cpage-recover]').hidden = !this.uncertain;
        this.personalCompleteness();
        const missing = this.querySelectorAll('[data-clean-cpage-missing=true]');
        const notice = this.querySelector('[data-clean-cpage-notice]');
        if (notice) notice.hidden = !missing.length;
        const deliveryNotice = this.querySelector('[data-clean-cpage-delivery-notice]');
        if (deliveryNotice) deliveryNotice.hidden = !this.querySelector('[data-clean-cpage-delivery-missing=true]');
        if (this.deliverySession) {
          const session = this.deliverySession;
          session.form.setAttribute('aria-busy', String(session.saving));
          session.form.querySelector('[type=submit]').disabled = busy || !session.picker;
          session.form.querySelector('[data-clean-cpage-recover]').hidden = !this.uncertain;
          session.form.querySelector('fieldset').disabled = session.saving || this.uncertain;
          this.dialog.querySelectorAll('[data-clean-cpage-close]').forEach((node) => {
            node.disabled = session.saving;
          });
        }
        if (this.personalSession) {
          const form = this.personalSession.form;
          form.setAttribute('aria-busy', String(this.personalSession.saving));
          this.dialog.querySelectorAll('[data-clean-cpage-close]').forEach((node) => {
            node.disabled = this.personalSession.saving;
          });
          form.querySelector('[data-clean-cpage-personal-recover]').hidden = !this.uncertain;
          form
            .querySelectorAll('input, textarea, button[type=submit], [data-clean-cpage-personal-back]')
            .forEach((node) => {
              node.disabled = this.personalSession.saving || this.uncertain || !this.personalSession.ready;
            });
        }
        this.querySelectorAll('[data-clean-cpage-form=group]').forEach((form) => {
          const lines = this.state.items.filter((line) => line.properties?._hamper_id === form.dataset.cleanCpageGroup);
          const host = lines.find((line) => String(line.properties?._hamper_host) === 'true') || lines[0];
          if (!host) return;
          const input = form.elements.quantity;
          input.min = Math.max(
            ...lines.map((line) => Math.ceil((this.quantityRules(line).min * host.quantity) / line.quantity)),
          );
          const max = Math.min(
            ...lines.map((line) => Math.floor((this.quantityRules(line).max * host.quantity) / line.quantity)),
          );
          if (Number.isFinite(max)) input.max = max;
          else input.removeAttribute('max');
        });
        const wrap = this.state.items.some((line) => Number(line.variant_id || line.id) === this.config.wrap);
        this.querySelectorAll('[data-clean-cpage-wrap-button]').forEach((button) => {
          button.textContent = wrap ? 'Remove gift wrap' : 'Add gift wrap';
        });
        for (const [key, quantity] of this.wanted) {
          if (key.startsWith('hamper:')) {
            const form = [...this.querySelectorAll('[data-clean-cpage-form=group]')].find(
              (node) => node.dataset.cleanCpageGroup === key.slice(7),
            );
            if (form) form.elements.quantity.value = quantity;
            continue;
          }
          const line = this.resolve(key);
          const form = [...this.querySelectorAll('[data-clean-cpage-form=quantity]')].find(
            (node) => node.dataset.cleanCpageKey === line?.key,
          );
          if (form) form.elements.quantity.value = quantity;
        }
        this.querySelectorAll('[data-clean-cpage-form=quantity], [data-clean-cpage-form=group]').forEach((form) =>
          this.quantityButtons(form),
        );
        window.CleanDisplayCurrency?.refresh?.(this);
      }
      notify() {
        const item_count = this.state.items.reduce((count, line) => count + (this.fee(line) ? 0 : line.quantity), 0);
        document.dispatchEvent(
          new CustomEvent('clean:cart:updated', {
            detail: { cart: this.state, item_count, source: 'clean-cart-page' },
          }),
        );
      }
      adopt(root, confirmed) {
        const next = this.read(root, 'state'),
          config = this.read(root, 'config');
        if (
          !Array.isArray(next?.items) ||
          !config ||
          !Array.isArray(config.fees) ||
          root.textContent.includes('Liquid error')
        )
          throw new Error('Unable to render the confirmed cart. Refresh to continue.');
        if (Array.isArray(confirmed?.items) && this.signature(next) !== this.signature(confirmed))
          throw new Error('Your cart changed. Refresh to confirm its current contents.');
        // DOMParser parses noscript contents with scripting disabled. Never move
        // fallback styles or controls into the enhanced cart's live document.
        root.querySelectorAll('noscript').forEach((node) => node.remove());
        this.personalCompleteness(root, next);
        const active = document.activeElement;
        const activeForm = active?.closest('[data-clean-cpage-form]');
        const focus =
          this.contains(active) && !this.dialog.contains(active)
            ? {
                key: activeForm?.dataset.cleanCpageKey,
                name: active.name,
                draft:
                  active.name === 'quantity' && !this.wanted.has(activeForm?.dataset.cleanCpageKey)
                    ? active.value
                    : null,
                step: active.dataset.cleanCpageStep,
                remove: active.classList.contains('clean-cpage-remove'),
              }
            : null;
        const wasEmpty = !this.querySelector('[data-clean-cpage-items]'),
          empty = !root.querySelector('[data-clean-cpage-items]');
        if (wasEmpty !== empty) {
          if (this.dialog.open) this.closeDialog();
          this.querySelector('[data-clean-cpage-body]').replaceChildren(
            ...root.querySelector('[data-clean-cpage-body]').childNodes,
          );
        } else if (!empty) {
          // Reuse unchanged rows and native details, and replace only changed rows.
          const patch = (current, incoming) => {
            const existing = new Map(
              [...current.children]
                .filter((node) => node.dataset.cleanCpageRow)
                .map((node) => [node.dataset.cleanCpageRow, node]),
            );
            for (const node of [...incoming.children]) {
              const key = node.dataset.cleanCpageRow;
              if (key && existing.has(key)) {
                const prior = existing.get(key);
                if (prior.outerHTML === node.outerHTML) node.replaceWith(prior);
                else {
                  const details = [...prior.querySelectorAll('details')].map((detail) => detail.open);
                  [...node.querySelectorAll('details')].forEach((detail, index) => {
                    detail.open = details[index] || false;
                  });
                }
              }
            }
            const oldAddons = current.querySelector('.clean-cpage-addons'),
              newAddons = incoming.querySelector('.clean-cpage-addons');
            if (oldAddons && newAddons) {
              newAddons.open = oldAddons.open;
              patch(oldAddons.querySelector('div'), newAddons.querySelector('div'));
              newAddons.querySelector('div').replaceWith(oldAddons.querySelector('div'));
            }
            current.replaceChildren(...incoming.childNodes);
          };
          patch(this.querySelector('[data-clean-cpage-items]'), root.querySelector('[data-clean-cpage-items]'));
          for (const hook of ['summary', 'rewards', 'count']) {
            const old = this.querySelector(`[data-clean-cpage-${hook}]`),
              nextNode = root.querySelector(`[data-clean-cpage-${hook}]`);
            if (old && nextNode) old.replaceWith(nextNode);
          }
        }
        this.state = next;
        this.config = config;
        this.querySelector('[data-clean-cpage-state]').textContent = JSON.stringify(next);
        this.querySelector('[data-clean-cpage-config]').textContent = JSON.stringify(config);
        // Adopt bundled membership before publishing; the shared helper needs no GET.
        const bulk = root.querySelector('[data-clean-bulk-discount-state]');
        if (bulk) window.CleanBulkDiscounts?.adopt(root);
        this.sync();
        this.notify();
        queueMicrotask(() => this.refreshDeliveryDates());
        if (focus && !document.contains(active)) {
          const key = this.resolve(focus.key)?.key;
          const form = [...this.querySelectorAll('[data-clean-cpage-form]')].find(
            (node) =>
              node.dataset.cleanCpageKey === key &&
              (focus.remove ? node.dataset.cleanCpageForm === 'remove' : node.dataset.cleanCpageForm === 'quantity'),
          );
          const target = focus.name
            ? form?.elements.namedItem(focus.name)
            : focus.step
              ? form?.querySelector(`[data-clean-cpage-step="${focus.step}"]`)
              : form?.querySelector('button');
          if (target && focus.draft !== null) target.value = focus.draft;
          (target || this.querySelector('[data-clean-cpage-checkout]') || this.querySelector('h1'))?.focus({
            preventScroll: true,
          });
        }
      }
      async section(html, confirmed) {
        const lifecycle = this.lifecycle;
        if (!html) {
          const url = new URL(this.sectionURL);
          url.searchParams.set('section_id', this.dataset.cleanCpageSection);
          // Recovery reads never replay a write and never emit shopper deltas.
          const response = await fetch(url, {
            credentials: 'same-origin',
            cache: 'no-store',
            signal: AbortSignal.timeout(10000),
          });
          if (!response.ok) throw new Error('Could not refresh your cart. Try again.');
          html = await response.text();
        }
        if (!this.isConnected || !lifecycle || lifecycle !== this.lifecycle || lifecycle.signal.aborted)
          throw new Error('Cart section was closed. Refresh to confirm your cart.');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const root = doc.querySelector('clean-cart-page');
        if (!root) throw new Error('Could not display your cart. Refresh to continue.');
        this.adopt(root, confirmed);
      }
      enqueue(task, { internal = false } = {}) {
        if (this.uncertain || this.checkoutHandedOff || (this.checkoutPending && !internal)) {
          this.status('Confirm your cart before continuing.');
          return Promise.resolve(false);
        }
        const lifecycle = this.lifecycle;
        this.pending++;
        this.sync();
        const run = this.queue
          .then(async () => {
            if (this.uncertain || !this.isConnected || lifecycle !== this.lifecycle || lifecycle.signal.aborted)
              return false;
            return task();
          })
          .catch((error) => {
            this.status(error.message);
            return false;
          })
          .finally(() => {
            if (lifecycle === this.lifecycle) {
              this.pending--;
              if (this.isConnected) {
                this.sync();
                queueMicrotask(() => this.refreshDeliveryDates());
              }
            }
          });
        this.queue = run;
        return run;
      }
      lock(message) {
        this.uncertain = true;
        this.dataset.cleanCpageUncertain = 'true';
        this.status(
          message || 'The update may have reached Shopify. Refresh your cart to confirm it before continuing.',
        );
        this.sync();
      }
      async write(kind, payload, affected = [], propertiesKey = '', { silent = false } = {}) {
        const lifecycle = this.lifecycle;
        const beforeCart = this.state;
        const commerce = window['clean-commerce'];
        const before = commerce?.snapshot(beforeCart);
        let response, data;
        try {
          response = await fetch(new URL(`${this.cartURL.pathname}/${kind}.js`, location.origin), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              ...payload,
              sections: [this.dataset.cleanCpageSection],
              sections_url: this.sectionURL.pathname + this.sectionURL.search,
            }),
            signal: AbortSignal.timeout(15000),
          });
          data = await response.json();
          if (lifecycle !== this.lifecycle || lifecycle.signal.aborted) return false;
        } catch {
          this.lock();
          return false;
        }
        if (!response.ok) {
          if (response.status >= 500 || response.status === 408 || response.status === 429) {
            this.lock();
            return false;
          }
          try {
            await this.section();
          } catch {
            this.lock('Refresh your cart to confirm the rejected update.');
          }
          this.status(
            typeof data.description === 'string'
              ? data.description
              : 'Shopify could not accept this update. Check the quantity and try again.',
          );
          return false;
        }
        try {
          // /add returns added lines; bundled Liquid is the authoritative full cart.
          await this.section(data.sections?.[this.dataset.cleanCpageSection], kind === 'add' ? null : data);
          if (propertiesKey) {
            const prior = beforeCart.items.find((line) => line.key === propertiesKey);
            const candidates = this.state.items.filter(
              (line) =>
                Number(line.variant_id || line.id) === Number(prior?.variant_id || prior?.id) &&
                line.selling_plan_allocation?.selling_plan?.id === prior?.selling_plan_allocation?.selling_plan?.id &&
                this.propertySignature(line.properties) === this.propertySignature(payload.properties),
            );
            if (candidates.length === 1 && candidates[0].key !== propertiesKey)
              this.aliases.set(propertiesKey, candidates[0].key);
          }
          // Property changes can rotate every line key. Match unchanged identities.
          for (const prior of beforeCart.items) {
            if (this.state.items.some((line) => line.key === prior.key)) continue;
            const candidates = this.state.items.filter(
              (line) =>
                Number(line.variant_id || line.id) === Number(prior.variant_id || prior.id) &&
                this.propertySignature(line.properties) === this.propertySignature(prior.properties) &&
                line.selling_plan_allocation?.selling_plan?.id === prior.selling_plan_allocation?.selling_plan?.id,
            );
            if (candidates.length === 1) this.aliases.set(prior.key, candidates[0].key);
          }
          if (affected.length) commerce?.changed(before, this.state, 'clean-cart-page', commerce.operation(), affected);
          if (!silent) this.status('Cart updated.', true);
          return true;
        } catch (error) {
          this.lock(error.message);
          return false;
        }
      }
      recover() {
        if (this.pending || this.checkoutPending) return;
        const lifecycle = this.lifecycle;
        this.pending++;
        this.sync();
        this.queue = this.queue
          .then(async () => {
            try {
              await this.section();
              if (lifecycle !== this.lifecycle) return;
              this.uncertain = false;
              delete this.dataset.cleanCpageUncertain;
              this.checkoutHandedOff = false;
              this.checkoutClosed = false;
              this.wanted.clear();
              this.status('Cart refreshed.', true);
              this.reconcilePersonalization();
              this.reconcileDelivery();
            } catch (error) {
              this.lock(error.message);
            }
          })
          .finally(() => {
            if (lifecycle === this.lifecycle) {
              this.pending--;
              this.sync();
            }
          });
      }
      quantity(form, quantity) {
        if (!Number.isSafeInteger(quantity) || quantity < 1) return;
        const key = form.dataset.cleanCpageKey,
          group = form.dataset.cleanCpageGroup;
        this.wanted.set(key || `hamper:${group}`, quantity);
        this.enqueue(async () => {
          if (group) {
            const lines = this.state.items.filter((line) => line.properties?._hamper_id === group);
            const host = lines.find((line) => String(line.properties?._hamper_host) === 'true') || lines[0];
            if (!host) return false;
            if (host.quantity === quantity) return true;
            const updates = {};
            for (const line of lines) {
              const next = (line.quantity * quantity) / host.quantity;
              if (!this.validQuantity(line, next))
                throw new Error('This hamper’s components cannot be divided into that quantity.');
              updates[line.key] = next;
            }
            return this.write(
              'update',
              { updates },
              lines.map((line) => line.variant_id || line.id),
            );
          }
          const line = this.resolve(key);
          if (!line) throw new Error('This item changed. Refresh your cart.');
          const minimum = this.quantityRules(line).min;
          if (!this.validQuantity(line, quantity)) throw new Error(`Choose a quantity from ${minimum} to 9999.`);
          if (line.quantity === quantity) return true;
          return this.write('change', { id: line.key, quantity }, [line.variant_id || line.id]);
        }).finally(() => {
          if (this.wanted.get(key || `hamper:${group}`) === quantity) this.wanted.delete(key || `hamper:${group}`);
          // Reconcile this edit without clearing another line's in-progress draft.
          if (group && !this.wanted.has(`hamper:${group}`)) {
            const lines = this.state.items.filter((line) => line.properties?._hamper_id === group);
            const host = lines.find((line) => String(line.properties?._hamper_host) === 'true') || lines[0];
            const current = [...this.querySelectorAll('[data-clean-cpage-form=group]')].find(
              (node) => node.dataset.cleanCpageGroup === group,
            );
            if (current && host) current.elements.quantity.value = host.quantity;
            this.quantityButtons(current);
          } else if (key && !this.wanted.has(key)) {
            const line = this.resolve(key);
            const current = [...this.querySelectorAll('[data-clean-cpage-form=quantity]')].find(
              (node) => node.dataset.cleanCpageKey === line?.key,
            );
            if (current && line) current.elements.quantity.value = line.quantity;
            this.quantityButtons(current);
          }
        });
      }
      submit(event) {
        const form = event.target.closest('[data-clean-cpage-form]');
        if (!form || !this.contains(form)) return;
        event.preventDefault();
        const type = form.dataset.cleanCpageForm;
        if (type === 'delivery') {
          this.saveDelivery();
          return;
        }
        if (type === 'configured-personal') {
          this.savePersonalization();
          return;
        }
        if (type === 'checkout') {
          this.checkout();
          return;
        }
        if (type === 'quantity' || type === 'group') {
          this.quantity(form, Number(form.elements.quantity.value));
          return;
        }
        const entries = [...new FormData(form).entries()];
        const key = form.dataset.cleanCpageKey,
          group = form.dataset.cleanCpageGroup;
        if (form.dataset.cleanCpageSaving === 'true') return;
        form.dataset.cleanCpageSaving = 'true';
        const submitButton = form.querySelector('[type=submit]');
        if (submitButton) submitButton.disabled = true;
        this.enqueue(async () => {
          let success = false;
          if (type === 'note')
            success = await this.write('update', { note: String(new Map(entries).get('note') || '') });
          if (type === 'card') {
            const attributes = {};
            for (const [name, value] of entries) {
              const match = name.match(/^attributes\[(.+)\]$/);
              if (match) attributes[match[1]] = value;
            }
            // Clear stale historical aliases when editing, while retaining unrelated attributes.
            for (const [name, alias] of [
              ['To', 'Card To'],
              ['From', 'Card From'],
              ['Message', 'Card Message'],
            ])
              attributes[alias] = attributes[name] || '';
            success = await this.write('update', { attributes });
          }
          if (type === 'personal') {
            const line = this.resolve(key);
            if (!line) throw new Error('This item changed. Refresh your cart.');
            const properties = { ...line.properties };
            // Only owned editable fields overwrite properties. Vendor/private data stays intact.
            for (const [name, value] of entries) {
              const match = name.match(
                /^properties\[(Name|Name \(Arabic\)|Date|Personalization notes|_wa_personalized)\]$/,
              );
              if (match) {
                properties[match[1]] =
                  match[1] === 'Date' && /^\d{4}-\d{2}-\d{2}$/.test(value)
                    ? `${value.slice(5, 7)}/${value.slice(8, 10)}/${value.slice(0, 4)}`
                    : value;
              }
            }
            success = await this.write('change', { id: line.key, quantity: line.quantity, properties }, [], line.key);
          }
          if (type === 'remove' || type === 'group-remove') {
            const line = this.resolve(key);
            const lines = group
              ? this.state.items.filter((item) => item.properties?._hamper_id === group)
              : line
                ? [line]
                : [];
            const links = new Set(
              lines
                .filter((item) => !this.addon(item))
                .map((item) => item.properties?.['_Clean add-on group'])
                .filter(Boolean),
            );
            lines.push(
              ...this.state.items.filter(
                (item) => this.addon(item) && links.has(item.properties?.['_Clean add-on group']),
              ),
            );
            if (!lines.length) throw new Error('This item changed. Refresh your cart.');
            success = await this.write(
              'update',
              { updates: Object.fromEntries(lines.map((item) => [item.key, 0])) },
              lines.map((item) => item.variant_id || item.id),
            );
          }
          if (type === 'wrap') {
            const lines = this.state.items.filter((line) => Number(line.variant_id || line.id) === this.config.wrap);
            if (lines.length)
              success = await this.write(
                'update',
                { updates: Object.fromEntries(lines.map((line) => [line.key, 0])) },
                [this.config.wrap],
              );
            else if (this.config.wrapAvailable)
              success = await this.write(
                'add',
                {
                  items: [
                    { id: this.config.wrap, quantity: 1, properties: { '_Hadiyah delivery exempt': 'Gift Wrap' } },
                  ],
                },
                [this.config.wrap],
              );
          }
          if (success && this.dialog.open) this.closeDialog();
          return success;
        }).finally(() => {
          delete form.dataset.cleanCpageSaving;
          if (submitButton) submitButton.disabled = false;
        });
      }
      addon(line) {
        return (
          String(line.properties?.['_Add-on upsell'] || '')
            .trim()
            .toLowerCase() === 'yes' ||
          String(line.properties?.['_Add-on source'] || '')
            .trim()
            .toLowerCase() === 'post add-to-cart drawer'
        );
      }
      click(event) {
        const delivery = event.target.closest('[data-clean-cpage-delivery]');
        if (delivery) {
          this.openDelivery(delivery);
          return;
        }
        if (event.target.closest('[data-clean-cpage-personal-back]')) {
          this.personalLayout(this.personalSession.index - 1, true);
          return;
        }
        if (event.target.closest('[data-clean-cpage-personal-recover]')) {
          this.recover();
          return;
        }
        const step = event.target.closest('[data-clean-cpage-step]');
        if (step) {
          const form = step.closest('form'),
            input = form.elements.quantity;
          const next = this.clampQuantity(
            input,
            Number(input.value) + Number(step.dataset.cleanCpageStep) * Number(input.step || 1),
          );
          if (next === null || next === Number(input.value)) return;
          input.value = next;
          this.quantity(form, next);
          return;
        }
        if (event.target.closest('[data-clean-cpage-recover]')) {
          event.preventDefault();
          this.recover();
          return;
        }
        if (event.target.closest('[data-clean-cpage-close]')) {
          this.closeDialog();
          return;
        }
        const preview = event.target.closest('[data-clean-cpage-preview]');
        if (preview) {
          this.preview(preview);
          return;
        }
        const summary = event.target.closest('summary');
        const details = summary?.parentElement;
        if (details?.hasAttribute('data-clean-cpage-tool') || details?.hasAttribute('data-clean-cpage-personal')) {
          event.preventDefault();
          this.openTool(details, summary);
        }
      }
      finishDialog() {
        if (this.deliverySession) {
          const session = this.deliverySession;
          this.deliverySession = null;
          session.controller.abort();
          document.body.classList.remove('clean-cpage-delivery-open');
          document.body.style.removeProperty('--clean-cpage-scrollbar');
          this.dialog.removeAttribute('data-clean-cpage-delivering');
          this.dialog.style.removeProperty('--clean-cpage-viewport-height');
          this.dialog.style.removeProperty('--clean-cpage-viewport-bottom');
          this.dialog.querySelectorAll('[data-clean-cpage-close]').forEach((node) => {
            node.disabled = false;
          });
          this.querySelector('[data-clean-cpage-dialog-body]').replaceChildren();
          const key = this.resolve(session.key)?.key;
          const target = [...this.querySelectorAll('[data-clean-cpage-delivery]')].find(
            (node) => node.dataset.cleanCpageDelivery === key,
          );
          const focusTarget = target || this.querySelector('[data-clean-cpage-checkout]');
          if (focusTarget?.disabled)
            requestAnimationFrame(() => {
              if (!this.dialog.open && focusTarget.isConnected) focusTarget.focus({ preventScroll: true });
            });
          else focusTarget?.focus({ preventScroll: true });
          if (!this.uncertain) this.status();
          return;
        }
        if (this.personalSession) {
          this.personalSession.read?.abort();
          const key = this.resolve(this.personalSession.key)?.key;
          this.personalSession = null;
          this.dialog.querySelectorAll('[data-clean-cpage-close]').forEach((node) => {
            node.disabled = false;
          });
          this.dialog.removeAttribute('data-clean-cpage-personalizing');
          this.querySelector('[data-clean-cpage-dialog-body]').replaceChildren();
          const target = [...this.querySelectorAll('[data-clean-cpage-personal]')]
            .find((node) => node.dataset.cleanCpagePersonal === key)
            ?.querySelector('summary');
          (target?.getClientRects().length ? target : this.querySelector('[data-clean-cpage-checkout]'))?.focus();
          if (!this.uncertain) this.status();
          return;
        }
        if (this.toolHome && this.toolForm) this.toolHome.append(this.toolForm);
        this.querySelector('[data-clean-cpage-dialog-body]').replaceChildren();
        if (this.opener?.isConnected) this.opener.focus();
        else if (this.toolHome?.dataset.cleanCpagePersonal) {
          const key = this.resolve(this.toolHome.dataset.cleanCpagePersonal)?.key;
          [...this.querySelectorAll('[data-clean-cpage-personal]')]
            .find((node) => node.dataset.cleanCpagePersonal === key)
            ?.querySelector('summary')
            ?.focus();
        }
        this.toolHome = this.toolForm = null;
      }
      closeDialog() {
        if (this.personalSession?.saving || this.deliverySession?.saving) return;
        this.dialog.close();
        this.finishDialog();
      }
      deliveryViewport() {
        if (!this.deliverySession) return;
        const viewport = window.visualViewport;
        this.dialog.style.setProperty('--clean-cpage-viewport-height', `${viewport?.height || innerHeight}px`);
        this.dialog.style.setProperty(
          '--clean-cpage-viewport-bottom',
          `${Math.max(0, innerHeight - (viewport?.height || innerHeight) - (viewport?.offsetTop || 0))}px`,
        );
        const focused = document.activeElement;
        if (this.deliverySession.form.contains(focused))
          requestAnimationFrame(() => focused.scrollIntoView({ block: 'nearest' }));
      }
      async openDelivery(opener) {
        if (this.dialog.open || this.pending || this.uncertain || this.checkoutPending || this.checkoutHandedOff)
          return;
        const key = opener.dataset.cleanCpageDelivery;
        const row = opener.closest('[data-clean-cpage-row]');
        const template = row.querySelector('[data-clean-cpage-delivery-template]');
        if (!template) return;
        const form = template.content.firstElementChild.cloneNode(true);
        const session = { key, form, controller: new AbortController(), saving: false };
        this.deliverySession = session;
        this.dialog.setAttribute('data-clean-cpage-delivering', '');
        this.dialog.querySelector('h2').textContent = 'Add Delivery Details';
        const description = this.dialog.querySelector('[data-clean-cpage-description]');
        description.hidden = false;
        description.textContent = row.querySelector('.clean-cpage-title-link').textContent;
        this.querySelector('[data-clean-cpage-dialog-body]').replaceChildren(form);
        this.status('Loading delivery options…');
        this.deliveryViewport();
        document.body.style.setProperty(
          '--clean-cpage-scrollbar',
          `${innerWidth - document.documentElement.clientWidth}px`,
        );
        document.body.classList.add('clean-cpage-delivery-open');
        this.dialog.showModal();
        this.sync();
        try {
          const picker = form.querySelector('[data-clean-product-delivery]');
          const [{ cleanInitializeDelivery }, { cleanParseDeliveryDate }] = await Promise.all([
            import(picker.dataset.cleanPickerModule),
            import(this.dataset.cleanCartDeliveryModule),
          ]);
          if (this.deliverySession !== session || session.controller.signal.aborted) return;
          const line = this.resolve(key);
          if (!line) throw new Error('This item changed. Refresh your cart.');
          form.elements.quantity.value = line.quantity;
          session.picker = cleanInitializeDelivery(picker, {
            root: form,
            signal: session.controller.signal,
            initial: line.properties,
            beforeCountryChange: () => this.closeDialog(),
            date: cleanParseDeliveryDate(line.properties?.['Delivery Date']),
          });
          this.status();
          this.sync();
        } catch {
          if (this.deliverySession === session) this.status('Could not load delivery options. Close and try again.');
        }
      }
      saveDelivery() {
        const session = this.deliverySession;
        if (
          !session?.picker ||
          session.saving ||
          this.pending ||
          this.uncertain ||
          this.checkoutPending ||
          this.checkoutHandedOff
        )
          return;
        if (!session.picker.validate()) return;
        const answers = session.picker.properties();
        session.saving = true;
        this.status('Saving your delivery details…');
        this.enqueue(async () => {
          const line = this.resolve(session.key);
          if (!line) throw new Error('This item changed. Refresh your cart.');
          const properties = { ...line.properties };
          for (const name of [
            'Pincode',
            'Delivery Date',
            'Delivery Day',
            'Delivery Time',
            'Delivery Method',
            'Delivery Tier',
            'Delivery Estimate',
            'Delivery Speed',
            '_Clean delivery details',
          ])
            delete properties[name];
          Object.assign(properties, answers);
          properties['_Clean delivery date anchor'] = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).format(new Date());
          session.intent = {
            variant: Number(line.variant_id || line.id),
            plan: line.selling_plan_allocation?.selling_plan?.id,
            properties,
          };
          return this.write('change', { id: line.key, quantity: line.quantity, properties }, [], line.key);
        }).then((success) => {
          if (this.deliverySession !== session) return;
          session.saving = false;
          if (success) this.closeDialog();
          else this.sync();
        });
      }
      reconcileDelivery() {
        const session = this.deliverySession;
        if (!session?.intent) return;
        const intent = session.intent;
        const matches = this.state.items.filter(
          (line) =>
            Number(line.variant_id || line.id) === intent.variant &&
            line.selling_plan_allocation?.selling_plan?.id === intent.plan &&
            this.propertySignature(line.properties) === this.propertySignature(intent.properties),
        );
        if (matches.length === 1) {
          this.aliases.set(session.key, matches[0].key);
          session.saving = false;
          this.closeDialog();
        }
      }
      personalFields(root) {
        const fields = [...root.querySelectorAll('input[name], textarea[name]')];
        const labels = fields.map((field) => field.dataset.cleanCpageProperty || field.name.slice(11, -1).trim());
        const used = new Set();
        fields.forEach((field, index) => {
          if (field.dataset.cleanCpageProperty) return;
          const label = labels[index];
          let key =
            labels.filter((value) => value === label).length > 1
              ? `${label} (Step ${Number(field.dataset.cleanStep || 0) + 1})`
              : label;
          if (used.has(key)) key += ` (${index + 1})`;
          if (
            !/^properties\[.+\]$/.test(field.name) ||
            !key ||
            /^_/.test(key) ||
            /^(Delivery Method|Delivery Tier|Delivery Date|Shipping Method)$/i.test(key)
          )
            throw new Error('This configuration requires the product editor.');
          used.add(key);
          field.dataset.cleanCpageProperty = key;
          field.name = `properties[${key}]`;
        });
        return fields;
      }
      personalDate(value) {
        let iso = value;
        const displayed = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value);
        if (displayed) iso = `${displayed[3]}-${displayed[2]}-${displayed[1]}`;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(iso) || iso.startsWith('0000')) return '';
        const date = new Date(`${iso}T00:00:00Z`);
        return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === iso ? iso : '';
      }
      personalError(field, value) {
        if (field.required && !value.trim()) return 'Please enter your details.';
        if (value && !value.trim()) return 'Please enter your details.';
        if (
          value &&
          (field.type === 'date' || field.hasAttribute('data-clean-cpage-date')) &&
          !this.personalDate(value)
        )
          return 'Choose a valid date using the calendar.';
        if (field.type !== 'date' && !field.hasAttribute('data-clean-cpage-date')) {
          if (field.maxLength > 0 && value.length > field.maxLength)
            return `Use ${field.maxLength} characters or fewer.`;
          if (value && field.minLength > 0 && value.length < field.minLength)
            return `Use at least ${field.minLength} characters.`;
        }
        return '';
      }
      personalCompleteness(root = this, state = this.state) {
        const entries = root.querySelectorAll('.clean-cpage-personal--configured');
        if (!entries.length) return;
        const lines = new Map(state.items.map((line) => [line.key, line]));
        for (const details of entries) {
          const template = details.querySelector('[data-clean-addon-fields]');
          if (!template) continue;
          if (template.hasAttribute('data-clean-addon-invalid')) {
            details.dataset.cleanCpageMissing = 'true';
            details.hidden = false;
            continue;
          }
          const assignment = template.dataset.cleanAddonAssignment;
          const definition = assignment ? this.personalDefinitions.get(assignment) : template.content;
          if (assignment && definition === null) {
            details.dataset.cleanCpageMissing = 'false';
            details.hidden = true;
            continue;
          }
          const line = lines.get(details.dataset.cleanCpagePersonal);
          if (!definition) {
            details.dataset.cleanCpageMissing = String(
              line?.properties?._clean_cart_personalization !== `details:${details.dataset.cleanCpageSku}`,
            );
            details.hidden = false;
            continue;
          }
          try {
            let fields = this.personalNativeFields.get(definition);
            if (!fields) {
              fields = this.personalFields(definition.cloneNode(true));
              this.personalNativeFields.set(definition, fields);
            }
            details.dataset.cleanCpageMissing = String(
              !fields.length ||
                fields.some((field) =>
                  this.personalError(field, String(line?.properties?.[field.dataset.cleanCpageProperty] ?? '')),
                ),
            );
            details.hidden =
              details.dataset.cleanCpageMissing === 'false' &&
              line?.properties?._clean_cart_personalization !== `details:${details.dataset.cleanCpageSku}` &&
              fields.some((field) => String(line?.properties?.[field.dataset.cleanCpageProperty] ?? '').trim());
          } catch {
            details.dataset.cleanCpageMissing = 'true';
            details.hidden = false;
          }
        }
      }
      async personalVendor(template, session) {
        const address = template.dataset.cleanAddonAssignment;
        if (this.personalDefinitions.has(address)) return this.personalDefinitions.get(address);
        const url = new URL(address);
        if (
          url.protocol !== 'https:' ||
          url.hostname !== 'json.staticmeow.com' ||
          url.username ||
          url.password ||
          !/^\/customeow\/app\/shopify\/\d+\/[^/]+\.json$/.test(url.pathname)
        )
          throw new Error();
        const response = await fetch(url, {
          credentials: 'omit',
          redirect: 'error',
          signal: AbortSignal.any([this.lifecycle.signal, session.read.signal, AbortSignal.timeout(10000)]),
        });
        if (response.status === 404) {
          this.personalDefinitions.set(address, null);
          return null;
        }
        if (!response.ok) throw new Error();
        const config = await response.json();
        if (!config || Array.isArray(config) || typeof config !== 'object') throw new Error();
        if (config.enabled === false || config.published === false) {
          this.personalDefinitions.set(address, null);
          return null;
        }
        if (
          !config.customizerId ||
          !config.customizerVersion ||
          !Array.isArray(config.customData?.layers) ||
          config.customData.layers.length > 30
        )
          throw new Error();
        const fragment = document.createDocumentFragment();
        const translate = (value) => config.locals?.[value]?.en_US || value;
        let count = 0;
        for (const [step, layer] of config.customData.layers.entries()) {
          if (
            !layer ||
            (layer.conditions != null && (!Array.isArray(layer.conditions) || layer.conditions.length)) ||
            !Array.isArray(layer.modules) ||
            layer.modules.length > 100
          )
            throw new Error();
          const group = document.createElement('fieldset'),
            legend = document.createElement('legend');
          const stepTitle = translate(layer.title) || 'Your details';
          if (typeof stepTitle !== 'string') throw new Error();
          legend.textContent = stepTitle;
          group.append(legend);
          for (const module of layer.modules) {
            if (module.type === 'preview_template') continue;
            const settings = module.config || {},
              title = translate(settings.label);
            if (
              !['text', 'datetime'].includes(module.type) ||
              settings.enableCondition ||
              typeof title !== 'string' ||
              !title.trim() ||
              ++count > 100
            )
              throw new Error();
            if (
              settings.limitCharacter?.length ||
              Object.keys(settings.validate || {}).some((key) => !['required', 'maxLength', 'minLength'].includes(key))
            )
              throw new Error();
            const label = document.createElement('label'),
              input = document.createElement('input');
            label.append(document.createTextNode(title));
            input.type = module.type === 'datetime' ? 'date' : 'text';
            input.name = `properties[${title.trim()}]`;
            input.dataset.cleanStep = String(step);
            input.required = settings.validate?.required === true;
            if (settings.validate?.required != null && typeof settings.validate.required !== 'boolean')
              throw new Error();
            for (const [rule, attribute] of [
              ['maxLength', 'maxlength'],
              ['minLength', 'minlength'],
            ]) {
              const limit = settings.validate?.[rule];
              if (limit != null && (!Number.isSafeInteger(limit) || limit < 0)) throw new Error();
              if (limit > 0 && input.type !== 'date') input.setAttribute(attribute, String(limit));
            }
            label.append(input);
            group.append(label);
          }
          if (group.querySelector('input')) fragment.append(group);
        }
        if (!count) throw new Error();
        this.personalFields(fragment);
        this.personalDefinitions.set(address, fragment);
        return fragment;
      }
      async openPersonalization(details, opener) {
        const line = this.resolve(details.dataset.cleanCpagePersonal);
        if (!line || details.hidden || this.pending || this.checkoutPending || this.checkoutHandedOff) return;
        const form = this.querySelector('[data-clean-cpage-personal-shell]').content.firstElementChild.cloneNode(true);
        const session = { key: line.key, form, index: 0, read: new AbortController(), ready: false, saving: false };
        this.personalSession = session;
        this.opener = opener;
        this.dialog.setAttribute('data-clean-cpage-personalizing', '');
        this.dialog.querySelector('h2').textContent = 'Customize your gift';
        const description = this.querySelector('[data-clean-cpage-description]');
        description.textContent = details
          .closest('[data-clean-cpage-row]')
          .querySelector('.clean-cpage-title-link').textContent;
        description.hidden = false;
        this.querySelector('[data-clean-cpage-dialog-body]').replaceChildren(form);
        const fallback = form.querySelector('[data-clean-cpage-personal-fallback]');
        const link = new URL(line.url, location.origin);
        link.searchParams.set('line_item_key', line.key);
        link.searchParams.set('edit_customization', '1');
        fallback.href = link.pathname + link.search;
        this.dialog.showModal();
        const picture = details.closest('[data-clean-cpage-row]').querySelector('.clean-cpage-picture img');
        const source = details.dataset.cleanCpagePersonalImage;
        if (source || picture) {
          const image = document.createElement('img');
          image.width = image.height = 320;
          image.alt = '';
          image.decoding = 'async';
          const media = form.querySelector('[data-clean-cpage-personal-photo]');
          image.onerror = () => {
            media.hidden = true;
          };
          image.src = source || picture.currentSrc || picture.src;
          media.append(image);
          media.hidden = false;
        }
        this.dialog.querySelector('[data-clean-cpage-close]').focus();
        this.status('Loading personalization details…');
        try {
          const template = details.querySelector('[data-clean-addon-fields]');
          if (template.hasAttribute('data-clean-addon-invalid')) throw new Error();
          const definition = template.dataset.cleanAddonAssignment
            ? await this.personalVendor(template, session)
            : template.content;
          if (this.personalSession !== session || session.read.signal.aborted) return;
          if (!definition) {
            this.sync();
            this.status('This variant does not require personalization.');
            return;
          }
          this.personalCompleteness();
          if (details.hidden) {
            this.closeDialog();
            return;
          }
          const fieldRoot = form.querySelector('[data-clean-cpage-personal-fields]');
          fieldRoot.append(definition.cloneNode(true));
          session.fields = this.personalFields(fieldRoot);
          if (!session.fields.length) throw new Error();
          for (const field of session.fields) {
            let value = String(line.properties?.[field.dataset.cleanCpageProperty] ?? '');
            if (field.type === 'date') {
              value = this.personalDate(value);
              field.removeAttribute('maxlength');
              field.removeAttribute('minlength');
              field.addEventListener(
                'click',
                () => {
                  if (typeof field.showPicker === 'function') {
                    try {
                      field.showPicker();
                    } catch {}
                  }
                },
                { signal: session.read.signal },
              );
            }
            field.value = value;
          }
          session.sku = details.dataset.cleanCpageSku;
          session.ready = true;
          this.status();
          this.personalProgress();
          this.personalLayout(0, true);
          this.sync();
        } catch {
          if (this.personalSession !== session || session.read.signal.aborted) return;
          form.querySelector('[data-clean-cpage-personal-fields]').replaceChildren();
          this.status('Personalization could not load. Close and try again, or use the product page.');
          fallback.hidden = false;
        }
      }
      personalProgress() {
        const session = this.personalSession;
        if (!session?.ready) return;
        const fields = session.fields;
        fields.forEach((field) => field.setCustomValidity(this.personalError(field, field.value)));
        const required = fields.filter((field) => field.required),
          counted = required.length ? required : fields;
        const completed = counted.filter((field) => field.value.trim() && field.validity.valid).length;
        const bar = session.form.querySelector('[data-clean-cpage-personal-progress]');
        bar.max = counted.length || 1;
        bar.value = completed;
        session.form.querySelector('[data-clean-cpage-personal-progress-text]').textContent =
          `${completed} of ${counted.length} details completed`;
      }
      reconcilePersonalization() {
        const session = this.personalSession,
          intent = session?.intent;
        if (!intent) return;
        const sameVariant = this.state.items.filter(
          (line) =>
            Number(line.variant_id || line.id) === intent.variant &&
            line.selling_plan_allocation?.selling_plan?.id === intent.plan,
        );
        const confirmed = sameVariant.filter(
          (line) => this.propertySignature(line.properties) === this.propertySignature(intent.properties),
        );
        if (confirmed.length === 1) {
          this.aliases.set(session.key, confirmed[0].key);
          session.key = confirmed[0].key;
          this.closeDialog();
          return;
        }
        if (!this.resolve(session.key)) {
          const unchanged = sameVariant.filter(
            (line) => this.propertySignature(line.properties) === this.propertySignature(intent.before),
          );
          if (unchanged.length === 1) this.aliases.set(session.key, unchanged[0].key);
          else {
            session.ready = false;
            this.status('This cart item changed. Close this form and open its current customization again.');
          }
        }
      }
      personalLayout(index, focus = false) {
        const session = this.personalSession;
        if (!session?.ready) return;
        const fields = session.fields,
          mobile = this.personalMedia.matches;
        const focused = fields.indexOf(document.activeElement);
        session.index = Math.max(0, Math.min(index ?? (focused < 0 ? session.index : focused), fields.length - 1));
        const active = fields[session.index],
          group = active.closest('fieldset');
        const groups = [...session.form.querySelectorAll('fieldset')].filter((node) =>
          node.querySelector('input,textarea'),
        );
        groups.forEach((node) => {
          node.hidden = mobile && node !== group;
        });
        fields.forEach((field) => {
          field.closest('label').hidden = mobile && field !== active;
        });
        const counts = session.form.querySelector('[data-clean-cpage-personal-counts]');
        counts.hidden = !mobile;
        counts.textContent = `Step ${groups.indexOf(group) + 1}/${groups.length} · Field ${[...group.querySelectorAll('input,textarea')].indexOf(active) + 1}/${group.querySelectorAll('input,textarea').length}`;
        session.form.querySelector('[data-clean-cpage-personal-back]').hidden = !mobile || session.index === 0;
        const next = mobile && session.index < fields.length - 1;
        const submit = session.form.querySelector('[type=submit]');
        submit.textContent = next ? 'Next' : mobile ? 'Save' : 'Save customization';
        submit.setAttribute('aria-label', next ? 'Next' : 'Save customization');
        if (focus) active.focus({ preventScroll: true });
      }
      savePersonalization() {
        const session = this.personalSession;
        if (!session?.ready || session.saving || this.uncertain || this.checkoutPending || this.checkoutHandedOff)
          return;
        this.personalProgress();
        if (this.personalMedia.matches && session.index < session.fields.length - 1) {
          if (session.fields[session.index].reportValidity()) this.personalLayout(session.index + 1, true);
          return;
        }
        const invalid = session.fields.findIndex((field) => !field.validity.valid);
        if (invalid >= 0) {
          this.personalLayout(invalid, true);
          session.fields[invalid].reportValidity();
          return;
        }
        const answers = Object.fromEntries(
          session.fields.map((field) => [
            field.dataset.cleanCpageProperty,
            field.type === 'date' && field.value ? field.value.split('-').reverse().join('-') : field.value.trim(),
          ]),
        );
        answers._clean_cart_personalization = `details:${session.sku}`;
        session.saving = true;
        this.status('Saving your personalization…');
        this.enqueue(async () => {
          const line = this.resolve(session.key);
          if (!line) throw new Error('This item changed. Refresh your cart.');
          session.intent = {
            variant: Number(line.variant_id || line.id),
            plan: line.selling_plan_allocation?.selling_plan?.id,
            before: { ...line.properties },
            properties: { ...line.properties, ...answers },
          };
          return this.write(
            'change',
            {
              id: line.key,
              quantity: line.quantity,
              properties: session.intent.properties,
            },
            [],
            line.key,
          );
        }).then((success) => {
          if (this.personalSession !== session) return;
          session.saving = false;
          if (success) this.closeDialog();
          else this.sync();
        });
      }
      openTool(details, opener) {
        if (this.dialog.open) return;
        if (details.classList.contains('clean-cpage-personal--configured')) {
          this.openPersonalization(details, opener);
          return;
        }
        this.opener = opener;
        this.dialog.querySelector('h2').textContent = details.hasAttribute('data-clean-cpage-personal')
          ? 'Customize your gift'
          : details.querySelector('strong')?.textContent || 'Cart options';
        const description = this.querySelector('[data-clean-cpage-description]');
        description.textContent =
          {
            note: 'Tell us anything that will help us prepare your order just right.',
            wrap: 'Make your gift feel even more special.',
            card: 'Write a thoughtful note for someone special.',
          }[details.dataset.cleanCpageTool] || '';
        description.hidden = !description.textContent;
        this.toolHome = details;
        this.toolForm = details.querySelector('form');
        this.querySelector('[data-clean-cpage-dialog-body]').replaceChildren(this.toolForm);
        this.querySelector('[data-clean-cpage-dialog-status]').textContent = '';
        this.dialog.showModal();
        this.toolForm.querySelector('input:not([type=hidden]),textarea,button[type=submit]')?.focus();
      }
      preview(opener) {
        const line = this.resolve(opener.dataset.cleanCpagePreview);
        if (!line) return;
        const properties = line.properties || {},
          urls = [];
        const collect = (value) => {
          if (Array.isArray(value)) {
            value.forEach(collect);
            return;
          }
          if (value && typeof value === 'object') {
            Object.values(value).forEach(collect);
            return;
          }
          if (typeof value !== 'string') return;
          try {
            const parsed = JSON.parse(value);
            if (parsed !== value) {
              collect(parsed);
              return;
            }
          } catch {}
          for (const match of value.matchAll(/(?:https?:\/\/|\/\/|\/(?:cdn\/shop|uploads|apps)\/)[^\s,"'<>\[\]|]+/g)) {
            try {
              const url = new URL(match[0].replaceAll('&amp;', '&'), location.origin);
              if (url.protocol === 'https:' && !url.username && !url.password && !urls.includes(url.href))
                urls.push(url.href);
            } catch {}
          }
        };
        for (const [key, value] of Object.entries(properties))
          if (
            [
              '_customization_preview',
              '_customization_previews',
              'preview.images',
              'preview.effects',
              'preview.image',
            ].includes(key) ||
            key === '_hg_preview_image'
          )
            collect(value);
        if (
          !urls.length &&
          /^[A-Za-z0-9_-]{1,200}$/.test(properties._hg_personalization_id || properties._customization_id || '')
        )
          urls.push(
            `https://hg-customization-studio-lime.vercel.app/api/preview-image?id=${encodeURIComponent(properties._hg_personalization_id || properties._customization_id)}`,
          );
        if (!urls.length) {
          this.status('No saved preview is available. Open the product to review your customization.');
          return;
        }
        this.opener = opener;
        this.dialog.querySelector('h2').textContent = 'Saved preview';
        this.querySelector('[data-clean-cpage-description]').hidden = true;
        const panel = document.createElement('div');
        panel.className = 'clean-cpage-preview';
        const image = new Image(440, 320);
        image.alt = 'Saved customization preview';
        image.decoding = 'async';
        const nav = document.createElement('nav'),
          previous = document.createElement('button'),
          next = document.createElement('button'),
          count = document.createElement('span');
        previous.type = next.type = 'button';
        previous.textContent = 'Previous';
        next.textContent = 'Next';
        let index = 0;
        const show = () => {
          image.src = urls[index];
          count.textContent = `${index + 1} / ${urls.length}`;
          previous.disabled = index === 0;
          next.disabled = index === urls.length - 1;
        };
        previous.onclick = () => {
          index--;
          show();
        };
        next.onclick = () => {
          index++;
          show();
        };
        nav.append(previous, count, next);
        image.onerror = () => {
          this.querySelector('[data-clean-cpage-dialog-status]').textContent =
            'The saved preview could not load. Your saved details are still retained.';
        };
        panel.append(image, nav);
        show();
        this.querySelector('[data-clean-cpage-dialog-body]').replaceChildren(panel);
        this.dialog.showModal();
      }
      visitor() {
        let country = this.visitorCountry;
        try {
          country ||=
            sessionStorage.getItem('clean:delivery-country-detected:v1') ||
            sessionStorage.getItem('hadiyah:visitor-country-code');
        } catch {}
        return /^[A-Z]{2}$/.test(country || '') ? country : '';
      }
      domestic() {
        let delivery = this.config.country;
        try {
          delivery = localStorage.getItem('hadiyah:delivery-country-code') || delivery;
        } catch {}
        return delivery === 'IN' && this.config.country === 'IN' && this.config.currency === 'INR';
      }
      bindCheckoutClose() {
        const sdk = window.gokwikSdk;
        if (
          this.dataset.cleanCpageGokwik !== 'true' ||
          typeof sdk?.on !== 'function' ||
          window['clean-cart-page-gokwik-sdk'] === sdk
        )
          return;
        // One SDK relay per page; section listeners are removed with their lifecycle.
        sdk.on('modal_closed', () => document.dispatchEvent(new Event('clean:cart-checkout-closed')));
        window['clean-cart-page-gokwik-sdk'] = sdk;
      }
      async refreshDeliveryDates(checkout = false) {
        if (!this.isConnected || !this.lifecycle || this.lifecycle.signal.aborted) return false;
        if (!this.state?.items?.some((line) => line.properties?.['Delivery Date'])) return true;
        const lifecycle = this.lifecycle;
        try {
          this.deliveryModule ||= import(this.dataset.cleanCartDeliveryModule).catch((error) => {
            this.deliveryModule = null;
            throw error;
          });
          const { cleanCreateDeliveryDates } = await this.deliveryModule;
          if (lifecycle !== this.lifecycle || lifecycle.signal.aborted) return false;
          this.deliveryDates ||= cleanCreateDeliveryDates({
            signal: lifecycle.signal,
            snapshot: () => ({ items: this.state.items, metadata: this.config.delivery }),
            ready: (internal) =>
              !this.pending &&
              !this.uncertain &&
              !this.checkoutHandedOff &&
              !this.dialog.open &&
              (!this.checkoutPending || internal),
            change: (line, properties, internal) =>
              this.enqueue(
                () =>
                  this.write('change', { id: line.key, quantity: line.quantity, properties }, [], line.key, {
                    silent: true,
                  }),
                { internal },
              ),
            status: (message) => this.status(message),
          });
          return await this.deliveryDates.refresh({ checkout });
        } catch {
          this.status('Your cart could not be updated. Refresh your cart and try again.');
          return false;
        }
      }
      async checkout() {
        if (this.pending || this.uncertain || this.checkoutPending || this.checkoutHandedOff || !this.config.count) {
          this.status('Wait for cart updates to finish, then confirm your cart before checkout.');
          return;
        }
        if (this.state.items.some((line) => !this.fee(line) && !this.validQuantity(line, line.quantity))) {
          this.status('Choose at least the minimum quantity for each item, or remove it, before checkout.');
          return;
        }
        const missingDelivery = this.querySelector('[data-clean-cpage-delivery-missing=true]');
        if (missingDelivery) {
          this.status('Please save delivery details for each gift before checkout.');
          for (const detail of this.querySelectorAll('.clean-cpage-hamper-details, .clean-cpage-addons'))
            if (detail.contains(missingDelivery)) detail.open = true;
          this.openDelivery(missingDelivery);
          return;
        }
        const missing = this.querySelector('[data-clean-cpage-missing=true]');
        if (missing) {
          this.status('Please save the required personalization details before checkout.');
          for (const detail of this.querySelectorAll('.clean-cpage-hamper-details'))
            if (detail.contains(missing)) detail.open = true;
          this.openTool(missing, missing.querySelector('summary'));
          return;
        }
        this.checkoutPending = true;
        this.sync();
        window['clean-commerce']?.checkout(this.state, 'clean-cart-page');
        try {
          if (!(await this.refreshDeliveryDates(true))) return;
          // Reconcile all known fees only on explicit checkout intent.
          const desired = new Map(this.config.feeIds.map((id) => [id, 0]));
          if (this.domestic())
            this.config.fees.forEach(({ id, quantity }) => desired.set(id, (desired.get(id) || 0) + quantity));
          const updates = {},
            additions = [];
          for (const [id, quantity] of desired) {
            const lines = this.state.items.filter((line) => Number(line.variant_id || line.id) === id);
            if (!lines.length && quantity)
              additions.push({
                id,
                quantity,
                properties: { '_Hadiyah delivery charge': id === 51050538893559 ? 'standard' : 'express' },
              });
            lines.forEach((line, index) => {
              if (line.quantity !== (index ? 0 : quantity)) updates[line.key] = index ? 0 : quantity;
            });
          }
          this.state.items
            .filter((line) => this.fee(line) && !desired.has(Number(line.variant_id || line.id)))
            .forEach((line) => {
              updates[line.key] = 0;
            });
          if (
            Object.keys(updates).length &&
            !(await this.enqueue(() => this.write('update', { updates }), { internal: true }))
          )
            return;
          if (
            additions.length &&
            !(await this.enqueue(() => this.write('add', { items: additions }), { internal: true }))
          )
            return;
          if (this.dataset.cleanCpageGokwik === 'true') window.cart = this.state;
          // The layout owns SDK installation. A bounded load wait never polls.
          if (this.dataset.cleanCpageGokwik === 'true' && this.domestic() && this.visitor() === 'IN') {
            if (typeof window.onCheckoutClick !== 'function')
              await new Promise((resolve) => {
                const script = document.getElementById('gokwik-merchant-integration');
                const finish = () => {
                  clearTimeout(timer);
                  script?.removeEventListener('load', finish);
                  script?.removeEventListener('error', finish);
                  resolve();
                };
                const timer = setTimeout(finish, 2000);
                script?.addEventListener('load', finish, { once: true });
                script?.addEventListener('error', finish, { once: true });
              });
            if (!this.isConnected || !this.lifecycle || this.uncertain) return;
            if (typeof window.onCheckoutClick === 'function') {
              window.cart = this.state;
              this.bindCheckoutClose();
              this.checkoutHandedOff = true;
              this.checkoutClosed = false;
              try {
                await window.onCheckoutClick(this.querySelector('[data-clean-cpage-checkout]'));
                this.status();
                return;
              } catch {
                this.checkoutHandedOff = false;
                /* Native Shopify fallback. */
              }
            }
          }
          if (this.uncertain || !this.isConnected) return;
          location.assign(new URL(this.cartURL.pathname.replace(/\/cart\/?$/, '/checkout'), location.origin));
        } finally {
          this.checkoutPending = false;
          this.sync();
          if (this.checkoutClosed && this.checkoutHandedOff) this.recover();
        }
      }
      scheduleClarity(listen) {
        const query = new URLSearchParams(location.search);
        if (
          [...query].some(
            ([name, value]) =>
              /token|(?:^|_)key|email|phone|pincode|address|properties|customization|proof|customer/i.test(name) ||
              /[^\s@]+@[^\s@]+\.[^\s@]+/.test(value),
          )
        )
          return;
        const consent = () => {
          if (!this.isConnected || !this.lifecycle) return;
          const privacy = window.Shopify?.customerPrivacy;
          if (!privacy) return;
          const analytics = privacy.analyticsProcessingAllowed?.() === true;
          if (!analytics && !window.clarity) return;
          if (!window.clarity) {
            window.clarity = function () {
              (window.clarity.q ||= []).push(arguments);
            };
            if (!document.querySelector('script[src*="clarity.ms/tag/"]')) {
              const script = document.createElement('script');
              script.async = true;
              script.src = 'https://www.clarity.ms/tag/ql3mvo7dpf';
              script.dataset.cleanCpageClarity = '';
              document.head.append(script);
            }
          }
          window.clarity('consentv2', {
            analytics_Storage: analytics ? 'granted' : 'denied',
            ad_Storage: privacy.marketingAllowed?.() === true ? 'granted' : 'denied',
          });
        };
        const start = () => {
          listen(document, 'visitorConsentCollected', consent);
          if (window.Shopify?.customerPrivacy) consent();
          else
            window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
              if (!error) consent();
            });
        };
        const schedule = () => {
          if ('requestIdleCallback' in window) this.idle = requestIdleCallback(start, { timeout: 8000 });
          else this.clarityTimer = setTimeout(start, 4000);
        };
        if (document.readyState === 'complete') schedule();
        else listen(window, 'load', schedule, { once: true });
      }
    }
    customElements.define('clean-cart-page', CleanCartPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clean-footer-menus')) {
    customElements.define(
      'clean-footer-menus',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.cleanInitialized) return;
          this.dataset.cleanInitialized = 'true';
          if (window.matchMedia('(min-width: 750px)').matches) {
            this.querySelectorAll('.clean-footer__menu').forEach((menu) => {
              menu.open = true;
            });
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-header"]) return;
  try {
    
  (() => {
    const headerRoot = document.querySelector('[data-clean-header]');

    if (headerRoot && headerRoot.dataset.cleanHeaderCountsBound !== 'true') {
      headerRoot.dataset.cleanHeaderCountsBound = 'true';
      const wishlistLink = headerRoot.querySelector('[data-clean-header-wishlist]');
      const wishlistCount = headerRoot.querySelector('[data-clean-header-wishlist-count]');
      const cartLink = headerRoot.querySelector('[data-clean-header-cart]');
      const cartCount = headerRoot.querySelector('[data-clean-header-cart-count]');
      const cleanWishlistStorageKey = 'clean:wishlist:v1';
      const legacyWishlistStorageKey = 'wishlistItem';
      let cartRequest;
      let lastCartRefresh = Date.now();

      const cleanNormalizeWishlist = (handles) => [
        ...new Set(
          handles.filter((handle) => typeof handle === 'string' && handle.trim()).map((handle) => handle.trim()),
        ),
      ];

      const cleanParseWishlist = (value, objectFormat = false) => {
        if (value === null) return null;

        try {
          const parsed = JSON.parse(value);
          const handles = objectFormat ? parsed?.handles : parsed;
          return Array.isArray(handles) ? cleanNormalizeWishlist(handles) : null;
        } catch {
          return null;
        }
      };

      const cleanReadWishlistCount = () => {
        try {
          const legacyHandles = cleanParseWishlist(window.localStorage.getItem(legacyWishlistStorageKey));
          if (legacyHandles !== null) return legacyHandles.length;

          return cleanParseWishlist(window.localStorage.getItem(cleanWishlistStorageKey), true)?.length || 0;
        } catch {
          return 0;
        }
      };

      const cleanUpdateCount = (link, countElement, count, label) => {
        if (!link || !countElement) return;

        const normalizedCount = Math.max(0, Math.floor(Number(count) || 0));
        countElement.textContent = normalizedCount > 99 ? '99+' : String(normalizedCount);
        countElement.hidden = normalizedCount === 0;
        link.setAttribute('aria-label', `${label}, ${normalizedCount} ${normalizedCount === 1 ? 'item' : 'items'}`);
      };

      const cleanUpdateWishlistCount = (handles) => {
        const count = Array.isArray(handles) ? cleanNormalizeWishlist(handles).length : cleanReadWishlistCount();
        cleanUpdateCount(wishlistLink, wishlistCount, count, 'View wishlist');
      };

      const cleanUpdateCartCount = (count) => {
        lastCartRefresh = Date.now();
        cleanUpdateCount(cartLink, cartCount, count, 'View cart');
      };

      const cleanCartCountFromDetail = (detail) => {
        const candidates = [
          detail?.item_count,
          detail?.cart?.item_count,
          detail?.data?.item_count,
          detail?.data?.cart?.item_count,
        ];
        const count = candidates.find((candidate) => Number.isFinite(Number(candidate)));
        return count === undefined ? null : Number(count);
      };

      const cleanHeaderMerchandiseCount = (cart) => Array.isArray(cart?.items) ? cart.items.reduce((count,line) => {
        const fee = Number(line.product_id || line.product?.id) === 10059690017015 ||
          [51050538893559,51050538926327,51256352473335,51256354898167,51256354930935,51256354963703,51256354996471,51256355029239,51256355062007].includes(Number(line.variant_id || line.id));
        return count + (fee ? 0 : Number(line.quantity || 0));
      },0) : cart?.item_count;
      const cleanRefreshCartCount = () => {
        if (!headerRoot.dataset.cleanHeaderCartJsonUrl) return Promise.resolve();
        if (cartRequest) return cartRequest;

        cartRequest = fetch(headerRoot.dataset.cleanHeaderCartJsonUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
            return response.json();
          })
          .then((cart) => cleanUpdateCartCount(cleanHeaderMerchandiseCount(cart)))
          .catch(() => {})
          .finally(() => {
            cartRequest = undefined;
          });

        return cartRequest;
      };

      const cleanHandleCartUpdate = (event) => {
        const count = cleanCartCountFromDetail(event.detail);
        if (count === null) cleanRefreshCartCount();
        else cleanUpdateCartCount(count);
      };

      cleanUpdateWishlistCount();

      window.addEventListener('clean:wishlist-change', (event) => cleanUpdateWishlistCount(event.detail?.handles));
      window.addEventListener('storage', (event) => {
        if (event.key === null || event.key === cleanWishlistStorageKey || event.key === legacyWishlistStorageKey) {
          cleanUpdateWishlistCount();
        }
      });
      document.addEventListener('cart:updated', cleanHandleCartUpdate);
      document.addEventListener('clean:cart:updated', cleanHandleCartUpdate);
      document.addEventListener('cart-update', cleanHandleCartUpdate);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && !document.querySelector('clean-cart-page')) cleanRefreshCartCount();
      });
      window.addEventListener('focus', () => {
        if (Date.now() - lastCartRefresh > 30000 && !document.querySelector('clean-cart-page')) cleanRefreshCartCount();
      });
    }

    const deliveryRoots = document.querySelectorAll('[data-clean-delivery]');

    deliveryRoots.forEach((root) => {
      if (root.dataset.cleanDeliveryBound === 'true') return;
      root.dataset.cleanDeliveryBound = 'true';

      const trigger = root.querySelector('[data-clean-delivery-trigger]');
      const triggerValue = root.querySelector('[data-clean-delivery-trigger-value]');
      const triggerMobileValue = root.querySelector('[data-clean-delivery-trigger-mobile-value]');
      const dialog = root.querySelector('[data-clean-delivery-dialog]');
      const closeButton = root.querySelector('[data-clean-delivery-close]');
      const form = root.querySelector('form');
      const countrySelect = root.querySelector('[data-clean-delivery-country]');
      const fields = root.querySelector('[data-clean-delivery-fields]');
      const divider = root.querySelector('[data-clean-delivery-divider]');
      const summaryFlag = root.querySelector('[data-clean-delivery-summary-flag]');
      const summaryCountry = root.querySelector('[data-clean-delivery-summary-country]');
      const changeButton = root.querySelector('[data-clean-delivery-change]');
      const countryCodeButton = root.querySelector('[data-clean-delivery-country-code]');
      const countryPicker = root.querySelector('[data-clean-country-picker]');
      const countrySearch = root.querySelector('[data-clean-country-search]');
      const countryList = root.querySelector('[data-clean-country-list]');
      const pincodeField = root.querySelector('[data-clean-delivery-pincode-field]');
      const pincodeInput = root.querySelector('[data-clean-delivery-pincode]');
      const status = root.querySelector('[data-clean-delivery-status]');
      const applyButton = root.querySelector('[data-clean-delivery-apply]');

      if (
        !trigger ||
        !triggerValue ||
        !triggerMobileValue ||
        !dialog ||
        !closeButton ||
        !form ||
        !countrySelect ||
        !fields ||
        !divider ||
        !summaryFlag ||
        !summaryCountry ||
        !changeButton ||
        !countryCodeButton ||
        !countryPicker ||
        !countrySearch ||
        !countryList ||
        !pincodeField ||
        !pincodeInput ||
        !status ||
        !applyButton
      ) {
        return;
      }

      const currentCountry = String(root.dataset.cleanCurrentCountry || '').toUpperCase();
      const pincodeStorageKey = 'clean:delivery-pincode:v1';
      const legacyPincodeStorageKey = 'hadiyah:pdp-pincode';
      const legacyPincodeCityStorageKey = 'hadiyah:pdp-pincode-city';
      const manualCountryStorageKey = 'clean:delivery-country-manual:v1';
      const legacyDeliveryCountryCodeKey = 'hadiyah:delivery-country-code';
      const legacyDeliveryCountryNameKey = 'hadiyah:delivery-country-name';
      const legacyDeliveryCountrySourceKey = 'hadiyah:delivery-country-source';
      const deliveryPromptSeenStorageKey = 'clean:delivery-prompt-seen:v1';
      const detectedCountrySessionKey = 'clean:delivery-country-detected:v1';
      const legacyVisitorCountrySessionKey = 'hadiyah:visitor-country-code';
      const legacyVisitorNameSessionKey = 'hadiyah:visitor-country-name';
      const countryBridgeAttemptSessionKey = 'clean:delivery-country-bridge-attempt:v1';
      let indexBytes = '';
      let indexRequest;
      let opener;
      let countryPickerOpen = false;
      let countryPickerOpener;
      let activeCountryIndex = -1;
      let renderedCountryOptions = [];
      let countries;
      let countrySearchFrame;
      let drawerCloseTimer;
      let drawerAnimationEndHandler;
      let dialogPositionFrame;
      let bridgeStorageTimer;
      const initializedAt = Date.now();
      const topCountryCodes = ['IN', 'AU', 'CA', 'AE', 'GB', 'US'];
      const desktopViewport = window.matchMedia('(min-width: 990px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const readStorage = (storage, key) => {
        try {
          return String(storage.getItem(key) || '');
        } catch (error) {
          return '';
        }
      };

      const writeStorage = (storage, key, value) => {
        try {
          if (value) storage.setItem(key, value);
          else storage.removeItem(key);
        } catch (error) {}
      };

      const normalizePincode = (value) =>
        String(value || '')
          .replace(/\D/g, '')
          .slice(0, 6);

      const isCompletePincode = (value) => /^\d{6}$/.test(value);

      const readPincodeForKey = (key) => {
        const pincode = normalizePincode(readStorage(window.localStorage, key));
        return isCompletePincode(pincode) ? pincode : '';
      };

      const readSavedPincode = () => {
        const legacyPincode = readPincodeForKey(legacyPincodeStorageKey);
        const cleanPincode = readPincodeForKey(pincodeStorageKey);
        const pincode = legacyPincode || cleanPincode;

        if (pincode && cleanPincode !== pincode) writeStorage(window.localStorage, pincodeStorageKey, pincode);
        if (pincode && legacyPincode !== pincode) {
          writeStorage(window.localStorage, legacyPincodeStorageKey, pincode);
        }
        return pincode;
      };

      const writeSavedPincode = (value) => {
        const pincode = normalizePincode(value);
        const nextPincode = isCompletePincode(pincode) ? pincode : '';
        const previousPincode = readPincodeForKey(legacyPincodeStorageKey) || readPincodeForKey(pincodeStorageKey);

        writeStorage(window.localStorage, pincodeStorageKey, nextPincode);
        writeStorage(window.localStorage, legacyPincodeStorageKey, nextPincode);
        if (!nextPincode || previousPincode !== nextPincode) {
          writeStorage(window.localStorage, legacyPincodeCityStorageKey, '');
        }
        if (previousPincode !== nextPincode) {
          document.dispatchEvent(
            new CustomEvent('clean:delivery-pincode-change', { detail: { pincode: nextPincode } }),
          );
        }
        return nextPincode;
      };

      const setStatus = (message = '', type = '') => {
        status.textContent = message;
        if (type) status.dataset.cleanStatus = type;
        else status.removeAttribute('data-clean-status');
      };

      const getCountryName = (option) =>
        String(option?.label || option?.textContent || option?.value || '')
          .replace(/&amp;/gi, '&')
          .trim();

      const normalizeCountryCode = (value) => {
        const code = String(value || '')
          .trim()
          .toUpperCase();
        return /^[A-Z]{2}$/.test(code) ? code : '';
      };

      const readManualCountry = () => {
        const legacySource = readStorage(window.localStorage, legacyDeliveryCountrySourceKey).toLowerCase();
        if (legacySource === 'auto') {
          writeStorage(window.localStorage, manualCountryStorageKey, '');
          return '';
        }

        const legacyCountry = normalizeCountryCode(readStorage(window.localStorage, legacyDeliveryCountryCodeKey));
        const cleanCountry = normalizeCountryCode(readStorage(window.localStorage, manualCountryStorageKey));
        return legacyCountry || cleanCountry;
      };

      const writeDeliveryCountryBridge = (countryCode, countryName, { source = 'manual' } = {}) => {
        const code = normalizeCountryCode(countryCode);
        const normalizedSource = source === 'auto' ? 'auto' : 'manual';

        if (!code) {
          writeStorage(window.localStorage, manualCountryStorageKey, '');
          writeStorage(window.localStorage, legacyDeliveryCountryCodeKey, '');
          writeStorage(window.localStorage, legacyDeliveryCountryNameKey, '');
          writeStorage(window.localStorage, legacyDeliveryCountrySourceKey, '');
          return;
        }

        writeStorage(window.localStorage, legacyDeliveryCountryCodeKey, code);
        writeStorage(window.localStorage, legacyDeliveryCountryNameKey, String(countryName || code).trim() || code);
        writeStorage(window.localStorage, legacyDeliveryCountrySourceKey, normalizedSource);
        writeStorage(window.localStorage, manualCountryStorageKey, normalizedSource === 'manual' ? code : '');
      };

      const getCountries = () => {
        if (countries) return countries;
        countries = Array.from(countrySelect.options, (option) => ({
          code: option.value,
          name: getCountryName(option),
          flagUrl: option.dataset.cleanCountryFlag || '',
        }));
        return countries;
      };

      const syncCountrySummary = () => {
        const selectedOption = countrySelect.selectedOptions[0];
        const isIndia = countrySelect.value === 'IN';
        const flagUrl = selectedOption?.dataset.cleanCountryFlag || '';

        fields.dataset.cleanCountryIsIndia = String(isIndia);
        summaryCountry.textContent = getCountryName(selectedOption);
        if (flagUrl) summaryFlag.src = flagUrl;
      };

      const syncCountryDetailsVisibility = () => {
        const isIndia = countrySelect.value === 'IN';
        fields.hidden = !isIndia;
        divider.hidden = !isIndia && !countryPickerOpen;
      };

      const syncPincodeField = () => {
        const isIndia = countrySelect.value === 'IN';
        syncCountrySummary();
        pincodeField.hidden = !isIndia;
        pincodeInput.disabled = !isIndia;
        syncCountryDetailsVisibility();
        setStatus();

        if (isIndia) {
          pincodeInput.value = readSavedPincode();
          loadPincodeIndex().catch(() => {});
        } else {
          pincodeInput.value = '';
        }
      };

      const setActiveCountry = (index, shouldScroll = true) => {
        if (!renderedCountryOptions.length) {
          activeCountryIndex = -1;
          countrySearch.removeAttribute('aria-activedescendant');
          return;
        }

        const boundedIndex = Math.min(Math.max(index, 0), renderedCountryOptions.length - 1);
        renderedCountryOptions.forEach((option, optionIndex) => {
          if (optionIndex === boundedIndex) option.dataset.cleanActive = 'true';
          else option.removeAttribute('data-clean-active');
        });
        activeCountryIndex = boundedIndex;
        const activeOption = renderedCountryOptions[boundedIndex];
        countrySearch.setAttribute('aria-activedescendant', activeOption.id);
        if (shouldScroll) activeOption.scrollIntoView({ block: 'nearest' });
      };

      const selectCountry = (countryCode) => {
        if (!countrySelect.querySelector(`option[value="${countryCode}"]`)) return;
        countrySelect.value = countryCode;
        syncPincodeField();
        closeCountryPicker();
        window.requestAnimationFrame(() => {
          if (countryCode === 'IN') pincodeInput.focus();
          else applyButton.focus();
        });
      };

      const createCountryOption = (country) => {
        const option = document.createElement('button');
        const flag = document.createElement('img');
        const name = document.createElement('span');
        const selectedMark = document.createElement('span');
        const selected = country.code === countrySelect.value;

        option.id = `${countryList.id}-option-${country.code}`;
        option.className = 'clean-header__country-option';
        option.type = 'button';
        option.tabIndex = -1;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', String(selected));
        option.dataset.cleanCountryCode = country.code;

        flag.src = country.flagUrl;
        flag.alt = '';
        flag.width = 24;
        flag.height = 24;
        flag.loading = 'lazy';
        flag.decoding = 'async';
        name.textContent = country.name;
        selectedMark.textContent = selected ? '✓' : '';
        selectedMark.setAttribute('aria-hidden', 'true');

        option.append(flag, name, selectedMark);
        return option;
      };

      const appendCountryGroup = (fragment, label, groupCountries) => {
        if (!groupCountries.length) return;
        const group = document.createElement('div');
        const heading = document.createElement('p');
        const headingId = `${countryList.id}-${label.toLowerCase().replace(/\s+/g, '-')}`;

        group.setAttribute('role', 'group');
        group.setAttribute('aria-labelledby', headingId);
        heading.id = headingId;
        heading.className = 'clean-header__country-group-label';
        heading.textContent = label;
        group.append(heading);

        groupCountries.forEach((country) => {
          const option = createCountryOption(country);
          renderedCountryOptions.push(option);
          group.append(option);
        });
        fragment.append(group);
      };

      const renderCountries = () => {
        const query = countrySearch.value.trim().toLocaleLowerCase();
        const fragment = document.createDocumentFragment();
        const countryData = getCountries();
        const matchingCountries = countryData.filter((country) => country.name.toLocaleLowerCase().includes(query));

        countryList.replaceChildren();
        renderedCountryOptions = [];
        activeCountryIndex = -1;

        if (!matchingCountries.length) {
          const message = document.createElement('p');
          message.className = 'clean-header__country-no-results';
          message.textContent = 'No countries found.';
          message.setAttribute('role', 'status');
          countryList.append(message);
          countrySearch.removeAttribute('aria-activedescendant');
          return;
        }

        if (query) {
          appendCountryGroup(fragment, 'Search results', matchingCountries);
        } else {
          const topCountries = topCountryCodes
            .map((code) => countryData.find((country) => country.code === code))
            .filter(Boolean);
          const remainingCountries = countryData.filter((country) => !topCountryCodes.includes(country.code));
          appendCountryGroup(fragment, 'Top countries', topCountries);
          appendCountryGroup(fragment, 'All countries', remainingCountries);
        }

        countryList.append(fragment);
        const selectedIndex = renderedCountryOptions.findIndex(
          (option) => option.dataset.cleanCountryCode === countrySelect.value,
        );
        setActiveCountry(selectedIndex >= 0 ? selectedIndex : 0, false);
      };

      const queueCountryRender = () => {
        if (countrySearchFrame) window.cancelAnimationFrame(countrySearchFrame);
        countrySearchFrame = window.requestAnimationFrame(() => {
          countrySearchFrame = undefined;
          renderCountries();
        });
      };

      const openCountryPicker = (pickerOpener = changeButton) => {
        if (countryPickerOpen) return;
        countryPickerOpen = true;
        countryPickerOpener = pickerOpener;
        countryPicker.hidden = false;
        changeButton.setAttribute('aria-expanded', 'true');
        countryCodeButton.setAttribute('aria-expanded', 'true');
        countrySearch.setAttribute('aria-expanded', 'true');
        syncCountryDetailsVisibility();
        renderCountries();
        window.requestAnimationFrame(() => {
          if (desktopViewport.matches) countrySearch.focus();
          else pickerOpener.focus({ preventScroll: true });
        });
      };

      function closeCountryPicker(restoreFocus = false) {
        if (!countryPickerOpen) return;
        countryPickerOpen = false;
        countryPicker.hidden = true;
        changeButton.setAttribute('aria-expanded', 'false');
        countryCodeButton.setAttribute('aria-expanded', 'false');
        countrySearch.setAttribute('aria-expanded', 'false');
        countrySearch.removeAttribute('aria-activedescendant');
        countrySearch.value = '';
        if (countrySearchFrame) window.cancelAnimationFrame(countrySearchFrame);
        countrySearchFrame = undefined;
        countryList.replaceChildren();
        renderedCountryOptions = [];
        activeCountryIndex = -1;
        syncCountryDetailsVisibility();
        if (restoreFocus) countryPickerOpener?.focus();
        countryPickerOpener = undefined;
      }

      const consumePincodeIndex = () => {
        const payload = window.CleanHeaderPincodeIndex;

        if (!payload || payload.version !== 1 || payload.bitCount !== 1_000_000 || typeof payload.data !== 'string') {
          throw new Error('The Clean header pincode index is invalid.');
        }

        indexBytes = window.atob(payload.data);
        window.CleanHeaderPincodeIndex = undefined;

        if (indexBytes.length * 8 !== payload.bitCount) {
          indexBytes = '';
          throw new Error('The Clean header pincode index size is invalid.');
        }

        return indexBytes;
      };

      function loadPincodeIndex() {
        if (indexBytes) return Promise.resolve(indexBytes);
        if (indexRequest) return indexRequest;

        if (window.CleanHeaderPincodeIndex) {
          try {
            return Promise.resolve(consumePincodeIndex());
          } catch (error) {
            window.CleanHeaderPincodeIndex = undefined;
          }
        }

        indexRequest = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = root.dataset.cleanPincodeIndexUrl;
          script.async = true;
          script.dataset.cleanHeaderPincodeIndexLoader = 'true';
          script.addEventListener('load', () => {
            try {
              resolve(consumePincodeIndex());
            } catch (error) {
              reject(error);
            }
          });
          script.addEventListener('error', () => reject(new Error('The pincode index could not be loaded.')));
          document.head.append(script);
        }).catch((error) => {
          indexRequest = undefined;
          document.querySelector('[data-clean-header-pincode-index-loader]')?.remove();
          throw error;
        });

        return indexRequest;
      }

      const isKnownPincode = (pincode) => {
        if (!indexBytes || !isCompletePincode(pincode)) return false;
        const numericPincode = Number(pincode);
        const byte = indexBytes.charCodeAt(numericPincode >> 3);
        return Boolean(byte & (1 << (numericPincode & 7)));
      };

      const updateTrigger = (validatedPincode = '') => {
        const savedPincode = currentCountry === 'IN' ? validatedPincode || readSavedPincode() : '';
        const selectedOption = countrySelect.querySelector(`option[value="${currentCountry}"]`);
        const countryName = getCountryName(selectedOption) || currentCountry;

        triggerValue.textContent = savedPincode || currentCountry;
        triggerMobileValue.textContent = savedPincode || countryName;
        trigger.setAttribute(
          'aria-label',
          savedPincode
            ? `Delivery location ${savedPincode}, India. Change delivery location.`
            : `Delivery country ${countryName}. Change delivery location.`,
        );
      };

      const prepareLocalizationSubmit = () => {
        const isLocalPreview = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
        if (!isLocalPreview) return;

        const localizationUrl = new URL(root.dataset.cleanLocalizationUrl);
        const returnToInput = form.elements.namedItem('return_to');
        const returnToUrl = new URL(
          returnToInput instanceof HTMLInputElement ? returnToInput.value : window.location.href,
          window.location.origin,
        );
        const previewThemeId = String(window.Shopify?.theme?.id || '');

        if (localizationUrl.protocol === 'https:') form.action = localizationUrl.href;
        if (returnToInput instanceof HTMLInputElement) {
          if (/^\d+$/.test(previewThemeId)) returnToUrl.searchParams.set('preview_theme_id', previewThemeId);
          returnToInput.value = `${returnToUrl.pathname}${returnToUrl.search}`;
        }
      };

      const submitLocalization = () => {
        prepareLocalizationSubmit();
        HTMLFormElement.prototype.submit.call(form);
      };

      const finishDialogClose = () => {
        if (drawerCloseTimer) window.clearTimeout(drawerCloseTimer);
        drawerCloseTimer = undefined;
        if (drawerAnimationEndHandler) dialog.removeEventListener('animationend', drawerAnimationEndHandler);
        drawerAnimationEndHandler = undefined;
        delete dialog.dataset.cleanDrawerClosing;
        if (dialog.open && typeof dialog.close === 'function') dialog.close();
      };

      const closeDialog = () => {
        if (!dialog.open || dialog.dataset.cleanDrawerClosing === 'true') return;
        if (desktopViewport.matches || reducedMotion.matches) {
          finishDialogClose();
          return;
        }

        dialog.dataset.cleanDrawerClosing = 'true';
        drawerAnimationEndHandler = (event) => {
          if (event.target === dialog && event.animationName === 'clean-bottom-drawer-exit') finishDialogClose();
        };
        dialog.addEventListener('animationend', drawerAnimationEndHandler);
        drawerCloseTimer = window.setTimeout(finishDialogClose, 240);
      };

      const positionDialog = () => {
        if (!dialog.open) return;

        const viewportWidth = document.documentElement.clientWidth;
        const visualViewport = window.visualViewport;
        const viewportHeight = visualViewport?.height || window.innerHeight;
        const gutter = 16;

        if (!desktopViewport.matches) {
          const viewportOffsetTop = visualViewport?.offsetTop || 0;
          const keyboardInset = Math.max(0, window.innerHeight - viewportHeight - viewportOffsetTop);
          dialog.style.setProperty('--clean-delivery-drawer-bottom', `${keyboardInset}px`);
          dialog.style.maxHeight = `${Math.max(160, viewportHeight - gutter)}px`;
          return;
        }

        const triggerRect = trigger.getBoundingClientRect();
        const gap = 12;
        const dialogWidth = Math.min(384, viewportWidth - gutter * 2);
        const triggerCenter = triggerRect.left + triggerRect.width / 2;
        const left = Math.min(Math.max(gutter, triggerCenter - dialogWidth / 2), viewportWidth - dialogWidth - gutter);
        const top = triggerRect.bottom + gap;
        const tooltipLeft = Math.min(Math.max(24, triggerCenter - left), dialogWidth - 24);

        dialog.style.setProperty('--clean-delivery-dialog-top', `${top}px`);
        dialog.style.setProperty('--clean-delivery-dialog-left', `${left}px`);
        dialog.style.setProperty('--clean-delivery-tooltip-left', `${tooltipLeft}px`);
        dialog.style.maxHeight = `${Math.max(160, viewportHeight - top - gutter)}px`;
      };

      const keepDialogFocusVisible = () => {
        if (desktopViewport.matches || !dialog.open) return;

        const activeElement = document.activeElement;
        if (!(activeElement instanceof HTMLElement) || !dialog.contains(activeElement)) return;

        const visualViewport = window.visualViewport;
        const viewportTop = visualViewport?.offsetTop || 0;
        const viewportBottom = viewportTop + (visualViewport?.height || window.innerHeight);
        const focusRect = activeElement.getBoundingClientRect();
        const focusGutter = 16;

        if (focusRect.top < viewportTop + focusGutter || focusRect.bottom > viewportBottom - focusGutter) {
          activeElement.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }
      };

      const queueDialogPosition = () => {
        if (dialogPositionFrame) window.cancelAnimationFrame(dialogPositionFrame);
        dialogPositionFrame = window.requestAnimationFrame(() => {
          dialogPositionFrame = undefined;
          positionDialog();
          keepDialogFocusVisible();
        });
      };

      const startDialogPositioning = () => {
        queueDialogPosition();
        window.addEventListener('resize', queueDialogPosition, { passive: true });
        window.visualViewport?.addEventListener('resize', queueDialogPosition, { passive: true });
        window.visualViewport?.addEventListener('scroll', queueDialogPosition, { passive: true });
        dialog.addEventListener('focusin', queueDialogPosition);
      };

      const stopDialogPositioning = () => {
        window.removeEventListener('resize', queueDialogPosition);
        window.visualViewport?.removeEventListener('resize', queueDialogPosition);
        window.visualViewport?.removeEventListener('scroll', queueDialogPosition);
        dialog.removeEventListener('focusin', queueDialogPosition);
        if (dialogPositionFrame) window.cancelAnimationFrame(dialogPositionFrame);
        dialogPositionFrame = undefined;
        dialog.style.removeProperty('--clean-delivery-drawer-bottom');
        dialog.style.removeProperty('--clean-delivery-dialog-top');
        dialog.style.removeProperty('--clean-delivery-dialog-left');
        dialog.style.removeProperty('--clean-delivery-tooltip-left');
        dialog.style.removeProperty('max-height');
      };

      const openDialog = ({ focusField = true } = {}) => {
        opener = document.activeElement;
        if (drawerCloseTimer) window.clearTimeout(drawerCloseTimer);
        drawerCloseTimer = undefined;
        delete dialog.dataset.cleanDrawerClosing;
        countrySelect.value = currentCountry;
        closeCountryPicker();
        syncPincodeField();
        if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        startDialogPositioning();
        document.body.classList.add('clean-header-delivery-open');
        window.requestAnimationFrame(() => {
          if (focusField && currentCountry === 'IN') pincodeInput.focus();
          else changeButton.focus();
        });
      };

      const scheduleMissingIndiaPincodeDialog = () => {
        if (
          root.dataset.cleanDesignMode === 'true' ||
          currentCountry !== 'IN' ||
          readSavedPincode() ||
          readStorage(window.localStorage, deliveryPromptSeenStorageKey) === 'true'
        ) {
          return;
        }

        const remainingDelay = Math.max(0, 2000 - (Date.now() - initializedAt));
        window.setTimeout(() => {
          if (
            currentCountry === 'IN' &&
            !readSavedPincode() &&
            readStorage(window.localStorage, deliveryPromptSeenStorageKey) !== 'true' &&
            !dialog.open
          ) {
            openDialog({ focusField: false });
            if (dialog.open) writeStorage(window.localStorage, deliveryPromptSeenStorageKey, 'true');
          }
        }, remainingDelay);
      };

      const detectVisitorCountry = async () => {
        if (root.dataset.cleanDesignMode === 'true') return false;

        const detectedThisSession = normalizeCountryCode(
          readStorage(window.sessionStorage, legacyVisitorCountrySessionKey) ||
            readStorage(window.sessionStorage, detectedCountrySessionKey),
        );
        if (detectedThisSession) {
          const detectedOption = countrySelect.querySelector(`option[value="${detectedThisSession}"]`);
          writeStorage(window.sessionStorage, detectedCountrySessionKey, detectedThisSession);
          writeStorage(window.sessionStorage, legacyVisitorCountrySessionKey, detectedThisSession);
          if (detectedOption) {
            writeStorage(window.sessionStorage, legacyVisitorNameSessionKey, getCountryName(detectedOption));
          }
        }

        const manualCountry = readManualCountry();
        let hasManualCountry = false;
        if (manualCountry) {
          const manualOption = countrySelect.querySelector(`option[value="${manualCountry}"]`);
          if (!manualOption) {
            writeDeliveryCountryBridge('', '');
          } else {
            hasManualCountry = true;
            writeDeliveryCountryBridge(manualCountry, getCountryName(manualOption));
            if (manualCountry === currentCountry && detectedThisSession) return false;

            if (manualCountry !== currentCountry) {
              const bridgeAttempt = `${currentCountry}:${manualCountry}`;
              if (readStorage(window.sessionStorage, countryBridgeAttemptSessionKey) === bridgeAttempt) return false;
              writeStorage(window.sessionStorage, countryBridgeAttemptSessionKey, bridgeAttempt);
              countrySelect.value = manualCountry;
              submitLocalization();
              return true;
            }
          }
        }

        if (detectedThisSession) return false;

        try {
          const discoveryUrl = new URL(root.dataset.cleanLocalizationDiscoveryUrl, window.location.origin);
          discoveryUrl.searchParams.set('country[enabled]', 'true');
          discoveryUrl.searchParams.set('country[exclude]', currentCountry);

          const response = await fetch(discoveryUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
          });
          if (!response.ok) throw new Error(`Localization discovery failed: ${response.status}`);

          const payload = await response.json();
          const detectedCountry = String(payload?.detected_values?.country?.handle || '').toUpperCase();
          const visitorCountry = detectedCountry || currentCountry;
          const visitorOption = countrySelect.querySelector(`option[value="${visitorCountry}"]`);
          writeStorage(window.sessionStorage, detectedCountrySessionKey, visitorCountry);
          writeStorage(window.sessionStorage, legacyVisitorCountrySessionKey, visitorCountry);
          writeStorage(
            window.sessionStorage,
            legacyVisitorNameSessionKey,
            getCountryName(visitorOption) || visitorCountry,
          );
          document.dispatchEvent(
            new CustomEvent('clean:visitor-country-detected', { detail: { country: visitorCountry } }),
          );

          if (hasManualCountry) return false;
          if (!detectedCountry || detectedCountry === currentCountry) return false;
          const detectedOption = countrySelect.querySelector(`option[value="${detectedCountry}"]`);
          if (!detectedOption) return false;

          writeDeliveryCountryBridge(detectedCountry, getCountryName(detectedOption), { source: 'auto' });
          countrySelect.value = detectedCountry;
          submitLocalization();
          return true;
        } catch (error) {
          writeStorage(window.sessionStorage, detectedCountrySessionKey, currentCountry);
          writeStorage(window.sessionStorage, legacyVisitorCountrySessionKey, currentCountry);
          writeStorage(
            window.sessionStorage,
            legacyVisitorNameSessionKey,
            getCountryName(countrySelect.querySelector(`option[value="${currentCountry}"]`)) || currentCountry,
          );
          document.dispatchEvent(
            new CustomEvent('clean:visitor-country-detected', { detail: { country: currentCountry } }),
          );
          return false;
        }
      };

      trigger.addEventListener(
        'pointerenter',
        () => {
          if (currentCountry === 'IN') loadPincodeIndex().catch(() => {});
        },
        { once: true, passive: true },
      );
      trigger.addEventListener(
        'focus',
        () => {
          if (currentCountry === 'IN') loadPincodeIndex().catch(() => {});
        },
        { once: true },
      );
      trigger.addEventListener('click', () => openDialog());
      closeButton.addEventListener('click', closeDialog);
      changeButton.addEventListener('click', () => {
        if (countryPickerOpen) closeCountryPicker();
        else openCountryPicker(changeButton);
      });
      countryCodeButton.addEventListener('click', () => {
        if (countryPickerOpen) closeCountryPicker();
        else openCountryPicker(countryCodeButton);
      });
      countrySearch.addEventListener('input', queueCountryRender);
      countrySearch.addEventListener('keydown', (event) => {
        if (countrySearchFrame) {
          window.cancelAnimationFrame(countrySearchFrame);
          countrySearchFrame = undefined;
          renderCountries();
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setActiveCountry(activeCountryIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          setActiveCountry(activeCountryIndex <= 0 ? renderedCountryOptions.length - 1 : activeCountryIndex - 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          setActiveCountry(0);
        } else if (event.key === 'End') {
          event.preventDefault();
          setActiveCountry(renderedCountryOptions.length - 1);
        } else if (event.key === 'Enter' && activeCountryIndex >= 0) {
          event.preventDefault();
          selectCountry(renderedCountryOptions[activeCountryIndex].dataset.cleanCountryCode);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          closeCountryPicker(true);
        }
      });
      countryList.addEventListener('click', (event) => {
        const option = event.target instanceof Element ? event.target.closest('[data-clean-country-code]') : null;
        if (option instanceof HTMLButtonElement && countryList.contains(option)) {
          selectCountry(option.dataset.cleanCountryCode);
        }
      });
      countryList.addEventListener('pointerover', (event) => {
        const option = event.target instanceof Element ? event.target.closest('[data-clean-country-code]') : null;
        if (!(option instanceof HTMLButtonElement) || !countryList.contains(option)) return;
        const index = renderedCountryOptions.indexOf(option);
        if (index >= 0) setActiveCountry(index, false);
      });
      pincodeInput.addEventListener('input', () => {
        pincodeInput.value = normalizePincode(pincodeInput.value);
        setStatus();
      });
      pincodeInput.addEventListener('focus', () => loadPincodeIndex().catch(() => {}), { once: true });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const selectedCountry = countrySelect.value;
        const selectedOption = countrySelect.selectedOptions[0];
        const selectedCountryName = getCountryName(selectedOption) || selectedCountry;

        applyButton.disabled = true;

        if (selectedCountry === 'IN') {
          const pincode = normalizePincode(pincodeInput.value);
          pincodeInput.value = pincode;

          if (!isCompletePincode(pincode)) {
            setStatus('Enter a six-digit Indian pincode.', 'error');
            applyButton.disabled = false;
            pincodeInput.focus();
            return;
          }

          setStatus('Checking pincode…');
          try {
            await loadPincodeIndex();
          } catch (error) {
            setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
            applyButton.disabled = false;
            return;
          }

          if (!isKnownPincode(pincode)) {
            setStatus('Enter a valid Indian pincode.', 'error');
            applyButton.disabled = false;
            pincodeInput.focus();
            return;
          }

          writeSavedPincode(pincode);
        } else {
          writeSavedPincode('');
        }

        writeDeliveryCountryBridge(selectedCountry, selectedCountryName);
        writeStorage(window.localStorage, deliveryPromptSeenStorageKey, 'true');

        if (selectedCountry !== currentCountry) {
          setStatus(`Loading prices for ${selectedCountryName}…`);
          submitLocalization();
          return;
        }

        updateTrigger();
        setStatus(
          selectedCountry === 'IN' ? 'Delivery pincode saved.' : `Delivery country set to ${selectedCountryName}.`,
        );
        window.setTimeout(closeDialog, 300);
        applyButton.disabled = false;
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });
      dialog.addEventListener('cancel', (event) => {
        if (!desktopViewport.matches && !reducedMotion.matches) {
          event.preventDefault();
          closeDialog();
        }
      });
      dialog.addEventListener('close', () => {
        writeStorage(window.localStorage, deliveryPromptSeenStorageKey, 'true');
        if (drawerCloseTimer) window.clearTimeout(drawerCloseTimer);
        drawerCloseTimer = undefined;
        if (drawerAnimationEndHandler) dialog.removeEventListener('animationend', drawerAnimationEndHandler);
        drawerAnimationEndHandler = undefined;
        delete dialog.dataset.cleanDrawerClosing;
        stopDialogPositioning();
        closeCountryPicker();
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('clean-header-delivery-open');
        opener?.focus();
        setStatus();
      });

      document.addEventListener('clean:product-delivery-pincode-validated', (event) => {
        const pincode = String(event.detail?.pincode || '');
        if (currentCountry !== 'IN' || !/^[1-9]\d{5}$/.test(pincode)) return;
        updateTrigger(pincode);
        if (dialog.open && countrySelect.value === 'IN') pincodeInput.value = pincode;
      });

      window.addEventListener('storage', (event) => {
        const pincodeKeys = [pincodeStorageKey, legacyPincodeStorageKey, legacyPincodeCityStorageKey];
        const countryKeys = [
          manualCountryStorageKey,
          legacyDeliveryCountryCodeKey,
          legacyDeliveryCountryNameKey,
          legacyDeliveryCountrySourceKey,
        ];
        if (![...pincodeKeys, ...countryKeys].includes(event.key)) return;

        window.clearTimeout(bridgeStorageTimer);
        bridgeStorageTimer = window.setTimeout(() => {
          updateTrigger();
          if (dialog.open && countrySelect.value === 'IN') pincodeInput.value = readSavedPincode();

          const manualCountry = readManualCountry();
          const option = countrySelect.querySelector(`option[value="${manualCountry}"]`);
          if (manualCountry && manualCountry !== currentCountry && option) {
            const bridgeAttempt = `${currentCountry}:${manualCountry}`;
            if (readStorage(window.sessionStorage, countryBridgeAttemptSessionKey) !== bridgeAttempt) {
              writeStorage(window.sessionStorage, countryBridgeAttemptSessionKey, bridgeAttempt);
              countrySelect.value = manualCountry;
              submitLocalization();
              return;
            }
          }
        });
      });

      window.addEventListener('pageshow', (event) => {
        const manualCountry = readManualCountry();
        if (event.persisted && manualCountry && manualCountry !== currentCountry) {
          window.location.reload();
          return;
        }
        updateTrigger();
        if (dialog.open && countrySelect.value === 'IN') pincodeInput.value = readSavedPincode();
      });

      updateTrigger();
      detectVisitorCountry().then((localizationChanging) => {
        if (!localizationChanging) scheduleMissingIndiaPincodeDialog();
      });
    });

    const currencyRoots = document.querySelectorAll('[data-clean-currency]');
    const currencyRoot = currencyRoots[0];

    if (currencyRoot && currencyRoot.dataset.cleanCurrencyBound !== 'true') {
      currencyRoot.dataset.cleanCurrencyBound = 'true';
      const supportedCurrencies = new Set(['INR', 'PKR', 'GBP', 'USD', 'AED', 'AUD', 'SAR', 'CAD', 'EUR']);
      const currencySymbols = {
        INR: '₹',
        PKR: 'PKR',
        GBP: '£',
        USD: '$',
        AED: 'AED',
        AUD: 'AUD',
        SAR: 'SAR',
        CAD: 'CAD',
        EUR: '€',
      };
      const representativeCountries = {
        INR: 'IN',
        PKR: 'PK',
        GBP: 'GB',
        USD: 'US',
        AED: 'AE',
        AUD: 'AU',
        SAR: 'SA',
        CAD: 'CA',
        EUR: 'EU',
      };
      const euroCountries = new Set([
        'AT',
        'BE',
        'BG',
        'HR',
        'CY',
        'CZ',
        'DK',
        'EE',
        'FI',
        'FR',
        'DE',
        'GR',
        'HU',
        'IE',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'ES',
        'SE',
      ]);
      const cleanStorageKey = 'clean:display-currency:v1';
      const legacyCurrencyKey = 'hadiyah_display_currency';
      const legacyCountryKey = 'hadiyah_display_country';
      const sourceCurrency = String(currencyRoot.dataset.cleanCurrencySource || 'INR').toUpperCase();
      const currencyForCountry = (country) => {
        const code = String(country || '').toUpperCase();
        if (euroCountries.has(code)) return 'EUR';
        return (
          {
            IN: 'INR',
            PK: 'PKR',
            GB: 'GBP',
            AE: 'AED',
            AU: 'AUD',
            SA: 'SAR',
            CA: 'CAD',
          }[code] || 'USD'
        );
      };
      const detectedVisitorCountry = (() => {
        try {
          const code = String(
            window.sessionStorage.getItem('hadiyah:visitor-country-code') ||
              window.sessionStorage.getItem('clean:delivery-country-detected:v1') ||
              currencyRoot.dataset.cleanCurrencyCountry ||
              'IN',
          ).toUpperCase();
          return /^[A-Z]{2}$/.test(code) ? code : 'IN';
        } catch (error) {
          return String(currencyRoot.dataset.cleanCurrencyCountry || 'IN').toUpperCase();
        }
      })();
      const autoPreference = {
        version: 1,
        currency: currencyForCountry(detectedVisitorCountry),
        country: detectedVisitorCountry,
        explicit: false,
      };
      let memoryPreference;
      let controllerRequest;

      const validPreference = (value) =>
        value &&
        value.version === 1 &&
        supportedCurrencies.has(String(value.currency || '').toUpperCase()) &&
        /^[A-Z]{2}$/.test(String(value.country || '').toUpperCase());

      const readPreference = () => {
        try {
          const cleanPreference = JSON.parse(window.localStorage.getItem(cleanStorageKey) || 'null');
          const normalizedCleanPreference = validPreference(cleanPreference)
            ? {
                version: 1,
                currency: cleanPreference.currency.toUpperCase(),
                country: cleanPreference.country.toUpperCase(),
                explicit: Boolean(cleanPreference.explicit),
              }
            : undefined;

          const legacyCurrency = String(window.localStorage.getItem(legacyCurrencyKey) || '').toUpperCase();
          if (supportedCurrencies.has(legacyCurrency)) {
            const legacyCountry = String(
              window.localStorage.getItem(legacyCountryKey) || representativeCountries[legacyCurrency],
            ).toUpperCase();
            if (
              !normalizedCleanPreference ||
              normalizedCleanPreference.currency !== legacyCurrency ||
              normalizedCleanPreference.country !== legacyCountry
            ) {
              return { version: 1, currency: legacyCurrency, country: legacyCountry, explicit: true };
            }
          }

          if (normalizedCleanPreference?.explicit) {
            window.localStorage.removeItem(cleanStorageKey);
            return autoPreference;
          }

          if (normalizedCleanPreference) return normalizedCleanPreference;
        } catch (error) {}

        return validPreference(memoryPreference) ? memoryPreference : autoPreference;
      };

      const syncBootstrap = (preference, actualCurrency = preference.currency) => {
        memoryPreference = preference;
        currencyRoots.forEach((root) => {
          root.dataset.cleanCurrencyCurrent = actualCurrency;
          const symbol = root.querySelector('[data-clean-currency-trigger-symbol]');
          const code = root.querySelector('[data-clean-currency-trigger-code]');
          const trigger = root.querySelector('[data-clean-currency-trigger]');
          const label = root.querySelector('[data-clean-currency-label]');
          const autoOption = root.querySelector('[data-clean-currency-auto-option]');
          if (symbol) symbol.textContent = currencySymbols[actualCurrency] || actualCurrency;
          if (code) code.textContent = actualCurrency;
          if (label) label.textContent = `Display Currency: ${actualCurrency}`;
          if (trigger) {
            trigger.setAttribute('aria-label', `Display currency, ${actualCurrency}.`);
          }
          autoOption?.setAttribute('aria-selected', String(!preference.explicit));
          root.querySelectorAll('[data-clean-currency-option]').forEach((option) => {
            option.setAttribute(
              'aria-selected',
              String(preference.explicit && option.dataset.cleanCurrencyCode === preference.currency),
            );
          });
        });
      };

      const loadController = () => {
        if (window.CleanDisplayCurrency?.ready) return Promise.resolve(window.CleanDisplayCurrency);
        if (controllerRequest) return controllerRequest;

        controllerRequest = new Promise((resolve, reject) => {
          const existing = document.querySelector('[data-clean-display-currency-controller]');
          const script = existing || document.createElement('script');
          const finish = () => {
            if (window.CleanDisplayCurrency?.ready) resolve(window.CleanDisplayCurrency);
            else reject(new Error('The display-currency controller did not initialize.'));
          };
          script.addEventListener('load', finish, { once: true });
          script.addEventListener('error', () => reject(new Error('The display-currency controller could not load.')), {
            once: true,
          });

          if (!existing) {
            script.src = currencyRoot.dataset.cleanCurrencyControllerUrl;
            script.async = true;
            script.dataset.cleanDisplayCurrencyController = 'true';
            document.head.append(script);
          }
        }).catch((error) => {
          controllerRequest = undefined;
          document.querySelector('[data-clean-display-currency-controller]')?.remove();
          throw error;
        });

        return controllerRequest;
      };

      const initialPreference = readPreference();
      syncBootstrap(
        initialPreference,
        initialPreference.currency === sourceCurrency ? initialPreference.currency : sourceCurrency,
      );
      window.CleanDisplayCurrencyBootstrap = {
        autoPreference,
        getPreference: readPreference,
        load: loadController,
        refresh: (root = document) => {
          if (window.CleanDisplayCurrency?.ready) {
            window.CleanDisplayCurrency.refresh(root);
            return;
          }
          if (readPreference().currency !== sourceCurrency) {
            loadController()
              .then((controller) => controller?.refresh(root))
              .catch(() => {});
          }
        },
        sourceCurrency,
        sync: syncBootstrap,
      };

      document.addEventListener('clean:visitor-country-detected', (event) => {
        const country = String(event.detail?.country || '').toUpperCase();
        if (!/^[A-Z]{2}$/.test(country)) return;

        autoPreference.country = country;
        autoPreference.currency = currencyForCountry(country);
        const currentPreference = readPreference();
        if (currentPreference.explicit) return;

        if (window.CleanDisplayCurrency?.ready) {
          window.CleanDisplayCurrency.applyPreference(autoPreference);
          return;
        }

        syncBootstrap(
          autoPreference,
          autoPreference.currency === sourceCurrency ? autoPreference.currency : sourceCurrency,
        );
        if (autoPreference.currency !== sourceCurrency) loadController().catch(() => {});
      });

      currencyRoots.forEach((root) => {
        const trigger = root.querySelector('[data-clean-currency-trigger]');
        if (!trigger) return;
        const loadOnIntent = () => loadController().catch(() => {});
        root.addEventListener('pointerenter', loadOnIntent, { once: true, passive: true });
        trigger.addEventListener('focus', loadOnIntent, { once: true });
        trigger.addEventListener('click', (event) => {
          if (window.CleanDisplayCurrency?.ready) return;
          event.preventDefault();
          loadController()
            .then((controller) => controller?.open(root))
            .catch(() => {});
        });
      });

      window.addEventListener('storage', (event) => {
        if (![cleanStorageKey, legacyCurrencyKey, legacyCountryKey].includes(event.key)) return;
        window.setTimeout(() => {
          const nextPreference = readPreference();
          if (window.CleanDisplayCurrency?.ready) {
            window.CleanDisplayCurrency.applyPreference(nextPreference);
            return;
          }
          syncBootstrap(
            nextPreference,
            nextPreference.currency === sourceCurrency ? nextPreference.currency : sourceCurrency,
          );
          if (nextPreference.currency !== sourceCurrency) loadController().catch(() => {});
        });
      });

      if (initialPreference.currency !== sourceCurrency) loadController().catch(() => {});
    }

    const searchRoots = document.querySelectorAll('[data-clean-search]');

    searchRoots.forEach((root) => {
      if (root.dataset.cleanSearchBound === 'true') return;
      root.dataset.cleanSearchBound = 'true';

      const form = root.querySelector('form');
      const input = root.querySelector('input[type="search"]');
      const panel = root.querySelector('[data-clean-search-panel]');
      const heading = root.querySelector('[data-clean-search-heading]');
      const results = root.querySelector('[data-clean-search-results]');
      const clearButton = root.querySelector('[data-clean-search-clear]');
      const viewAll = root.querySelector('[data-clean-search-view-all]');

      if (!form || !input || !panel || !heading || !results || !clearButton || !viewAll) return;

      const placeholderPrefix = String(input.dataset.cleanSearchPlaceholderPrefix || 'Search for').trim();
      const placeholderTerms = String(input.dataset.cleanSearchPlaceholderTerms || '')
        .split('|')
        .map((term) => term.trim())
        .filter(Boolean);
      const placeholderReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const placeholderDesktop = window.matchMedia('(min-width: 990px)');
      const placeholderTypeDelay = 90;
      const placeholderHoldDelay = 1600;
      const placeholderDeleteDelay = 45;
      const placeholderBetweenTermsDelay = 300;
      let placeholderTermIndex = 0;
      let placeholderCharacterIndex = placeholderTerms[0]?.length || 0;
      let placeholderTimer;

      const placeholderText = (term = '') => `${placeholderPrefix}${term ? ` ${term}` : ''}`;
      const stopPlaceholderRotation = () => {
        window.clearTimeout(placeholderTimer);
        placeholderTimer = undefined;
      };
      const canRotatePlaceholder = () =>
        placeholderTerms.length > 0 &&
        placeholderDesktop.matches &&
        !placeholderReducedMotion.matches &&
        !document.hidden &&
        document.activeElement !== input &&
        !input.value &&
        root.isConnected;
      const schedulePlaceholder = (callback, delay) => {
        stopPlaceholderRotation();
        if (canRotatePlaceholder()) placeholderTimer = window.setTimeout(callback, delay);
      };

      const typePlaceholder = () => {
        if (!canRotatePlaceholder()) return;

        const term = placeholderTerms[placeholderTermIndex];
        placeholderCharacterIndex += 1;
        input.placeholder = placeholderText(term.slice(0, placeholderCharacterIndex));
        schedulePlaceholder(
          placeholderCharacterIndex >= term.length ? erasePlaceholder : typePlaceholder,
          placeholderCharacterIndex >= term.length ? placeholderHoldDelay : placeholderTypeDelay,
        );
      };

      const erasePlaceholder = () => {
        if (!canRotatePlaceholder()) return;

        const term = placeholderTerms[placeholderTermIndex];
        placeholderCharacterIndex = Math.max(0, placeholderCharacterIndex - 1);
        input.placeholder = placeholderText(term.slice(0, placeholderCharacterIndex));

        if (placeholderCharacterIndex === 0) {
          placeholderTermIndex = (placeholderTermIndex + 1) % placeholderTerms.length;
          schedulePlaceholder(typePlaceholder, placeholderBetweenTermsDelay);
          return;
        }

        schedulePlaceholder(erasePlaceholder, placeholderDeleteDelay);
      };

      const restartPlaceholderRotation = () => {
        stopPlaceholderRotation();
        if (!placeholderTerms.length) return;

        if (placeholderReducedMotion.matches) placeholderTermIndex = 0;

        if (document.activeElement === input || input.value) {
          input.placeholder = placeholderText();
          return;
        }

        placeholderCharacterIndex = placeholderTerms[placeholderTermIndex].length;
        input.placeholder = placeholderText(placeholderTerms[placeholderTermIndex]);
        schedulePlaceholder(erasePlaceholder, placeholderHoldDelay);
      };

      input.addEventListener('focus', () => {
        stopPlaceholderRotation();
        input.placeholder = placeholderText();
      });
      input.addEventListener('blur', restartPlaceholderRotation);
      input.addEventListener('input', () => {
        if (input.value) stopPlaceholderRotation();
      });
      document.addEventListener('visibilitychange', restartPlaceholderRotation);
      window.addEventListener('pageshow', restartPlaceholderRotation);
      placeholderDesktop.addEventListener?.('change', restartPlaceholderRotation);
      placeholderReducedMotion.addEventListener?.('change', restartPlaceholderRotation);
      restartPlaceholderRotation();

      let initialized = false;
      let searchAbortController;
      let searchTimeout;
      let requestSequence = 0;
      let popularMarkup = '';
      let popularRequest;
      const searchCache = new Map();

      const updateClearButton = () => {
        clearButton.hidden = input.value.length === 0;
      };

      const setOpen = (open) => {
        panel.hidden = !open;
        input.setAttribute('aria-expanded', String(open));
      };

      const cancelSearchRequest = () => {
        requestSequence += 1;
        window.clearTimeout(searchTimeout);
        searchAbortController?.abort();
        searchAbortController = undefined;
        results.setAttribute('aria-busy', 'false');
      };

      const closeSearch = () => {
        cancelSearchRequest();
        setOpen(false);
      };

      const responseMarkup = (text) => {
        const responseDocument = new DOMParser().parseFromString(text, 'text/html');
        const response = responseDocument.querySelector('[data-clean-search-response]');
        if (!response) throw new Error('Search response markup was missing.');
        return response.innerHTML;
      };

      const fetchMarkup = async (url, signal) => {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html',
            'X-Requested-With': 'XMLHttpRequest',
          },
          signal,
        });

        if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
        return responseMarkup(await response.text());
      };

      const popularSearchMarkup = () => {
        if (popularMarkup) return Promise.resolve(popularMarkup);
        if (popularRequest) return popularRequest;

        const url = new URL(root.dataset.cleanPopularSearchUrl, window.location.origin);
        url.searchParams.set('section_id', 'clean-header-popular-search-results');

        popularRequest = fetchMarkup(url)
          .then((markup) => {
            popularMarkup = markup;
            return markup;
          })
          .catch(() => {
            popularMarkup = '<p class="clean-header__search-message">Unable to load popular products.</p>';
            return popularMarkup;
          })
          .finally(() => {
            popularRequest = undefined;
          });

        return popularRequest;
      };

      const showPopularProducts = async () => {
        cancelSearchRequest();
        const requestId = requestSequence;

        heading.textContent = 'Popular products';
        viewAll.hidden = true;
        results.setAttribute('aria-busy', 'true');
        results.innerHTML = '<p class="clean-header__search-message">Loading popular products…</p>';
        setOpen(true);

        const markup = await popularSearchMarkup();
        if (requestId !== requestSequence || input.value.trim()) return;

        results.innerHTML = markup;
        window.CleanDisplayCurrencyBootstrap?.refresh(results);
        results.setAttribute('aria-busy', 'false');
      };

      const showProductResults = (query, markup) => {
        heading.textContent = 'Product results';
        results.innerHTML = markup;
        window.CleanDisplayCurrencyBootstrap?.refresh(results);
        results.setAttribute('aria-busy', 'false');

        const searchUrl = new URL(form.action, window.location.origin);
        searchUrl.searchParams.set('q', query);
        searchUrl.searchParams.set('type', 'product');
        viewAll.href = searchUrl.toString();
        viewAll.hidden = false;
        setOpen(true);
      };

      const loadProductResults = (query) => {
        const normalizedQuery = query.toLocaleLowerCase();
        const cachedMarkup = searchCache.get(normalizedQuery);

        cancelSearchRequest();

        if (cachedMarkup) {
          showProductResults(query, cachedMarkup);
          return;
        }

        heading.textContent = 'Product results';
        viewAll.hidden = true;
        results.setAttribute('aria-busy', 'true');
        results.innerHTML = '<p class="clean-header__search-message">Searching…</p>';
        setOpen(true);

        const requestId = requestSequence;
        searchTimeout = window.setTimeout(async () => {
          searchAbortController = new AbortController();

          const url = new URL(root.dataset.cleanPredictiveSearchUrl, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('section_id', 'clean-header-search-results');

          try {
            const markup = await fetchMarkup(url, searchAbortController.signal);
            searchCache.set(normalizedQuery, markup);

            if (requestId === requestSequence && input.value.trim().toLocaleLowerCase() === normalizedQuery) {
              showProductResults(input.value.trim(), markup);
            }
          } catch (error) {
            if (error?.name !== 'AbortError' && requestId === requestSequence) {
              results.innerHTML = '<p class="clean-header__search-message">Unable to load products.</p>';
              results.setAttribute('aria-busy', 'false');
            }
          } finally {
            if (requestId === requestSequence) searchAbortController = undefined;
          }
        }, 300);
      };

      const handleSearchIntent = () => {
        updateClearButton();
        const query = input.value.trim();

        if (query) {
          loadProductResults(query);
        } else {
          showPopularProducts();
        }
      };

      const handleSearchSubmit = (event) => {
        if (!input.value.trim()) {
          event.preventDefault();
          showPopularProducts();
          return;
        }

        closeSearch();
      };

      const searchOptions = () => Array.from(results.querySelectorAll('[data-clean-search-option]'));

      const handleInputKeydown = (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          closeSearch();
          return;
        }

        if (event.key !== 'ArrowDown' || panel.hidden) return;
        const firstOption = searchOptions()[0];
        if (!firstOption) return;
        event.preventDefault();
        firstOption.focus();
      };

      const handlePanelKeydown = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeSearch();
          input.focus();
          return;
        }

        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const options = searchOptions();
        const currentIndex = options.indexOf(document.activeElement);
        if (!options.length || currentIndex < 0) return;

        event.preventDefault();
        const nextIndex =
          event.key === 'Home'
            ? 0
            : event.key === 'End'
              ? options.length - 1
              : (currentIndex + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options[nextIndex].focus();
      };

      const initializeSearch = () => {
        if (initialized) return;
        initialized = true;

        input.removeEventListener('focus', initializeAndHandleSearch);
        input.removeEventListener('click', initializeAndHandleSearch);
        input.removeEventListener('input', initializeAndHandleSearch);
        clearButton.removeEventListener('click', initializeAndClearSearch);
        form.removeEventListener('submit', initializeAndSubmitSearch);

        input.addEventListener('focus', handleSearchIntent);
        input.addEventListener('click', handleSearchIntent);
        input.addEventListener('input', handleSearchIntent);
        input.addEventListener('keydown', handleInputKeydown);
        clearButton.addEventListener('click', () => {
          input.value = '';
          updateClearButton();
          input.focus();
          showPopularProducts();
        });
        form.addEventListener('submit', handleSearchSubmit);
        panel.addEventListener('keydown', handlePanelKeydown);
        root.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!root.contains(document.activeElement)) closeSearch();
          });
        });
        document.addEventListener('pointerdown', (event) => {
          if (!root.contains(event.target)) closeSearch();
        });
      };

      function initializeAndHandleSearch() {
        initializeSearch();
        handleSearchIntent();
      }

      function initializeAndClearSearch() {
        initializeSearch();
        input.value = '';
        updateClearButton();
        input.focus();
        showPopularProducts();
      }

      function initializeAndSubmitSearch(event) {
        initializeSearch();
        handleSearchSubmit(event);
      }

      input.addEventListener('focus', initializeAndHandleSearch);
      input.addEventListener('click', initializeAndHandleSearch);
      input.addEventListener('input', initializeAndHandleSearch);
      clearButton.addEventListener('click', initializeAndClearSearch);
      form.addEventListener('submit', initializeAndSubmitSearch);
      updateClearButton();
    });

    const accountButtons = document.querySelectorAll('[data-clean-account-login]');

    const openKwikPass = () => {
      if (!document.getElementById('iframe-kp')) return false;

      if (typeof window.kpHandleLogin === 'function') {
        window.kpHandleLogin('/pages/kp-account');
        return true;
      }

      if (typeof window.handleKpAndShopifyLogin === 'function') {
        window.handleKpAndShopifyLogin('/pages/kp-account');
        return true;
      }

      if (typeof window.openIframe === 'function') {
        window.openIframe('kp_sso_token');
        return true;
      }

      return false;
    };

    accountButtons.forEach((button) => {
      if (button.dataset.cleanAccountLoginBound === 'true') return;
      button.dataset.cleanAccountLoginBound = 'true';

      button.addEventListener('click', () => {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');

        let attempts = 0;
        const tryToOpen = () => {
          if (openKwikPass()) {
            button.removeAttribute('aria-busy');
            return;
          }

          attempts += 1;
          if (attempts < 80) {
            window.setTimeout(tryToOpen, 100);
            return;
          }

          button.removeAttribute('aria-busy');
          console.error('[Clean header] KwikPass login API did not become available.');
        };

        tryToOpen();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-hg-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const cleanFormatCartMoney = (cents, moneyFormat) => {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      const placeholderPattern = (name) => new RegExp(['\\{', `\\{\\s*${name}\\s*\\}\\}`].join(''), 'g');
      const format = moneyFormat || `₹${['{', '{ amount }}'].join('')}`;

      return format
        .replace(placeholderPattern('amount_with_comma_separator'), amount.replace('.', ','))
        .replace(placeholderPattern('amount_no_decimals'), amount.replace(/\.\d+$/, ''))
        .replace(placeholderPattern('amount'), amount)
        .replace(/<[^>]*>/g, '')
        .replace(/\b(?:Rs\.?|INR)[\s\u00a0]*/gi, '₹');
    };

    const escapeCleanCartHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const cleanCartMoneyAttributes = (cents, drawer) => {
      const sourceText = cleanFormatCartMoney(cents, drawer.dataset.cleanCartMoneyFormat);
      const sourceCurrency =
        drawer.dataset.cleanCartSourceCurrency ||
        document.querySelector('[data-clean-display-currency-config]')?.dataset.cleanDisplayCurrencySource ||
        '';

      return `data-clean-money data-clean-money-minor="${escapeCleanCartHtml(
        cents,
      )}" data-clean-money-currency="${escapeCleanCartHtml(
        sourceCurrency,
      )}" data-clean-money-source-text="${escapeCleanCartHtml(
        sourceText,
      )}" data-money-cents="${escapeCleanCartHtml(cents)}" data-inr-display="${escapeCleanCartHtml(sourceText)}"`;
    };

    const cleanCartAjaxUrl = (url, fallback) => {
      const rawUrl = url || fallback;

      try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        const path = parsedUrl.pathname.replace(/\/$/, '');
        parsedUrl.pathname = path.endsWith('.js') ? path : `${path}.js`;
        parsedUrl.search = '';

        return `${parsedUrl.pathname}${parsedUrl.search}`;
      } catch (error) {
        const path = String(rawUrl || fallback || '').replace(/\/$/, '');
        return path.endsWith('.js') ? path : `${path}.js`;
      }
    };

    const cleanCartRequest = (url, options = {}) =>
      fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          'X-Clean-Cart': 'true',
          ...(options.headers || {}),
        },
      });

    const getCleanCartStateCoordinator = () => {
      if (window.CleanCartState?.refresh && window.CleanCartState?.publish) return window.CleanCartState;

      const state = {
        cart: window.cart || null,
        inFlight: null,
        revision: 0,
        lastUpdatedAt: window.cart ? Date.now() : 0,
      };
      const publish = (cart) => {
        if (!cart || !Array.isArray(cart.items)) return cart;
        state.revision++;
        state.cart = cart;
        state.lastUpdatedAt = Date.now();
        return cart;
      };
      const readCart = async () => {
        const drawer = getCleanCartDrawer();
        if (!drawer) return null;
        const response = await cleanCartRequest(getCleanCartJsonUrl(drawer));
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      };
      const refresh = (loader = readCart) => {
        if (state.inFlight) return state.inFlight;

        const revision = state.revision;
        const request = Promise.resolve()
          .then(loader)
          .then((cart) => revision === state.revision ? publish(cart) : state.cart)
          .finally(() => {
            if (state.inFlight === request) state.inFlight = null;
          });
        state.inFlight = request;
        return request;
      };

      window.CleanCartState = { publish, refresh, state };
      return window.CleanCartState;
    };

    const cleanClampCartQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
    };

    const cleanCartMaximumBulkQuantity = 9999;

    const getCleanCartMinimumQuantity = (item = {}) => {
      const minimum = Number.parseInt(item?.properties?._minimum_quantity, 10);
      return Number.isFinite(minimum) && minimum > 0
        ? Math.min(cleanCartMaximumBulkQuantity, minimum)
        : 0;
    };


    const cleanCartLineQuantity = (item, value, { allowRemoval = false } = {}) => {
      const quantity = cleanClampCartQuantity(value);
      const minimum = getCleanCartMinimumQuantity(item);

      if (!minimum) return quantity;
      if (allowRemoval && quantity === 0) return 0;
      return Math.min(cleanCartMaximumBulkQuantity, Math.max(minimum, quantity));
    };

    const getCleanCartElementMinimumQuantity = (item) => {
      const minimum = Number.parseInt(item?.dataset.cleanCartMinimumQuantity, 10);
      return Number.isFinite(minimum) && minimum > 0 ? minimum : 0;
    };

    const syncCleanCartItemQuantityControls = (item) => {
      const input = item?.querySelector('[data-clean-cart-quantity-input]');
      if (!input) return;

      const minimum = getCleanCartElementMinimumQuantity(item);
      const quantity = cleanClampCartQuantity(input.value);
      const decrease = item.querySelector('[data-clean-cart-quantity-decrease]');
      const increase = item.querySelector('[data-clean-cart-quantity-increase]');

      input.min = String(minimum || 0);
      if (minimum) {
        input.max = String(cleanCartMaximumBulkQuantity);
      } else {
        input.removeAttribute('max');
      }
      if (decrease) decrease.disabled = minimum > 0 && quantity <= minimum;
      if (increase) increase.disabled = minimum > 0 && quantity >= cleanCartMaximumBulkQuantity;
    };

    const getCleanCartImageUrl = (source, width = 140) => {
      if (!source) return '';

      try {
        const imageUrl = new URL(source, window.location.origin);
        const hostname = imageUrl.hostname.toLowerCase();
        const isShopifyImage =
          hostname === window.location.hostname.toLowerCase() ||
          hostname === 'cdn.shopify.com' ||
          hostname.endsWith('.myshopify.com') ||
          hostname.endsWith('.shopifycdn.com');

        if (isShopifyImage) imageUrl.searchParams.set('width', String(width));
        return imageUrl.toString();
      } catch (error) {
        return String(source);
      }
    };

    const cleanCartProductCache = new Map();
    const cleanCartPendingCompareHydrations = new WeakMap();
    const cleanCartCompareHydrationConcurrency = 3;
    let cleanCartRenderSequence = 0;
    let cleanCartLastTrackedAddAt = 0;
    let cleanCartTrackedAddPromise = null;

    const cleanNormalizeCartPrice = (value) => {
      const price = Number(value);
      return Number.isFinite(price) ? price : 0;
    };

    const hasCleanCartDiscount = (item = {}) => {
      if (
        cleanNormalizeCartPrice(item.total_discount) > 0 ||
        cleanNormalizeCartPrice(item.line_level_total_discount) > 0
      )
        return true;
      return [
        ...(item.discount_allocations || []),
        ...(item.line_level_discount_allocations || []),
      ].some((allocation) => cleanNormalizeCartPrice(allocation?.amount) > 0);
    };

    const getCleanCartLinePrice = (item = {}) => {
      // Shopify owns discounts. A browser estimate must never replace its price.
      for (const value of [item.final_line_price, item.line_price]) {
        if (
          value !== null &&
          value !== undefined &&
          value !== '' &&
          Number.isFinite(Number(value)) &&
          Number(value) >= 0
        )
          return Number(value);
      }
      if (
        item.final_price !== null &&
        item.final_price !== undefined &&
        item.final_price !== '' &&
        Number.isFinite(Number(item.final_price)) &&
        Number(item.final_price) >= 0
      )
        return Number(item.final_price) * cleanClampCartQuantity(item.quantity);
      if (hasCleanCartDiscount(item)) return 0;
      const unitPrice = cleanNormalizeCartPrice(item.price);
      return unitPrice > 0
        ? unitPrice * cleanClampCartQuantity(item.quantity)
        : cleanNormalizeCartPrice(item.original_line_price);
    };

    const hasCleanCartUnexpectedZeroPrice = (item = {}) =>
      cleanClampCartQuantity(item.quantity) > 0 && getCleanCartLinePrice(item) === 0 && !hasCleanCartDiscount(item);

    const getCleanCartDirectCompareUnitPrice = (item) => {
      const candidates = [
        item?.variant_compare_at_price,
        item?.compare_at_price,
        item?.variant?.compare_at_price,
        item?.original_price,
      ];

      return candidates.map(cleanNormalizeCartPrice).find((price) => price > 0) || 0;
    };

    const hasCleanCartDirectCompareAtPrice = (item) =>
      [item?.variant_compare_at_price, item?.compare_at_price, item?.variant?.compare_at_price]
        .map(cleanNormalizeCartPrice)
        .some((price) => price > 0);

    const getCleanCartCompareAtUnitPrice = (item) =>
      [item?.variant_compare_at_price, item?.compare_at_price, item?.variant?.compare_at_price]
        .map(cleanNormalizeCartPrice)
        .find((price) => price > 0) || 0;

    const getCleanCartCompareLinePrice = (item, compareUnitPrice = getCleanCartDirectCompareUnitPrice(item)) => {
      if (window.CleanBulkDiscounts?.isEligible(item)) {
        const original = cleanNormalizeCartPrice(item.original_line_price);
        return original > getCleanCartLinePrice(item) ? original : 0;
      }
      const quantity = cleanClampCartQuantity(item?.quantity || 1) || 1;
      const linePrice = getCleanCartLinePrice(item);
      const directCompareLinePrice = compareUnitPrice * quantity;
      const originalLinePrice = cleanNormalizeCartPrice(item?.original_line_price);

      if (directCompareLinePrice > linePrice) return directCompareLinePrice;
      if (originalLinePrice > linePrice) return originalLinePrice;
      return 0;
    };

    const getCleanCartDiscountPercent = (compareLinePrice, linePrice) => {
      if (!compareLinePrice || compareLinePrice <= linePrice) return 0;
      return Math.round(((compareLinePrice - linePrice) * 100) / compareLinePrice);
    };

    const renderCleanCartPriceHtml = (item, drawer, compareLinePrice = getCleanCartCompareLinePrice(item)) => {
      const linePrice = getCleanCartLinePrice(item);
      const discountPercent = getCleanCartDiscountPercent(compareLinePrice, linePrice);
      const comparePrice = compareLinePrice
        ? `<s class="clean-cart-drawer__compare-price" ${cleanCartMoneyAttributes(
            compareLinePrice,
            drawer,
          )}>${escapeCleanCartHtml(cleanFormatCartMoney(compareLinePrice, drawer.dataset.cleanCartMoneyFormat))}</s>`
        : '';
      const discount = discountPercent
        ? `<span class="clean-cart-drawer__discount">${discountPercent}% off</span>`
        : '';

      return `
        ${comparePrice}
        <span class="clean-cart-drawer__price" ${cleanCartMoneyAttributes(
          linePrice,
          drawer,
        )}>${escapeCleanCartHtml(cleanFormatCartMoney(linePrice, drawer.dataset.cleanCartMoneyFormat))}</span>
        ${discount}
      `;
    };

    const getCleanCartItemKey = (item) => String(item?.key || item?.id || item?.variant_id || '').trim();

    const getCleanCartCompareAtLinePrice = (item, compareUnitPrice = getCleanCartCompareAtUnitPrice(item)) => {
      if (window.CleanBulkDiscounts?.isEligible(item)) {
        const original = cleanNormalizeCartPrice(item.original_line_price);
        return original > getCleanCartLinePrice(item) ? original : 0;
      }
      const quantity = cleanClampCartQuantity(item?.quantity || 1) || 1;
      const linePrice = getCleanCartLinePrice(item);
      const compareLinePrice = compareUnitPrice * quantity;
      return compareLinePrice > linePrice ? compareLinePrice : 0;
    };

    const getCleanCartHydratedCompareLinePrice = (item, compareLinePrices) => {
      if (window.CleanBulkDiscounts?.isEligible(item)) {
        const original = cleanNormalizeCartPrice(item.original_line_price);
        return original > getCleanCartLinePrice(item) ? original : 0;
      }
      const directCompareLinePrice = getCleanCartCompareAtLinePrice(item) || getCleanCartCompareLinePrice(item);
      if (directCompareLinePrice) return directCompareLinePrice;

      if (!compareLinePrices) return 0;
      return cleanNormalizeCartPrice(compareLinePrices.get(getCleanCartItemKey(item)));
    };

    const cleanCartDefaultFreeShippingThreshold = 50000;
    const cleanCartStandardShippingCharge = 2500;
    const cleanCartDeliveryChargeVariantIds = new Set([51050538893559, 51050538926327, 51256352473335, 51256354898167, 51256354930935, 51256354963703, 51256354996471, 51256355029239, 51256355062007]);
    const cleanCartDeliveryExemptHandles = new Set(['gift-wrap', 'gift-wrapping']);
    const isCleanCartDeliveryChargeItem = (item = {}) =>
      window.HadiyahDeliveryCharge?.isFeeItem?.(item)
      ?? (cleanCartDeliveryChargeVariantIds.has(Number(item.variant_id || item.id || 0))
        || Number(item.product_id || item.product?.id) === 10059690017015
        || String(item.handle || item.product_handle || item.product?.handle || '').toLowerCase() === 'delivery-charge');
    const isCleanCartDeliveryExemptItem = (item = {}) => {
      if (window.HadiyahDeliveryCharge?.isDeliveryExemptItem) {
        return window.HadiyahDeliveryCharge.isDeliveryExemptItem(item);
      }
      const exemption = String(item?.properties?.['_Hadiyah delivery exempt'] || '').trim().toLowerCase();
      const directHandle = String(item.handle || item.product_handle || '').trim().toLowerCase();
      const urlHandle = String(item.url || '').split('?')[0].match(/\/products\/([^/]+)\/?$/i)?.[1] || '';
      const handle = directHandle || String(urlHandle).trim().toLowerCase();
      return exemption === 'gift wrap' || cleanCartDeliveryExemptHandles.has(handle);
    };
    const getCleanCartDeliverySummary = (cart = {}, drawer = null) => {
      if (window.HadiyahDeliveryCharge?.getSummary) {
        return window.HadiyahDeliveryCharge.getSummary(cart);
      }

      const merchandiseItems = (cart.items || []).filter((item) => !isCleanCartDeliveryChargeItem(item));
      const deliveryItems = merchandiseItems.filter((item) => !isCleanCartDeliveryExemptItem(item));
      const merchandiseSubtotal = merchandiseItems.reduce(
        (total, item) => total + getCleanCartLinePrice(item),
        0,
      );
      const merchandiseItemCount = merchandiseItems.reduce(
        (total, item) => total + cleanClampCartQuantity(item.quantity),
        0,
      );
      const getMethod = (item) => String(
        item?.properties?.['Delivery Method'] ?? item?.properties?.['Delivery Tier'] ?? '',
      ).trim().toLowerCase();
      const expressItemCount = deliveryItems.reduce(
        (total, item) => getMethod(item) === 'express'
          ? total + cleanClampCartQuantity(item.quantity)
          : total,
        0,
      );
      const expressCharge = deliveryItems.reduce((total, item) => {
        if (getMethod(item) !== 'express') return total;
        const grams = Number(item.grams);
        const rate = [[1500, 3000, 9900], [3500, 5000, 14900], [5500, 6500, 19900],
          [7000, 8500, 24900], [9000, 10500, 29900], [11000, 11500, 34900], [12000, 13000, 39900]]
          .find(([min, max]) => grams >= min && grams <= max)?.[2] ?? 4900;
        return total + rate * cleanClampCartQuantity(item.quantity);
      }, 0);
      const standardItems = deliveryItems.filter((item) => getMethod(item) === 'standard');
      const legacyItems = deliveryItems.filter((item) => !getMethod(item));
      const standardPotentialQuantity = isCleanCartNational(drawer)
        && (standardItems.length || legacyItems.length)
        ? 1
        : 0;
      const standardFeeQuantity = standardPotentialQuantity
        && merchandiseSubtotal <= cleanCartDefaultFreeShippingThreshold
        ? 1
        : 0;
      const standardFreeQuantity = Math.max(0, standardPotentialQuantity - standardFeeQuantity);
      const isExpress = expressItemCount > 0;
      const hasProductSpecificDelivery = isExpress || standardItems.length > 0;
      const isStandardFree = standardPotentialQuantity > 0 && standardFeeQuantity === 0;

      return {
        charge: expressCharge
          + (cleanCartStandardShippingCharge * standardFeeQuantity),
        isExpress,
        expressItemCount,
        hasProductSpecificDelivery,
        isStandardFree,
        merchandiseItemCount,
        merchandiseItems,
        merchandiseSubtotal,
        standardFeeQuantity,
        standardFreeQuantity,
        standardPotentialQuantity,
      };
    };
    const cleanCartRewardMilestones = [
      { amount: 200000, discount: 10000 },
      { amount: 500000, discount: 25000 },
      { amount: 750000, discount: 35000 },
      { amount: 1000000, discount: 50000 },
    ];
    const cleanCartRewardMaximum = cleanCartRewardMilestones[cleanCartRewardMilestones.length - 1].amount;
    const isCleanCartNational = (drawer) => {
      let country = window.HadiyahLocalization?.getState?.()?.deliveryCountry
        || '';
      try {
        country = country || localStorage.getItem('hadiyah:delivery-country-code') || '';
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browsers.
      }
      country = country || drawer?.dataset.cleanGokwikCountry || '';
      return ['IN', 'INDIA'].includes(String(country).trim().toUpperCase());
    };

    const getCleanCartRewardState = (cartTotal) => {
      const unlockedMilestone = [...cleanCartRewardMilestones]
        .reverse()
        .find((milestone) => cartTotal >= milestone.amount) || null;
      const nextMilestone = cleanCartRewardMilestones.find((milestone) => cartTotal < milestone.amount) || null;

      return {
        nextMilestone,
        remainingToNextMilestone: nextMilestone
          ? Math.max(100, Math.ceil((nextMilestone.amount - cartTotal) / 100) * 100)
          : 0,
        progress: Math.min(100, Math.max(0, (cartTotal * 100) / cleanCartRewardMaximum)),
        unlockedMilestone,
      };
    };

    const getCleanCartTotalsBreakdown = (cart, compareLinePrices, drawer) => {
      const deliverySummary = getCleanCartDeliverySummary(cart, drawer);
      const items = deliverySummary.merchandiseItems;
      const cartTotal = deliverySummary.merchandiseSubtotal;
      const isShippingFree = Boolean(items.length && deliverySummary.charge === 0);
      const shippingCharge = items.length ? deliverySummary.charge : 0;
      const hasBulk = window.CleanBulkDiscounts?.hasEligible(cart) !== false;
      const shippingSavings = hasBulk ? 0 : deliverySummary.standardFreeQuantity * cleanCartStandardShippingCharge;
      const rewardState = getCleanCartRewardState(cartTotal);
      const rewardDiscount = !hasBulk && isCleanCartNational(drawer) ? rewardState.unlockedMilestone?.discount || 0 : 0;
      const estimatedTotal = Math.max(0, cartTotal + shippingCharge - rewardDiscount);
      let mrpTotal = 0;
      let hasCompareSavings = false;

      items.forEach((item) => {
        const linePrice = getCleanCartLinePrice(item);
        const compareLinePrice = getCleanCartHydratedCompareLinePrice(item, compareLinePrices);

        if (compareLinePrice > linePrice) {
          mrpTotal += compareLinePrice;
          hasCompareSavings = true;
          return;
        }

        mrpTotal += linePrice;
      });

      const savings = hasCompareSavings ? Math.max(0, mrpTotal - cartTotal) : 0;
      const totalSavings = savings + shippingSavings + rewardDiscount;
      const estimatedCompareTotal = mrpTotal + shippingCharge + shippingSavings;
      const discountPercent = totalSavings ? getCleanCartDiscountPercent(estimatedCompareTotal, estimatedTotal) : 0;

      return {
        cartTotal,
        hasBulk,
        discountPercent,
        estimatedCompareTotal,
        estimatedTotal,
        hasItems: items.length > 0,
        hasSavings: totalSavings > 0,
        isShippingFree,
        mrpTotal,
        rewardDiscount,
        savings,
        shippingCharge,
        shippingSavings,
        totalSavings,
      };
    };

    const refreshCleanCartCurrency = (element) => {
      window.CleanDisplayCurrency?.refresh?.(element);
      window.HadiyahDisplayCurrency?.refresh?.(element);
    };

    const setCleanCartMoneyText = (target, value, drawer, { prefix = '', suffix = '' } = {}) => {
      if (!target) return;

      const sourceText = cleanFormatCartMoney(value, drawer.dataset.cleanCartMoneyFormat);

      if (!prefix && !suffix) {
        target.dataset.cleanMoney = '';
        target.dataset.cleanMoneyMinor = String(value);
        target.dataset.cleanMoneyCurrency = drawer.dataset.cleanCartSourceCurrency || '';
        target.dataset.cleanMoneySourceText = sourceText;
        target.dataset.moneyCents = String(value);
        target.dataset.inrDisplay = sourceText;
        target.textContent = sourceText;
        refreshCleanCartCurrency(target);
        return;
      }

      target.removeAttribute('data-clean-money');
      target.removeAttribute('data-clean-money-minor');
      target.removeAttribute('data-clean-money-currency');
      target.removeAttribute('data-clean-money-source-text');
      target.removeAttribute('data-clean-money-display-currency');
      target.removeAttribute('data-money-cents');
      target.removeAttribute('data-inr-amount');
      target.removeAttribute('data-inr-display');
      target.removeAttribute('data-display-currency-converted');
      target.removeAttribute('title');
      target.removeAttribute('aria-label');
      const money = document.createElement('span');
      money.dataset.cleanMoney = '';
      money.dataset.cleanMoneyMinor = String(value);
      money.dataset.cleanMoneyCurrency = drawer.dataset.cleanCartSourceCurrency || '';
      money.dataset.cleanMoneySourceText = sourceText;
      money.dataset.moneyCents = String(value);
      money.dataset.inrDisplay = sourceText;
      money.textContent = sourceText;
      target.replaceChildren(document.createTextNode(prefix), money, document.createTextNode(suffix));
      refreshCleanCartCurrency(money);
    };

    const setCleanCartCompactMoneyText = (target, value, { abbreviateThousands = false } = {}) => {
      if (!target) return;

      const rupees = Math.max(0, Number(value) || 0) / 100;
      const amount =
        abbreviateThousands && rupees >= 1000
          ? `${Number.isInteger(rupees / 1000) ? rupees / 1000 : (rupees / 1000).toFixed(1)}k`
          : Math.round(rupees).toLocaleString('en-IN');
      const sourceText = `₹${amount}`;

      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(value);
      target.dataset.cleanMoneyCurrency = 'INR';
      target.dataset.cleanMoneySourceText = sourceText;
      target.dataset.moneyCents = String(value);
      target.dataset.inrDisplay = sourceText;
      target.textContent = sourceText;
      refreshCleanCartCurrency(target);
    };

    const setCleanCartMoneyParts = (target, parts, drawer) => {
      if (!target) return;

      const moneyBindings = [];
      const nodes = parts.map((part) => {
        if (typeof part === 'string') return document.createTextNode(part);

        const money = document.createElement('span');
        moneyBindings.push([money, part.money]);
        return money;
      });

      target.replaceChildren(...nodes);
      moneyBindings.forEach(([money, value]) => setCleanCartMoneyText(money, value, drawer));
    };

    const updateCleanCartRewardCelebration = (drawer, rewardsComplete) => {
      const panel = drawer?.querySelector('[data-clean-cart-shipping-progress-panel]');
      const detail = drawer?.querySelector('[data-clean-cart-reward-detail]');
      if (!drawer || !panel) return;

      panel.classList.toggle('clean-cart-drawer__shipping-progress-panel--complete', rewardsComplete);
      detail?.classList.toggle('clean-cart-drawer__reward-detail--complete', rewardsComplete);

      if (!rewardsComplete) {
        panel.classList.remove('clean-cart-drawer__shipping-progress-panel--celebrating');
        drawer.cleanCartRewardsWereComplete = false;
        return;
      }

      if (drawer.cleanCartRewardsWereComplete) return;
      drawer.cleanCartRewardsWereComplete = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      panel.classList.remove('clean-cart-drawer__shipping-progress-panel--celebrating');
      void panel.offsetWidth;
      panel.classList.add('clean-cart-drawer__shipping-progress-panel--celebrating');
      window.clearTimeout(drawer.cleanCartRewardCelebrationTimer);
      drawer.cleanCartRewardCelebrationTimer = window.setTimeout(() => {
        panel.classList.remove('clean-cart-drawer__shipping-progress-panel--celebrating');
      }, 1600);
    };

    const renderCleanCartTotals = (drawer, cart, compareLinePrices) => {
      const totalTarget = drawer?.querySelector('[data-clean-cart-drawer-total]');
      const compareTarget = drawer?.querySelector('[data-clean-cart-total-compare]');
      const discountTarget = drawer?.querySelector('[data-clean-cart-total-discount]');
      const toggle = drawer?.querySelector('[data-clean-cart-summary-toggle]');
      const summary = drawer?.querySelector('[data-clean-cart-summary]');
      if (!drawer || !totalTarget) return;

      const breakdown = getCleanCartTotalsBreakdown(cart, compareLinePrices, drawer);
      const rewardState = getCleanCartRewardState(breakdown.cartTotal);
      drawer.querySelectorAll("[data-clean-cart-summary-original-label]").forEach((label) => { label.textContent = breakdown.hasBulk ? "Original total" : "MRP total"; });
      drawer.querySelectorAll("[data-clean-cart-summary-savings-label]").forEach((label) => { label.textContent = breakdown.hasBulk ? "Product savings" : "Discount on MRP"; });
      setCleanCartMoneyText(totalTarget, breakdown.estimatedTotal, drawer);

      if (compareTarget) {
        compareTarget.hidden = !breakdown.hasSavings;
        if (breakdown.hasSavings) {
          setCleanCartMoneyText(compareTarget, breakdown.estimatedCompareTotal, drawer);
        }
      }

      if (discountTarget) {
        discountTarget.hidden = !breakdown.hasSavings || !breakdown.discountPercent;
        discountTarget.textContent = breakdown.discountPercent ? `(${breakdown.discountPercent}% OFF)` : '';
      }

      if (toggle) {
        toggle.hidden = !breakdown.hasItems;
        if (!breakdown.hasItems) toggle.setAttribute('aria-expanded', 'false');
      }

      if (summary) {
        const shouldShowSummary = breakdown.hasItems && toggle?.getAttribute('aria-expanded') === 'true';
        summary.hidden = !shouldShowSummary;
      }

      drawer.querySelectorAll('[data-clean-cart-summary-saved]').forEach((target) => {
        target.hidden = !breakdown.hasSavings;
        if (breakdown.hasSavings) {
          setCleanCartMoneyText(target, breakdown.totalSavings, drawer, { suffix: ' saved so far' });
        } else {
          target.replaceChildren();
        }
      });
      drawer.querySelectorAll('[data-clean-cart-shipping-progress-panel]').forEach((target) => {
        const shouldShowProgress = breakdown.hasItems && !breakdown.hasBulk;
        const progressTarget = target.querySelector('[data-clean-cart-shipping-progress]');
        const progressFill = target.querySelector('[data-clean-cart-shipping-progress-fill]');
        const progressTruck = target.querySelector('[data-clean-cart-shipping-progress-truck]');
        const nextMarkerAmount = rewardState.nextMilestone?.amount;

        target.hidden = !shouldShowProgress;
        target.dataset.cleanCartShippingProgress = String(rewardState.progress);
        if (progressTarget) progressTarget.setAttribute('aria-valuenow', String(Math.round(rewardState.progress)));
        if (progressFill) progressFill.style.width = `${rewardState.progress}%`;
        if (progressTruck) progressTruck.style.left = `${rewardState.progress}%`;

        target.querySelectorAll('[data-clean-cart-reward-marker]').forEach((marker) => {
          const markerAmount = cleanNormalizeCartPrice(marker.dataset.cleanCartRewardMarkerAmount);
          const markerPosition = Math.min(100, Math.max(0, (markerAmount * 100) / cleanCartRewardMaximum));
          const unlocked = breakdown.cartTotal >= markerAmount;

          marker.style.left = `${markerPosition}%`;
          marker.classList.toggle('clean-cart-drawer__reward-marker--unlocked', unlocked);
          marker.classList.toggle(
            'clean-cart-drawer__reward-marker--next',
            !unlocked && markerAmount === nextMarkerAmount,
          );
        });

        target.querySelectorAll('[data-clean-cart-reward-marker-discount]').forEach((label) => {
          setCleanCartCompactMoneyText(label, label.dataset.cleanCartRewardMarkerDiscount);
        });
        target.querySelectorAll('[data-clean-cart-reward-marker-spend]').forEach((label) => {
          setCleanCartCompactMoneyText(label, label.dataset.cleanCartRewardMarkerSpend, {
            abbreviateThousands: true,
          });
        });
      });
      drawer.querySelectorAll('[data-clean-cart-footer-savings]').forEach((target) => {
        const shouldShowRibbon = breakdown.hasSavings;
        const textTarget = target.querySelector('[data-clean-cart-footer-savings-text]');

        target.hidden = !shouldShowRibbon;
        target.classList.remove('clean-cart-drawer__savings-ribbon--shipping-prompt');
        if (textTarget) {
          if (breakdown.hasSavings) {
            setCleanCartMoneyText(textTarget, breakdown.totalSavings, drawer, { suffix: ' saved so far!' });
          } else {
            textTarget.replaceChildren();
          }
        }
      });
      drawer.querySelectorAll('[data-clean-cart-reward-detail]').forEach((target) => {
        const shouldShowRewardDetail = breakdown.hasItems && !breakdown.hasBulk;
        target.hidden = !shouldShowRewardDetail;

        if (!shouldShowRewardDetail) {
          target.replaceChildren();
        } else if (rewardState.nextMilestone) {
          setCleanCartMoneyParts(
            target,
            [
              'Add ',
              { money: rewardState.remainingToNextMilestone },
              ' more → unlock ',
              { money: rewardState.nextMilestone.discount },
              ' off',
            ],
            drawer,
          );
        } else {
          target.textContent = 'All rewards unlocked!';
        }
      });
      updateCleanCartRewardCelebration(
        drawer,
        breakdown.hasItems && !breakdown.hasBulk && !rewardState.nextMilestone,
      );
      drawer
        .querySelectorAll('[data-clean-cart-summary-mrp]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.mrpTotal, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-discount-row]')
        .forEach((target) => (target.hidden = breakdown.savings <= 0));
      drawer
        .querySelectorAll('[data-clean-cart-summary-discount]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.savings, drawer, { prefix: '-' }));
      drawer
        .querySelectorAll('[data-clean-cart-summary-reward-row]')
        .forEach((target) => (target.hidden = breakdown.rewardDiscount <= 0));
      drawer
        .querySelectorAll('[data-clean-cart-summary-reward]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.rewardDiscount, drawer, { prefix: '-' }));
      drawer.querySelectorAll('[data-clean-cart-summary-shipping]').forEach((target) => {
        const compareTarget = target.querySelector('[data-clean-cart-summary-shipping-compare]');
        const currentTarget = target.querySelector('[data-clean-cart-summary-shipping-current]');

        target.classList.toggle('clean-cart-drawer__summary-shipping--free', breakdown.shippingCharge === 0);
        if (compareTarget) {
          compareTarget.hidden = !breakdown.isShippingFree;
          setCleanCartMoneyText(compareTarget, cleanCartStandardShippingCharge, drawer);
        }
        if (currentTarget) {
          if (breakdown.isShippingFree) {
            currentTarget.removeAttribute('data-clean-money');
            currentTarget.removeAttribute('data-clean-money-minor');
            currentTarget.removeAttribute('data-clean-money-currency');
            currentTarget.removeAttribute('data-clean-money-source-text');
            currentTarget.removeAttribute('data-clean-money-display-currency');
            currentTarget.removeAttribute('aria-label');
            currentTarget.textContent = 'FREE';
          } else {
            setCleanCartMoneyText(currentTarget, breakdown.shippingCharge, drawer);
          }
        }
      });
      drawer
        .querySelectorAll('[data-clean-cart-summary-total-savings-row]')
        .forEach((target) => (target.hidden = !breakdown.hasSavings));
      drawer
        .querySelectorAll('[data-clean-cart-summary-total-savings]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.totalSavings, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-subtotal]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.cartTotal, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-total]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.estimatedTotal, drawer));
    };

    const getCleanCartProductJson = async (handle, { retries = 0, signal } = {}) => {
      const cleanHandle = String(handle || '').trim();
      if (!cleanHandle) return null;

      if (!cleanCartProductCache.has(cleanHandle)) {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const productUrl = `${rootUrl.replace(/\/?$/, '/')}products/${encodeURIComponent(cleanHandle)}.js`;
        const requestPromise = (async () => {
          for (let attempt = 0; attempt <= retries; attempt += 1) {
            try {
              const response = await fetch(productUrl, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
                signal,
              });

              if (response.ok) {
                const product = await response.json();
                return product;
              }

              const isTransientResponse = response.status === 408 || response.status === 429 || response.status >= 500;
              if (!isTransientResponse) return null;
            } catch (error) {
              if (error?.name === 'AbortError') return null;
              if (attempt === retries) return null;
            }

            if (attempt < retries) {
              await new Promise((resolve) => {
                const timer = window.setTimeout(resolve, 200 * 2 ** attempt);
                signal?.addEventListener(
                  'abort',
                  () => {
                    window.clearTimeout(timer);
                    resolve();
                  },
                  { once: true },
                );
              });
              if (signal?.aborted) return null;
            }
          }

          return null;
        })();

        cleanCartProductCache.set(cleanHandle, requestPromise);
      }

      const cachedRequest = cleanCartProductCache.get(cleanHandle);
      const product = await cachedRequest;

      if (!product && cleanCartProductCache.get(cleanHandle) === cachedRequest) {
        cleanCartProductCache.delete(cleanHandle);
      }

      return product;
    };

    const hydrateCleanCartComparePrices = async (drawer, cart, renderId) => {
      const items = cart?.items || [];
      const compareLinePrices = new Map();
      if (!drawer || !items.length) return;

      if (drawer.hidden || !drawer.classList.contains('clean-cart-drawer--open')) {
        cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
        return;
      }

      cleanCartPendingCompareHydrations.delete(drawer);

      const itemNodes = new Map(
        Array.from(drawer.querySelectorAll('[data-clean-cart-item]')).map((element) => [
          String(element.dataset.cleanCartItem || ''),
          element,
        ]),
      );
      const itemsByHandle = new Map();

      items.forEach((item) => {
        const itemKey = getCleanCartItemKey(item);
        const directCompareLinePrice = getCleanCartCompareAtLinePrice(item);
        if (directCompareLinePrice) compareLinePrices.set(itemKey, directCompareLinePrice);
        if (hasCleanCartDirectCompareAtPrice(item) || !item?.handle) return;

        const handle = String(item.handle);
        if (!itemsByHandle.has(handle)) itemsByHandle.set(handle, []);
        itemsByHandle.get(handle).push(item);
      });

      const handleEntries = Array.from(itemsByHandle.entries());
      let handleIndex = 0;
      let didHydrateComparePrice = false;

      const hydrateNextHandle = async () => {
        while (handleIndex < handleEntries.length) {
          if (
            drawer.hidden ||
            !drawer.classList.contains('clean-cart-drawer--open') ||
            drawer.dataset.cleanCartRenderId !== renderId
          ) {
            cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
            return;
          }

          const [handle, handleItems] = handleEntries[handleIndex];
          handleIndex += 1;
          const product = await getCleanCartProductJson(handle);
          const variants = new Map((product?.variants || []).map((variant) => [String(variant?.id || ''), variant]));

          if (
            drawer.hidden ||
            !drawer.classList.contains('clean-cart-drawer--open') ||
            drawer.dataset.cleanCartRenderId !== renderId
          ) {
            cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
            return;
          }

          handleItems.forEach((item) => {
            const itemKey = getCleanCartItemKey(item);
            const variant = variants.get(String(item?.variant_id || item?.id || ''));
            const compareLinePrice = getCleanCartCompareAtLinePrice(
              item,
              cleanNormalizeCartPrice(variant?.compare_at_price),
            );
            if (!compareLinePrice) return;

            compareLinePrices.set(itemKey, compareLinePrice);
            const priceBlock = itemNodes.get(String(item.key || ''))?.querySelector('[data-clean-cart-price-block]');
            const nextPriceHtml = renderCleanCartPriceHtml(item, drawer, compareLinePrice);

            if (priceBlock && priceBlock.innerHTML !== nextPriceHtml) {
              priceBlock.innerHTML = nextPriceHtml;
            }

            didHydrateComparePrice = true;
          });
        }
      };

      await Promise.all(
        Array.from({ length: Math.min(cleanCartCompareHydrationConcurrency, handleEntries.length) }, hydrateNextHandle),
      );

      if (didHydrateComparePrice && drawer.dataset.cleanCartRenderId === renderId && !drawer.hidden) {
        renderCleanCartTotals(drawer, cart, compareLinePrices);
      }
    };

    const resumeCleanCartCompareHydration = (drawer) => {
      const pending = cleanCartPendingCompareHydrations.get(drawer);
      if (!pending || drawer?.dataset.cleanCartRenderId !== pending.renderId) return;
      hydrateCleanCartComparePrices(drawer, pending.cart, pending.renderId).catch(() => {});
    };

    window.CleanGokwik =
      window.CleanGokwik ||
      (() => {
        const state = {
          countryPromise: null,
          scriptPromise: null,
        };

        const COUNTRY_CACHE_KEY = 'cleanGokwikCountry';
        const COUNTRY_CACHE_TIME_KEY = 'cleanGokwikCountryAt';
        const COUNTRY_CACHE_TTL_MS = 5 * 60 * 1000;
        const CHECKOUT_STATE_TIMEOUT_MS = 4000;

        const settleWithin = (promise, timeoutMs, fallbackValue) =>
          new Promise((resolve) => {
            let settled = false;
            const finish = (value) => {
              if (settled) return;
              settled = true;
              window.clearTimeout(timer);
              resolve(value);
            };
            const timer = window.setTimeout(() => finish(fallbackValue), timeoutMs);
            Promise.resolve(promise).then(finish, () => finish(fallbackValue));
          });

        const invalidateDetectedCountry = ({ clearStorage = false } = {}) => {
          state.countryPromise = null;
          if (!clearStorage) return;

          try {
            sessionStorage.removeItem(COUNTRY_CACHE_KEY);
            sessionStorage.removeItem(COUNTRY_CACHE_TIME_KEY);
          } catch (error) {}
        };

        const readDetectedCountry = async ({ force = false } = {}) => {
          if (!force && state.countryPromise) return state.countryPromise;

          const request = (async () => {
            try {
              if (!force) {
                const cachedCountry = String(sessionStorage.getItem(COUNTRY_CACHE_KEY) || '').toUpperCase();
                const cachedAt = Number(sessionStorage.getItem(COUNTRY_CACHE_TIME_KEY) || 0);
                if (cachedCountry && cachedAt && Date.now() - cachedAt < COUNTRY_CACHE_TTL_MS) {
                  return cachedCountry;
                }
              }

              const response = await settleWithin(
                fetch('/browsing_context_suggestions.json', {
                  credentials: 'same-origin',
                  headers: { Accept: 'application/json' },
                  cache: 'no-store',
                }),
                CHECKOUT_STATE_TIMEOUT_MS,
                null,
              );
              if (!response?.ok) return '';

              const data = await response.json();
              const detected = data?.detected_values || {};
              const country =
                detected.country_code ||
                detected.country?.iso_code ||
                detected.country?.handle ||
                (detected.country_name === 'India' ? 'IN' : detected.country_name || '');
              const normalizedCountry = String(country || '').toUpperCase();

              if (normalizedCountry) {
                sessionStorage.setItem(COUNTRY_CACHE_KEY, normalizedCountry);
                sessionStorage.setItem(COUNTRY_CACHE_TIME_KEY, String(Date.now()));
              }
              return normalizedCountry;
            } catch (error) {
              return '';
            }
          })();

          state.countryPromise = request;
          try {
            return await request;
          } finally {
            if (state.countryPromise === request) state.countryPromise = null;
          }
        };

        const scriptHostForEnv = (environment) => {
          const normalizedEnvironment = environment || 'production';
          if (normalizedEnvironment === 'production') return 'pdp.gokwik.co';
          if (normalizedEnvironment === 'sandbox') return 'sandbox.pdp.gokwik.co';
          return 'qa.pdp.gokwik.co';
        };

        const loadSdk = (scope) => {
          if (typeof window.onCheckoutClick === 'function') {
            return Promise.resolve();
          }
          if (state.scriptPromise) return state.scriptPromise;

          window.merchantInfo = {
            mid: scope.dataset.cleanGokwikMid || '',
            environment: scope.dataset.cleanGokwikEnv || 'production',
            type: 'merchantInfo',
            storeId: scope.dataset.cleanGokwikStoreId || '',
            fbpixel: scope.dataset.cleanGokwikFbpixel || '',
          };
          window.productFormSelector = window.productFormSelector || '';
          window.templateName =
            window.templateName || (scope.matches('[data-clean-cart-page]') ? 'cart' : 'product');

          state.scriptPromise = new Promise((resolve, reject) => {
            let isSettled = false;
            const scriptUrl = `https://${scriptHostForEnv(scope.dataset.cleanGokwikEnv)}/merchant-integration/build/merchant.integration.js?v4`;
            const existingScript =
              document.getElementById('gokwik-merchant-integration') ||
              document.querySelector(
                '[data-clean-gokwik-sdk], script[src*="merchant-integration/build/merchant.integration.js"]',
              );
            let readyTimer = null;
            let readyTimeout = null;
            const cleanup = () => {
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
            };
            const finish = () => {
              if (isSettled || typeof window.onCheckoutClick !== 'function') return;
              isSettled = true;
              cleanup();
              resolve();
            };
            const fail = (message = 'GoKwik checkout is not ready yet.') => {
              if (isSettled) return;
              isSettled = true;
              cleanup();
              state.scriptPromise = null;
              reject(new Error(message));
            };

            document.addEventListener('gokwikLoaded', finish);
            window.addEventListener('gokwikLoaded', finish);
            readyTimer = window.setInterval(finish, 100);
            readyTimeout = window.setTimeout(() => fail(), 8000);

            if (existingScript) {
              existingScript.id = 'gokwik-merchant-integration';
              existingScript.setAttribute('data-hadiyah-tp-ok', '1');
              existingScript.dataset.cleanGokwikSdk = 'true';
              existingScript.addEventListener('error', () => fail('Unable to load GoKwik checkout.'), {
                once: true,
              });
              if (!existingScript.getAttribute('src')) {
                existingScript.removeAttribute('type');
                existingScript.removeAttribute('data-hadiyah-tp-deferred');
                existingScript.src = scriptUrl;
              }
              finish();
              return;
            }

            const script = document.createElement('script');
            script.id = 'gokwik-merchant-integration';
            script.setAttribute('data-hadiyah-tp-ok', '1');
            script.defer = true;
            script.dataset.cleanGokwikSdk = 'true';
            script.src = scriptUrl;
            script.onload = () => {
              window.setTimeout(finish, 0);
            };
            script.onerror = () => fail('Unable to load GoKwik checkout.');
            document.head.appendChild(script);
          });

          return state.scriptPromise;
        };

        const setScopeVisibility = (scope, useGokwik) => {
          const gokwikButton = scope.querySelector('[data-clean-gokwik-checkout]');
          const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');
          const gokwikReady = useGokwik && typeof window.onCheckoutClick === 'function';

          if (!gokwikReady || !gokwikButton) {
            if (shopifyCheckout) shopifyCheckout.hidden = false;
            if (!gokwikButton) return;

            gokwikButton.hidden = true;
            gokwikButton.setAttribute('aria-hidden', 'true');
            return;
          }

          gokwikButton.hidden = false;
          gokwikButton.setAttribute('aria-hidden', 'false');
          if (shopifyCheckout) shopifyCheckout.hidden = true;
        };

        const getScopeCountry = (scope) => String(scope?.dataset.cleanGokwikCountry || '').toUpperCase();

        const isGokwikCountry = (country) => country === 'IN' || country === 'INDIA';

        const getScopeForControl = (control, scope) =>
          scope || control?.closest?.('[data-clean-gokwik-scope]') || document.querySelector('[data-clean-gokwik-scope]');

        const readDeliveryCountry = async (scope) => {
          const marketCountry = getScopeCountry(scope);
          let deliveryCountry = marketCountry;

          try {
            const localizationState = window.HadiyahLocalization?.getState?.();
            deliveryCountry = String(localizationState?.deliveryCountry || marketCountry || '').toUpperCase();
          } catch (error) {}

          return {
            deliveryCountry,
            marketCountry,
            synchronized: Boolean(deliveryCountry && marketCountry && deliveryCountry === marketCountry),
          };
        };

        const trackDecision = (decision, source) => {
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'checkout_router_decision',
              route: decision.route,
              reason: decision.reason,
              source: source || 'unknown',
              delivery_country: decision.deliveryCountry || '',
              market_country: decision.marketCountry || '',
              visitor_country: decision.detectedCountry || '',
              path: window.location.pathname,
            });
          } catch (error) {}
        };

        const resolveScope = async (
          scope,
          { detect = false, forceDetect = false, prepare = false, source = '', track = false } = {},
        ) => {
          const decision = {
            route: 'shopify',
            reason: 'scope_unavailable',
            deliveryCountry: '',
            marketCountry: '',
            detectedCountry: '',
          };

          if (!scope) {
            if (track) trackDecision(decision, source);
            return decision;
          }

          setScopeVisibility(scope, false);
          if (scope.dataset.cleanGokwikEnabled !== 'true') {
            decision.reason = 'gokwik_disabled';
            if (track) trackDecision(decision, source);
            return decision;
          }

          const delivery = await readDeliveryCountry(scope);
          decision.deliveryCountry = delivery.deliveryCountry;
          decision.marketCountry = delivery.marketCountry;
          if (!delivery.synchronized) {
            decision.reason = 'delivery_market_mismatch';
            if (track) trackDecision(decision, source);
            return decision;
          }
          if (!isGokwikCountry(delivery.deliveryCountry)) {
            decision.reason = 'international_delivery';
            if (track) trackDecision(decision, source);
            return decision;
          }

          const sdkReadyPromise = prepare
            ? loadSdk(scope)
                .then(() => true)
                .catch(() => false)
            : Promise.resolve(typeof window.onCheckoutClick === 'function');
          const detectedCountry = detect
            ? await readDetectedCountry({ force: forceDetect })
            : delivery.deliveryCountry;
          decision.detectedCountry = detectedCountry;

          if (!isGokwikCountry(detectedCountry)) {
            decision.reason = detectedCountry ? 'international_visitor' : 'visitor_country_unknown';
            if (track) trackDecision(decision, source);
            return decision;
          }

          const sdkReady = await sdkReadyPromise;
          const useGokwik = sdkReady && typeof window.onCheckoutClick === 'function';
          setScopeVisibility(scope, useGokwik);

          decision.route = useGokwik ? 'gokwik' : 'shopify';
          decision.reason = useGokwik ? 'india_visitor_and_delivery' : 'gokwik_not_ready';
          if (track) trackDecision(decision, source);
          return decision;
        };

        const syncScope = async (scope, options = {}) => {
          const decision = await resolveScope(scope, options);
          return decision.route === 'gokwik';
        };

        const fallbackToShopify = async (scope, reason, checkoutUrl = '') => {
          if (scope) setScopeVisibility(scope, false);

          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'gokwik_fallback_used',
              path: window.location.pathname,
              reason,
            });
          } catch (error) {}

          const shopifyCheckout = scope?.querySelector('[data-clean-shopify-checkout]');
          const destination =
            checkoutUrl || shopifyCheckout?.getAttribute('href') || scope?.dataset.cleanCartCheckoutUrl || '/checkout';
          let localizationPreparation = true;
          try {
            localizationPreparation = window.HadiyahLocalization?.prepareCheckout?.(destination);
          } catch (error) {}
          const localizationReady = await settleWithin(
            localizationPreparation,
            CHECKOUT_STATE_TIMEOUT_MS,
            true,
          );
          if (localizationReady === false) return 'shopify';
          window.location.assign(destination);
          return 'shopify';
        };

        const routeCheckout = async (control, scope, { checkoutUrl = '', source = 'checkout_control' } = {}) => {
          const checkoutScope = getScopeForControl(control, scope);
          try {
            const decision = await resolveScope(checkoutScope, {
              detect: true,
              forceDetect: true,
              prepare: true,
              source,
              track: true,
            });
            if (decision.route !== 'gokwik' || typeof window.onCheckoutClick !== 'function') {
              return fallbackToShopify(checkoutScope, decision.reason, checkoutUrl);
            }

            try {
              const gokwikButton =
                checkoutScope?.querySelector('[data-clean-gokwik-checkout]') || control;
              if (!gokwikButton) return fallbackToShopify(checkoutScope, 'gokwik_control_missing', checkoutUrl);
              window.onCheckoutClick(gokwikButton);
              return 'gokwik';
            } catch (error) {
              return fallbackToShopify(checkoutScope, 'checkout_handler_threw', checkoutUrl);
            }
          } catch (error) {
            return fallbackToShopify(checkoutScope, 'checkout_exception', checkoutUrl);
          }
        };

        const syncAllScopes = (options = {}) => {
          document.querySelectorAll('[data-clean-gokwik-scope]').forEach((scope) => {
            syncScope(scope, options).catch(() => setScopeVisibility(scope, false));
          });
        };

        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          invalidateDetectedCountry({ clearStorage: true });
          syncAllScopes({ detect: true, forceDetect: true, prepare: false });
        });

        document.addEventListener('hadiyah:localization:changed', () => {
          syncAllScopes({ detect: true, prepare: false });
        });

        return {
          checkout: routeCheckout,
          fallbackToShopify,
          invalidateDetectedCountry,
          resolveScope,
          routeCheckout,
          syncScope,
        };
      })();

    const getCleanCartDrawer = () => document.querySelector('[data-clean-cart-drawer]');

    if (!customElements.get('cart-drawer')) {
      class CleanHadiyahCartDrawer extends HTMLElement {
        setActiveElement(element) {
          this.cleanCartActiveElement = element;
        }

        getSectionsToRender() {
          return [{ id: 'cart-icon-bubble' }];
        }

        async renderContents(parsedState, options = {}) {
          let revision;
          try {
            const refresh = refreshCleanCartDrawer(this, parsedState, options);
            revision = this.cleanCartRefreshRevision;
            const cart = await refresh;
            if (!cart || revision !== this.cleanCartRefreshRevision) return null;

            if (options.openDrawer !== false) {
              await openCleanCartDrawer({ refresh: false });
            }

            return cart;
          } catch (error) {
            if (revision !== this.cleanCartRefreshRevision) return null;
            if (options.openDrawer !== false) {
              await openCleanCartDrawer({ refresh: false });
            }

            setCleanCartStatus(this, error?.message || 'Unable to refresh cart.');
            return null;
          }
        }

        renderCartJson(cart, options = {}) {
          return this.renderContents(cart, options);
        }

        beginCartHandoff() {
          this.cleanCartHandoff = true;
          this.cleanCartRefreshRevision = (this.cleanCartRefreshRevision || 0) + 1;
          const coordinator = getCleanCartStateCoordinator();
          coordinator.state.revision++;
          coordinator.state.inFlight = null;
        }

        endCartHandoff() {
          this.cleanCartHandoff = false;
        }

        open(triggeredBy) {
          if (triggeredBy) this.setActiveElement(triggeredBy);
          return openCleanCartDrawer();
        }

        close() {
          const focusTarget = this.cleanCartActiveElement;
          closeCleanCartDrawer();

          window.setTimeout(
            () => {
              if (focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
            },
            reducedMotion.matches ? 0 : 220,
          );
        }
      }

      customElements.define('cart-drawer', CleanHadiyahCartDrawer);
    }


    const getCleanCartUrl = (drawer, key, fallback) => drawer?.dataset[key] || fallback;

    const getCleanCartJsonUrl = (drawer) => {
      const cartUrl = getCleanCartUrl(drawer, 'cleanCartUrl', '/cart');
      return cleanCartAjaxUrl(cartUrl, '/cart');
    };

    const setCleanCartStatus = (drawer, message = '') => {
      const status = drawer?.querySelector('[data-clean-cart-drawer-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const setCleanCartInputValue = (input, value = '') => {
      if (!input || document.activeElement === input) return;
      input.value = value || '';
    };

    const getCleanCartGiftWrapVariantId = (drawer) => String(drawer?.dataset.cleanCartGiftWrapVariantId || '').trim();

    const isCleanCartGiftWrapItem = (item, variantId) => {
      const giftWrapVariantId = String(variantId || '').trim();
      if (!giftWrapVariantId) return false;

      return String(item?.id || '') === giftWrapVariantId || String(item?.variant_id || '') === giftWrapVariantId;
    };

    const hasCleanCartGiftWrapItem = (cart, variantId) => {
      const giftWrapVariantId = String(variantId || '').trim();
      if (!giftWrapVariantId) return false;

      return (cart?.items || []).some((item) => isCleanCartGiftWrapItem(item, giftWrapVariantId));
    };

    const syncCleanCartToolCount = (drawer) => {
      const tools = drawer?.querySelector('[data-clean-cart-tools]');
      if (!tools) return;

      const visibleToolCount = [...tools.querySelectorAll('[data-clean-cart-tool-trigger]')].filter(
        (button) => !button.hidden,
      ).length;
      tools.dataset.cleanCartToolsCount = String(Math.max(visibleToolCount, 1));
    };

    const syncCleanCartGiftWrapTool = (drawer, cart) => {
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);
      const giftWrapTool = drawer?.querySelector('[data-clean-cart-gift-wrap-tool]');
      const giftWrapPanel = drawer?.querySelector('[data-clean-cart-tool-panel="gift-wrap"]');
      const hasGiftWrap = hasCleanCartGiftWrapItem(cart, giftWrapVariantId);
      const shouldShowGiftWrap = Boolean(giftWrapVariantId);

      if (giftWrapTool) {
        giftWrapTool.hidden = !shouldShowGiftWrap;
        giftWrapTool.disabled = hasGiftWrap;
        giftWrapTool.setAttribute('aria-disabled', String(hasGiftWrap));
        if (!shouldShowGiftWrap || hasGiftWrap) giftWrapTool.setAttribute('aria-expanded', 'false');
      }

      if ((!shouldShowGiftWrap || hasGiftWrap) && giftWrapPanel) {
        giftWrapPanel.hidden = true;
      }

      if (!drawer?.querySelector('[data-clean-cart-tool-panel]:not([hidden])')) {
        drawer?.classList.remove('clean-cart-drawer--tool-open');
      }

      syncCleanCartToolCount(drawer);
    };

    const syncCleanCartToolFields = (drawer, cart) => {
      if (!drawer || !cart) return;

      const attributes = cart.attributes || {};

      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-note-input]'), cart.note || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-to]'), attributes.To || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-from]'), attributes.From || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-message]'), attributes.Message || '');
      syncCleanCartGiftWrapTool(drawer, cart);
    };

    const syncCleanCartToolViewport = (drawer) => {
      if (!drawer) return;

      const visualViewport = window.visualViewport;
      const visualHeight = Math.max(0, visualViewport?.height || window.innerHeight);
      const visualOffsetTop = Math.max(0, visualViewport?.offsetTop || 0);
      const keyboardInset = Math.max(0, window.innerHeight - visualHeight - visualOffsetTop);

      drawer.style.setProperty('--clean-cart-tool-viewport-height', `${visualHeight}px`);
      drawer.style.setProperty('--clean-cart-tool-keyboard-inset', `${keyboardInset}px`);
    };

    const resetCleanCartToolViewport = (drawer) => {
      drawer?.style.removeProperty('--clean-cart-tool-viewport-height');
      drawer?.style.removeProperty('--clean-cart-tool-keyboard-inset');
    };

    const closeCleanCartToolPanel = (drawer = getCleanCartDrawer(), { restoreFocus = true } = {}) => {
      if (!drawer) return;

      drawer.classList.remove('clean-cart-drawer--tool-open');
      drawer.querySelectorAll('[data-clean-cart-tool-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('[data-clean-cart-tool-panel]').forEach((panel) => {
        panel.hidden = true;
      });

      resetCleanCartToolViewport(drawer);

      const restoreTarget = drawer.cleanCartToolRestoreFocus;
      drawer.cleanCartToolRestoreFocus = null;
      if (restoreFocus && restoreTarget?.isConnected && !restoreTarget.disabled) {
        restoreTarget.focus({ preventScroll: true });
      }
    };

    const openCleanCartToolPanel = (drawer, toolName) => {
      if (!drawer || !toolName) return;

      drawer.cleanCartToolRestoreFocus = document.activeElement;
      drawer.classList.add('clean-cart-drawer--tool-open');
      syncCleanCartToolViewport(drawer);
      drawer.querySelectorAll('[data-clean-cart-tool-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', String(button.dataset.cleanCartToolTrigger === toolName));
      });
      drawer.querySelectorAll('[data-clean-cart-tool-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.cleanCartToolPanel !== toolName;
      });

      const panel = drawer.querySelector(`[data-clean-cart-tool-panel="${toolName}"]`);
      const firstField = panel?.querySelector('textarea, [data-clean-cart-tool-save]');
      const panelBody = panel?.querySelector('.clean-cart-drawer__tool-panel-body');

      if (panel) panel.scrollTop = 0;
      if (panelBody) panelBody.scrollTop = 0;
      firstField?.focus({ preventScroll: true });
    };

    const updateCleanCartDetails = async (drawer, entries = {}) => {
      const body = new FormData();

      Object.entries(entries).forEach(([name, value]) => {
        body.append(name, value || '');
      });

      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartUpdateUrl', '/cart/update'), '/cart/update'),
        {
          method: 'POST',
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to save cart details.');
      }

      const cart = await response.json();
      await window.CleanBulkDiscounts?.refresh(cart);
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const addCleanCartGiftWrap = async (drawer) => {
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);

      if (!giftWrapVariantId) {
        throw new Error('Gift wrap is not available.');
      }

      if (hasCleanCartGiftWrapItem(window.cart, giftWrapVariantId)) {
        return refreshCleanCartDrawer(drawer);
      }

      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartAddUrl', '/cart/add'), '/cart/add'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftWrapVariantId,
            quantity: 1,
            properties: {
              '_Hadiyah delivery exempt': 'Gift Wrap',
            },
          }),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to add gift wrap.');
      }

      response.json().then(data => window['clean-commerce']?.added(data, [{ id: giftWrapVariantId, quantity: 1 }], 'legacy-cart-drawer')).catch(() => {});
      return refreshCleanCartDrawer(drawer);
    };

    const saveCleanCartToolPanel = async (drawer, toolName, saveButton) => {
      if (!drawer || !toolName || !saveButton) return;

      const originalLabel = saveButton.textContent.trim();
      saveButton.disabled = true;
      saveButton.textContent = 'Saving...';
      setCleanCartStatus(drawer);

      try {
        if (toolName === 'instructions') {
          await updateCleanCartDetails(drawer, {
            note: drawer.querySelector('[data-clean-cart-note-input]')?.value || '',
          });
        }

        if (toolName === 'gift-wrap') {
          await addCleanCartGiftWrap(drawer);
        }

        if (toolName === 'card') {
          await updateCleanCartDetails(drawer, {
            'attributes[To]': drawer.querySelector('[data-clean-cart-card-to]')?.value || '',
            'attributes[From]': drawer.querySelector('[data-clean-cart-card-from]')?.value || '',
            'attributes[Message]': drawer.querySelector('[data-clean-cart-card-message]')?.value || '',
          });
        }

        closeCleanCartToolPanel(drawer);
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to save cart details.');
      } finally {
        saveButton.disabled = false;
        saveButton.textContent = originalLabel;
      }
    };

    const updateCleanCartCountTargets = (itemCount) => {
      document.querySelectorAll('[data-clean-cart-count], [data-cart-count]').forEach((target) => {
        target.textContent = String(itemCount);
      });
    };

    const cleanCartNameOnCakePropertyName = 'Name On Cake';
    const cleanCartNameOnCakePropertyHandle = cleanCartNameOnCakePropertyName.toLowerCase();

    const cleanCartPropertyStringValue = (value) => (Array.isArray(value) ? value.join(', ') : String(value ?? ''));

    const isCleanCartPreviewProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase()
        .startsWith('preview.');

    const isCleanCartNameOnCakeProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase() === cleanCartNameOnCakePropertyHandle;

    const getCleanCartItemByKey = (key) =>
      (window.cart?.items || []).find((item) => String(item?.key || '') === String(key || ''));

    const getCleanCartPreviewUrls = (value) => {
      const values = Array.isArray(value) ? value : [value];
      const urls = [];

      values.forEach((item) => {
        const matches = String(item ?? '').match(/https?:\/\/[^\s,]+/gi) || [];

        matches.forEach((match) => {
          const candidate = match.replace(/^[('"[]+|[)'"\]]+$/g, '');

          try {
            const url = new URL(candidate);
            if ((url.protocol === 'http:' || url.protocol === 'https:') && !urls.includes(url.href)) {
              urls.push(url.href);
            }
          } catch (error) {
            // Ignore malformed preview URLs and fall back to the raw property value below.
          }
        });
      });

      return urls;
    };

    const normalizeCleanCartLineProperties = (properties) => {
      if (!properties) return {};
      if (Array.isArray(properties)) {
        const normalized = {};
        properties.forEach((entry) => {
          if (entry?.name != null && entry?.value != null && entry.value !== '') {
            normalized[entry.name] = String(entry.value);
          }
        });
        return normalized;
      }
      return typeof properties === 'object' ? properties : {};
    };

    const isCleanCartPreviewImageUrl = (raw) => {
      const value = String(raw ?? '').trim();
      if (!value || /^data:image\//i.test(value)) return false;
      return /^https?:\/\//i.test(value) || value.startsWith('//') || value.startsWith('/');
    };

    const normalizePreviewUrlForCleanCart = (raw) => {
      const value = String(raw ?? '').trim();
      if (!value) return '';
      if (/^https?:\/\//i.test(value)) return value;
      if (value.startsWith('//')) return `https:${value}`;
      if (value.startsWith('/')) return `${window.location.origin}${value}`;
      return value;
    };

    const hasHgCustomization = (properties = {}) => {
      const props = normalizeCleanCartLineProperties(properties);
      const multi = String(props._customization_previews || '').trim();
      if (multi) {
        const urls = multi
          .split('|')
          .map((part) => String(part || '').trim())
          .filter((url) => url && isCleanCartPreviewImageUrl(url));
        if (urls.length) return true;
      }
      const preview = String(props._customization_preview || '').trim();
      if (preview && isCleanCartPreviewImageUrl(preview)) return true;
      return !!(
        props._hg_customizer ||
        props._hg_preview_zones ||
        props._hg_preview_render ||
        props._hg_personalization_id ||
        props._customization_id
      );
    };

    const buildHgPreviewUrls = (item = {}) => {
      const properties = normalizeCleanCartLineProperties(item?.properties);
      const multiRaw = String(properties._customization_previews || '').trim();
      if (multiRaw) {
        return multiRaw
          .split('|')
          .map((part) => normalizePreviewUrlForCleanCart(String(part || '').trim()))
          .filter((url) => url && isCleanCartPreviewImageUrl(url));
      }
      const single = String(properties._customization_preview || '').trim();
      const normalized = normalizePreviewUrlForCleanCart(single);
      return normalized && isCleanCartPreviewImageUrl(normalized) ? [normalized] : [];
    };

    const renderHgCustomizationPreview = (item = {}) => {
      if (!hasHgCustomization(item?.properties)) return '';
      const urls = buildHgPreviewUrls(item);
      if (!urls.length) return '';
      return renderCleanCartPreviewControl(urls, item);
    };

    const renderCleanCartPreviewControl = (previewUrls = [], item = {}) => {
      const urls = (previewUrls || []).filter(Boolean);
      if (!urls.length) return '';

      const productTitle = String(item.product_title || item.title || '').trim();
      const label = urls.length > 1 ? `View Preview (${urls.length})` : 'View Preview';

      // Put URLs on the button — <script> JSON inside innerHTML is unreliable.
      return `
        <span class="cart-item__custom-preview">
          <button
            type="button"
            class="clean-cart-drawer__meta-link cart-item__preview-open"
            data-cart-preview-open
            data-cart-preview-urls="${escapeCleanCartHtml(urls.join('|'))}"
            data-cart-preview-product="${escapeCleanCartHtml(productTitle)}"
            data-cart-preview-product-url="${escapeCleanCartHtml(item.url || '')}"
            data-cart-preview-line-key="${escapeCleanCartHtml(item.key || '')}"
          >
            ${escapeCleanCartHtml(label)}
          </button>
        </span>
      `;
    };

    const renderCleanCartPropertyValue = (name, value, item = {}) => {
      const previewUrls = isCleanCartPreviewProperty(name) ? getCleanCartPreviewUrls(value) : [];

      if (previewUrls.length) {
        return renderCleanCartPreviewControl(previewUrls, item);
      }

      return escapeCleanCartHtml(cleanCartPropertyStringValue(value));
    };

    const renderCleanCartPropertyLabel = (name) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      if (normalizedName === 'preview.effects') return '';
      if (normalizedName === 'preview.texts') return 'Text';
      if (normalizedName === 'preview.images') return 'Photos';
      return name;
    };

    const isCleanCartZipcodeProperty = (name) =>
      ['pincode', 'delivery tier', 'delivery estimate', 'delivery speed'].includes(
        String(name || '')
          .trim()
          .toLowerCase(),
      );

    const renderCleanCartVariantOptions = (item = {}) => {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const visibleOptions = options.filter((option) => {
        const name = String(option?.name || '').trim();
        const value = String(option?.value || '').trim();
        return name && value && value !== 'Default Title';
      });

      if (visibleOptions.length) {
        return `
          <dl class="clean-cart-drawer__meta clean-cart-drawer__meta--variants">
            ${visibleOptions
              .map(
                (option) => `
                  <div class="clean-cart-drawer__meta-row">
                    <dt>${escapeCleanCartHtml(option.name)}:</dt>
                    <dd>${escapeCleanCartHtml(option.value)}</dd>
                  </div>
                `,
              )
              .join('')}
          </dl>
        `;
      }

      const variantTitle = String(item.variant_title || '').trim();
      if (!variantTitle || variantTitle === 'Default Title') return '';

      return `
        <dl class="clean-cart-drawer__meta clean-cart-drawer__meta--variants">
          <div class="clean-cart-drawer__meta-row">
            <dt>Variant:</dt>
            <dd>${escapeCleanCartHtml(variantTitle)}</dd>
          </div>
        </dl>
      `;
    };

    const renderCleanCartNameOnCakeProperty = (value) => {
      const stringValue = cleanCartPropertyStringValue(value);
      const escapedValue = escapeCleanCartHtml(stringValue);

      return `
        <div class="clean-cart-drawer__meta-row clean-cart-drawer__meta-row--editable" data-clean-cart-name-on-cake-row>
          <dt>${escapeCleanCartHtml(cleanCartNameOnCakePropertyName)}:</dt>
          <dd>
            <span class="clean-cart-drawer__property-view" data-clean-cart-name-on-cake-view>
              <span data-clean-cart-name-on-cake-value>${escapedValue}</span>
              <button
                class="clean-cart-drawer__property-edit"
                type="button"
                aria-label="Edit name on cake"
                data-clean-cart-edit-name-on-cake
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="m4 20 4.5-1 10-10a2.1 2.1 0 0 0-3-3l-10 10L4 20Z"></path>
                  <path d="m13.5 7.5 3 3"></path>
                </svg>
              </button>
            </span>
            <span class="clean-cart-drawer__property-editor" data-clean-cart-name-on-cake-editor hidden>
              <input
                class="clean-cart-drawer__property-input"
                type="text"
                value="${escapedValue}"
                autocomplete="off"
                aria-label="Name On Cake"
                data-clean-cart-name-on-cake-input
              >
              <button
                class="clean-cart-drawer__property-action clean-cart-drawer__property-action--save"
                type="button"
                data-clean-cart-save-name-on-cake
              >
                Save
              </button>
              <button
                class="clean-cart-drawer__property-action"
                type="button"
                data-clean-cart-cancel-name-on-cake
              >
                Cancel
              </button>
            </span>
          </dd>
        </div>
      `;
    };

    const renderCleanCartProperties = (properties = {}, item = {}) => {
      const normalized = normalizeCleanCartLineProperties(properties);
      const entries = Object.entries(normalized).filter(([name, value]) => {
        const stringValue = cleanCartPropertyStringValue(value);
        const lower = String(name || '').trim().toLowerCase();
        if (lower === 'hamper') return false;
        return name && !name.startsWith('_') && !isCleanCartZipcodeProperty(name) && stringValue.trim() !== '';
      });

      if (!entries.length) return '';

      const visibleEntries = entries.filter(
        ([name]) =>
          ['Delivery Date', 'Delivery Day', 'Delivery Time', 'Name On Cake'].includes(name) ||
          isCleanCartPreviewProperty(name),
      );
      const fallbackEntries = visibleEntries.length ? visibleEntries : entries.slice(0, 3);

      return `
        <dl class="clean-cart-drawer__meta">
          ${fallbackEntries
            .map(([name, value]) => {
              if (isCleanCartNameOnCakeProperty(name)) {
                return renderCleanCartNameOnCakeProperty(value);
              }

              const label = renderCleanCartPropertyLabel(name);
              return `
                <div class="clean-cart-drawer__meta-row">
                  ${label ? `<dt>${escapeCleanCartHtml(label)}:</dt>` : ''}
                  <dd>${renderCleanCartPropertyValue(name, value, item)}</dd>
                </div>
              `;
            })
            .join('')}
        </dl>
      `;
    };

    const isCleanCartAddOnItem = (item = {}) => {
      const properties = item?.properties || {};
      return (
        String(properties['_Add-on upsell'] || '').trim().toLowerCase() === 'yes' ||
        String(properties['_Add-on source'] || '').trim().toLowerCase() === 'post add-to-cart drawer'
      );
    };

    const getCleanCartHamperId = (item = {}) => {
      const properties = normalizeCleanCartLineProperties(item?.properties);
      const id = String(properties._hamper_id || '').trim();
      if (id) return id;
      const named = String(properties.Hamper || properties.hamper || '').trim();
      return named ? `named:${named}` : '';
    };

    const isCleanCartHamperHost = (item = {}) => {
      const properties = normalizeCleanCartLineProperties(item?.properties);
      return String(properties._hamper_host || '').trim().toLowerCase() === 'true';
    };

    const groupCleanCartHamperItems = (items = []) => {
      const groups = new Map();
      const nonHamper = [];

      items.forEach((item) => {
        const hamperId = getCleanCartHamperId(item);
        if (!hamperId) {
          nonHamper.push(item);
          return;
        }
        if (!groups.has(hamperId)) {
          groups.set(hamperId, { id: hamperId, host: null, children: [], all: [] });
        }
        const group = groups.get(hamperId);
        group.all.push(item);
        if (isCleanCartHamperHost(item)) group.host = item;
        else group.children.push(item);
      });

      groups.forEach((group) => {
        if (!group.host && group.all.length) {
          group.host = group.all[0];
          group.children = group.all.slice(1);
        } else if (group.host) {
          group.children = group.all.filter((item) => item.key !== group.host.key);
        }
      });

      return { groups: [...groups.values()], nonHamper };
    };

    const cleanCartLineMoney = (item = {}) =>
      getCleanCartLinePrice(item);

    const renderCleanCartHamper = (group, drawer) => {
      const host = group.host || group.all[0];
      const hostQty = cleanClampCartQuantity(host?.quantity || 1);
      const lineCount = group.all.length;
      const total = group.all.reduce((sum, item) => sum + cleanCartLineMoney(item), 0);
      const title = 'Custom Hamper';
      const editUrl = '/pages/make-your-own-hamper';
      const hostImage = host?.image
        ? `<img class="clean-cart-drawer__hamper-thumb" src="${escapeCleanCartHtml(
            getCleanCartImageUrl(host.image),
          )}" alt="" width="70" height="70" loading="lazy">`
        : `<div class="clean-cart-drawer__hamper-icon" aria-hidden="true">
              <svg viewBox="0 0 48 48" fill="none">
                <path d="M8 16h32l-2 24H10L8 16Z" stroke="currentColor" stroke-width="2"/>
                <path d="M8 16l4-8h24l4 8" stroke="currentColor" stroke-width="2"/>
                <path d="M24 8v8" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>`;
      const lines = group.all
        .map((item) => {
          const qty = cleanClampCartQuantity(item.quantity || 1);
          const thumb = item.image
            ? `<img src="${escapeCleanCartHtml(getCleanCartImageUrl(item.image))}" alt="" width="40" height="40" loading="lazy">`
            : '<span class="clean-cart-drawer__hamper-line-placeholder"></span>';
          return `
            <li class="clean-cart-drawer__hamper-line">
              ${thumb}
              <span class="clean-cart-drawer__hamper-line-title">${escapeCleanCartHtml(
                item.product_title || item.title,
              )}</span>
              <span class="clean-cart-drawer__hamper-line-price" ${cleanCartMoneyAttributes(
                cleanCartLineMoney(item),
                drawer,
              )}>${escapeCleanCartHtml(
                cleanFormatCartMoney(cleanCartLineMoney(item), drawer.dataset.cleanCartMoneyFormat),
              )} ×${qty}</span>
            </li>
          `;
        })
        .join('');

      return `
        <article class="clean-cart-drawer__hamper" data-clean-cart-hamper="${escapeCleanCartHtml(
          group.id,
        )}" data-clean-cart-hamper-qty="${hostQty}">
          <div class="clean-cart-drawer__hamper-top">
            ${hostImage}
            <div class="clean-cart-drawer__hamper-main">
              <div class="clean-cart-drawer__hamper-heading">
                <div>
                  <h3 class="clean-cart-drawer__hamper-title">${escapeCleanCartHtml(title)}</h3>
                  <p class="clean-cart-drawer__hamper-sub">${lineCount} item(s)</p>
                  <strong class="clean-cart-drawer__hamper-total" ${cleanCartMoneyAttributes(
                    total,
                    drawer,
                  )}>${escapeCleanCartHtml(
                    cleanFormatCartMoney(total, drawer.dataset.cleanCartMoneyFormat),
                  )}</strong>
                  <button type="button" class="clean-cart-drawer__hamper-details" data-clean-cart-hamper-details aria-expanded="false">
                    View Details
                  </button>
                </div>
                <div class="clean-cart-drawer__hamper-meta">
                  <button class="clean-cart-drawer__hamper-remove" type="button" aria-label="Remove Custom Hamper" data-clean-cart-hamper-remove>
                    <svg viewBox="0 0 24 24" aria-hidden="true" width="18" height="18">
                      <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3" fill="none" stroke="currentColor" stroke-width="1.6"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="clean-cart-drawer__hamper-quantity" data-clean-cart-hamper-quantity>
                <button type="button" aria-label="Decrease hamper quantity" data-clean-cart-hamper-decrease${
                  hostQty <= 1 ? ' disabled' : ''
                }>-</button>
                <input
                  type="number"
                  min="1"
                  step="1"
                  value="${hostQty}"
                  inputmode="numeric"
                  aria-label="Hamper quantity"
                  data-clean-cart-hamper-input
                >
                <button type="button" aria-label="Increase hamper quantity" data-clean-cart-hamper-increase>+</button>
              </div>
              <div class="clean-cart-drawer__hamper-actions">
                <a class="clean-cart-drawer__hamper-edit" href="${escapeCleanCartHtml(editUrl)}" data-clean-cart-hamper-edit>Edit</a>
              </div>
            </div>
          </div>
          <ul class="clean-cart-drawer__hamper-lines" data-clean-cart-hamper-lines hidden>${lines}</ul>
        </article>
      `;
    };

    const renderCleanCartItems = (drawer, cart) => {
      const itemsTarget = drawer?.querySelector('[data-clean-cart-drawer-items]');
      const countTarget = drawer?.querySelector('[data-clean-cart-drawer-count]');
      const totalTarget = drawer?.querySelector('[data-clean-cart-drawer-total]');
      const footer = drawer?.querySelector('[data-clean-cart-drawer-footer]');
      const checkout = drawer?.querySelector('.clean-cart-drawer__checkout');
      const gokwikCheckout = drawer?.querySelector('[data-clean-gokwik-checkout]');

      if (!itemsTarget || !countTarget || !totalTarget) return;

      const renderId = String(++cleanCartRenderSequence);
      drawer.dataset.cleanCartRenderId = renderId;
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);
      const deliverySummary = getCleanCartDeliverySummary(cart, drawer);
      const itemCount = deliverySummary.merchandiseItemCount;
      const itemText = itemCount === 1 ? 'item' : 'items';
      itemsTarget.classList.toggle('clean-cart-drawer__items--empty', itemCount === 0);
      if (footer) footer.hidden = itemCount === 0;
      countTarget.textContent = `${itemCount} ${itemText}`;
      renderCleanCartTotals(drawer, cart);
      window.cart = cart;
      drawer.cleanCartRenderedCart = cart;
      syncCleanCartToolFields(drawer, cart);
      updateCleanCartCountTargets(itemCount);

      [checkout, gokwikCheckout].forEach((target) => {
        if (!target) return;

        if (itemCount === 0) {
          target.setAttribute('aria-disabled', 'true');
        } else {
          target.removeAttribute('aria-disabled');
        }
      });

      if (!itemCount) {
        const emptyTemplate = drawer.querySelector('[data-clean-cart-empty-template]');
        if (emptyTemplate) {
          itemsTarget.replaceChildren(emptyTemplate.content.cloneNode(true));
        } else {
          itemsTarget.replaceChildren();
        }
        return;
      }

      const addOnsWereOpen = itemsTarget.querySelector('[data-clean-cart-drawer-add-ons]')?.open ?? true;
      const ordinaryItems = deliverySummary.merchandiseItems.filter((item) => !isCleanCartAddOnItem(item));
      const addOnItems = deliverySummary.merchandiseItems.filter((item) => isCleanCartAddOnItem(item));
      const addOnQuantity = addOnItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
      const { groups: hamperGroups, nonHamper } = groupCleanCartHamperItems(ordinaryItems);
      const renderItem = (item) => {
        const isGiftWrapItem = isCleanCartGiftWrapItem(item, giftWrapVariantId);
        const isAddOnItem = isCleanCartAddOnItem(item);
        const minimumQuantity = getCleanCartMinimumQuantity(item);
        const itemQuantity = cleanClampCartQuantity(item.quantity);
        const decreaseDisabled = minimumQuantity > 0 && itemQuantity <= minimumQuantity ? ' disabled' : '';
        const increaseDisabled =
          minimumQuantity > 0 && itemQuantity >= cleanCartMaximumBulkQuantity ? ' disabled' : '';
        const maximumAttribute = minimumQuantity ? ` max="${cleanCartMaximumBulkQuantity}"` : '';
        const itemImage = item.image
          ? `<img class="clean-cart-drawer__image" src="${escapeCleanCartHtml(
              getCleanCartImageUrl(item.image),
            )}" alt="${escapeCleanCartHtml(item.product_title || item.title)}" width="70" height="70" loading="lazy">`
          : '<div class="clean-cart-drawer__image" aria-hidden="true"></div>';
        const quantityControls = isGiftWrapItem
          ? ''
          : `
                <div class="clean-cart-drawer__quantity" data-clean-cart-quantity>
                  <button type="button" aria-label="Decrease quantity" data-clean-cart-quantity-decrease${decreaseDisabled}>-</button>
                  <input
                    type="number"
                    min="${minimumQuantity || 0}"
                    ${maximumAttribute}
                    step="1"
                    value="${itemQuantity}"
                    inputmode="numeric"
                    aria-label="Quantity for ${escapeCleanCartHtml(item.product_title || item.title)}"
                    data-clean-cart-quantity-input
                  >
                  <button type="button" aria-label="Increase quantity" data-clean-cart-quantity-increase${increaseDisabled}>+</button>
                </div>
              `;

        return `
            <article class="clean-cart-drawer__item${
              isAddOnItem ? ' clean-cart-drawer__item--add-on' : ''
            }" data-clean-cart-item="${escapeCleanCartHtml(
              item.key,
            )}" data-cart-line-key="${escapeCleanCartHtml(item.key || '')}" data-clean-cart-minimum-quantity="${minimumQuantity}">
              <a href="${escapeCleanCartHtml(item.url || '#')}" aria-label="${escapeCleanCartHtml(item.title)}">
                ${itemImage}
              </a>
              <div class="clean-cart-drawer__item-body">
                <a class="clean-cart-drawer__item-title" href="${escapeCleanCartHtml(item.url || '#')}">
                  ${escapeCleanCartHtml(item.product_title || item.title)}
                </a>
                ${renderCleanCartVariantOptions(item)}
                ${renderCleanCartProperties(item.properties, item)}
                ${renderHgCustomizationPreview(item)}
                <div class="clean-cart-drawer__prices" data-clean-cart-price-block>
                  ${renderCleanCartPriceHtml(item, drawer)}
                </div>
                ${quantityControls}
              </div>
              <button class="clean-cart-drawer__remove" type="button" aria-label="Remove ${escapeCleanCartHtml(
                item.product_title || item.title,
              )}" data-clean-cart-remove>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3"></path>
                </svg>
              </button>
              <span class="clean-cart-drawer__item-loading" data-clean-cart-item-loading-label aria-live="polite">
                Updating cart...
              </span>
            </article>
          `;
      };
      const addOnMarkup = addOnItems.map(renderItem).join('');
      const hamperMarkup = hamperGroups.map((group) => renderCleanCartHamper(group, drawer)).join('');

      itemsTarget.innerHTML = `
        ${hamperMarkup}
        ${nonHamper.map(renderItem).join('')}
        ${
          addOnItems.length
            ? `
              <details class="clean-cart-drawer__add-ons" data-clean-cart-drawer-add-ons${
                addOnsWereOpen ? ' open' : ''
              }>
                <summary class="clean-cart-drawer__add-ons-summary">
                  <span>Add-ons</span>
                  <span class="clean-cart-drawer__add-ons-count">${addOnQuantity}</span>
                </summary>
                <div class="clean-cart-drawer__add-ons-items">
                  ${addOnMarkup}
                </div>
              </details>
            `
            : ''
        }
      `;

      hydrateCleanCartComparePrices(drawer, cart, renderId).catch(() => {});
    };

    const setCleanCartItemLoading = (item, isLoading, message = 'Updating cart...') => {
      if (!item) return;

      item.classList.toggle('clean-cart-drawer__item--loading', isLoading);
      item.toggleAttribute('aria-busy', isLoading);
      item.dataset.cleanCartItemLoading = isLoading ? 'true' : 'false';

      const label = item.querySelector('[data-clean-cart-item-loading-label]');
      if (label) label.textContent = message;

      item.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isLoading;
      });

      if (!isLoading) syncCleanCartItemQuantityControls(item);
    };

    const restoreCleanCartItemQuantity = (item) => {
      const key = item?.dataset.cleanCartItem;
      const cartItem = getCleanCartItemByKey(key);
      const input = item?.querySelector('[data-clean-cart-quantity-input]');
      if (!input || !cartItem) return;

      input.value = String(cleanClampCartQuantity(cartItem.quantity));
      syncCleanCartItemQuantityControls(item);
    };

    const changeCleanCartItemWithLoading = async (
      drawer,
      item,
      quantity,
      message,
      { allowRemoval = false } = {},
    ) => {
      const key = item?.dataset.cleanCartItem;
      if (!drawer || !item || !key || item.dataset.cleanCartItemLoading === 'true') return null;

      const cartItem = getCleanCartItemByKey(key);
      const cleanQuantity = cleanCartLineQuantity(cartItem, quantity, { allowRemoval });

      setCleanCartItemLoading(item, true, message);

      try {
        return await changeCleanCartItem(drawer, key, cleanQuantity, { allowRemoval });
      } catch (error) {
        restoreCleanCartItemQuantity(item);
        throw error;
      } finally {
        if (item.isConnected) {
          setCleanCartItemLoading(item, false);
        }
      }
    };

    const fetchCleanCart = async (drawer = getCleanCartDrawer(), suppliedCart, options = {}) => {
      if (!drawer || (drawer.cleanCartHandoff && !options.handoff)) return null;
      const revision = (drawer.cleanCartRefreshRevision || 0) + 1;
      drawer.cleanCartRefreshRevision = revision;
      const isCurrent = () => drawer.cleanCartRefreshRevision === revision;
      // /cart/add items are only the added lines, never an authoritative cart.
      const complete = Array.isArray(suppliedCart?.items) &&
        typeof suppliedCart.item_count === 'number' &&
        typeof suppliedCart.total_price === 'number' && typeof suppliedCart.currency === 'string';

      const coordinator = getCleanCartStateCoordinator();
      let cart = complete ? coordinator.publish(suppliedCart) : await coordinator.refresh(async () => {
        const response = await cleanCartRequest(getCleanCartJsonUrl(drawer));
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      });

      if (!isCurrent()) return null;

      if (drawer.dataset.cleanCartZeroPriceRepairAttempted !== 'true') {
        const zeroPriceUpdates = Object.fromEntries(
          (cart?.items || [])
            .filter((item) => !isCleanCartDeliveryChargeItem(item) && hasCleanCartUnexpectedZeroPrice(item))
            .map((item) => [String(item.key || '').trim(), cleanClampCartQuantity(item.quantity)])
            .filter(([key, quantity]) => key && quantity > 0),
        );

        if (Object.keys(zeroPriceUpdates).length) {
          drawer.dataset.cleanCartZeroPriceRepairAttempted = 'true';
          const response = await cleanCartRequest(
            cleanCartAjaxUrl(drawer.dataset.cleanCartUpdateUrl, '/cart/update'),
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: zeroPriceUpdates }),
            },
          );

          if (response.ok) {
            cart = await response.json();
            if (!isCurrent()) return null;
            coordinator.publish(cart);
          }
        }
      }

      if (!isCurrent()) return null;
      if (window.HadiyahDeliveryCharge?.sync) {
        cart = await window.HadiyahDeliveryCharge.sync(cart);
        if (!isCurrent()) return null;
        coordinator.publish(cart);
      }

      await window.CleanBulkDiscounts?.refresh(cart);
      if (!isCurrent()) return null;
      if (drawer.cleanCartRenderedCart !== cart) renderCleanCartItems(drawer, cart);
      return cart;
    };

    const broadcastCleanCart = (cart, origin = 'clean-cart-drawer') => {
      getCleanCartStateCoordinator().publish(cart);
      document.dispatchEvent(
        new CustomEvent('clean:cart:updated', {
          detail: { cart, origin },
        }),
      );
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            item_count: getCleanCartDeliverySummary(cart).merchandiseItemCount,
            cart,
            data: cart,
          },
        }),
      );

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: origin,
          cartData: cart,
        });
      }
    };

    const refreshCleanCartDrawer = async (drawer = getCleanCartDrawer(), suppliedCart, options) => {
      const cart = await fetchCleanCart(drawer, suppliedCart, options);
      if (cart) broadcastCleanCart(cart);
      return cart;
    };

    const animateCleanCartShippingProgress = (drawer) => {
      if (!drawer || drawer.cleanCartShippingProgressAnimated) return false;

      const panel = drawer.querySelector('[data-clean-cart-shipping-progress-panel]');
      if (!panel || panel.hidden) return false;

      const progress = Math.min(100, Math.max(0, Number(panel.dataset.cleanCartShippingProgress) || 0));
      const fill = panel.querySelector('[data-clean-cart-shipping-progress-fill]');
      const truck = panel.querySelector('[data-clean-cart-shipping-progress-truck]');
      if (!fill || !truck) return false;

      drawer.cleanCartShippingProgressAnimated = true;
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        fill.style.width = `${progress}%`;
        truck.style.left = `${progress}%`;
        return true;
      }

      fill.style.transition = 'none';
      truck.style.transition = 'none';
      fill.style.width = '0%';
      truck.style.left = '0%';

      drawer.cleanCartShippingProgressStartFrame = window.requestAnimationFrame(() => {
        drawer.cleanCartShippingProgressEndFrame = window.requestAnimationFrame(() => {
          fill.style.removeProperty('transition');
          truck.style.removeProperty('transition');
          fill.style.width = `${progress}%`;
          truck.style.left = `${progress}%`;
        });
      });

      return true;
    };

    const openCleanCartDrawer = async ({ refresh = true } = {}) => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      const cleanOpening = drawer.hidden;
      setCleanCartStatus(drawer);
      drawer.hidden = false;
      drawer.cleanCartShippingProgressAnimated = false;
      document.body.classList.add('clean-cart-drawer-open');

      window.cancelAnimationFrame(drawer.cleanCartOpenFrame);
      drawer.cleanCartOpenFrame = window.requestAnimationFrame(() => {
        drawer.classList.add('clean-cart-drawer--open');
        resumeCleanCartCompareHydration(drawer);
        if (!refresh) {
          animateCleanCartShippingProgress(drawer);
          if (cleanOpening) window['clean-commerce']?.viewCart(drawer.cleanCartRenderedCart, 'legacy-cart-drawer');
        }
      });

      window.CleanGokwik.syncScope(drawer, { detect: true, prepare: true }).catch(() => {});

      if (refresh) {
        try {
          const cleanViewedCart = await fetchCleanCart(drawer);
          if (cleanOpening && !drawer.hidden)
            window['clean-commerce']?.viewCart(cleanViewedCart, 'legacy-cart-drawer');
          if (drawer.classList.contains('clean-cart-drawer--open')) {
            animateCleanCartShippingProgress(drawer);
          }
        } catch (error) {
          setCleanCartStatus(drawer, error?.message || 'Unable to refresh cart.');
          if (drawer.classList.contains('clean-cart-drawer--open')) {
            animateCleanCartShippingProgress(drawer);
          }
        }
      }
    };

    const closeCleanCartDrawer = () => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      const wasOpen = drawer.classList.contains('clean-cart-drawer--open');
      closeCleanCartToolPanel(drawer, { restoreFocus: false });
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);
      drawer.classList.remove('clean-cart-drawer--open');
      document.body.classList.remove('clean-cart-drawer-open');

      if (wasOpen) {
        document.dispatchEvent(
          new CustomEvent('clean:cart-drawer:closed', {
            detail: { cart: window.cart || null },
          }),
        );
      }

      window.clearTimeout(drawer.cleanCartCloseTimer);
      drawer.cleanCartCloseTimer = window.setTimeout(
        () => {
          if (!drawer.classList.contains('clean-cart-drawer--open')) {
            drawer.hidden = true;
          }
        },
        reducedMotion.matches ? 0 : 220,
      );
    };

    const changeCleanCartItem = async (drawer, key, quantity, { allowRemoval = false } = {}) => {
      const item = getCleanCartItemByKey(key);
      const commerce = window['clean-commerce'];
      const cleanBefore = commerce?.snapshot(drawer.cleanCartRenderedCart || window.cart);
      const cleanQuantity = cleanCartLineQuantity(item, quantity, { allowRemoval });
      const body = JSON.stringify({ id: key, quantity: cleanQuantity });
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartChangeUrl', '/cart/change'), '/cart/change'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      let cart = await response.json();
      commerce?.changed(cleanBefore, cart, 'legacy-cart-drawer', undefined, [item?.variant_id || item?.id]);
      if (window.HadiyahDeliveryCharge?.sync) cart = await window.HadiyahDeliveryCharge.sync(cart);
      await window.CleanBulkDiscounts?.refresh(cart);
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const updateCleanCartHamper = async (drawer, hamperId, nextHostQty) => {
      const cart = drawer?.cleanCartRenderedCart || window.cart;
      const lines = (cart?.items || []).filter((item) => getCleanCartHamperId(item) === String(hamperId || ''));
      if (!lines.length) return cart;

      const host = lines.find((item) => isCleanCartHamperHost(item)) || lines[0];
      const commerce = window['clean-commerce'];
      const cleanBefore = commerce?.snapshot(cart);
      const currentHostQty = Math.max(1, cleanClampCartQuantity(host?.quantity || 1));
      const targetQty = Math.max(0, cleanClampCartQuantity(nextHostQty));
      const updates = Object.fromEntries(
        lines.map((item) => {
          const base = Math.max(1, Math.round(cleanClampCartQuantity(item.quantity || 1) / currentHostQty));
          return [item.key, targetQty <= 0 ? 0 : base * targetQty];
        }),
      );

      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartUpdateUrl', '/cart/update'), '/cart/update'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update hamper.');
      }

      let nextCart = await response.json();
      commerce?.changed(cleanBefore, nextCart, 'legacy-cart-drawer', undefined, lines.map(line => line.variant_id || line.id));
      if (window.HadiyahDeliveryCharge?.sync) nextCart = await window.HadiyahDeliveryCharge.sync(nextCart);
      await window.CleanBulkDiscounts?.refresh(nextCart);
      renderCleanCartItems(drawer, nextCart);
      broadcastCleanCart(nextCart);
      return nextCart;
    };

    const updateCleanCartItemProperties = async (drawer, key, properties = {}, quantity = 1) => {
      const item = getCleanCartItemByKey(key);
      const body = JSON.stringify({
        id: key,
        quantity: cleanCartLineQuantity(item, quantity),
        properties,
      });
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartChangeUrl', '/cart/change'), '/cart/change'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      let cart = await response.json();
      if (window.HadiyahDeliveryCharge?.sync) cart = await window.HadiyahDeliveryCharge.sync(cart);
      await window.CleanBulkDiscounts?.refresh(cart);
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const setCleanCartNameOnCakeEditing = (row, isEditing) => {
      const view = row?.querySelector('[data-clean-cart-name-on-cake-view]');
      const editor = row?.querySelector('[data-clean-cart-name-on-cake-editor]');
      const input = row?.querySelector('[data-clean-cart-name-on-cake-input]');

      if (!view || !editor || !input) return;

      view.hidden = isEditing;
      editor.hidden = !isEditing;

      if (isEditing) {
        input.value = input.defaultValue;
        input.focus({ preventScroll: true });
        input.select();
      }
    };

    const saveCleanCartNameOnCake = async (drawer, row, saveButton) => {
      const itemElement = row?.closest('[data-clean-cart-item]');
      const key = itemElement?.dataset.cleanCartItem;
      const item = getCleanCartItemByKey(key);
      const input = row?.querySelector('[data-clean-cart-name-on-cake-input]');

      if (!drawer || !row || !saveButton || !key || !item || !input) {
        setCleanCartStatus(drawer, 'Unable to edit the name on cake.');
        return;
      }

      const originalLabel = saveButton.textContent.trim();
      const properties = { ...(item.properties || {}) };
      const propertyName =
        Object.keys(properties).find((name) => isCleanCartNameOnCakeProperty(name)) || cleanCartNameOnCakePropertyName;
      const nextValue = input.value.trim();

      if (nextValue) {
        properties[propertyName] = nextValue;
      } else {
        properties[propertyName] = '';
      }

      saveButton.disabled = true;
      saveButton.textContent = 'Saving';
      setCleanCartStatus(drawer);

      try {
        await updateCleanCartItemProperties(drawer, key, properties, item.quantity || 1);
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to update the name on cake.');
        saveButton.disabled = false;
        saveButton.textContent = originalLabel;
      }
    };

    const addCleanCartForm = async (drawer, productForm) => {
      const cleanRequested = [{ id: productForm.elements.id?.value, quantity: productForm.elements.quantity?.value || 1 }];
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartAddUrl', '/cart/add'), '/cart/add'),
        {
          method: 'POST',
          body: new FormData(productForm),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to add this item.');
      }

      response.json().then(data => window['clean-commerce']?.added(data, cleanRequested, 'legacy-cart-drawer')).catch(() => {});
      try {
        const cart = await refreshCleanCartDrawer(drawer);
        return { cart };
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to refresh cart.');
        return { cart: window.cart || null };
      }
    };

    const addCleanCartFormAndOpen = async (productForm) => {
      const drawer = getCleanCartDrawer();
      if (!drawer || !productForm) throw new Error('Cart drawer is not available.');

      setCleanCartStatus(drawer);

      try {
        const { cart } = await addCleanCartForm(drawer, productForm);
        await openCleanCartDrawer({ refresh: false });
        return cart;
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to add this item.');
        throw error;
      }
    };

    const isCleanCartAddUrl = (input) => {
      const rawUrl = typeof input === 'string' ? input : input?.url;
      if (!rawUrl) return false;

      try {
        const url = new URL(rawUrl, window.location.origin);
        return /\/cart\/add(\.js)?$/.test(url.pathname);
      } catch (error) {
        return String(rawUrl).includes('/cart/add');
      }
    };

    const isCleanCartInternalRequest = (init) => {
      try {
        return new Headers(init?.headers || {}).get('X-Clean-Cart') === 'true';
      } catch (error) {
        return false;
      }
    };

    const refreshCleanCartAfterTrackedAdd = async () => {
      const drawer = getCleanCartDrawer();
      if (!drawer || drawer.cleanCartHandoff) return;

      cleanCartLastTrackedAddAt = Date.now();
      const operation = (async () => {
        const cart = await refreshCleanCartDrawer(drawer);
        await openCleanCartDrawer({ refresh: false });
        return cart;
      })();
      cleanCartTrackedAddPromise = operation;

      try {
        return await operation;
      } finally {
        if (cleanCartTrackedAddPromise === operation) cleanCartTrackedAddPromise = null;
      }
    };

    const initCleanCartDrawer = (root = document) => {
      const drawer = getCleanCartDrawer();
      if (!drawer || drawer.dataset.cleanCartDrawerReady === 'true') return;

      drawer.dataset.cleanCartDrawerReady = 'true';
      const lifecycle = new AbortController();
      // The visible shell can still contain old controls during a handoff.
      // Block keyboard and change events too; keep dismissal and Tab available.
      ['click', 'change', 'keydown'].forEach((type) => {
        drawer.addEventListener(type, (event) => {
          if ((!drawer.cleanCartHandoff && drawer.getAttribute('aria-busy') !== 'true') ||
              event.target.closest('[data-clean-cart-drawer-close]') ||
              (type === 'keydown' && ['Escape', 'Tab'].includes(event.key))) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { capture: true, signal: lifecycle.signal });
      });
      drawer.cleanCartDrawerLifecycle = lifecycle;
      syncCleanCartToolCount(drawer);

      const syncToolPanelViewport = () => syncCleanCartToolViewport(drawer);
      window.addEventListener('resize', syncToolPanelViewport, { signal: lifecycle.signal });
      window.visualViewport?.addEventListener('resize', syncToolPanelViewport, {
        signal: lifecycle.signal,
      });
      window.visualViewport?.addEventListener('scroll', syncToolPanelViewport, {
        signal: lifecycle.signal,
      });

      drawer.addEventListener(
        'click',
        (event) => {
          const previewButton = event.target.closest('[data-cart-preview-open], .cart-item__preview-open');
          if (previewButton && drawer.contains(previewButton)) {
            event.preventDefault();
            event.stopPropagation();

            const openPreview = () => {
              if (typeof window.__hadiyahOpenCartPreview === 'function') {
                window.__hadiyahOpenCartPreview(previewButton);
                return true;
              }
              return false;
            };

            if (openPreview()) return;

            if (typeof window.__mountCartPreviewSetup === 'function') {
              window.__mountCartPreviewSetup(() => {
                openPreview();
              });
            }
            return;
          }

          const closeButton = event.target.closest('[data-clean-cart-drawer-close]');
          if (closeButton && drawer.contains(closeButton)) {
            event.preventDefault();
            closeCleanCartDrawer();
            return;
          }

          const summaryToggle = event.target.closest('[data-clean-cart-summary-toggle]');
          if (summaryToggle && drawer.contains(summaryToggle)) {
            event.preventDefault();
            const summary = drawer.querySelector('[data-clean-cart-summary]');
            const isExpanded = summaryToggle.getAttribute('aria-expanded') === 'true';
            summaryToggle.setAttribute('aria-expanded', String(!isExpanded));
            if (summary) summary.hidden = isExpanded;
            return;
          }

          const trigger = event.target.closest('[data-clean-cart-tool-trigger]');
          if (trigger && drawer.contains(trigger)) {
            event.preventDefault();
            if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
            openCleanCartToolPanel(drawer, trigger.dataset.cleanCartToolTrigger);
            return;
          }

          const panelClose = event.target.closest('[data-clean-cart-tool-close]');
          if (panelClose && drawer.contains(panelClose)) {
            event.preventDefault();
            closeCleanCartToolPanel(drawer);
            return;
          }

          if (event.target.closest('[data-clean-cart-tool-cancel]')) {
            event.preventDefault();
            closeCleanCartToolPanel(drawer);
            return;
          }

          const saveButton = event.target.closest('[data-clean-cart-tool-save]');
          if (saveButton && drawer.contains(saveButton)) {
            event.preventDefault();
            saveCleanCartToolPanel(drawer, saveButton.dataset.cleanCartToolSave, saveButton);
          }
        },
        { capture: true, signal: lifecycle.signal },
      );

      drawer.querySelectorAll('[data-clean-gokwik-checkout]').forEach((button) => {
        button.addEventListener(
          'click',
          async (event) => {
            event.preventDefault();

            if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

            window['clean-commerce']?.checkout(drawer.cleanCartRenderedCart || window.cart, 'legacy-cart-drawer');
            button.disabled = true;
            setCleanCartStatus(drawer);

            try {
              await refreshCleanCartDrawer(drawer);
              await window.CleanGokwik.checkout(button, drawer);
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to start GoKwik checkout.');
              window.CleanGokwik.fallbackToShopify(drawer, 'drawer_refresh_failed');
            } finally {
              button.disabled = false;
            }
          },
          { signal: lifecycle.signal },
        );
      });

      drawer.querySelectorAll('[data-clean-shopify-checkout]').forEach((link) => {
        link.addEventListener(
          'click',
          async (event) => {
            event.preventDefault();
            if (link.getAttribute('aria-disabled') === 'true') return;
            window['clean-commerce']?.checkout(drawer.cleanCartRenderedCart || window.cart, 'legacy-cart-drawer');

            try {
              await refreshCleanCartDrawer(drawer);
              await window.CleanGokwik.routeCheckout(link, drawer, {
                checkoutUrl: link.href,
                source: 'drawer_shopify_control',
              });
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to prepare checkout.');
            }
          },
          { signal: lifecycle.signal },
        );
      });

      drawer.addEventListener(
        'click',
        async (event) => {
          const hamper = event.target.closest('[data-clean-cart-hamper]');
          if (hamper && drawer.contains(hamper)) {
            const hamperId = hamper.dataset.cleanCartHamper;
            const currentQty = cleanClampCartQuantity(hamper.dataset.cleanCartHamperQty || 1);

            if (event.target.closest('[data-clean-cart-hamper-edit]')) {
              return;
            }

            if (event.target.closest('[data-clean-cart-hamper-details]')) {
              event.preventDefault();
              const lines = hamper.querySelector('[data-clean-cart-hamper-lines]');
              const toggle = event.target.closest('[data-clean-cart-hamper-details]');
              if (!lines || !toggle) return;
              const isOpen = !lines.hidden;
              lines.hidden = isOpen;
              toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
              toggle.textContent = isOpen ? 'View Details' : 'Hide Details';
              return;
            }

            if (event.target.closest('[data-clean-cart-hamper-remove]')) {
              event.preventDefault();
              hamper.classList.add('clean-cart-drawer__hamper--loading');
              try {
                await updateCleanCartHamper(drawer, hamperId, 0);
              } catch (error) {
                hamper.classList.remove('clean-cart-drawer__hamper--loading');
                setCleanCartStatus(drawer, error?.message || 'Unable to remove hamper.');
              }
              return;
            }

            if (event.target.closest('[data-clean-cart-hamper-decrease]')) {
              event.preventDefault();
              if (currentQty <= 1) return;
              hamper.classList.add('clean-cart-drawer__hamper--loading');
              try {
                await updateCleanCartHamper(drawer, hamperId, currentQty - 1);
              } catch (error) {
                hamper.classList.remove('clean-cart-drawer__hamper--loading');
                setCleanCartStatus(drawer, error?.message || 'Unable to update hamper.');
              }
              return;
            }

            if (event.target.closest('[data-clean-cart-hamper-increase]')) {
              event.preventDefault();
              hamper.classList.add('clean-cart-drawer__hamper--loading');
              try {
                await updateCleanCartHamper(drawer, hamperId, currentQty + 1);
              } catch (error) {
                hamper.classList.remove('clean-cart-drawer__hamper--loading');
                setCleanCartStatus(drawer, error?.message || 'Unable to update hamper.');
              }
              return;
            }
          }

          const item = event.target.closest('[data-clean-cart-item]');
          if (!item || !drawer.contains(item)) return;

          const quantityInput = item.querySelector('[data-clean-cart-quantity-input]');

          const editNameOnCakeButton = event.target.closest('[data-clean-cart-edit-name-on-cake]');
          if (editNameOnCakeButton) {
            event.preventDefault();
            setCleanCartNameOnCakeEditing(editNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'), true);
            return;
          }

          const cancelNameOnCakeButton = event.target.closest('[data-clean-cart-cancel-name-on-cake]');
          if (cancelNameOnCakeButton) {
            event.preventDefault();
            setCleanCartNameOnCakeEditing(cancelNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'), false);
            return;
          }

          const saveNameOnCakeButton = event.target.closest('[data-clean-cart-save-name-on-cake]');
          if (saveNameOnCakeButton) {
            event.preventDefault();
            await saveCleanCartNameOnCake(
              drawer,
              saveNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'),
              saveNameOnCakeButton,
            );
            return;
          }

          if (event.target.closest('[data-clean-cart-remove]')) {
            event.preventDefault();
            try {
              await changeCleanCartItemWithLoading(drawer, item, 0, 'Removing...', { allowRemoval: true });
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to remove item.');
            }
            return;
          }

          if (event.target.closest('[data-clean-cart-quantity-decrease]')) {
            event.preventDefault();
            const minimum = getCleanCartElementMinimumQuantity(item);
            const currentQuantity = cleanClampCartQuantity(quantityInput?.value);
            if (minimum && currentQuantity <= minimum) {
              quantityInput.value = String(minimum);
              syncCleanCartItemQuantityControls(item);
              setCleanCartStatus(drawer, `Minimum order quantity is ${minimum}.`);
              return;
            }
            try {
              await changeCleanCartItemWithLoading(
                drawer,
                item,
                currentQuantity - 1,
                'Updating cart...',
              );
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
            }
            return;
          }

          if (event.target.closest('[data-clean-cart-quantity-increase]')) {
            event.preventDefault();
            const minimum = getCleanCartElementMinimumQuantity(item);
            const currentQuantity = cleanClampCartQuantity(quantityInput?.value);
            if (minimum && currentQuantity >= cleanCartMaximumBulkQuantity) {
              quantityInput.value = String(cleanCartMaximumBulkQuantity);
              syncCleanCartItemQuantityControls(item);
              setCleanCartStatus(drawer, `Maximum quantity is ${cleanCartMaximumBulkQuantity}.`);
              return;
            }
            try {
              await changeCleanCartItemWithLoading(
                drawer,
                item,
                currentQuantity + 1,
                'Updating cart...',
              );
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
            }
          }
        },
        { signal: lifecycle.signal },
      );

      drawer.addEventListener(
        'change',
        async (event) => {
          const hamperInput = event.target.closest('[data-clean-cart-hamper-input]');
          if (hamperInput && drawer.contains(hamperInput)) {
            const hamper = hamperInput.closest('[data-clean-cart-hamper]');
            if (!hamper) return;
            const hamperId = hamper.dataset.cleanCartHamper;
            const cleanQuantity = Math.max(1, cleanClampCartQuantity(hamperInput.value));
            hamperInput.value = String(cleanQuantity);
            hamper.classList.add('clean-cart-drawer__hamper--loading');
            try {
              await updateCleanCartHamper(drawer, hamperId, cleanQuantity);
            } catch (error) {
              hamper.classList.remove('clean-cart-drawer__hamper--loading');
              setCleanCartStatus(drawer, error?.message || 'Unable to update hamper.');
            }
            return;
          }

          const input = event.target.closest('[data-clean-cart-quantity-input]');
          if (!input || !drawer.contains(input)) return;

          const item = input.closest('[data-clean-cart-item]');
          if (!item) return;

          const minimum = getCleanCartElementMinimumQuantity(item);
          const requestedQuantity = cleanClampCartQuantity(input.value);
          const cleanQuantity = minimum
            ? Math.min(cleanCartMaximumBulkQuantity, Math.max(minimum, requestedQuantity))
            : requestedQuantity;

          if (cleanQuantity !== requestedQuantity) {
            input.value = String(cleanQuantity);
            syncCleanCartItemQuantityControls(item);
            setCleanCartStatus(
              drawer,
              requestedQuantity < minimum
                ? `Minimum order quantity is ${minimum}.`
                : `Maximum quantity is ${cleanCartMaximumBulkQuantity}.`,
            );
          }

          try {
            await changeCleanCartItemWithLoading(drawer, item, cleanQuantity, 'Updating cart...');
          } catch (error) {
            setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
          }
        },
        { signal: lifecycle.signal },
      );

      drawer.addEventListener(
        'keydown',
        async (event) => {
          const input = event.target.closest('[data-clean-cart-name-on-cake-input]');
          if (!input || !drawer.contains(input)) return;

          const row = input.closest('[data-clean-cart-name-on-cake-row]');

          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            setCleanCartNameOnCakeEditing(row, false);
            row?.querySelector('[data-clean-cart-edit-name-on-cake]')?.focus({ preventScroll: true });
            return;
          }

          if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            const saveButton = row?.querySelector('[data-clean-cart-save-name-on-cake]');
            if (!saveButton || saveButton.disabled) return;
            await saveCleanCartNameOnCake(drawer, row, saveButton);
          }
        },
        { signal: lifecycle.signal },
      );

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape' || drawer.hidden) return;

          if (drawer.classList.contains('clean-cart-drawer--tool-open')) {
            closeCleanCartToolPanel(drawer);
            return;
          }

          closeCleanCartDrawer();
        },
        { signal: lifecycle.signal },
      );

      drawer.cleanCartDrawerCleanup = () => {
        lifecycle.abort();
        window.cancelAnimationFrame(drawer.cleanCartOpenFrame);
        window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
        window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);
        window.clearTimeout(drawer.cleanCartCloseTimer);
        window.clearTimeout(drawer.cleanCartRewardCelebrationTimer);
        cleanCartPendingCompareHydrations.delete(drawer);
        delete drawer.dataset.cleanCartDrawerReady;
      };
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCartDrawer(), { once: true });
    } else {
      initCleanCartDrawer();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCartDrawer(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const cartDrawer =
        event.target.querySelector?.('[data-clean-cart-drawer]') ||
        (event.target.matches?.('[data-clean-cart-drawer]') ? event.target : null);
      cartDrawer?.cleanCartDrawerCleanup?.();
    });

    if (
      getCleanCartDrawer()?.dataset.cleanCartHostAddFlow !== 'true' &&
      document.body.dataset.cleanCartAddWatcherReady !== 'true'
    ) {
      document.body.dataset.cleanCartAddWatcherReady = 'true';

      const nativeFetch = window.fetch;
      window.fetch = function cleanCartDrawerFetch(input, init) {
        const isCartAdd = isCleanCartAddUrl(input);
        const responsePromise = nativeFetch.apply(this, arguments);

        if (isCartAdd && !isCleanCartInternalRequest(init) && getCleanCartDrawer() &&
            !getCleanCartDrawer().cleanCartHandoff) {
          responsePromise
            .then((response) => {
              if (response.ok) {
                window.setTimeout(() => {
                  refreshCleanCartAfterTrackedAdd().catch(() => {});
                }, 80);
              }
            })
            .catch(() => {});
        }

        return responsePromise;
      };

      const nativeXhrOpen = window.XMLHttpRequest?.prototype?.open;
      if (nativeXhrOpen) {
        window.XMLHttpRequest.prototype.open = function cleanCartDrawerXhrOpen(method, url) {
          this.cleanCartDrawerTrackedAdd = isCleanCartAddUrl(url);

          if (this.cleanCartDrawerLoadReady !== 'true') {
            this.cleanCartDrawerLoadReady = 'true';
            this.addEventListener('load', function cleanCartDrawerXhrLoad() {
              if (this.cleanCartDrawerTrackedAdd && this.status >= 200 && this.status < 300 && getCleanCartDrawer()) {
                window.setTimeout(() => {
                  refreshCleanCartAfterTrackedAdd().catch(() => {});
                }, 80);
              }
            });
          }

          return nativeXhrOpen.apply(this, arguments);
        };
      }
    }

    window.CleanCart = {
      ...(window.CleanCart || {}),
      addFromForm: addCleanCartFormAndOpen,
      changeItem: changeCleanCartItem,
      fetch: refreshCleanCartDrawer,
      getRecentCart: (maxAge = 2000) => {
        const coordinator = getCleanCartStateCoordinator();
        const isRecent =
          Date.now() - Math.max(cleanCartLastTrackedAddAt, coordinator.state?.lastUpdatedAt || 0) <= maxAge;
        return {
          cart: isRecent ? coordinator.state?.cart || window.cart || null : null,
          inFlight: coordinator.state?.inFlight || cleanCartTrackedAddPromise,
          isRecent,
        };
      },
      openDrawer: openCleanCartDrawer,
      closeDrawer: closeCleanCartDrawer,
    };

    document.dispatchEvent(new CustomEvent('clean:cart:ready', { detail: { cart: window.CleanCart } }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-brand-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-clean-home-brand-story]';

    const initialize = (root) => {
      if (root.hasAttribute('data-clean-home-brand-story-initialized')) return;

      const video = root.querySelector('[data-clean-home-brand-story-video]');
      const control = root.querySelector('[data-clean-home-brand-story-control]');
      const media = root.querySelector('[data-clean-home-brand-story-media]');
      if (!video || !control || !media) return;

      root.setAttribute('data-clean-home-brand-story-initialized', '');
      control.hidden = false;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const shouldAutoplay = root.hasAttribute('data-clean-home-brand-story-autoplay');
      let hydrated = false;
      let autoplayVisible = false;
      let userPaused = false;
      let observer;

      const canAutoplay = () => {
        const saveData = window.navigator?.connection?.saveData === true;
        return shouldAutoplay && !reducedMotion.matches && !saveData;
      };

      const setState = (state) => {
        root.setAttribute('data-clean-home-brand-story-state', state);
        const playing = state === 'playing';
        control.setAttribute('aria-label', playing ? 'Pause brand story video' : 'Play brand story video');
      };

      const hydrate = () => {
        if (hydrated) return;
        hydrated = true;

        root.querySelectorAll('[data-clean-home-brand-story-source]').forEach((source) => {
          const url = source.getAttribute('data-clean-home-brand-story-source');
          if (url) source.src = url;
        });

        video.load();
      };

      const play = () => {
        hydrate();
        setState('loading');
        const playPromise = video.play();

        if (playPromise) {
          playPromise.catch(() => {
            userPaused = true;
            setState('paused');
          });
        }
      };

      const pause = () => {
        video.pause();
        setState('paused');
      };

      control.addEventListener('click', () => {
        if (!video.paused) {
          userPaused = true;
          pause();
          return;
        }

        userPaused = false;
        play();
      });

      video.addEventListener('playing', () => setState('playing'));
      video.addEventListener('pause', () => setState('paused'));
      video.addEventListener('ended', () => setState('paused'));
      video.addEventListener('error', () => {
        userPaused = true;
        setState('paused');
      });

      const handleVisibility = () => {
        if (document.hidden) {
          if (!video.paused) pause();
          return;
        }

        if (autoplayVisible && canAutoplay() && !userPaused) play();
      };

      const handleReducedMotion = () => {
        if (reducedMotion.matches) {
          if (!video.paused) pause();
          return;
        }

        if (autoplayVisible && canAutoplay() && !userPaused && !document.hidden) play();
      };

      document.addEventListener('visibilitychange', handleVisibility);
      reducedMotion.addEventListener('change', handleReducedMotion);

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            autoplayVisible = entry.isIntersecting && entry.intersectionRatio >= 0.2;

            if (!entry.isIntersecting) {
              if (!video.paused) pause();
              return;
            }

            if (autoplayVisible && canAutoplay() && !userPaused && !document.hidden) play();
          },
          { threshold: [0, 0.2] },
        );
        observer.observe(media);
      }

      const handleUnload = (event) => {
        if (!event.target.contains(root)) return;
        observer?.disconnect();
        document.removeEventListener('visibilitychange', handleVisibility);
        document.removeEventListener('shopify:section:unload', handleUnload);
        reducedMotion.removeEventListener('change', handleReducedMotion);
      };

      document.addEventListener('shopify:section:unload', handleUnload);
      setState('paused');
    };

    const initializeWithin = (scope) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll?.(selector).forEach(initialize);
    };

    initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-category-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-category-rail';

    if (customElements.get(elementName)) return;

    class CleanHomeCategoryRail extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanViewport = this.querySelector('[data-clean-home-category-viewport]');
        this.cleanPrevious = this.querySelector('[data-clean-home-category-previous]');
        this.cleanNext = this.querySelector('[data-clean-home-category-next]');

        if (!this.cleanViewport || !this.cleanPrevious || !this.cleanNext) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;

        this.cleanPrevious.addEventListener('click', () => this.cleanScroll(-1), { signal });
        this.cleanNext.addEventListener('click', () => this.cleanScroll(1), { signal });
        this.cleanViewport.addEventListener('scroll', () => this.cleanQueueUpdate(), {
          passive: true,
          signal,
        });

        this.cleanResizeObserver = new ResizeObserver(() => this.cleanQueueUpdate());
        this.cleanResizeObserver.observe(this.cleanViewport);
        this.setAttribute('data-clean-home-category-enhanced', 'true');
        this.cleanUpdateControls();
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanResizeObserver?.disconnect();
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanConnected = false;
      }

      cleanScroll(direction) {
        let distance = Math.max(1, Math.round(this.cleanViewport.clientWidth * 0.75));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (window.matchMedia('(min-width: 990px)').matches) {
          const items = this.cleanViewport.querySelectorAll('.clean-home-category-rail__item');

          if (items.length > 1) {
            const step = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
            distance = Math.max(1, Math.round(step * 3));
          }
        }

        this.cleanViewport.scrollBy({
          left: distance * direction,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      cleanQueueUpdate() {
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanUpdateFrame = requestAnimationFrame(() => this.cleanUpdateControls());
      }

      cleanUpdateControls() {
        const maximumScroll = Math.max(0, this.cleanViewport.scrollWidth - this.cleanViewport.clientWidth);
        const hasOverflow = maximumScroll > 2;
        const isAtStart = !hasOverflow || this.cleanViewport.scrollLeft <= 2;
        const isAtEnd = !hasOverflow || this.cleanViewport.scrollLeft >= maximumScroll - 2;

        this.cleanPrevious.hidden = !hasOverflow;
        this.cleanNext.hidden = !hasOverflow;
        this.cleanPrevious.disabled = isAtStart;
        this.cleanNext.disabled = isAtEnd;
      }
    }

    customElements.define(elementName, CleanHomeCategoryRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-customer-reviews';
    if (customElements.get(elementName)) return;

    customElements.define(
      elementName,
      class extends HTMLElement {
        connectedCallback() {
          if (this.cleanAbortController) return;
          const section = this.closest('.clean-home-customer-reviews-section');
          if (!section) return;

          this.cleanAbortController = new AbortController();
          const release = () => {
            section.classList.add('clean-home-customer-reviews-section--active');
            this.cleanObserver?.disconnect();
            this.cleanAbortController.abort();
          };
          const { signal } = this.cleanAbortController;
          this.addEventListener('focusin', release, { signal });
          this.addEventListener('pointerdown', release, { signal });

          if (!('IntersectionObserver' in window)) {
            release();
            return;
          }

          this.cleanObserver = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) release();
            },
            { rootMargin: '600px 0px' },
          );
          this.cleanObserver.observe(section);
        }

        disconnectedCallback() {
          this.cleanObserver?.disconnect();
          this.cleanAbortController?.abort();
          this.cleanAbortController = null;
        }
      },
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-gift-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-gift-finder';

    if (customElements.get(elementName)) return;

    const occasionMatrix = Object.freeze({
      him: ['pre-wedding', 'wedding', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      her: ['pre-wedding', 'wedding', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      couples: [
        'pre-wedding',
        'wedding',
        'anniversary',
        'birthday',
        'umrah',
        'hajj',
        'generic',
        'housewarming',
        'ramadan',
        'eid',
      ],
      husband: ['anniversary', 'birthday', 'umrah', 'hajj', 'generic', 'ramadan', 'eid'],
      brother: ['pre-wedding', 'wedding', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      'friend-m': ['pre-wedding', 'wedding', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      father: ['anniversary', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      son: ['birthday', 'generic', 'bismillah', 'khatm', 'ramadan', 'eid'],
      wife: ['anniversary', 'birthday', 'umrah', 'hajj', 'generic', 'ramadan', 'eid'],
      sister: ['pre-wedding', 'wedding', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      'friend-f': ['pre-wedding', 'wedding', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      mother: ['anniversary', 'birthday', 'umrah', 'hajj', 'generic', 'housewarming', 'ramadan', 'eid'],
      daughter: ['birthday', 'generic', 'bismillah', 'khatm', 'ramadan', 'eid'],
    });

    const occasionDestinationMatrix = Object.freeze({
      husband: {
        ramadan: '/collections/ramadan-gifts-for-husband',
      },
      brother: {
        umrah: '/collections/umrah-gifts-for-brother',
        hajj: '/collections/hajj-gifts-for-brother',
        eid: '/collections/eid-gifts-for-brother',
      },
      'friend-m': {
        'pre-wedding': '/collections/engagement-baat-pakki-gifts-for-friends',
        wedding: '/collections/islamic-wedding-gifts-for-friends',
        birthday: '/collections/birthday-gifts-for-friends',
        umrah: '/collections/umrah-gifts-for-friends',
        hajj: '/collections/hajj-gifts-for-male-friends',
      },
      father: {
        umrah: '/collections/umrah-gifts-for-father',
        hajj: '/collections/hajj-gifts-for-father',
      },
      sister: {
        umrah: '/collections/umrah-gifts-for-sister',
        hajj: '/collections/hajj-gifts-for-sister',
      },
      'friend-f': {
        umrah: '/collections/umrah-gifts-for-friends',
      },
      mother: {
        umrah: '/collections/umrah-gifts-for-mother',
        hajj: '/collections/hajj-gifts-for-mother',
      },
      couples: {
        umrah: '/collections/umrah-gifts-for-couples',
        hajj: '/collections/hajj-gifts-for-couples',
      },
    });

    class CleanHomeGiftFinder extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanStart = this.querySelector('[data-clean-home-gift-finder-open]');
        this.cleanDialog = this.querySelector('[data-clean-home-gift-finder-dialog]');
        this.cleanDialogSurface = this.querySelector('[data-clean-home-gift-finder-dialog-surface]');
        this.cleanRecipientTemplate = this.querySelector('[data-clean-home-gift-finder-recipient-template]');
        this.cleanRelationshipTemplate = this.querySelector('[data-clean-home-gift-finder-relationship-template]');
        this.cleanOccasionTemplate = this.querySelector('[data-clean-home-gift-finder-occasion-template]');
        this.cleanRecipientGrid = this.querySelector('[data-clean-home-gift-finder-recipient-grid]');
        this.cleanRelationshipGrid = this.querySelector('[data-clean-home-gift-finder-relationship-grid]');
        this.cleanOccasionGrid = this.querySelector('[data-clean-home-gift-finder-occasion-grid]');
        this.cleanProgressText = this.querySelector('[data-clean-home-gift-finder-progress-text]');
        this.cleanRecipientSummary = this.querySelector('[data-clean-home-gift-finder-recipient-summary]');
        this.cleanRecipientSummaryValue = this.querySelector('[data-clean-home-gift-finder-recipient-summary-value]');
        this.cleanRelationshipSummary = this.querySelector('[data-clean-home-gift-finder-relationship-summary]');
        this.cleanRelationshipSummaryValue = this.querySelector(
          '[data-clean-home-gift-finder-relationship-summary-value]',
        );
        this.cleanBack = this.querySelector('[data-clean-home-gift-finder-back]');
        this.cleanStatus = this.querySelector('[data-clean-home-gift-finder-status]');
        this.cleanEmpty = this.querySelector('[data-clean-home-gift-finder-empty]');
        this.cleanDesktop = window.matchMedia('(min-width: 990px)');
        this.cleanReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.cleanQueueDialogPosition = this.cleanQueueDialogPosition.bind(this);

        if (
          !this.cleanStart ||
          !this.cleanDialog ||
          !this.cleanDialogSurface ||
          !this.cleanRecipientTemplate ||
          !this.cleanRelationshipTemplate ||
          !this.cleanOccasionTemplate ||
          !this.cleanRecipientGrid ||
          !this.cleanRelationshipGrid ||
          !this.cleanOccasionGrid ||
          this.dataset.cleanHomeGiftFinderReady !== 'true'
        ) {
          return;
        }

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const listenerOptions = { signal: this.cleanAbortController.signal };

        this.cleanStart.addEventListener('click', (event) => this.cleanOpen(event), listenerOptions);
        this.addEventListener('click', (event) => this.cleanHandleClick(event), listenerOptions);
        this.cleanDialog.addEventListener('cancel', (event) => this.cleanHandleCancel(event), listenerOptions);
        this.cleanDialog.addEventListener('close', () => this.cleanHandleClosed(), listenerOptions);
        this.cleanDialog.addEventListener('click', (event) => this.cleanHandleBackdrop(event), listenerOptions);
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanStopPositioning();
        if (this.cleanCloseTimer) window.clearTimeout(this.cleanCloseTimer);
        this.cleanConnected = false;
      }

      cleanBuildGrid(template, grid, selector, predicate = () => true) {
        const fragment = document.createDocumentFragment();

        template.content.querySelectorAll(selector).forEach((option) => {
          if (predicate(option)) fragment.append(option.cloneNode(true));
        });

        grid.replaceChildren(fragment);
        return grid.children.length;
      }

      cleanSetSummaryMedia(summary, option) {
        const summaryMedia = summary.querySelector(
          '[data-clean-home-gift-finder-recipient-summary-media], [data-clean-home-gift-finder-relationship-summary-media]',
        );
        const optionMedia = option.querySelector('.clean-home-gift-finder__option-media');
        const visual = optionMedia?.querySelector('img, .clean-home-gift-finder__option-fallback');

        summaryMedia?.replaceChildren();
        if (!summaryMedia || !visual) return;

        const visualCopy = visual.cloneNode(true);
        if (visualCopy instanceof HTMLImageElement) visualCopy.alt = '';
        summaryMedia.append(visualCopy);
      }

      cleanReset() {
        this.cleanState = { recipient: '', recipientLabel: '', relationship: '', relationshipLabel: '' };
        this.cleanBuildGrid(
          this.cleanRecipientTemplate,
          this.cleanRecipientGrid,
          '[data-clean-home-gift-finder-recipient]',
        );
        this.cleanRelationshipGrid.replaceChildren();
        this.cleanOccasionGrid.replaceChildren();
        this.cleanRecipientSummary
          .querySelector('[data-clean-home-gift-finder-recipient-summary-media]')
          ?.replaceChildren();
        this.cleanRelationshipSummary
          .querySelector('[data-clean-home-gift-finder-relationship-summary-media]')
          ?.replaceChildren();
        this.cleanRecipientSummary.setAttribute('aria-label', 'Change recipient');
        this.cleanRelationshipSummary.setAttribute('aria-label', 'Change relationship');
        this.cleanRecipientSummary.hidden = true;
        this.cleanRelationshipSummary.hidden = true;
        this.cleanEmpty.hidden = true;
        this.cleanShowStep('recipient', false);
      }

      cleanOpen(event) {
        if (typeof this.cleanDialog.showModal !== 'function') return;

        event.preventDefault();
        this.cleanOpener = event.currentTarget;
        this.cleanReset();
        delete this.cleanDialog.dataset.cleanHomeGiftFinderClosing;
        this.cleanDialog.showModal();
        this.cleanStart.setAttribute('aria-expanded', 'true');
        document.body.classList.add('clean-home-gift-finder-open');
        this.cleanStartPositioning();
        window.requestAnimationFrame(() => this.cleanFocusActiveHeading());
      }

      cleanClose() {
        if (!this.cleanDialog.open || this.cleanDialog.dataset.cleanHomeGiftFinderClosing === 'true') return;

        if (this.cleanReducedMotion.matches) {
          this.cleanFinishClose();
          return;
        }

        this.cleanDialog.dataset.cleanHomeGiftFinderClosing = 'true';
        this.cleanAnimationEndHandler = (event) => {
          if (
            event.target === this.cleanDialog &&
            ['clean-home-gift-finder-drawer-exit', 'clean-home-gift-finder-dialog-exit'].includes(event.animationName)
          ) {
            this.cleanFinishClose();
          }
        };
        this.cleanDialog.addEventListener('animationend', this.cleanAnimationEndHandler);
        this.cleanCloseTimer = window.setTimeout(() => this.cleanFinishClose(), 240);
      }

      cleanFinishClose() {
        if (this.cleanCloseTimer) window.clearTimeout(this.cleanCloseTimer);
        this.cleanCloseTimer = undefined;
        if (this.cleanAnimationEndHandler) {
          this.cleanDialog.removeEventListener('animationend', this.cleanAnimationEndHandler);
          this.cleanAnimationEndHandler = undefined;
        }
        delete this.cleanDialog.dataset.cleanHomeGiftFinderClosing;
        if (this.cleanDialog.open) this.cleanDialog.close();
      }

      cleanHandleClosed() {
        this.cleanStopPositioning();
        this.cleanStart.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('clean-home-gift-finder-open');
        this.cleanStatus.textContent = '';
        this.cleanOpener?.focus();
      }

      cleanHandleCancel(event) {
        event.preventDefault();
        this.cleanClose();
      }

      cleanHandleBackdrop(event) {
        if (event.target !== this.cleanDialog) return;

        const rect = this.cleanDialogSurface.getBoundingClientRect();
        const outside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;
        if (outside) this.cleanClose();
      }

      cleanHandleClick(event) {
        if (!(event.target instanceof Element)) return;

        if (event.target.closest('[data-clean-home-gift-finder-close]')) {
          this.cleanClose();
          return;
        }

        if (event.target.closest('[data-clean-home-gift-finder-back]')) {
          this.cleanGoBack();
          return;
        }

        if (event.target.closest('[data-clean-home-gift-finder-recipient-summary]')) {
          this.cleanShowStep('recipient');
          return;
        }

        if (event.target.closest('[data-clean-home-gift-finder-relationship-summary]')) {
          this.cleanShowStep('relationship');
          return;
        }

        const recipient = event.target.closest('[data-clean-home-gift-finder-recipient]');
        if (recipient) {
          this.cleanSelectRecipient(recipient);
          return;
        }

        const relationship = event.target.closest('[data-clean-home-gift-finder-relationship]');
        if (relationship) this.cleanSelectRelationship(relationship);
      }

      cleanSelectRecipient(option) {
        const recipient = option.dataset.cleanHomeGiftFinderRecipient;
        const label = option.dataset.cleanHomeGiftFinderLabel || '';

        this.cleanState.recipient = recipient;
        this.cleanState.recipientLabel = label;
        this.cleanState.relationship = '';
        this.cleanState.relationshipLabel = '';
        this.cleanSetPressed(this.cleanRecipientGrid, option);
        this.cleanSetSummaryMedia(this.cleanRecipientSummary, option);
        this.cleanRecipientSummaryValue.textContent = label;
        this.cleanRecipientSummary.setAttribute('aria-label', `Change recipient: ${label}`);
        this.cleanRelationshipSummaryValue.textContent = '';

        if (recipient === 'couples') {
          this.cleanBuildOccasions(recipient);
          this.cleanShowStep('occasion');
          return;
        }

        const relationshipCount = this.cleanBuildGrid(
          this.cleanRelationshipTemplate,
          this.cleanRelationshipGrid,
          '[data-clean-home-gift-finder-relationship]',
          (relationship) => relationship.dataset.cleanHomeGiftFinderParent === recipient,
        );

        if (relationshipCount) this.cleanShowStep('relationship');
        else {
          this.cleanBuildOccasions(recipient);
          this.cleanShowStep('occasion');
        }
      }

      cleanSelectRelationship(option) {
        const relationship = option.dataset.cleanHomeGiftFinderRelationship;
        const label = option.dataset.cleanHomeGiftFinderLabel || '';

        this.cleanState.relationship = relationship;
        this.cleanState.relationshipLabel = label;
        this.cleanSetPressed(this.cleanRelationshipGrid, option);
        this.cleanSetSummaryMedia(this.cleanRelationshipSummary, option);
        this.cleanRelationshipSummaryValue.textContent = label;
        this.cleanRelationshipSummary.setAttribute('aria-label', `Change relationship: ${label}`);
        this.cleanBuildOccasions(relationship);
        this.cleanShowStep('occasion');
      }

      cleanBuildOccasions(matrixKey) {
        const allowed = occasionMatrix[matrixKey] || occasionMatrix[this.cleanState.recipient] || [];
        const count = this.cleanBuildGrid(
          this.cleanOccasionTemplate,
          this.cleanOccasionGrid,
          '[data-clean-home-gift-finder-occasion]',
          (occasion) => allowed.includes(occasion.dataset.cleanHomeGiftFinderOccasion),
        );
        const destinations = occasionDestinationMatrix[matrixKey] || {};

        this.cleanOccasionGrid.querySelectorAll('[data-clean-home-gift-finder-occasion]').forEach((occasion) => {
          const destination = destinations[occasion.dataset.cleanHomeGiftFinderOccasion];
          if (destination) occasion.setAttribute('href', destination);
        });

        this.cleanEmpty.hidden = count > 0;
      }

      cleanSetPressed(grid, selectedOption) {
        grid.querySelectorAll('[aria-pressed]').forEach((option) => {
          option.setAttribute('aria-pressed', String(option === selectedOption));
        });
      }

      cleanGoBack() {
        const activeStep = this.querySelector('[data-clean-home-gift-finder-step]:not([hidden])')?.dataset
          .cleanHomeGiftFinderStep;

        if (activeStep === 'occasion' && this.cleanState.recipient !== 'couples' && this.cleanState.relationship) {
          this.cleanShowStep('relationship');
        } else if (activeStep !== 'recipient') {
          this.cleanShowStep('recipient');
        }
      }

      cleanShowStep(stepName, focus = true) {
        this.querySelectorAll('[data-clean-home-gift-finder-step]').forEach((step) => {
          step.hidden = step.dataset.cleanHomeGiftFinderStep !== stepName;
        });

        const couplesPath = this.cleanState?.recipient === 'couples';
        const progress =
          stepName === 'recipient'
            ? { current: 1, total: 3 }
            : stepName === 'relationship'
              ? { current: 2, total: 3 }
              : couplesPath
                ? { current: 2, total: 2 }
                : { current: 3, total: 3 };

        this.style.setProperty('--clean-home-gift-finder-progress', `${(progress.current / progress.total) * 100}%`);
        this.cleanProgressText.textContent = `Step ${progress.current} of ${progress.total}`;
        this.cleanBack.hidden = stepName === 'recipient';
        this.cleanRecipientSummary.hidden = stepName === 'recipient' || !this.cleanState?.recipient;
        this.cleanRelationshipSummary.hidden = stepName !== 'occasion' || !this.cleanState?.relationship;

        const activeHeading = this.querySelector(
          `[data-clean-home-gift-finder-step="${stepName}"] [data-clean-home-gift-finder-step-heading]`,
        );
        const headingText = activeHeading?.textContent.trim() || '';
        this.cleanStatus.textContent = `${headingText} Step ${progress.current} of ${progress.total}.`;

        if (focus && this.cleanDialog.open)
          window.requestAnimationFrame(() => activeHeading?.focus({ preventScroll: true }));
      }

      cleanFocusActiveHeading() {
        this.querySelector(
          '[data-clean-home-gift-finder-step]:not([hidden]) [data-clean-home-gift-finder-step-heading]',
        )?.focus({ preventScroll: true });
      }

      cleanPositionDialog() {
        if (!this.cleanDialog.open) return;

        if (this.cleanDesktop.matches) {
          this.cleanDialog.style.removeProperty('--clean-home-gift-finder-drawer-bottom');
          this.cleanDialog.style.removeProperty('max-height');
          return;
        }

        const visualViewport = window.visualViewport;
        const viewportHeight = visualViewport?.height || window.innerHeight;
        const viewportOffsetTop = visualViewport?.offsetTop || 0;
        const keyboardInset = Math.max(0, window.innerHeight - viewportHeight - viewportOffsetTop);
        this.cleanDialog.style.setProperty('--clean-home-gift-finder-drawer-bottom', `${keyboardInset}px`);
        this.cleanDialog.style.maxHeight = `${Math.max(160, viewportHeight - 16)}px`;
      }

      cleanKeepDialogFocusVisible() {
        if (this.cleanDesktop.matches || !this.cleanDialog.open) return;

        const activeElement = document.activeElement;
        if (!(activeElement instanceof HTMLElement) || !this.cleanDialog.contains(activeElement)) return;

        const visualViewport = window.visualViewport;
        const viewportTop = visualViewport?.offsetTop || 0;
        const viewportBottom = viewportTop + (visualViewport?.height || window.innerHeight);
        const focusRect = activeElement.getBoundingClientRect();
        const focusGutter = 16;

        if (focusRect.top < viewportTop + focusGutter || focusRect.bottom > viewportBottom - focusGutter) {
          activeElement.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }
      }

      cleanQueueDialogPosition() {
        if (this.cleanPositionFrame) window.cancelAnimationFrame(this.cleanPositionFrame);
        this.cleanPositionFrame = window.requestAnimationFrame(() => {
          this.cleanPositionFrame = undefined;
          this.cleanPositionDialog();
          this.cleanKeepDialogFocusVisible();
        });
      }

      cleanStartPositioning() {
        this.cleanQueueDialogPosition();
        window.addEventListener('resize', this.cleanQueueDialogPosition, { passive: true });
        window.visualViewport?.addEventListener('resize', this.cleanQueueDialogPosition, { passive: true });
        window.visualViewport?.addEventListener('scroll', this.cleanQueueDialogPosition, { passive: true });
        this.cleanDialog.addEventListener('focusin', this.cleanQueueDialogPosition);
      }

      cleanStopPositioning() {
        if (!this.cleanDialog) return;
        window.removeEventListener('resize', this.cleanQueueDialogPosition);
        window.visualViewport?.removeEventListener('resize', this.cleanQueueDialogPosition);
        window.visualViewport?.removeEventListener('scroll', this.cleanQueueDialogPosition);
        this.cleanDialog.removeEventListener('focusin', this.cleanQueueDialogPosition);
        if (this.cleanPositionFrame) window.cancelAnimationFrame(this.cleanPositionFrame);
        this.cleanPositionFrame = undefined;
        this.cleanDialog.style.removeProperty('--clean-home-gift-finder-drawer-bottom');
        this.cleanDialog.style.removeProperty('max-height');
      }
    }

    customElements.define(elementName, CleanHomeGiftFinder);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-hero-slideshow';

    if (customElements.get(elementName)) return;

    class CleanHomeHeroSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.cleanHomeHeroConnected) return;

        this.cleanHomeHeroConnected = true;
        this.cleanHomeHeroAbortController = new AbortController();
        this.cleanHomeHeroSignal = this.cleanHomeHeroAbortController.signal;
        this.cleanHomeHeroSlides = Array.from(this.querySelectorAll('[data-clean-home-hero-slide]'));
        this.cleanHomeHeroDots = Array.from(this.querySelectorAll('[data-clean-home-hero-dot]'));
        this.cleanHomeHeroViewport = this.querySelector('[data-clean-home-hero-viewport]');
        this.cleanHomeHeroStatus = this.querySelector('[data-clean-home-hero-status]');
        this.cleanHomeHeroCurrentIndex = 0;
        this.cleanHomeHeroTimer = 0;
        this.cleanHomeHeroIdleCallback = 0;
        this.cleanHomeHeroTransitioning = false;
        this.cleanHomeHeroManualPause = false;
        this.cleanHomeHeroHoverPause = false;
        this.cleanHomeHeroFocusPause = false;
        this.cleanHomeHeroFirstImageReady = false;
        this.cleanHomeHeroSuppressClickUntil = 0;
        this.cleanHomeHeroSuppressLegacyClickUntil = 0;
        this.cleanHomeHeroSuppressClickPointerId = null;
        this.cleanHomeHeroAutoplay = this.dataset.cleanHomeHeroAutoplay === 'true';
        this.cleanHomeHeroInterval = Number.parseInt(this.dataset.cleanHomeHeroInterval, 10) || 5000;
        this.cleanHomeHeroReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.cleanHomeHeroPeekViewport = window.matchMedia('(max-width: 749px), (min-width: 990px)');
        this.cleanHomeHeroDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

        if (this.cleanHomeHeroSlides.length < 2) return;

        this.cleanHomeHeroDots.forEach((dot) => {
          dot.disabled = false;
        });

        this.bindCleanHomeHeroEvents();
        this.setAttribute('data-clean-home-hero-enhanced', 'true');
        this.updateCleanHomeHeroReducedMotion();

        Promise.all([
          this.waitForCleanHomeHeroImage(this.cleanHomeHeroSlides[0]),
          this.waitForCleanHomeHeroDocumentReady(),
        ]).then(([loaded]) => {
          if (!this.cleanHomeHeroConnected) return;

          this.cleanHomeHeroFirstImageReady = loaded;
          this.deferCleanHomeHeroNextSlide();
          this.scheduleCleanHomeHeroAutoplay();
        });
      }

      disconnectedCallback() {
        this.cleanHomeHeroConnected = false;
        window.clearTimeout(this.cleanHomeHeroTimer);

        if (this.cleanHomeHeroIdleCallback) {
          if ('cancelIdleCallback' in window) {
            window.cancelIdleCallback(this.cleanHomeHeroIdleCallback);
          } else {
            window.clearTimeout(this.cleanHomeHeroIdleCallback);
          }
        }

        if (this.cleanHomeHeroAbortController) {
          this.cleanHomeHeroAbortController.abort();
        }
      }

      bindCleanHomeHeroEvents() {
        const signal = this.cleanHomeHeroSignal;

        this.cleanHomeHeroDots.forEach((dot) => {
          dot.addEventListener(
            'click',
            () => {
              this.pauseCleanHomeHeroManually();
              this.showCleanHomeHeroSlide(Number(dot.dataset.cleanHomeHeroTarget), 'manual');
            },
            { signal },
          );

          dot.addEventListener('keydown', (event) => this.handleCleanHomeHeroDotKeydown(event), { signal });
        });

        this.addEventListener(
          'mouseenter',
          () => {
            this.cleanHomeHeroHoverPause = true;
            this.stopCleanHomeHeroAutoplay();
          },
          { signal },
        );

        this.addEventListener(
          'mouseleave',
          () => {
            this.cleanHomeHeroHoverPause = false;
            this.scheduleCleanHomeHeroAutoplay();
          },
          { signal },
        );

        this.addEventListener(
          'focusin',
          () => {
            this.cleanHomeHeroFocusPause = true;
            this.stopCleanHomeHeroAutoplay();
          },
          { signal },
        );

        this.addEventListener(
          'focusout',
          () => {
            window.setTimeout(() => {
              this.cleanHomeHeroFocusPause = this.contains(document.activeElement);
              this.scheduleCleanHomeHeroAutoplay();
            }, 0);
          },
          { signal },
        );

        document.addEventListener('visibilitychange', () => this.scheduleCleanHomeHeroAutoplay(), { signal });
        document.addEventListener('shopify:block:select', (event) => this.handleCleanHomeHeroBlockSelect(event), {
          signal,
        });
        document.addEventListener(
          'shopify:section:select',
          (event) => {
            if (event.target.contains(this)) this.pauseCleanHomeHeroManually();
          },
          { signal },
        );

        if (this.cleanHomeHeroReducedMotion.addEventListener) {
          this.cleanHomeHeroReducedMotion.addEventListener('change', () => this.updateCleanHomeHeroReducedMotion(), {
            signal,
          });
        }

        if (this.cleanHomeHeroPeekViewport.addEventListener) {
          this.cleanHomeHeroPeekViewport.addEventListener('change', () => this.updateCleanHomeHeroPeek(), { signal });
        }

        this.bindCleanHomeHeroSwipe();
      }

      bindCleanHomeHeroSwipe() {
        if (!this.cleanHomeHeroViewport) return;

        let pointerId = null;
        let startX = 0;
        let startY = 0;
        let pointerCaptured = false;
        let pointerType = '';

        this.cleanHomeHeroViewport.addEventListener(
          'pointerdown',
          (event) => {
            // Any new pointer sequence is deliberate customer input. Clear the
            // completed swipe's compatibility-click guard before filtering it.
            this.clearCleanHomeHeroClickSuppression();
            if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;

            pointerId = event.pointerId;
            pointerType = event.pointerType;
            startX = event.clientX;
            startY = event.clientY;
            pointerCaptured = false;
            this.stopCleanHomeHeroAutoplay();
            this.settleCleanHomeHeroForPointer(event);
          },
          { signal: this.cleanHomeHeroSignal },
        );

        this.cleanHomeHeroViewport.addEventListener(
          'pointermove',
          (event) => {
            if (event.pointerId !== pointerId || pointerCaptured) return;

            const horizontalDistance = event.clientX - startX;
            const verticalDistance = event.clientY - startY;
            const swipeThreshold = pointerType === 'mouse' ? 24 : 32;
            if (
              Math.abs(horizontalDistance) < swipeThreshold ||
              Math.abs(horizontalDistance) <= Math.abs(verticalDistance)
            )
              return;

            if (this.cleanHomeHeroViewport.setPointerCapture) {
              this.cleanHomeHeroViewport.setPointerCapture(pointerId);
              pointerCaptured = true;
              this.setAttribute('data-clean-home-hero-dragging', 'true');
            }

            event.preventDefault();
          },
          { signal: this.cleanHomeHeroSignal },
        );

        this.cleanHomeHeroViewport.addEventListener(
          'pointerup',
          (event) => {
            if (event.pointerId !== pointerId) return;

            const horizontalDistance = event.clientX - startX;
            const verticalDistance = event.clientY - startY;
            const activePointerId = pointerId;
            const activePointerType = pointerType;
            const swipeThreshold = activePointerType === 'mouse' ? 24 : 32;
            pointerId = null;
            pointerType = '';
            this.removeAttribute('data-clean-home-hero-dragging');

            if (pointerCaptured && this.cleanHomeHeroViewport.releasePointerCapture) {
              this.cleanHomeHeroViewport.releasePointerCapture(activePointerId);
            }
            pointerCaptured = false;

            if (
              Math.abs(horizontalDistance) >= swipeThreshold &&
              Math.abs(horizontalDistance) > Math.abs(verticalDistance)
            ) {
              this.cleanHomeHeroSuppressClickUntil = Date.now() + 400;
              this.cleanHomeHeroSuppressLegacyClickUntil = Date.now() + 80;
              this.cleanHomeHeroSuppressClickPointerId = activePointerId;
              this.pauseCleanHomeHeroManually();
              this.showCleanHomeHeroSlide(
                this.cleanHomeHeroCurrentIndex + (horizontalDistance < 0 ? 1 : -1),
                'manual',
                activePointerType === 'touch',
              );
            } else {
              this.scheduleCleanHomeHeroAutoplay();
            }
          },
          { signal: this.cleanHomeHeroSignal },
        );

        this.cleanHomeHeroViewport.addEventListener(
          'pointercancel',
          () => {
            pointerId = null;
            pointerCaptured = false;
            pointerType = '';
            this.clearCleanHomeHeroClickSuppression();
            this.removeAttribute('data-clean-home-hero-dragging');
            this.scheduleCleanHomeHeroAutoplay();
          },
          { signal: this.cleanHomeHeroSignal },
        );

        this.cleanHomeHeroViewport.addEventListener('dragstart', (event) => event.preventDefault(), {
          signal: this.cleanHomeHeroSignal,
        });

        this.cleanHomeHeroViewport.addEventListener(
          'click',
          (event) => {
            const clickHasPointerId = typeof event.pointerId === 'number';
            const suppressionDeadline = clickHasPointerId
              ? this.cleanHomeHeroSuppressClickUntil
              : this.cleanHomeHeroSuppressLegacyClickUntil;

            if (Date.now() >= suppressionDeadline) {
              this.clearCleanHomeHeroClickSuppression();
              return;
            }

            const isSwipeCompatibilityClick = clickHasPointerId
              ? event.pointerId === this.cleanHomeHeroSuppressClickPointerId
              : true;
            if (!isSwipeCompatibilityClick) return;

            event.preventDefault();
            event.stopPropagation();
            this.clearCleanHomeHeroClickSuppression();
          },
          { capture: true, signal: this.cleanHomeHeroSignal },
        );
      }

      clearCleanHomeHeroClickSuppression() {
        this.cleanHomeHeroSuppressClickUntil = 0;
        this.cleanHomeHeroSuppressLegacyClickUntil = 0;
        this.cleanHomeHeroSuppressClickPointerId = null;
      }

      settleCleanHomeHeroForPointer(event) {
        if (!this.cleanHomeHeroTransitioning) return;
        if (event.target.closest('[data-clean-home-hero-peek="true"]')) return;

        const viewportBounds = this.cleanHomeHeroViewport.getBoundingClientRect();
        if (event.clientX < viewportBounds.left || event.clientX > viewportBounds.right) return;

        const activeSlide = this.cleanHomeHeroSlides[this.cleanHomeHeroCurrentIndex];
        if (!activeSlide || !this.querySelector('[data-clean-home-hero-leave-to]')) return;

        // A new gesture should hit the destination card even while its incoming
        // transform still leaves the inert outgoing artwork under the pointer.
        this.cleanHomeHeroSlides.forEach((slide) => {
          slide.getAnimations().forEach((animation) => animation.finish());
        });

        const activeLink = activeSlide.querySelector('[data-clean-home-hero-slide-link]');
        if (!activeLink || !activeLink.setPointerCapture) return;

        // Hit testing preceded pointerdown, so merely settling the animation
        // cannot retarget that gesture. Capture preserves one native link click;
        // a subsequent swipe takes capture back on the viewport as usual.
        activeLink.setPointerCapture(event.pointerId);
      }

      handleCleanHomeHeroDotKeydown(event) {
        const currentDotIndex = this.cleanHomeHeroDots.indexOf(event.currentTarget);
        let targetIndex = null;

        if (event.key === 'ArrowRight') targetIndex = currentDotIndex + 1;
        if (event.key === 'ArrowLeft') targetIndex = currentDotIndex - 1;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = this.cleanHomeHeroDots.length - 1;
        if (targetIndex === null) return;

        event.preventDefault();
        targetIndex = this.normalizeCleanHomeHeroIndex(targetIndex);
        this.cleanHomeHeroDots[targetIndex].focus();
        this.pauseCleanHomeHeroManually();
        this.showCleanHomeHeroSlide(targetIndex, 'manual');
      }

      handleCleanHomeHeroBlockSelect(event) {
        const slide = event.target.closest('[data-clean-home-hero-slide]');
        if (!slide || !this.contains(slide)) return;

        this.pauseCleanHomeHeroManually();
        this.showCleanHomeHeroSlide(Number(slide.dataset.cleanHomeHeroIndex), 'editor');
      }

      normalizeCleanHomeHeroIndex(index) {
        const slideCount = this.cleanHomeHeroSlides.length;
        return ((index % slideCount) + slideCount) % slideCount;
      }

      async showCleanHomeHeroSlide(requestedIndex, source, instant = false) {
        const targetIndex = this.normalizeCleanHomeHeroIndex(requestedIndex);
        if (targetIndex === this.cleanHomeHeroCurrentIndex || this.cleanHomeHeroTransitioning) {
          this.scheduleCleanHomeHeroAutoplay();
          return;
        }

        this.cleanHomeHeroTransitioning = true;
        this.setAttribute('aria-busy', 'true');

        const targetSlide = this.cleanHomeHeroSlides[targetIndex];
        const currentSlide = this.cleanHomeHeroSlides[this.cleanHomeHeroCurrentIndex];
        const loaded = await this.hydrateCleanHomeHeroSlide(targetIndex, true);

        if (!loaded || !this.cleanHomeHeroConnected) {
          this.cleanHomeHeroTransitioning = false;
          this.removeAttribute('aria-busy');
          if (this.cleanHomeHeroStatus)
            this.cleanHomeHeroStatus.textContent = 'The requested slide could not be loaded.';
          this.scheduleCleanHomeHeroAutoplay();
          return;
        }

        const direction =
          targetIndex > this.cleanHomeHeroCurrentIndex ||
          (this.cleanHomeHeroCurrentIndex === this.cleanHomeHeroSlides.length - 1 && targetIndex === 0)
            ? 'next'
            : 'previous';

        if (instant) this.setAttribute('data-clean-home-hero-instant', 'true');
        this.clearCleanHomeHeroPeek(targetSlide);
        targetSlide.hidden = false;
        targetSlide.setAttribute('data-clean-home-hero-enter-from', direction);
        targetSlide.offsetWidth;

        if (!instant) await new Promise((resolve) => window.requestAnimationFrame(resolve));

        currentSlide.setAttribute('aria-hidden', 'true');
        currentSlide.setAttribute('inert', '');
        currentSlide.setAttribute('data-clean-home-hero-active', 'false');
        currentSlide.setAttribute('data-clean-home-hero-leave-to', direction);

        targetSlide.removeAttribute('inert');
        targetSlide.setAttribute('aria-hidden', 'false');
        targetSlide.setAttribute('data-clean-home-hero-active', 'true');
        targetSlide.removeAttribute('data-clean-home-hero-enter-from');

        const currentLink = currentSlide.querySelector('[data-clean-home-hero-slide-link]');
        const targetLink = targetSlide.querySelector('[data-clean-home-hero-slide-link]');
        if (currentLink) currentLink.tabIndex = -1;
        if (targetLink) targetLink.removeAttribute('tabindex');

        this.cleanHomeHeroCurrentIndex = targetIndex;
        this.updateCleanHomeHeroDots();

        if (!instant) await this.waitForCleanHomeHeroTransition(targetSlide);

        currentSlide.hidden = true;
        currentSlide.removeAttribute('data-clean-home-hero-leave-to');
        this.cleanHomeHeroTransitioning = false;
        this.removeAttribute('aria-busy');

        if (source === 'manual' && this.cleanHomeHeroStatus) {
          this.cleanHomeHeroStatus.textContent = `Slide ${targetIndex + 1} of ${this.cleanHomeHeroSlides.length}: ${targetSlide.dataset.cleanHomeHeroLabel}`;
        }

        this.deferCleanHomeHeroNextSlide();
        if (instant) {
          // Commit the final card positions before restoring animated controls.
          targetSlide.offsetWidth;
          this.removeAttribute('data-clean-home-hero-instant');
        }
        this.scheduleCleanHomeHeroAutoplay();
      }

      hydrateCleanHomeHeroSlide(index, eager) {
        const slide = this.cleanHomeHeroSlides[index];
        if (!slide) return Promise.resolve(false);
        if (slide.cleanHomeHeroHydration) return slide.cleanHomeHeroHydration;

        const template = slide.querySelector('[data-clean-home-hero-media-template]');

        if (template) {
          const fragment = template.content.cloneNode(true);
          const image = fragment.querySelector('img');

          if (image && eager) {
            image.loading = 'eager';
            image.fetchPriority = 'low';
          }

          const placeholder = slide.querySelector('.clean-home-hero-slideshow__placeholder');
          if (placeholder) placeholder.remove();

          template.replaceWith(fragment);
        }

        slide.cleanHomeHeroHydration = this.waitForCleanHomeHeroImage(slide);
        return slide.cleanHomeHeroHydration;
      }

      waitForCleanHomeHeroImage(slide) {
        const image = slide.querySelector('img');
        if (!image) return Promise.resolve(false);
        if (image.complete) return Promise.resolve(image.naturalWidth > 0);

        return new Promise((resolve) => {
          image.addEventListener('load', () => resolve(true), { once: true });
          image.addEventListener('error', () => resolve(false), { once: true });
        });
      }

      waitForCleanHomeHeroDocumentReady() {
        if (document.readyState !== 'loading') return Promise.resolve();

        return new Promise((resolve) => {
          document.addEventListener('DOMContentLoaded', resolve, {
            once: true,
            signal: this.cleanHomeHeroSignal,
          });
        });
      }

      waitForCleanHomeHeroTransition(slide) {
        if (this.cleanHomeHeroReducedMotion.matches) return Promise.resolve();

        return new Promise((resolve) => {
          let complete = false;
          const finish = () => {
            if (complete) return;
            complete = true;
            resolve();
          };

          slide.addEventListener('transitionend', finish, { once: true });
          window.setTimeout(finish, 360);
        });
      }

      deferCleanHomeHeroNextSlide() {
        const nextIndex = this.normalizeCleanHomeHeroIndex(this.cleanHomeHeroCurrentIndex + 1);
        const nextSlide = this.cleanHomeHeroSlides[nextIndex];

        if (nextSlide.cleanHomeHeroHydration) {
          nextSlide.cleanHomeHeroHydration.then((loaded) => {
            if (loaded) this.updateCleanHomeHeroPeek();
          });
          return;
        }

        const hydrate = () => {
          this.hydrateCleanHomeHeroSlide(nextIndex, true).then((loaded) => {
            if (loaded) this.updateCleanHomeHeroPeek();
          });
        };

        if (this.cleanHomeHeroPeekViewport.matches) {
          hydrate();
          return;
        }

        if ('requestIdleCallback' in window) {
          this.cleanHomeHeroIdleCallback = window.requestIdleCallback(hydrate, { timeout: 2500 });
        } else {
          this.cleanHomeHeroIdleCallback = window.setTimeout(hydrate, 500);
        }
      }

      clearCleanHomeHeroPeek(exception = null) {
        this.cleanHomeHeroSlides.forEach((slide, index) => {
          if (!slide.hasAttribute('data-clean-home-hero-peek')) return;

          slide.removeAttribute('data-clean-home-hero-peek');
          if (index !== this.cleanHomeHeroCurrentIndex) {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
            const link = slide.querySelector('[data-clean-home-hero-slide-link]');
            if (link) link.tabIndex = -1;
            if (slide !== exception) slide.hidden = true;
          }
        });
      }

      updateCleanHomeHeroPeek() {
        if (this.cleanHomeHeroTransitioning) return;

        this.clearCleanHomeHeroPeek();
        if (!this.cleanHomeHeroPeekViewport.matches || this.cleanHomeHeroSlides.length < 2) return;

        const nextIndex = this.normalizeCleanHomeHeroIndex(this.cleanHomeHeroCurrentIndex + 1);
        const nextSlide = this.cleanHomeHeroSlides[nextIndex];
        if (!nextSlide.cleanHomeHeroHydration) return;

        nextSlide.hidden = false;
        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.removeAttribute('inert');
        nextSlide.setAttribute('data-clean-home-hero-peek', 'true');

        const nextLink = nextSlide.querySelector('[data-clean-home-hero-slide-link]');
        if (nextLink) nextLink.removeAttribute('tabindex');

        this.primeCleanHomeHeroFollowingPeek();
      }

      primeCleanHomeHeroFollowingPeek() {
        if (!this.cleanHomeHeroPeekViewport.matches || this.cleanHomeHeroSlides.length < 3) return;

        const followingIndex = this.normalizeCleanHomeHeroIndex(this.cleanHomeHeroCurrentIndex + 2);
        const followingSlide = this.cleanHomeHeroSlides[followingIndex];
        if (followingSlide.cleanHomeHeroHydration) return;

        this.hydrateCleanHomeHeroSlide(followingIndex, true);
      }

      pauseCleanHomeHeroManually() {
        this.cleanHomeHeroManualPause = true;
        this.stopCleanHomeHeroAutoplay();
      }

      stopCleanHomeHeroAutoplay() {
        window.clearTimeout(this.cleanHomeHeroTimer);
        this.cleanHomeHeroTimer = 0;
      }

      scheduleCleanHomeHeroAutoplay() {
        this.stopCleanHomeHeroAutoplay();

        if (
          !this.cleanHomeHeroAutoplay ||
          !this.cleanHomeHeroFirstImageReady ||
          this.cleanHomeHeroReducedMotion.matches ||
          this.cleanHomeHeroDesignMode ||
          this.cleanHomeHeroManualPause ||
          this.cleanHomeHeroHoverPause ||
          this.cleanHomeHeroFocusPause ||
          document.hidden
        ) {
          return;
        }

        this.cleanHomeHeroTimer = window.setTimeout(() => {
          this.showCleanHomeHeroSlide(this.cleanHomeHeroCurrentIndex + 1, 'autoplay');
        }, this.cleanHomeHeroInterval);
      }

      updateCleanHomeHeroDots() {
        this.cleanHomeHeroDots.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.cleanHomeHeroCurrentIndex ? 'true' : 'false');
        });
      }

      updateCleanHomeHeroReducedMotion() {
        const reduced = this.cleanHomeHeroReducedMotion.matches;
        this.setAttribute('data-clean-home-hero-reduced-motion', reduced ? 'true' : 'false');

        this.scheduleCleanHomeHeroAutoplay();
      }
    }

    customElements.define(elementName, CleanHomeHeroSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-loved-ones"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-loved-ones';

    if (customElements.get(elementName)) return;

    class CleanHomeLovedOnes extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanViewport = this.querySelector('[data-clean-home-loved-ones-viewport]');
        this.cleanControls = this.querySelector('[data-clean-home-loved-ones-controls]');
        this.cleanPrevious = this.querySelector('[data-clean-home-loved-ones-previous]');
        this.cleanNext = this.querySelector('[data-clean-home-loved-ones-next]');

        if (!this.cleanViewport || !this.cleanControls || !this.cleanPrevious || !this.cleanNext) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;

        this.cleanPrevious.addEventListener('click', () => this.cleanScroll(-1), { signal });
        this.cleanNext.addEventListener('click', () => this.cleanScroll(1), { signal });
        this.cleanViewport.addEventListener('scroll', () => this.cleanQueueUpdate(), {
          passive: true,
          signal,
        });

        this.cleanResizeObserver = new ResizeObserver(() => this.cleanQueueUpdate());
        this.cleanResizeObserver.observe(this.cleanViewport);
        this.setAttribute('data-clean-home-loved-ones-enhanced', 'true');
        this.cleanUpdateControls();
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanResizeObserver?.disconnect();
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanConnected = false;
      }

      cleanScroll(direction) {
        const items = this.cleanViewport.querySelectorAll('.clean-home-loved-ones__item');
        let distance = Math.max(1, Math.round(this.cleanViewport.clientWidth * 0.8));

        if (items.length > 1) {
          const step = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
          const visibleSteps = Math.max(1, Math.floor(this.cleanViewport.clientWidth / step) - 1);
          distance = Math.max(1, Math.round(step * visibleSteps));
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.cleanViewport.scrollBy({
          left: distance * direction,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      cleanQueueUpdate() {
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanUpdateFrame = requestAnimationFrame(() => this.cleanUpdateControls());
      }

      cleanUpdateControls() {
        const maximumScroll = Math.max(0, this.cleanViewport.scrollWidth - this.cleanViewport.clientWidth);
        const hasOverflow = maximumScroll > 2;
        const supportsControls = window.matchMedia('(min-width: 750px)').matches;

        this.cleanControls.hidden = !hasOverflow || !supportsControls;
        this.cleanPrevious.disabled = !hasOverflow || this.cleanViewport.scrollLeft <= 2;
        this.cleanNext.disabled = !hasOverflow || this.cleanViewport.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define(elementName, CleanHomeLovedOnes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-occasion-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-occasion-tabs';

    if (customElements.get(elementName)) return;

    class CleanHomeOccasionTabs extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanTabs = [...this.querySelectorAll('[data-clean-home-occasion-tab]')];
        this.cleanPanels = [...this.querySelectorAll('[data-clean-home-occasion-panel]')];

        if (this.cleanTabs.length === 0 || this.cleanPanels.length === 0) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;

        this.cleanTabs.forEach((tab) => {
          tab.addEventListener('click', () => this.cleanActivate(tab), { signal });
          tab.addEventListener('keydown', (event) => this.cleanHandleKeydown(event), { signal });
        });

        if (window.Shopify?.designMode) {
          document.addEventListener('shopify:block:select', (event) => this.cleanRevealEditorBlock(event), {
            signal,
          });
        }

        this.setAttribute('data-clean-home-occasion-enhanced', 'true');
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanConnected = false;
      }

      cleanActivate(nextTab, moveFocus = false) {
        const controlledPanelId = nextTab.getAttribute('aria-controls');

        this.cleanTabs.forEach((tab) => {
          const isSelected = tab === nextTab;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.cleanPanels.forEach((panel) => {
          const isSelected = panel.id === controlledPanelId;
          panel.hidden = !isSelected;

          if (!isSelected) return;

          const template = panel.querySelector('[data-clean-home-occasion-template]');
          if (template) template.replaceWith(template.content.cloneNode(true));
        });

        if (moveFocus) nextTab.focus();

        nextTab.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });
      }

      cleanHandleKeydown(event) {
        const currentIndex = this.cleanTabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.cleanTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.cleanTabs.length) % this.cleanTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.cleanTabs.length - 1;

        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.cleanActivate(this.cleanTabs[nextIndex], true);
      }

      cleanRevealEditorBlock(event) {
        const blockId = event.detail?.blockId;
        if (!blockId) return;

        const panel = this.cleanPanels.find((candidate) => {
          const liveBlocks = [...candidate.querySelectorAll('[data-clean-home-occasion-block]')];
          const template = candidate.querySelector('[data-clean-home-occasion-template]');
          const inertBlocks = template
            ? [...template.content.querySelectorAll('[data-clean-home-occasion-block]')]
            : [];

          return [...liveBlocks, ...inertBlocks].some(
            (block) => block.dataset.cleanHomeOccasionBlock === blockId,
          );
        });

        if (!panel) return;

        const tab = this.cleanTabs.find((candidate) => candidate.getAttribute('aria-controls') === panel.id);
        if (tab) this.cleanActivate(tab);
      }
    }

    customElements.define(elementName, CleanHomeOccasionTabs);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-product-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-product-rail';
    if (customElements.get(elementName)) return;

    class CleanHomeProductRail extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanViewport = this.querySelector('[data-clean-home-product-viewport]');
        this.cleanPrevious = this.querySelector('[data-clean-home-product-previous]');
        this.cleanNext = this.querySelector('[data-clean-home-product-next]');

        if (!this.cleanViewport || !this.cleanPrevious || !this.cleanNext) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;

        this.cleanPrevious.addEventListener('click', () => this.cleanScroll(-1), { signal });
        this.cleanNext.addEventListener('click', () => this.cleanScroll(1), { signal });
        this.cleanViewport.addEventListener('scroll', () => this.cleanQueueUpdate(), {
          passive: true,
          signal,
        });

        this.cleanResizeObserver = new ResizeObserver(() => this.cleanQueueUpdate());
        this.cleanResizeObserver.observe(this.cleanViewport);
        this.setAttribute('data-clean-home-product-enhanced', 'true');
        this.cleanUpdateControls();

        if (this.dataset.cleanProductRailSource && this.dataset.cleanProductRailState !== 'ready') {
          if ('IntersectionObserver' in window) {
            this.cleanProductLoadObserver = new IntersectionObserver(
              (entries) => {
                if (!entries.some((entry) => entry.isIntersecting)) return;
                this.cleanProductLoadObserver.disconnect();
                this.cleanLoadSortedProducts();
              },
              { rootMargin: '400px 0px' },
            );
            this.cleanProductLoadObserver.observe(this);
          } else {
            this.cleanLoadSortedProducts();
          }
        }
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanResizeObserver?.disconnect();
        this.cleanProductLoadObserver?.disconnect();
        const requestController = this.cleanSourceController;
        this.cleanSourceController = null;
        requestController?.abort();
        this.cleanProductsStarted = false;
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanConnected = false;
      }

      async cleanLoadSortedProducts() {
        if (this.cleanProductsStarted || this.dataset.cleanProductRailState === 'ready') return;
        this.cleanProductsStarted = true;
        const status = this.querySelector('[data-clean-product-rail-status]');
        const shell = this.querySelector('.clean-home-product-rail__shell');
        const requestController = new AbortController();
        this.cleanSourceController = requestController;
        const timeout = window.setTimeout(() => requestController.abort(), 12000);

        try {
          const url = new URL(this.dataset.cleanProductRailSource, window.location.origin);
          const sort = this.dataset.cleanProductRailRequestedSort;
          if (url.origin !== window.location.origin || !['created-descending', 'best-selling'].includes(sort)) {
            throw new Error('Invalid sorted collection source.');
          }
          url.searchParams.set('sort_by', sort);
          url.searchParams.set('section_id', 'clean-home-product-rail');
          this.dataset.cleanProductRailState = 'loading';
          this.setAttribute('aria-busy', 'true');
          if (status) status.textContent = 'Loading products…';

          const response = await fetch(url, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
            signal: requestController.signal,
          });
          if (!response.ok || response.redirected) throw new Error('Sorted collection request failed.');
          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseRoot = responseDocument.querySelector('[data-clean-product-rail-response]');
          if (
            !responseRoot ||
            responseRoot.dataset.cleanProductRailCollection !== this.dataset.cleanProductRailCollection ||
            responseRoot.dataset.cleanProductRailSort !== sort
          )
            throw new Error('Sorted collection context did not match.');

          const cards = responseRoot.querySelector('clean-product-cards');
          const list = cards?.querySelector('.clean-home-product-rail__list');
          const items = list ? Array.from(list.children) : [];
          if (
            !cards ||
            !list ||
            items.length > 4 ||
            items.some(
              (item) =>
                !item.matches('li.clean-home-product-rail__item') || !item.querySelector('.clean-product-card__link'),
            )
          )
            throw new Error('Sorted product cards were missing or invalid.');

          const limit = Math.min(4, Math.max(1, Number(this.dataset.cleanProductRailLimit) || 4));
          items.slice(limit).forEach((item) => item.remove());
          list.style.setProperty('--clean-home-product-count', Math.min(items.length, limit));
          if (!this.isConnected || this.cleanSourceController !== requestController) return;
          this.querySelector('clean-product-cards').replaceWith(document.importNode(cards, true));
          this.dataset.cleanProductRailState = 'ready';
          shell.hidden = items.length === 0;
          if (status)
            status.textContent = items.length ? 'Products loaded.' : 'No products are available in this collection.';
          try {
            window.CleanDisplayCurrencyBootstrap?.refresh(this);
          } catch {
            // Keep confirmed product cards usable when display conversion fails.
          }
          this.cleanQueueUpdate();
        } catch {
          if (!this.isConnected || this.cleanSourceController !== requestController) return;
          this.dataset.cleanProductRailState = 'error';
          shell.hidden = true;
          if (status) status.textContent = 'Use View All to browse these products in the collection.';
        } finally {
          window.clearTimeout(timeout);
          if (this.cleanSourceController === requestController) {
            this.cleanSourceController = null;
            this.removeAttribute('aria-busy');
          }
        }
      }

      cleanScroll(direction) {
        const card = this.querySelector('.clean-home-product-rail__item');
        const gap = Number.parseFloat(getComputedStyle(this.cleanViewport.firstElementChild).columnGap) || 0;
        const distance = Math.max(1, Math.round((card?.offsetWidth || 160) + gap));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.cleanViewport.scrollBy({
          left: distance * direction,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      cleanQueueUpdate() {
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanUpdateFrame = requestAnimationFrame(() => this.cleanUpdateControls());
      }

      cleanUpdateControls() {
        const maximumScroll = Math.max(0, this.cleanViewport.scrollWidth - this.cleanViewport.clientWidth);
        const hasOverflow = maximumScroll > 2;
        const isAtStart = !hasOverflow || this.cleanViewport.scrollLeft <= 2;
        const isAtEnd = !hasOverflow || this.cleanViewport.scrollLeft >= maximumScroll - 2;

        this.cleanPrevious.hidden = !hasOverflow;
        this.cleanNext.hidden = !hasOverflow;
        this.cleanPrevious.disabled = isAtStart;
        this.cleanNext.disabled = isAtEnd;
      }
    }

    customElements.define(elementName, CleanHomeProductRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-quran-set-rail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-quran-set-rail';

    if (customElements.get(elementName)) return;

    class CleanHomeQuranSetRail extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanViewport = this.querySelector('[data-clean-home-quran-set-viewport]');
        this.cleanPrevious = this.querySelector('[data-clean-home-quran-set-previous]');
        this.cleanNext = this.querySelector('[data-clean-home-quran-set-next]');

        if (!this.cleanViewport || !this.cleanPrevious || !this.cleanNext) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;

        this.cleanPrevious.addEventListener('click', () => this.cleanScroll(-1), { signal });
        this.cleanNext.addEventListener('click', () => this.cleanScroll(1), { signal });
        this.cleanViewport.addEventListener('scroll', () => this.cleanQueueUpdate(), {
          passive: true,
          signal,
        });

        this.cleanResizeObserver = new ResizeObserver(() => this.cleanQueueUpdate());
        this.cleanResizeObserver.observe(this.cleanViewport);
        this.setAttribute('data-clean-home-quran-set-enhanced', 'true');
        this.cleanUpdateControls();
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanResizeObserver?.disconnect();
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanConnected = false;
      }

      cleanScroll(direction) {
        const card = this.querySelector('.clean-home-quran-set-rail__item');
        const gap = Number.parseFloat(getComputedStyle(this.cleanViewport.firstElementChild).columnGap) || 0;
        const distance = Math.max(1, Math.round((card?.offsetWidth || 180) + gap));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.cleanViewport.scrollBy({
          left: distance * direction,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      cleanQueueUpdate() {
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanUpdateFrame = requestAnimationFrame(() => this.cleanUpdateControls());
      }

      cleanUpdateControls() {
        const maximumScroll = Math.max(0, this.cleanViewport.scrollWidth - this.cleanViewport.clientWidth);
        const hasOverflow = maximumScroll > 2;
        const isAtStart = !hasOverflow || this.cleanViewport.scrollLeft <= 2;
        const isAtEnd = !hasOverflow || this.cleanViewport.scrollLeft >= maximumScroll - 2;

        this.cleanPrevious.hidden = !hasOverflow;
        this.cleanNext.hidden = !hasOverflow;
        this.cleanPrevious.disabled = isAtStart;
        this.cleanNext.disabled = isAtEnd;
      }
    }

    customElements.define(elementName, CleanHomeQuranSetRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-seo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clean-home-seo')) {
    customElements.define(
      'clean-home-seo',
      class CleanHomeSeo extends HTMLElement {
        connectedCallback() {
          if (this.cleanAbortController) return;

          this.cleanAbortController = new AbortController();
          this.cleanContent = this.querySelector('[data-clean-home-seo-content]');
          this.cleanToggle = this.querySelector('[data-clean-home-seo-toggle]');
          this.cleanToggleLabel = this.querySelector('[data-clean-home-seo-toggle-label]');

          if (!this.cleanContent || !this.cleanToggle || !this.cleanToggleLabel) return;

          this.setAttribute('data-clean-home-seo-enhanced', '');
          this.cleanExpanded = this.hasAttribute('data-clean-start-expanded');
          this.cleanSyncState();
          this.cleanToggle.addEventListener('click', () => this.cleanSetExpanded(!this.cleanExpanded), {
            signal: this.cleanAbortController.signal,
          });
        }

        disconnectedCallback() {
          this.cleanAbortController?.abort();
          this.cleanAbortController = null;
        }

        cleanSetExpanded(expanded) {
          this.cleanExpanded = expanded;
          this.cleanSyncState();
        }

        cleanSyncState() {
          const expanded = this.cleanExpanded;
          this.dataset.cleanHomeSeoState = expanded ? 'expanded' : 'collapsed';
          this.cleanToggle.setAttribute('aria-expanded', String(expanded));
          this.cleanToggleLabel.textContent = expanded
            ? this.dataset.cleanReadLess || 'Read less'
            : this.dataset.cleanReadMore || 'Read more';
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-home-worldwide-gifting"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-home-worldwide-gifting';

    if (customElements.get(elementName)) return;

    class CleanHomeWorldwideGifting extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanViewport = this.querySelector('[data-clean-home-worldwide-gifting-viewport]');
        this.cleanControls = this.querySelector('[data-clean-home-worldwide-gifting-controls]');
        this.cleanPrevious = this.querySelector('[data-clean-home-worldwide-gifting-previous]');
        this.cleanNext = this.querySelector('[data-clean-home-worldwide-gifting-next]');

        if (!this.cleanViewport || !this.cleanControls || !this.cleanPrevious || !this.cleanNext) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;

        this.cleanPrevious.addEventListener('click', () => this.cleanScroll(-1), { signal });
        this.cleanNext.addEventListener('click', () => this.cleanScroll(1), { signal });
        this.cleanViewport.addEventListener('scroll', () => this.cleanQueueUpdate(), {
          passive: true,
          signal,
        });

        this.cleanResizeObserver = new ResizeObserver(() => this.cleanQueueUpdate());
        this.cleanResizeObserver.observe(this.cleanViewport);
        this.setAttribute('data-clean-home-worldwide-gifting-enhanced', 'true');
        this.cleanUpdateControls();
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanResizeObserver?.disconnect();
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanConnected = false;
      }

      cleanScroll(direction) {
        const items = this.cleanViewport.querySelectorAll('.clean-home-worldwide-gifting__item');
        let distance = Math.max(1, Math.round(this.cleanViewport.clientWidth * 0.8));

        if (items.length > 1) {
          const itemWidth = items[0].getBoundingClientRect().width;
          const step = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
          const gap = Math.max(0, step - itemWidth);
          const visibleSteps = Math.max(1, Math.floor((this.cleanViewport.clientWidth + gap + 1) / step) - 1);
          distance = Math.max(1, Math.round(step * visibleSteps));
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.cleanViewport.scrollBy({
          left: distance * direction,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      cleanQueueUpdate() {
        cancelAnimationFrame(this.cleanUpdateFrame);
        this.cleanUpdateFrame = requestAnimationFrame(() => this.cleanUpdateControls());
      }

      cleanUpdateControls() {
        const maximumScroll = Math.max(0, this.cleanViewport.scrollWidth - this.cleanViewport.clientWidth);
        const hasOverflow = maximumScroll > 2;
        const supportsControls = window.matchMedia('(min-width: 750px)').matches;

        this.cleanControls.hidden = !hasOverflow || !supportsControls;
        this.cleanPrevious.disabled = !hasOverflow || this.cleanViewport.scrollLeft <= 2;
        this.cleanNext.disabled = !hasOverflow || this.cleanViewport.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define(elementName, CleanHomeWorldwideGifting);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-article"]) return;
  try {
    
  (() => {
    const cleanRoot = document.querySelector('[data-clean-article]');
    if (!cleanRoot) return;
    const cleanCurrent = new URL(window.location.href);
    const cleanTransient = new Set(['view', 'page', 'phcursor', 'section_id', 'sections', 'comment', 'comment_id']);
    const cleanNormalize = (value, pagination = false) => {
      const cleanTarget = new URL(value, cleanCurrent);
      if (cleanTarget.origin !== cleanCurrent.origin) return value;
      for (const cleanKey of [...new Set(cleanTarget.searchParams.keys())]) {
        const cleanValue = cleanTarget.searchParams.get(cleanKey);
        cleanTarget.searchParams.delete(cleanKey);
        if (!cleanTransient.has(cleanKey) || (pagination && ['page', 'phcursor'].includes(cleanKey)))
          cleanTarget.searchParams.set(cleanKey, cleanValue);
      }
      for (const [cleanKey, cleanValue] of cleanCurrent.searchParams) {
        if (!cleanTransient.has(cleanKey) && !cleanTarget.searchParams.has(cleanKey))
          cleanTarget.searchParams.set(cleanKey, cleanValue);
      }
      cleanTarget.searchParams.set('view', 'clean');
      return cleanTarget.pathname + cleanTarget.search + cleanTarget.hash;
    };
    cleanRoot.querySelectorAll('[data-clean-article-navigation], .clean-article__related a').forEach((cleanLink) => {
      cleanLink.setAttribute(
        'href',
        cleanNormalize(cleanLink.getAttribute('href'), cleanLink.dataset.cleanArticleNavigation === 'page'),
      );
    });
    const cleanForm = cleanRoot.querySelector('.clean-article__form');
    if (cleanForm) {
      cleanForm.setAttribute('action', cleanNormalize(cleanForm.getAttribute('action')));
      const cleanReturn = cleanForm.querySelector('input[name="return_to"]');
      if (cleanReturn) cleanReturn.value = cleanNormalize(cleanReturn.value);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-blog"]) return;
  try {
    
  (() => {
    const cleanBlogRoots = document.querySelectorAll('[data-clean-blog]');
    if (!cleanBlogRoots.length) return;
    const cleanCurrentQuery = new URLSearchParams(window.location.search);
    const cleanTransientKeys = new Set(['page', 'phcursor', 'section_id', 'sections', 'view']);
    cleanBlogRoots.forEach((cleanRoot) => {
      cleanRoot.querySelectorAll('[data-clean-blog-navigation]').forEach((cleanLink) => {
        const cleanDestination = new URL(cleanLink.href, window.location.href);
        if (cleanDestination.origin !== window.location.origin) return;
        const cleanQuery = new URLSearchParams();
        cleanCurrentQuery.forEach((cleanValue, cleanKey) => {
          if (!cleanTransientKeys.has(cleanKey)) cleanQuery.set(cleanKey, cleanValue);
        });
        cleanDestination.searchParams.forEach((cleanValue, cleanKey) => {
          if (cleanKey !== 'section_id' && cleanKey !== 'sections') cleanQuery.set(cleanKey, cleanValue);
        });
        if (cleanLink.dataset.cleanBlogNavigation === 'clear') {
          cleanTransientKeys.forEach((cleanKey) => cleanQuery.delete(cleanKey));
        }
        cleanQuery.set('view', 'clean');
        cleanDestination.search = cleanQuery.toString();
        cleanLink.href = cleanDestination.pathname + cleanDestination.search + cleanDestination.hash;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-cart"]) return;
  try {
    
  (() => {
    const escapeCleanCartPageHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const cleanCartPageAjaxUrl = (url, fallback) => {
      const rawUrl = url || fallback;

      try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        const path = parsedUrl.pathname.replace(/\/$/, '');
        parsedUrl.pathname = path.endsWith('.js') ? path : `${path}.js`;
        parsedUrl.search = '';

        return `${parsedUrl.pathname}${parsedUrl.search}`;
      } catch (error) {
        const path = String(rawUrl || fallback || '').replace(/\/$/, '');
        return path.endsWith('.js') ? path : `${path}.js`;
      }
    };

    const cleanCartPageRequest = (url, options = {}) =>
      fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          'X-Clean-Cart': 'true',
          ...(options.headers || {}),
        },
      });

    const cleanCartPageNormalizeMoneyText = (text) => {
      const wrapper = document.createElement('span');
      wrapper.innerHTML = String(text);

      return (wrapper.textContent || wrapper.innerText || '')
        .replace(/\b(?:Rs\.?|INR)[\s\u00a0]*/gi, '₹')
        .trim();
    };

    const cleanCartPageFormatMoney = (cents, moneyFormat) => {
      const selectedCurrency = window.HadiyahDisplayCurrency?.getCurrency?.();

      if (
        (!selectedCurrency || selectedCurrency === 'INR') &&
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      ) {
        return cleanCartPageNormalizeMoneyText(
          window.Shopify.formatMoney(cents, moneyFormat).replace(/\.00(?!\d)/g, ''),
        );
      }

      const numericAmount = Number(cents || 0) / 100;
      const amountWithCommas = numericAmount.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      const amountNoDecimals = Math.round(numericAmount).toLocaleString('en-IN');
      const placeholderPattern = (name) => new RegExp(['\\{', `\\{\\s*${name}\\s*\\}\\}`].join(''), 'g');
      const format = moneyFormat || `₹${['{', '{ amount }}'].join('')}`;

      return cleanCartPageNormalizeMoneyText(
        format
        .replace(placeholderPattern('amount_with_comma_separator'), amountWithCommas)
        .replace(placeholderPattern('amount_no_decimals'), amountNoDecimals)
        .replace(placeholderPattern('amount'), amountWithCommas)
        .replace(/<[^>]*>/g, '')
      );
    };

    const cleanCartPageSourceCurrency = () =>
      document.querySelector('[data-clean-display-currency-config]')?.dataset.cleanDisplayCurrencySource ||
      document.querySelector('[data-clean-cart-page]')?.dataset.cleanCartSourceCurrency ||
      window.cart?.currency ||
      'INR';

    const cleanCartPageMoneyAttributes = (cents, moneyFormat) => {
      const sourceText = cleanCartPageFormatMoney(cents, moneyFormat);
      return `data-clean-money data-clean-money-minor="${escapeCleanCartPageHtml(
        cents,
      )}" data-clean-money-currency="${escapeCleanCartPageHtml(
        cleanCartPageSourceCurrency(),
      )}" data-clean-money-source-text="${escapeCleanCartPageHtml(
        sourceText,
      )}" data-money-cents="${escapeCleanCartPageHtml(cents)}" data-inr-display="${escapeCleanCartPageHtml(
        sourceText,
      )}"`;
    };

    const cleanSetCartPageMoney = (target, cents, moneyFormat) => {
      if (!target) return;

      const sourceText = cleanCartPageFormatMoney(cents, moneyFormat);
      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(cents);
      target.dataset.cleanMoneyCurrency = cleanCartPageSourceCurrency();
      target.dataset.cleanMoneySourceText = sourceText;
      target.dataset.moneyCents = String(cents);
      target.dataset.inrDisplay = sourceText;
      target.textContent = sourceText;
      window.CleanDisplayCurrency?.refresh(target);
      window.HadiyahDisplayCurrency?.refresh(target);
    };

    const cleanSetCartPageCompactMoney = (target, cents, { abbreviateThousands = false } = {}) => {
      if (!target) return;

      const rupees = Math.max(0, Number(cents) || 0) / 100;
      const amount =
        abbreviateThousands && rupees >= 1000
          ? `${Number.isInteger(rupees / 1000) ? rupees / 1000 : (rupees / 1000).toFixed(1)}k`
          : Math.round(rupees).toLocaleString('en-IN');
      const sourceText = `₹${amount}`;

      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(cents);
      target.dataset.cleanMoneyCurrency = cleanCartPageSourceCurrency();
      target.dataset.cleanMoneySourceText = sourceText;
      target.dataset.moneyCents = String(cents);
      target.dataset.inrDisplay = sourceText;
      target.textContent = sourceText;
      window.CleanDisplayCurrency?.refresh(target);
      window.HadiyahDisplayCurrency?.refresh(target);
    };

    const cleanSetCartPageMoneyParts = (target, parts, moneyFormat) => {
      if (!target) return;

      const bindings = [];
      const nodes = parts.map((part) => {
        if (typeof part === 'string') return document.createTextNode(part);
        const money = document.createElement('span');
        bindings.push([money, part.money]);
        return money;
      });

      target.replaceChildren(...nodes);
      bindings.forEach(([money, value]) => cleanSetCartPageMoney(money, value, moneyFormat));
    };

    const cleanCartPageQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
    };

    const cleanCartPageMaximumBulkQuantity = 9999;

    const getCleanCartPageMinimumQuantity = (item = {}) => {
      const minimum = Number.parseInt(item?.properties?._minimum_quantity, 10);
      return Number.isFinite(minimum) && minimum > 0
        ? Math.min(cleanCartPageMaximumBulkQuantity, minimum)
        : 0;
    };


    const getCleanCartPageElementMinimumQuantity = (item) => {
      const minimum = Number.parseInt(item?.dataset.cleanCartPageMinimumQuantity, 10);
      return Number.isFinite(minimum) && minimum > 0 ? minimum : 0;
    };

    const cleanCartPageLineQuantity = (item, value, { allowRemoval = false } = {}) => {
      const quantity = cleanCartPageQuantity(value);
      const minimum = getCleanCartPageElementMinimumQuantity(item);

      if (!minimum) return quantity;
      if (allowRemoval && quantity === 0) return 0;
      return Math.min(cleanCartPageMaximumBulkQuantity, Math.max(minimum, quantity));
    };

    const syncCleanCartPageItemQuantityControls = (item) => {
      const input = item?.querySelector('[data-clean-cart-page-quantity-input]');
      if (!input) return;

      const minimum = getCleanCartPageElementMinimumQuantity(item);
      const quantity = cleanCartPageQuantity(input.value);
      const decrease = item.querySelector('[data-clean-cart-page-quantity-decrease]');
      const increase = item.querySelector('[data-clean-cart-page-quantity-increase]');

      input.min = String(minimum || 0);
      if (minimum) {
        input.max = String(cleanCartPageMaximumBulkQuantity);
      } else {
        input.removeAttribute('max');
      }
      if (decrease) decrease.disabled = minimum > 0 && quantity <= minimum;
      if (increase) increase.disabled = minimum > 0 && quantity >= cleanCartPageMaximumBulkQuantity;
    };

    const getCleanCartPageImageUrl = (source, width = 220) => {
      if (!source) return '';

      try {
        const imageUrl = new URL(source, window.location.origin);
        const hostname = imageUrl.hostname.toLowerCase();
        const isShopifyImage =
          hostname === window.location.hostname.toLowerCase() ||
          hostname === 'cdn.shopify.com' ||
          hostname.endsWith('.myshopify.com') ||
          hostname.endsWith('.shopifycdn.com');

        if (isShopifyImage) imageUrl.searchParams.set('width', String(width));
        return imageUrl.toString();
      } catch (error) {
        return String(source);
      }
    };

    const cleanCartPageNormalizePrice = (value) => {
      const price = Number(value);
      return Number.isFinite(price) ? Math.max(0, price) : 0;
    };

    const cleanCartPageHasDiscount = (item = {}) => {
      if (
        cleanCartPageNormalizePrice(item.total_discount) > 0 ||
        cleanCartPageNormalizePrice(item.line_level_total_discount) > 0
      )
        return true;
      return [
        ...(item.discount_allocations || []),
        ...(item.line_level_discount_allocations || []),
      ].some((allocation) => cleanCartPageNormalizePrice(allocation?.amount) > 0);
    };

    const cleanCartPageLinePrice = (item = {}) => {
      // Shopify owns discounts. A browser estimate must never replace its price.
      for (const value of [item.final_line_price, item.line_price]) {
        if (
          value !== null &&
          value !== undefined &&
          value !== '' &&
          Number.isFinite(Number(value)) &&
          Number(value) >= 0
        )
          return Number(value);
      }
      if (
        item.final_price !== null &&
        item.final_price !== undefined &&
        item.final_price !== '' &&
        Number.isFinite(Number(item.final_price)) &&
        Number(item.final_price) >= 0
      )
        return Number(item.final_price) * cleanCartPageQuantity(item.quantity);
      if (cleanCartPageHasDiscount(item)) return 0;
      const unitPrice = cleanCartPageNormalizePrice(item.price);
      return unitPrice > 0
        ? unitPrice * cleanCartPageQuantity(item.quantity)
        : cleanCartPageNormalizePrice(item.original_line_price);
    };

    const cleanCartPageDeliveryChargeVariantIds = new Set([51050538893559, 51050538926327, 51256352473335, 51256354898167, 51256354930935, 51256354963703, 51256354996471, 51256355029239, 51256355062007]);
    const cleanCartPageDeliveryExemptHandles = new Set(['gift-wrap', 'gift-wrapping']);
    const isCleanCartPageDeliveryChargeItem = (item = {}) =>
      window.HadiyahDeliveryCharge?.isFeeItem?.(item)
      ?? (cleanCartPageDeliveryChargeVariantIds.has(Number(item.variant_id || item.id || 0))
        || Number(item.product_id || item.product?.id) === 10059690017015
        || String(item.handle || item.product_handle || item.product?.handle || '').toLowerCase() === 'delivery-charge');
    const isCleanCartPageDeliveryExemptItem = (item = {}) => {
      if (window.HadiyahDeliveryCharge?.isDeliveryExemptItem) {
        return window.HadiyahDeliveryCharge.isDeliveryExemptItem(item);
      }
      const exemption = String(item?.properties?.['_Hadiyah delivery exempt'] || '').trim().toLowerCase();
      const directHandle = String(item.handle || item.product_handle || '').trim().toLowerCase();
      const urlHandle = String(item.url || '').split('?')[0].match(/\/products\/([^/]+)\/?$/i)?.[1] || '';
      const handle = directHandle || String(urlHandle).trim().toLowerCase();
      return exemption === 'gift wrap' || cleanCartPageDeliveryExemptHandles.has(handle);
    };
    const getCleanCartPageDeliverySummary = (cart = {}, cartPage = null) => {
      if (window.HadiyahDeliveryCharge?.getSummary) {
        return window.HadiyahDeliveryCharge.getSummary(cart);
      }

      const merchandiseItems = (cart.items || []).filter((item) => !isCleanCartPageDeliveryChargeItem(item));
      const deliveryItems = merchandiseItems.filter((item) => !isCleanCartPageDeliveryExemptItem(item));
      const merchandiseSubtotal = merchandiseItems.reduce(
        (total, item) => total + cleanCartPageLinePrice(item),
        0,
      );
      const merchandiseItemCount = merchandiseItems.reduce(
        (total, item) => total + cleanCartPageQuantity(item.quantity),
        0,
      );
      const getMethod = (item) => String(
        item?.properties?.['Delivery Method'] ?? item?.properties?.['Delivery Tier'] ?? '',
      ).trim().toLowerCase();
      const expressItemCount = deliveryItems.reduce(
        (total, item) => getMethod(item) === 'express'
          ? total + cleanCartPageQuantity(item.quantity)
          : total,
        0,
      );
      const expressCharge = deliveryItems.reduce((total, item) => {
        if (getMethod(item) !== 'express') return total;
        const grams = Number(item.grams);
        const rate = [[1500, 3000, 9900], [3500, 5000, 14900], [5500, 6500, 19900],
          [7000, 8500, 24900], [9000, 10500, 29900], [11000, 11500, 34900], [12000, 13000, 39900]]
          .find(([min, max]) => grams >= min && grams <= max)?.[2] ?? 4900;
        return total + rate * cleanCartPageQuantity(item.quantity);
      }, 0);
      const standardItems = deliveryItems.filter((item) => getMethod(item) === 'standard');
      const legacyItems = deliveryItems.filter((item) => !getMethod(item));
      const standardPotentialQuantity = isCleanCartPageNational(cartPage)
        && (standardItems.length || legacyItems.length)
        ? 1
        : 0;
      const standardFeeQuantity = standardPotentialQuantity && merchandiseSubtotal <= 50000 ? 1 : 0;
      const standardFreeQuantity = Math.max(0, standardPotentialQuantity - standardFeeQuantity);
      const isExpress = expressItemCount > 0;
      const hasProductSpecificDelivery = isExpress || standardItems.length > 0;
      const isStandardFree = standardPotentialQuantity > 0 && standardFeeQuantity === 0;

      return {
        charge: expressCharge + (2500 * standardFeeQuantity),
        expressItemCount,
        hasProductSpecificDelivery,
        isExpress,
        isStandardFree,
        merchandiseItemCount,
        merchandiseItems,
        merchandiseSubtotal,
        standardFeeQuantity,
        standardFreeQuantity,
        standardPotentialQuantity,
      };
    };

    const cleanCartPageHasUnexpectedZeroPrice = (item = {}) =>
      cleanCartPageQuantity(item.quantity) > 0 &&
      cleanCartPageLinePrice(item) === 0 &&
      !cleanCartPageHasDiscount(item);

    const cleanCartPageRewardMilestones = [
      { amount: 200000, discount: 10000 },
      { amount: 500000, discount: 25000 },
      { amount: 750000, discount: 35000 },
      { amount: 1000000, discount: 50000 },
    ];
    const cleanCartPageRewardMaximum =
      cleanCartPageRewardMilestones[cleanCartPageRewardMilestones.length - 1].amount;
    const isCleanCartPageNational = (cartPage) => {
      let country = window.HadiyahLocalization?.getState?.()?.deliveryCountry
        || '';
      try {
        country = country || localStorage.getItem('hadiyah:delivery-country-code') || '';
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browsers.
      }
      country = country || cartPage?.dataset.cleanGokwikCountry || '';
      return ['IN', 'INDIA'].includes(String(country).trim().toUpperCase());
    };
    const getCleanCartPageRewardState = (cartPage, cartTotal, cart) => {
      const hasBulk = window.CleanBulkDiscounts?.hasEligible(cart) !== false;
      const unlockedMilestone = [...cleanCartPageRewardMilestones]
        .reverse()
        .find((milestone) => cartTotal >= milestone.amount) || null;
      const nextMilestone = cleanCartPageRewardMilestones.find(
        (milestone) => cartTotal < milestone.amount,
      ) || null;

      return {
        discount: !hasBulk && isCleanCartPageNational(cartPage) ? unlockedMilestone?.discount || 0 : 0,
        nextMilestone,
      };
    };

    const updateCleanCartPageRewards = (cartPage, cart = {}) => {
      const rewards = cartPage.querySelector('[data-clean-cart-page-rewards]');
      if (!rewards) return;
      rewards.hidden = window.CleanBulkDiscounts?.hasEligible(cart) !== false;

      const deliverySummary = getCleanCartPageDeliverySummary(cart, cartPage);
      const cartTotal = deliverySummary.merchandiseSubtotal;
      const rewardState = getCleanCartPageRewardState(cartPage, cartTotal, cart);
      const nextReward = rewardState.nextMilestone;
      const nextMarkerAmount = nextReward?.amount;
      const progress = Math.min(100, Math.max(0, (cartTotal * 100) / cleanCartPageRewardMaximum));
      const progressTarget = rewards.querySelector('[data-clean-cart-page-rewards-progress]');
      const fill = rewards.querySelector('[data-clean-cart-page-rewards-fill]');
      const truck = rewards.querySelector('[data-clean-cart-page-rewards-truck]');
      const detail = rewards.querySelector('[data-clean-cart-page-rewards-detail]');

      cartPage.dataset.cleanCartTotalCents = String(cartTotal);
      progressTarget?.setAttribute('aria-valuenow', String(Math.round(progress)));
      if (fill) fill.style.width = `${progress}%`;
      if (truck) truck.style.left = `${progress}%`;

      rewards.querySelectorAll('[data-clean-cart-page-reward-marker]').forEach((marker) => {
        const markerAmount = cleanCartPageNormalizePrice(marker.dataset.cleanCartPageRewardAmount);
        const markerPosition = Math.min(100, Math.max(0, (markerAmount * 100) / cleanCartPageRewardMaximum));
        const unlocked = cartTotal >= markerAmount;

        marker.style.left = `${markerPosition}%`;
        marker.classList.toggle('clean-main-cart__reward-marker--unlocked', unlocked);
        marker.classList.toggle('clean-main-cart__reward-marker--next', !unlocked && markerAmount === nextMarkerAmount);
      });

      rewards.querySelectorAll('[data-clean-cart-page-reward-discount]').forEach((label) => {
        cleanSetCartPageCompactMoney(label, label.dataset.cleanCartPageRewardDiscount);
      });
      rewards.querySelectorAll('[data-clean-cart-page-reward-spend]').forEach((label) => {
        cleanSetCartPageCompactMoney(label, label.dataset.cleanCartPageRewardSpend, { abbreviateThousands: true });
      });

      const rewardsComplete = !nextReward;
      rewards.classList.toggle('clean-main-cart__rewards--complete', rewardsComplete);

      if (!detail) return;
      if (nextReward) {
        cleanSetCartPageMoneyParts(
          detail,
          [
            'Add ',
            { money: Math.max(100, Math.ceil((nextReward.amount - cartTotal) / 100) * 100) },
            ' more → unlock ',
            { money: nextReward.discount },
            ' off',
          ],
          cartPage.dataset.cleanCartMoneyFormat,
        );
      } else {
        detail.textContent = 'All rewards unlocked!';
      }
    };
    window.CleanGokwik =
      window.CleanGokwik ||
      (() => {
        const state = {
          countryPromise: null,
          scriptPromise: null,
        };

        const COUNTRY_CACHE_KEY = 'cleanGokwikCountry';
        const COUNTRY_CACHE_TIME_KEY = 'cleanGokwikCountryAt';
        const COUNTRY_CACHE_TTL_MS = 5 * 60 * 1000;
        const CHECKOUT_STATE_TIMEOUT_MS = 4000;

        const settleWithin = (promise, timeoutMs, fallbackValue) =>
          new Promise((resolve) => {
            let settled = false;
            const finish = (value) => {
              if (settled) return;
              settled = true;
              window.clearTimeout(timer);
              resolve(value);
            };
            const timer = window.setTimeout(() => finish(fallbackValue), timeoutMs);
            Promise.resolve(promise).then(finish, () => finish(fallbackValue));
          });

        const invalidateDetectedCountry = ({ clearStorage = false } = {}) => {
          state.countryPromise = null;
          if (!clearStorage) return;

          try {
            sessionStorage.removeItem(COUNTRY_CACHE_KEY);
            sessionStorage.removeItem(COUNTRY_CACHE_TIME_KEY);
          } catch (error) {}
        };

        const readDetectedCountry = async ({ force = false } = {}) => {
          if (!force && state.countryPromise) return state.countryPromise;

          const request = (async () => {
            try {
              if (!force) {
                const cachedCountry = String(sessionStorage.getItem(COUNTRY_CACHE_KEY) || '').toUpperCase();
                const cachedAt = Number(sessionStorage.getItem(COUNTRY_CACHE_TIME_KEY) || 0);
                if (cachedCountry && cachedAt && Date.now() - cachedAt < COUNTRY_CACHE_TTL_MS) {
                  return cachedCountry;
                }
              }

              const response = await settleWithin(
                fetch('/browsing_context_suggestions.json', {
                  credentials: 'same-origin',
                  headers: { Accept: 'application/json' },
                  cache: 'no-store',
                }),
                CHECKOUT_STATE_TIMEOUT_MS,
                null,
              );
              if (!response?.ok) return '';

              const data = await response.json();
              const detected = data?.detected_values || {};
              const country =
                detected.country_code ||
                detected.country?.iso_code ||
                detected.country?.handle ||
                (detected.country_name === 'India' ? 'IN' : detected.country_name || '');
              const normalizedCountry = String(country || '').toUpperCase();

              if (normalizedCountry) {
                sessionStorage.setItem(COUNTRY_CACHE_KEY, normalizedCountry);
                sessionStorage.setItem(COUNTRY_CACHE_TIME_KEY, String(Date.now()));
              }
              return normalizedCountry;
            } catch (error) {
              return '';
            }
          })();

          state.countryPromise = request;
          try {
            return await request;
          } finally {
            if (state.countryPromise === request) state.countryPromise = null;
          }
        };

        const scriptHostForEnv = (environment) => {
          const normalizedEnvironment = environment || 'production';
          if (normalizedEnvironment === 'production') return 'pdp.gokwik.co';
          if (normalizedEnvironment === 'sandbox') return 'sandbox.pdp.gokwik.co';
          return 'qa.pdp.gokwik.co';
        };

        const loadSdk = (scope) => {
          if (typeof window.onCheckoutClick === 'function') {
            return Promise.resolve();
          }
          if (state.scriptPromise) return state.scriptPromise;

          window.merchantInfo = {
            mid: scope.dataset.cleanGokwikMid || '',
            environment: scope.dataset.cleanGokwikEnv || 'production',
            type: 'merchantInfo',
            storeId: scope.dataset.cleanGokwikStoreId || '',
            fbpixel: scope.dataset.cleanGokwikFbpixel || '',
          };
          window.productFormSelector = window.productFormSelector || '';
          window.templateName =
            window.templateName || (scope.matches('[data-clean-cart-page]') ? 'cart' : 'product');

          state.scriptPromise = new Promise((resolve, reject) => {
            let isSettled = false;
            const scriptUrl = `https://${scriptHostForEnv(scope.dataset.cleanGokwikEnv)}/merchant-integration/build/merchant.integration.js?v4`;
            const existingScript =
              document.getElementById('gokwik-merchant-integration') ||
              document.querySelector(
                '[data-clean-gokwik-sdk], script[src*="merchant-integration/build/merchant.integration.js"]',
              );
            let readyTimer = null;
            let readyTimeout = null;
            const cleanup = () => {
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
            };
            const finish = () => {
              if (isSettled || typeof window.onCheckoutClick !== 'function') return;
              isSettled = true;
              cleanup();
              resolve();
            };
            const fail = (message = 'GoKwik checkout is not ready yet.') => {
              if (isSettled) return;
              isSettled = true;
              cleanup();
              state.scriptPromise = null;
              reject(new Error(message));
            };

            document.addEventListener('gokwikLoaded', finish);
            window.addEventListener('gokwikLoaded', finish);
            readyTimer = window.setInterval(finish, 100);
            readyTimeout = window.setTimeout(() => fail(), 8000);

            if (existingScript) {
              existingScript.id = 'gokwik-merchant-integration';
              existingScript.setAttribute('data-hadiyah-tp-ok', '1');
              existingScript.dataset.cleanGokwikSdk = 'true';
              existingScript.addEventListener('error', () => fail('Unable to load GoKwik checkout.'), {
                once: true,
              });
              if (!existingScript.getAttribute('src')) {
                existingScript.removeAttribute('type');
                existingScript.removeAttribute('data-hadiyah-tp-deferred');
                existingScript.src = scriptUrl;
              }
              finish();
              return;
            }

            const script = document.createElement('script');
            script.id = 'gokwik-merchant-integration';
            script.setAttribute('data-hadiyah-tp-ok', '1');
            script.defer = true;
            script.dataset.cleanGokwikSdk = 'true';
            script.src = scriptUrl;
            script.onload = () => {
              window.setTimeout(finish, 0);
            };
            script.onerror = () => fail('Unable to load GoKwik checkout.');
            document.head.appendChild(script);
          });

          return state.scriptPromise;
        };

        const setScopeVisibility = (scope, useGokwik) => {
          const gokwikButton = scope.querySelector('[data-clean-gokwik-checkout]');
          const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');
          const gokwikReady = useGokwik && typeof window.onCheckoutClick === 'function';

          if (!gokwikReady || !gokwikButton) {
            if (shopifyCheckout) shopifyCheckout.hidden = false;
            if (!gokwikButton) return;

            gokwikButton.hidden = true;
            gokwikButton.setAttribute('aria-hidden', 'true');
            return;
          }

          gokwikButton.hidden = false;
          gokwikButton.setAttribute('aria-hidden', 'false');
          if (shopifyCheckout) shopifyCheckout.hidden = true;
        };

        const getScopeCountry = (scope) => String(scope?.dataset.cleanGokwikCountry || '').toUpperCase();

        const isGokwikCountry = (country) => country === 'IN' || country === 'INDIA';

        const getScopeForControl = (control, scope) =>
          scope || control?.closest?.('[data-clean-gokwik-scope]') || document.querySelector('[data-clean-gokwik-scope]');

        const readDeliveryCountry = async (scope) => {
          const marketCountry = getScopeCountry(scope);
          let deliveryCountry = marketCountry;

          try {
            const localizationState = window.HadiyahLocalization?.getState?.();
            deliveryCountry = String(localizationState?.deliveryCountry || marketCountry || '').toUpperCase();
          } catch (error) {}

          return {
            deliveryCountry,
            marketCountry,
            synchronized: Boolean(deliveryCountry && marketCountry && deliveryCountry === marketCountry),
          };
        };

        const trackDecision = (decision, source) => {
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'checkout_router_decision',
              route: decision.route,
              reason: decision.reason,
              source: source || 'unknown',
              delivery_country: decision.deliveryCountry || '',
              market_country: decision.marketCountry || '',
              visitor_country: decision.detectedCountry || '',
              path: window.location.pathname,
            });
          } catch (error) {}
        };

        const resolveScope = async (
          scope,
          { detect = false, forceDetect = false, prepare = false, source = '', track = false } = {},
        ) => {
          const decision = {
            route: 'shopify',
            reason: 'scope_unavailable',
            deliveryCountry: '',
            marketCountry: '',
            detectedCountry: '',
          };

          if (!scope) {
            if (track) trackDecision(decision, source);
            return decision;
          }

          setScopeVisibility(scope, false);
          if (scope.dataset.cleanGokwikEnabled !== 'true') {
            decision.reason = 'gokwik_disabled';
            if (track) trackDecision(decision, source);
            return decision;
          }

          const delivery = await readDeliveryCountry(scope);
          decision.deliveryCountry = delivery.deliveryCountry;
          decision.marketCountry = delivery.marketCountry;
          if (!delivery.synchronized) {
            decision.reason = 'delivery_market_mismatch';
            if (track) trackDecision(decision, source);
            return decision;
          }
          if (!isGokwikCountry(delivery.deliveryCountry)) {
            decision.reason = 'international_delivery';
            if (track) trackDecision(decision, source);
            return decision;
          }

          const sdkReadyPromise = prepare
            ? loadSdk(scope)
                .then(() => true)
                .catch(() => false)
            : Promise.resolve(typeof window.onCheckoutClick === 'function');
          const detectedCountry = detect
            ? await readDetectedCountry({ force: forceDetect })
            : delivery.deliveryCountry;
          decision.detectedCountry = detectedCountry;

          if (!isGokwikCountry(detectedCountry)) {
            decision.reason = detectedCountry ? 'international_visitor' : 'visitor_country_unknown';
            if (track) trackDecision(decision, source);
            return decision;
          }

          const sdkReady = await sdkReadyPromise;
          const useGokwik = sdkReady && typeof window.onCheckoutClick === 'function';
          setScopeVisibility(scope, useGokwik);

          decision.route = useGokwik ? 'gokwik' : 'shopify';
          decision.reason = useGokwik ? 'india_visitor_and_delivery' : 'gokwik_not_ready';
          if (track) trackDecision(decision, source);
          return decision;
        };

        const syncScope = async (scope, options = {}) => {
          const decision = await resolveScope(scope, options);
          return decision.route === 'gokwik';
        };

        const fallbackToShopify = async (scope, reason, checkoutUrl = '') => {
          if (scope) setScopeVisibility(scope, false);

          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'gokwik_fallback_used',
              path: window.location.pathname,
              reason,
            });
          } catch (error) {}

          const shopifyCheckout = scope?.querySelector('[data-clean-shopify-checkout]');
          const destination =
            checkoutUrl || shopifyCheckout?.getAttribute('href') || scope?.dataset.cleanCartCheckoutUrl || '/checkout';
          let localizationPreparation = true;
          try {
            localizationPreparation = window.HadiyahLocalization?.prepareCheckout?.(destination);
          } catch (error) {}
          const localizationReady = await settleWithin(
            localizationPreparation,
            CHECKOUT_STATE_TIMEOUT_MS,
            true,
          );
          if (localizationReady === false) return 'shopify';
          window.location.assign(destination);
          return 'shopify';
        };

        const routeCheckout = async (control, scope, { checkoutUrl = '', source = 'checkout_control' } = {}) => {
          const checkoutScope = getScopeForControl(control, scope);
          try {
            const decision = await resolveScope(checkoutScope, {
              detect: true,
              forceDetect: true,
              prepare: true,
              source,
              track: true,
            });
            if (decision.route !== 'gokwik' || typeof window.onCheckoutClick !== 'function') {
              return fallbackToShopify(checkoutScope, decision.reason, checkoutUrl);
            }

            try {
              const gokwikButton =
                checkoutScope?.querySelector('[data-clean-gokwik-checkout]') || control;
              if (!gokwikButton) return fallbackToShopify(checkoutScope, 'gokwik_control_missing', checkoutUrl);
              window.onCheckoutClick(gokwikButton);
              return 'gokwik';
            } catch (error) {
              return fallbackToShopify(checkoutScope, 'checkout_handler_threw', checkoutUrl);
            }
          } catch (error) {
            return fallbackToShopify(checkoutScope, 'checkout_exception', checkoutUrl);
          }
        };

        const syncAllScopes = (options = {}) => {
          document.querySelectorAll('[data-clean-gokwik-scope]').forEach((scope) => {
            syncScope(scope, options).catch(() => setScopeVisibility(scope, false));
          });
        };

        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          invalidateDetectedCountry({ clearStorage: true });
          syncAllScopes({ detect: true, forceDetect: true, prepare: false });
        });

        document.addEventListener('hadiyah:localization:changed', () => {
          syncAllScopes({ detect: true, prepare: false });
        });

        return {
          checkout: routeCheckout,
          fallbackToShopify,
          invalidateDetectedCountry,
          resolveScope,
          routeCheckout,
          syncScope,
        };
      })();

    const setCleanCartPageStatus = (cartPage, message = '') => {
      const status = cartPage.querySelector('[data-clean-cart-page-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const cleanCartPageToolTitles = {
      instructions: 'Special Instructions',
      'gift-wrap': 'Gift Wrap',
      card: 'Card',
    };

    const cleanCartPageToolDescriptions = {
      instructions: 'Tell us anything that will help us prepare your order just right.',
      'gift-wrap': 'Make your gift feel even more special.',
      card: 'Write a thoughtful note for someone special.',
    };

    const cleanCartPageToolAttributes = (attributes) => {
      if (Array.isArray(attributes)) {
        return Object.fromEntries(
          attributes
            .filter((attribute) => attribute && attribute.key)
            .map((attribute) => [String(attribute.key), String(attribute.value ?? '')]),
        );
      }

      if (!attributes || typeof attributes !== 'object') return {};

      return Object.fromEntries(
        Object.entries(attributes).map(([key, value]) => [String(key), String(value ?? '')]),
      );
    };

    const cleanCartPageToolFallbackCart = (cartPage) => ({
      item_count: cartPage.querySelectorAll('[data-clean-cart-page-item]').length,
      note: cartPage.dataset.cleanCartNote || '',
      attributes: {
        To: cartPage.dataset.cleanCartCardTo || '',
        From: cartPage.dataset.cleanCartCardFrom || '',
        Message: cartPage.dataset.cleanCartCardMessage || '',
      },
      items: [],
    });

    const cleanCartPageToolHasItems = (cart) =>
      Number(cart?.item_count || 0) > 0 ||
      (Array.isArray(cart?.items) && cart.items.some((item) => Number(item?.quantity || 0) > 0));

    const cleanCartPageGiftWrapHandle = (cartPage) =>
      String(cartPage.dataset.cleanCartGiftWrapHandle || 'gift-wrap')
        .trim()
        .toLowerCase();

    const cleanCartPageGiftWrapVariantId = (cartPage) =>
      String(cartPage.dataset.cleanCartGiftWrapVariantId || '').trim();

    const cleanCartPageGiftWrapItem = (cartPage, cart) => {
      const handle = cleanCartPageGiftWrapHandle(cartPage);
      const variantId = cleanCartPageGiftWrapVariantId(cartPage);
      return (cart?.items || []).find((item) => {
        if (
          variantId &&
          (String(item?.id || '').trim() === variantId ||
            String(item?.variant_id || '').trim() === variantId)
        ) {
          return true;
        }

        const itemHandle = String(item?.handle || item?.product_handle || '')
          .trim()
          .toLowerCase();
        const itemUrl = String(item?.url || '').toLowerCase();
        return itemHandle === handle || itemUrl.includes(`/products/${handle}`);
      });
    };

    const cleanCartPageToolDrafts = (cartPage, cart) => {
      const fallback = cleanCartPageToolFallbackCart(cartPage);
      const source = cart || fallback;
      const attributes = cleanCartPageToolAttributes(source.attributes);
      const getAttribute = (name, legacyName) =>
        attributes[name] || attributes[legacyName] || '';

      return {
        note: String(source.note ?? fallback.note ?? ''),
        to: String(getAttribute('To', 'Card To') || fallback.attributes.To || ''),
        from: String(getAttribute('From', 'Card From') || fallback.attributes.From || ''),
        message: String(getAttribute('Message', 'Card Message') || fallback.attributes.Message || ''),
      };
    };

    const setCleanCartPageToolsStatus = (cartPage, message = '') => {
      const status = cartPage.querySelector('[data-clean-cart-tools-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const updateCleanCartPageTools = (cartPage, cart) => {
      const hasItems = cleanCartPageToolHasItems(cart);
      const giftWrapItem = cleanCartPageGiftWrapItem(cartPage, cart);
      const giftWrapVariant = cartPage.cleanCartGiftWrapVariant;

      cartPage.querySelectorAll('[data-clean-cart-tool]').forEach((button) => {
        const tool = button.dataset.cleanCartTool;
        button.disabled = !hasItems;

        if (tool !== 'gift-wrap') return;

        const subtext = button.querySelector('[data-clean-cart-tool-subtext="gift-wrap"]');
        if (!subtext) return;

        subtext.textContent = giftWrapItem
          ? 'Gift wrap added — manage it here'
          : giftWrapVariant === null
            ? 'Gift wrap is currently unavailable'
            : 'Make your gift feel extra special';
      });
    };

    const setCleanCartPageToolDialogStatus = (dialog, message = '', isError = false) => {
      const status = dialog.querySelector('[data-clean-cart-tool-form-status]');
      if (!status) return;

      status.textContent = message;
      status.dataset.error = isError ? 'true' : 'false';
      status.hidden = !message;
    };

    const setCleanCartPageToolDialogBusy = (dialog, busy) => {
      const state = dialog.closest('[data-clean-cart-page]')?.cleanCartPageToolsState;
      if (state) state.busy = busy;

      dialog.setAttribute('aria-busy', busy ? 'true' : 'false');
      dialog.querySelectorAll('button, textarea').forEach((control) => {
        if (control.matches('[data-clean-cart-tool-close]')) {
          control.disabled = busy;
          return;
        }

        control.disabled = busy || control.dataset.cleanCartToolUnavailable === 'true';
      });
    };

    const renderCleanCartPageToolActions = (submitLabel, pendingLabel, submitDisabled = false) => `
      <div class="clean-main-cart__tool-actions">
        <button
          class="clean-main-cart__tool-action"
          type="submit"
          data-clean-cart-tool-submit
          data-clean-cart-tool-original-label="${escapeCleanCartPageHtml(submitLabel)}"
          data-clean-cart-tool-pending-label="${escapeCleanCartPageHtml(pendingLabel)}"
          ${submitDisabled ? "data-clean-cart-tool-unavailable='true' disabled" : ''}
        >${escapeCleanCartPageHtml(submitLabel)}</button>
        <button class="clean-main-cart__tool-action clean-main-cart__tool-action--secondary" type="button" data-clean-cart-tool-cancel>Cancel</button>
        <p class="clean-main-cart__tool-form-status" data-clean-cart-tool-form-status role="status" aria-live="polite" hidden></p>
      </div>
    `;

    const renderCleanCartPageToolLoading = (dialog, tool = 'gift-wrap') => {
      dialog.querySelector('[data-clean-cart-tool-dialog-title]').textContent = cleanCartPageToolTitles[tool];
      dialog.querySelector('[data-clean-cart-tool-dialog-description]').textContent = cleanCartPageToolDescriptions[tool];
      dialog.querySelector('[data-clean-cart-tool-dialog-content]').innerHTML =
        '<p class="clean-main-cart__tool-loading">Checking cart options…</p>';
    };

    const renderCleanCartPageToolDialog = (dialog, tool, cart, giftWrapVariant, errorMessage = '') => {
      const content = dialog.querySelector('[data-clean-cart-tool-dialog-content]');
      const drafts = cleanCartPageToolDrafts(dialog.closest('[data-clean-cart-page]'), cart);
      const escapedNote = escapeCleanCartPageHtml(drafts.note);
      const escapedTo = escapeCleanCartPageHtml(drafts.to);
      const escapedFrom = escapeCleanCartPageHtml(drafts.from);
      const escapedMessage = escapeCleanCartPageHtml(drafts.message);

      dialog.querySelector('[data-clean-cart-tool-dialog-title]').textContent = cleanCartPageToolTitles[tool];
      dialog.querySelector('[data-clean-cart-tool-dialog-description]').textContent =
        cleanCartPageToolDescriptions[tool];

      if (tool === 'instructions') {
        content.innerHTML = `
          <form class="clean-main-cart__tool-form" data-clean-cart-tool-form data-clean-cart-tool-form-type="instructions">
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-special-instructions">Order special instructions</label>
              <textarea id="clean-main-cart-special-instructions" name="note" rows="5" data-clean-cart-tool-autofocus placeholder="Order special instructions">${escapedNote}</textarea>
            </div>
            ${renderCleanCartPageToolActions('Save Instructions', 'Saving instructions…')}
          </form>
        `;
      } else if (tool === 'card') {
        content.innerHTML = `
          <form class="clean-main-cart__tool-form" data-clean-cart-tool-form data-clean-cart-tool-form-type="card">
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-card-to">To</label>
              <textarea id="clean-main-cart-card-to" name="to" rows="2" data-clean-cart-tool-autofocus placeholder="Enter recipient name">${escapedTo}</textarea>
            </div>
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-card-from">From</label>
              <textarea id="clean-main-cart-card-from" name="from" rows="2" placeholder="Enter sender name">${escapedFrom}</textarea>
            </div>
            <div class="clean-main-cart__tool-field">
              <label for="clean-main-cart-card-message">Message</label>
              <textarea id="clean-main-cart-card-message" name="message" rows="4" placeholder="Enter a message">${escapedMessage}</textarea>
            </div>
            ${renderCleanCartPageToolActions('Save Card', 'Saving card message…')}
          </form>
        `;
      } else {
        const cartPage = dialog.closest('[data-clean-cart-page]');
        const giftWrapItem = cleanCartPageGiftWrapItem(cartPage, cart);
        const hasGiftWrap = Boolean(giftWrapItem);
        const canSubmit = hasGiftWrap || Boolean(giftWrapVariant?.available);
        const submitLabel = hasGiftWrap ? 'Remove Gift Wrap' : 'Add Gift Wrap';
        const pendingLabel = hasGiftWrap ? 'Removing gift wrap…' : 'Adding gift wrap…';
        const copy = errorMessage ||
          (hasGiftWrap
            ? 'Gift wrap is already included. You can remove it here if you change your mind.'
            : canSubmit
              ? 'Add gift wrap to make your present feel extra special.'
              : 'Gift wrap is currently unavailable. Please try again later.');

        content.innerHTML = `
          <form class="clean-main-cart__tool-gift-wrap" data-clean-cart-tool-form data-clean-cart-tool-form-type="gift-wrap" data-clean-cart-tool-action="${hasGiftWrap ? 'remove' : 'add'}">
            <span class="clean-main-cart__tool-gift-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24"><path d="M4 10h16v11H4zM3 7h18v3H3zM12 7v14M12 7H8.5A2.5 2.5 0 1 1 12 4.5zM12 7h3.5A2.5 2.5 0 1 0 12 4.5z"></path></svg>
            </span>
            <p class="clean-main-cart__tool-gift-copy">${escapeCleanCartPageHtml(copy)}</p>
            ${renderCleanCartPageToolActions(submitLabel, pendingLabel, !canSubmit)}
          </form>
        `;
      }

      setCleanCartPageToolDialogStatus(dialog, errorMessage, Boolean(errorMessage));
    };

    const cleanCartPageToolProductUrl = (cartPage) => {
      const rootUrl = new URL(cartPage.dataset.cleanCartRootUrl || '/', window.location.origin);
      const rootPath = rootUrl.pathname.replace(/\/$/, '');
      const handle = encodeURIComponent(cleanCartPageGiftWrapHandle(cartPage));
      return `${rootPath}/products/${handle}.js`;
    };

    const loadCleanCartPageGiftWrapVariant = async (cartPage) => {
      if (Object.prototype.hasOwnProperty.call(cartPage, 'cleanCartGiftWrapVariant')) {
        return cartPage.cleanCartGiftWrapVariant;
      }

      const configuredVariantId = cleanCartPageGiftWrapVariantId(cartPage);
      if (configuredVariantId) {
        cartPage.cleanCartGiftWrapVariant = { id: configuredVariantId, available: true };
        return cartPage.cleanCartGiftWrapVariant;
      }

      if (cartPage.cleanCartGiftWrapVariantPromise) {
        return cartPage.cleanCartGiftWrapVariantPromise;
      }

      cartPage.cleanCartGiftWrapVariantPromise = cleanCartPageRequest(cleanCartPageToolProductUrl(cartPage))
        .then(async (response) => {
          if (!response.ok) throw new Error('Gift wrap is currently unavailable.');
          const product = await response.json();
          const variant = (product.variants || []).find((item) => item.available) || null;
          cartPage.cleanCartGiftWrapVariant = variant;
          return variant;
        })
        .catch((error) => {
          delete cartPage.cleanCartGiftWrapVariantPromise;
          throw error;
        });

      return cartPage.cleanCartGiftWrapVariantPromise;
    };

    const getCleanCartPageRequestError = async (response, fallback) => {
      const payload = await response.json().catch(() => ({}));
      const errors = Array.isArray(payload?.errors) ? payload.errors : [];
      const firstError = errors.find((error) => error);
      const message =
        payload?.description ||
        payload?.message ||
        (typeof firstError === 'string' ? firstError : firstError?.message) ||
        fallback;
      return String(message);
    };

    const postCleanCartPageToolJson = async (cartPage, url, payload, fallback) => {
      const commerce = window['clean-commerce'];
      const cleanBefore = commerce?.snapshot(window.cart);
      const cleanLine = window.cart?.items?.find(item => item.key === payload.id);
      const response = await cleanCartPageRequest(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(await getCleanCartPageRequestError(response, fallback));
      }

      const result = await response.json();
      if (url.includes('/add')) commerce?.added(result, [{ id: payload.id, quantity: payload.quantity }], 'legacy-cart');
      else commerce?.changed(cleanBefore, result, 'legacy-cart', undefined, [cleanLine?.variant_id || cleanLine?.id]);
      return result;
    };

    const postCleanCartPageToolForm = async (cartPage, url, entries, fallback) => {
      const body = new FormData();
      Object.entries(entries).forEach(([name, value]) => body.append(name, value || ''));

      const response = await cleanCartPageRequest(url, {
        method: 'POST',
        body,
      });

      if (!response.ok) {
        throw new Error(await getCleanCartPageRequestError(response, fallback));
      }

      return response.json();
    };

    const refreshCleanCartPageAfterToolMutation = async (cartPage) => {
      const cart = await fetchCleanCartPage(cartPage);
      await window.CleanBulkDiscounts?.refresh(cart);
      window.CleanCartState?.publish?.(cart);
      document.dispatchEvent(
        new CustomEvent('clean:cart:updated', {
          detail: { cart, origin: 'clean-main-cart-tools' },
        }),
      );
      return cart;
    };

    const submitCleanCartPageTool = async (cartPage, dialog, form) => {
      const type = form.dataset.cleanCartToolFormType;
      let cart = await refreshCleanCartPageAfterToolMutation(cartPage);

      if (!cleanCartPageToolHasItems(cart)) {
        window.location.assign(cartPage.dataset.cleanCartUrl || '/cart');
        return '';
      }

      if (type === 'instructions') {
        const note = String(form.elements.note?.value || '');
        await postCleanCartPageToolForm(
          cartPage,
          cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update'),
          { note },
          'Unable to save special instructions.',
        );
        cart = await refreshCleanCartPageAfterToolMutation(cartPage);
        return 'Special instructions saved.';
      }

      if (type === 'card') {
        const attributes = cleanCartPageToolAttributes(cart.attributes);
        attributes.To = String(form.elements.to?.value || '');
        attributes.From = String(form.elements.from?.value || '');
        attributes.Message = String(form.elements.message?.value || '');
        await postCleanCartPageToolForm(
          cartPage,
          cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update'),
          {
            'attributes[To]': attributes.To,
            'attributes[From]': attributes.From,
            'attributes[Message]': attributes.Message,
            'attributes[Card To]': '',
            'attributes[Card From]': '',
            'attributes[Card Message]': '',
          },
          'Unable to save the card message.',
        );
        cart = await refreshCleanCartPageAfterToolMutation(cartPage);
        return 'Card message saved.';
      }

      const giftWrapItem = cleanCartPageGiftWrapItem(cartPage, cart);
      if (form.dataset.cleanCartToolAction === 'remove') {
        if (giftWrapItem?.key) {
          await postCleanCartPageToolJson(
            cartPage,
            cleanCartPageAjaxUrl(cartPage.dataset.cleanCartChangeUrl, '/cart/change'),
            { id: giftWrapItem.key, quantity: 0 },
            'Unable to remove gift wrap.',
          );
          cart = await refreshCleanCartPageAfterToolMutation(cartPage);
        }
        return 'Gift wrap removed from your cart.';
      }

      if (giftWrapItem) return 'Gift wrap is already included in your cart.';

      const variant = await loadCleanCartPageGiftWrapVariant(cartPage);
      if (!variant?.available) {
        throw new Error('Gift wrap is currently unavailable. Please try again later.');
      }

      await postCleanCartPageToolJson(
        cartPage,
        cleanCartPageAjaxUrl(cartPage.dataset.cleanCartAddUrl, '/cart/add'),
        {
          id: variant.id,
          quantity: 1,
          properties: { '_Hadiyah delivery exempt': 'Gift Wrap' },
        },
        'Unable to add gift wrap.',
      );
      cart = await refreshCleanCartPageAfterToolMutation(cartPage);
      return 'Gift wrap added to your cart.';
    };

    const initCleanCartPageTools = (cartPage, lifecycle) => {
      const tools = cartPage.querySelector('[data-clean-cart-tools]');
      const dialog = cartPage.querySelector('[data-clean-cart-tool-dialog]');
      if (!tools || !dialog || tools.dataset.cleanCartToolsReady === 'true') return;

      tools.dataset.cleanCartToolsReady = 'true';
      cartPage.cleanCartPageToolsState = { busy: false, openToken: null, restoreFocus: null };
      updateCleanCartPageTools(cartPage, window.cart || cleanCartPageToolFallbackCart(cartPage));

      const getState = () => cartPage.cleanCartPageToolsState;

      const syncToolDialogViewport = () => {
        if (!dialog.open) return;

        const visualViewport = window.visualViewport;
        const visualHeight = Math.max(0, visualViewport?.height || window.innerHeight);
        const visualOffsetTop = Math.max(0, visualViewport?.offsetTop || 0);
        const keyboardInset = Math.max(0, window.innerHeight - visualHeight - visualOffsetTop);

        dialog.style.setProperty('--clean-main-cart-tool-viewport-height', `${visualHeight}px`);
        dialog.style.setProperty('--clean-main-cart-tool-keyboard-inset', `${keyboardInset}px`);
      };

      const resetToolDialogViewport = () => {
        dialog.style.removeProperty('--clean-main-cart-tool-viewport-height');
        dialog.style.removeProperty('--clean-main-cart-tool-keyboard-inset');
      };

      const closeDialog = () => {
        const state = getState();
        if (state.busy) return;
        state.openToken = null;
        if (dialog.open) dialog.close();
      };

      dialog.querySelector('[data-clean-cart-tool-close]')?.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          closeDialog();
        },
        { signal: lifecycle.signal },
      );

      window.addEventListener('resize', syncToolDialogViewport, { signal: lifecycle.signal });
      window.visualViewport?.addEventListener('resize', syncToolDialogViewport, {
        signal: lifecycle.signal,
      });
      window.visualViewport?.addEventListener('scroll', syncToolDialogViewport, {
        signal: lifecycle.signal,
      });

      tools.addEventListener(
        'click',
        async (event) => {
          const button = event.target.closest('[data-clean-cart-tool]');
          if (!button || !tools.contains(button) || button.disabled) return;

          event.preventDefault();
          const tool = button.dataset.cleanCartTool;
          const state = getState();
          if (!tool || state.busy || dialog.open) return;

          state.openToken = {};
          const token = state.openToken;
          state.restoreFocus = button;
          setCleanCartPageToolsStatus(cartPage, '');
          renderCleanCartPageToolLoading(dialog, tool);
          dialog.dataset.cleanCartTool = tool;
          dialog.showModal();
          syncToolDialogViewport();

          try {
            let cart = window.cart;
            if (!cart || !Array.isArray(cart.items)) {
              cart = await fetchCleanCartPage(cartPage);
            }
            if (state.openToken !== token || !dialog.open) return;

            if (!cleanCartPageToolHasItems(cart)) {
              closeDialog();
              return;
            }

            let giftWrapVariant;
            if (tool === 'gift-wrap' && !cleanCartPageGiftWrapItem(cartPage, cart)) {
              try {
                giftWrapVariant = await loadCleanCartPageGiftWrapVariant(cartPage);
              } catch (error) {
                giftWrapVariant = null;
              }
            } else {
              giftWrapVariant = cartPage.cleanCartGiftWrapVariant;
            }

            if (state.openToken !== token || !dialog.open) return;
            renderCleanCartPageToolDialog(dialog, tool, cart, giftWrapVariant);
            requestAnimationFrame(() => {
              dialog.querySelector('[data-clean-cart-tool-autofocus]')?.focus({ preventScroll: true });
            });
          } catch (error) {
            if (state.openToken !== token || !dialog.open) return;
            renderCleanCartPageToolDialog(
              dialog,
              tool,
              window.cart || cleanCartPageToolFallbackCart(cartPage),
              null,
              error?.message || 'Unable to load this cart option.',
            );
          }
        },
        { signal: lifecycle.signal },
      );

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
        if (event.target.closest('[data-clean-cart-tool-close], [data-clean-cart-tool-cancel]')) {
          closeDialog();
        }
      }, { signal: lifecycle.signal });

      dialog.addEventListener('cancel', (event) => {
        if (getState().busy) event.preventDefault();
      }, { signal: lifecycle.signal });

      dialog.addEventListener('close', () => {
        const state = getState();
        state.openToken = null;
        state.busy = false;
        dialog.removeAttribute('aria-busy');
        resetToolDialogViewport();
        const restoreFocus = state.restoreFocus;
        state.restoreFocus = null;
        if (restoreFocus?.isConnected && !restoreFocus.disabled) {
          restoreFocus.focus({ preventScroll: true });
        }
      }, { signal: lifecycle.signal });

      dialog.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-clean-cart-tool-form]');
        if (!form || !dialog.contains(form)) return;

        event.preventDefault();
        const state = getState();
        if (state.busy) return;

        setCleanCartPageToolDialogBusy(dialog, true);
        const submit = form.querySelector('[data-clean-cart-tool-submit]');
        const originalLabel = submit?.dataset.cleanCartToolOriginalLabel || submit?.textContent || '';
        const pendingLabel = submit?.dataset.cleanCartToolPendingLabel || 'Saving…';
        if (submit) submit.textContent = pendingLabel;
        setCleanCartPageToolDialogStatus(dialog, pendingLabel);

        try {
          const message = await submitCleanCartPageTool(cartPage, dialog, form);
          updateCleanCartPageTools(cartPage, window.cart || cleanCartPageToolFallbackCart(cartPage));
          setCleanCartPageToolsStatus(cartPage, message);
          if (dialog.open) dialog.close();
        } catch (error) {
          setCleanCartPageToolDialogBusy(dialog, false);
          if (submit) submit.textContent = originalLabel;
          setCleanCartPageToolDialogStatus(
            dialog,
            `${error?.message || 'Unable to save this cart option.'} Your entries are still here; please try again.`,
            true,
          );
        }
      }, { signal: lifecycle.signal });

      lifecycle.signal.addEventListener('abort', () => {
        if (dialog.open) dialog.close();
      }, { once: true });
    };

    const cleanCartPagePropertyStringValue = (value) => (Array.isArray(value) ? value.join(', ') : String(value ?? ''));

    const isCleanCartPagePreviewProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase()
        .startsWith('preview.');

    const getCleanCartPagePreviewUrls = (value) => {
      const values = Array.isArray(value) ? value : [value];
      const urls = [];

      values.forEach((item) => {
        const matches = String(item ?? '').match(/https?:\/\/[^\s,]+/gi) || [];

        matches.forEach((match) => {
          const candidate = match.replace(/^[('"[]+|[)'"\]]+$/g, '');

          try {
            const url = new URL(candidate);
            if ((url.protocol === 'http:' || url.protocol === 'https:') && !urls.includes(url.href)) {
              urls.push(url.href);
            }
          } catch (error) {
            // Ignore malformed preview URLs and fall back to the raw property value below.
          }
        });
      });

      return urls;
    };

    const renderCleanCartPagePreviewControl = (previewUrls = [], item = {}) => {
      const urls = (previewUrls || []).filter(Boolean);
      if (!urls.length) return '';

      const productTitle = String(item.product_title || item.title || '').trim();
      const label = urls.length > 1 ? `View Preview (${urls.length})` : 'View Preview';

      // Put URLs on the button — <script> JSON inside innerHTML is unreliable.
      return `
        <span class="cart-item__custom-preview">
          <button
            type="button"
            class="clean-main-cart__meta-link cart-item__preview-open"
            data-cart-preview-open
            data-cart-preview-urls="${escapeCleanCartPageHtml(urls.join('|'))}"
            data-cart-preview-product="${escapeCleanCartPageHtml(productTitle)}"
            data-cart-preview-product-url="${escapeCleanCartPageHtml(item.url || '')}"
            data-cart-preview-line-key="${escapeCleanCartPageHtml(item.key || '')}"
          >
            ${escapeCleanCartPageHtml(label)}
          </button>
        </span>
      `;
    };

    const renderCleanCartPagePropertyValue = (name, value, item = {}) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      const previewUrls = isCleanCartPagePreviewProperty(name) ? getCleanCartPagePreviewUrls(value) : [];

      if (previewUrls.length) {
        return renderCleanCartPagePreviewControl(previewUrls, item);
      }

      return escapeCleanCartPageHtml(cleanCartPagePropertyStringValue(value));
    };

    const renderCleanCartPagePropertyLabel = (name) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      if (normalizedName === 'preview.effects') return '';
      if (normalizedName === 'preview.texts') return 'Text';
      if (normalizedName === 'preview.images') return 'Photos';
      return name;
    };

    const isCleanCartPageZipcodeProperty = (name) =>
      ['pincode', 'delivery tier', 'delivery estimate', 'delivery speed'].includes(
        String(name || '')
          .trim()
          .toLowerCase(),
      );

    const renderCleanCartPageVariantOptions = (item = {}) => {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const visibleOptions = options.filter((option) => {
        const name = String(option?.name || '').trim();
        const value = String(option?.value || '').trim();
        return name && value && value !== 'Default Title';
      });

      if (visibleOptions.length) {
        return `
          <dl class="clean-main-cart__meta clean-main-cart__meta--variants">
            ${visibleOptions
              .map(
                (option) => `
                  <div class="clean-main-cart__meta-row">
                    <dt>${escapeCleanCartPageHtml(option.name)}:</dt>
                    <dd>${escapeCleanCartPageHtml(option.value)}</dd>
                  </div>
                `,
              )
              .join('')}
          </dl>
        `;
      }

      const variantTitle = String(item.variant_title || '').trim();
      if (!variantTitle || variantTitle === 'Default Title') return '';

      return `
        <dl class="clean-main-cart__meta clean-main-cart__meta--variants">
          <div class="clean-main-cart__meta-row">
            <dt>Variant:</dt>
            <dd>${escapeCleanCartPageHtml(variantTitle)}</dd>
          </div>
        </dl>
      `;
    };

    const renderCleanCartPageProperties = (properties = {}, item = {}) => {
      const entries = Object.entries(properties).filter(([name, value]) => {
        const stringValue = cleanCartPagePropertyStringValue(value);
        return name && !name.startsWith('_') && !isCleanCartPageZipcodeProperty(name) && stringValue.trim() !== '';
      });

      if (!entries.length) return '';

      const visibleEntries = entries.filter(
        ([name]) =>
          ['Delivery Date', 'Delivery Day', 'Delivery Time', 'Name On Cake'].includes(name) ||
          isCleanCartPagePreviewProperty(name),
      );
      const fallbackEntries = visibleEntries.length ? visibleEntries : entries.slice(0, 3);

      return `
        <dl class="clean-main-cart__meta">
          ${fallbackEntries
            .map(([name, value]) => {
              const label = renderCleanCartPagePropertyLabel(name);
              return `
                <div class="clean-main-cart__meta-row">
                  ${label ? `<dt>${escapeCleanCartPageHtml(label)}:</dt>` : ''}
                  <dd>${renderCleanCartPagePropertyValue(name, value, item)}</dd>
                </div>
              `;
            })
            .join('')}
        </dl>
      `;
    };

    const isCleanCartPageAddOnItem = (item = {}) => {
      const properties = item?.properties || {};

      return (
        String(properties['_Add-on upsell'] || '').trim().toLowerCase() === 'yes' ||
        String(properties['_Add-on source'] || '').trim().toLowerCase() === 'post add-to-cart drawer'
      );
    };

    const getCleanCartPageHamperId = (item = {}) =>
      String(item?.properties?._hamper_id || '').trim();

    const isCleanCartPageHamperHost = (item = {}) =>
      String(item?.properties?._hamper_host || '').trim().toLowerCase() === 'true';

    const groupCleanCartPageHampers = (items = []) => {
      const groups = new Map();
      const nonHamper = [];

      items.forEach((item) => {
        const hamperId = getCleanCartPageHamperId(item);
        if (!hamperId) {
          nonHamper.push(item);
          return;
        }

        if (!groups.has(hamperId)) groups.set(hamperId, { id: hamperId, host: null, items: [] });
        const group = groups.get(hamperId);
        group.items.push(item);
        if (isCleanCartPageHamperHost(item)) group.host = item;
      });

      groups.forEach((group) => {
        if (!group.host) group.host = group.items[0];
      });

      return { groups: [...groups.values()], nonHamper };
    };

    const updateCleanCartPageHamper = async (cartPage, hamperId, nextHostQuantity) => {
      const lines = (window.cart?.items || []).filter(
        (item) => getCleanCartPageHamperId(item) === String(hamperId || ''),
      );
      if (!lines.length) return window.cart;

      const host = lines.find(isCleanCartPageHamperHost) || lines[0];
      const commerce = window['clean-commerce'];
      const cleanBefore = commerce?.snapshot(window.cart);
      const currentHostQuantity = Math.max(1, cleanCartPageQuantity(host.quantity));
      const targetQuantity = cleanCartPageQuantity(nextHostQuantity);
      const updates = Object.fromEntries(
        lines.map((item) => {
          const perHamperQuantity = Math.max(
            1,
            Math.round(cleanCartPageQuantity(item.quantity) / currentHostQuantity),
          );
          return [item.key, targetQuantity === 0 ? 0 : perHamperQuantity * targetQuantity];
        }),
      );

      const response = await cleanCartPageRequest(
        cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        },
      );
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update hamper.');
      }

      let cart = await response.json();
      commerce?.changed(cleanBefore, cart, 'legacy-cart', undefined, lines.map(line => line.variant_id || line.id));
      if (window.HadiyahDeliveryCharge?.sync) cart = await window.HadiyahDeliveryCharge.sync(cart);
      await window.CleanBulkDiscounts?.refresh(cart);
      window.CleanCartState?.publish?.(cart);
      window.cart = cart;
      renderCleanCartPage(cartPage, cart);
      return cart;
    };

    const getCleanWaPersonalizableIds = (cartPage) => {
      try {
        const parsed = JSON.parse(cartPage.dataset.cleanWaPersonalizableIds || '[]');
        return new Set((Array.isArray(parsed) ? parsed : []).map((id) => String(id)));
      } catch (_error) {
        return new Set();
      }
    };

    const cleanWaTplIdFromKey = (key) =>
      String(key || '')
        .replace(/[:?/]/g, '-');

    const isCleanWaPersonalizableItem = (item, personalizableIds) => {
      if (!item) return false;
      if (personalizableIds.has(String(item.product_id || ''))) return true;
      const properties = item.properties || {};
      const nameValue = String(properties.Name || properties.name || '').trim();
      if (nameValue && nameValue !== 'undefined') return true;
      if (String(properties._wa_personalized || '') === '1') return true;
      return Boolean(
        properties['preview.effects'] || properties['preview.images'] || properties['preview.image'],
      );
    };

    const itemHasCleanWaCustomization = (item) => {
      const properties = item?.properties || {};
      const nameValue = String(properties.Name || properties.name || '').trim();
      return Boolean(nameValue && nameValue !== 'undefined');
    };

    const getCleanWaPreviewImage = (item) => {
      const properties = item?.properties || {};
      const preview =
        properties['preview.effects'] || properties['preview.images'] || properties['preview.image'] || '';
      const firstPreview = String(preview)
        .split(',')
        .map((part) => part.trim())
        .find(Boolean);
      return firstPreview || item?.image || '';
    };

    const renderCleanWaCustomizeButton = (item, personalizableIds) => {
      if (!isCleanWaPersonalizableItem(item, personalizableIds)) return '';

      const hasCustomization = itemHasCleanWaCustomization(item);
      const tplId = cleanWaTplIdFromKey(item.key);
      const hiddenAttr = document.documentElement.classList.contains('wa-cart-flow') ? '' : ' hidden';

      return `
        <div class="clean-main-cart__wa-customize" data-wa-personalizable>
          <button
            type="button"
            class="button wa-customize-now-btn"
            data-wa-open-customize
            data-line-key="${escapeCleanCartPageHtml(item.key)}"
            data-line-index="${escapeCleanCartPageHtml(tplId)}"
            data-product-title="${escapeCleanCartPageHtml(item.product_title || item.title)}"
            data-product-image="${escapeCleanCartPageHtml(getCleanWaPreviewImage(item))}"
            data-product-image-alt="${escapeCleanCartPageHtml(item.product_title || item.title)}"
            data-variant-id="${escapeCleanCartPageHtml(item.variant_id || item.id)}"
            data-quantity="${Number(item.quantity || 0)}"
            data-has-customization="${hasCustomization}"
            ${hiddenAttr}
          >
            ${hasCustomization ? 'Edit customization' : 'Customize now'}
          </button>
        </div>
      `;
    };

    const revealCleanWaCustomizeButtons = () => {
      if (!document.documentElement.classList.contains('wa-cart-flow')) return;
      document.querySelectorAll('[data-wa-open-customize]').forEach((btn) => {
        btn.hidden = false;
      });
    };

    const renderCleanCartPage = (cartPage, cart) => {
      const itemsTarget = cartPage.querySelector('[data-clean-cart-page-items]');
      const countTarget = cartPage.querySelector('[data-clean-cart-page-count]');
      const subtotalTarget = cartPage.querySelector('[data-clean-cart-page-subtotal]');
      const rewardRow = cartPage.querySelector('[data-clean-cart-page-reward-row]');
      const rewardTarget = cartPage.querySelector('[data-clean-cart-page-reward]');
      const shippingTarget = cartPage.querySelector('[data-clean-cart-page-shipping]');
      const totalTarget = cartPage.querySelector('[data-clean-cart-page-total]');
      const checkout = cartPage.querySelector('.clean-main-cart__checkout');
      const gokwikCheckout = cartPage.querySelector('[data-clean-gokwik-checkout]');
      const deliverySummary = getCleanCartPageDeliverySummary(cart, cartPage);
      const rewardState = getCleanCartPageRewardState(cartPage, deliverySummary.merchandiseSubtotal, cart);
      const itemCount = deliverySummary.merchandiseItemCount;

      if (!itemsTarget || !countTarget || !subtotalTarget || !totalTarget) return;

      window.cart = cart;
      updateCleanCartPageRewards(cartPage, cart);

      if (!itemCount) {
        window.location.assign(cartPage.dataset.cleanCartUrl || '/cart');
        return;
      }

      countTarget.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
      cleanSetCartPageMoney(
        subtotalTarget,
        deliverySummary.merchandiseSubtotal,
        cartPage.dataset.cleanCartMoneyFormat,
      );
      if (rewardRow) rewardRow.hidden = rewardState.discount <= 0;
      if (rewardTarget && rewardState.discount > 0) {
        cleanSetCartPageMoneyParts(
          rewardTarget,
          ['-', { money: rewardState.discount }],
          cartPage.dataset.cleanCartMoneyFormat,
        );
      }
      if (shippingTarget) {
        if (deliverySummary.charge > 0) {
          cleanSetCartPageMoney(shippingTarget, deliverySummary.charge, cartPage.dataset.cleanCartMoneyFormat);
        } else {
          shippingTarget.removeAttribute('data-clean-money');
          shippingTarget.removeAttribute('data-clean-money-minor');
          shippingTarget.removeAttribute('data-clean-money-currency');
          shippingTarget.removeAttribute('data-clean-money-source-text');
          shippingTarget.removeAttribute('data-money-cents');
          shippingTarget.textContent = 'FREE';
        }
      }
      cleanSetCartPageMoney(
        totalTarget,
        Math.max(
          0,
          deliverySummary.merchandiseSubtotal + deliverySummary.charge - rewardState.discount,
        ),
        cartPage.dataset.cleanCartMoneyFormat,
      );
      document.querySelectorAll('[data-clean-cart-count], [data-cart-count]').forEach((target) => {
        target.textContent = String(itemCount);
      });

      [checkout, gokwikCheckout].forEach((target) => {
        if (!target) return;

        if (itemCount === 0) {
          target.setAttribute('aria-disabled', 'true');
        } else {
          target.removeAttribute('aria-disabled');
        }
      });

      const addOnsWereOpen = itemsTarget.querySelector('[data-clean-cart-page-add-ons]')?.open ?? true;
      const ordinaryItems = deliverySummary.merchandiseItems.filter((item) => !isCleanCartPageAddOnItem(item));
      const addOnItems = deliverySummary.merchandiseItems.filter((item) => isCleanCartPageAddOnItem(item));
      const addOnQuantity = addOnItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
      const { groups: hamperGroups, nonHamper } = groupCleanCartPageHampers(ordinaryItems);
      const waPersonalizableIds = getCleanWaPersonalizableIds(cartPage);
      const renderHamper = (group) => {
        const host = group.host || group.items[0];
        const hostQuantity = Math.max(1, cleanCartPageQuantity(host?.quantity));
        const itemCount = group.items.reduce(
          (total, item) => total + cleanCartPageQuantity(item.quantity),
          0,
        );
        const total = group.items.reduce((sum, item) => sum + cleanCartPageLinePrice(item), 0);
        const title = String(host?.properties?.Hamper || 'Make Your Own Hamper');
        const hostMedia = host?.image
          ? `<img class="clean-main-cart__hamper-thumb" src="${escapeCleanCartPageHtml(
              getCleanCartPageImageUrl(host.image),
            )}" alt="${escapeCleanCartPageHtml(host.product_title || host.title)}" width="64" height="64" loading="lazy">`
          : `<div class="clean-main-cart__hamper-icon" aria-hidden="true">
              <svg viewBox="0 0 48 48" fill="none">
                <path d="M8 16h32l-2 24H10L8 16Z" stroke="currentColor" stroke-width="2"/>
                <path d="M8 16l4-8h24l4 8" stroke="currentColor" stroke-width="2"/>
                <path d="M24 8v8" stroke="currentColor" stroke-width="2"/>
              </svg>
            </div>`;
        const lines = group.items
          .map((item) => {
            const quantity = cleanCartPageQuantity(item.quantity);
            const linePrice = cleanCartPageLinePrice(item);
            const thumbnail = item.image
              ? `<img src="${escapeCleanCartPageHtml(getCleanCartPageImageUrl(item.image))}" alt="" width="40" height="40" loading="lazy">`
              : '<span class="clean-main-cart__hamper-line-placeholder"></span>';

            return `
              <li class="clean-main-cart__hamper-line">
                ${thumbnail}
                <span class="clean-main-cart__hamper-line-title">${escapeCleanCartPageHtml(
                  item.product_title || item.title,
                )}</span>
                <span class="clean-main-cart__hamper-line-price" ${cleanCartPageMoneyAttributes(
                  linePrice,
                  cartPage.dataset.cleanCartMoneyFormat,
                )}>${escapeCleanCartPageHtml(
                  cleanCartPageFormatMoney(linePrice, cartPage.dataset.cleanCartMoneyFormat),
                )} ×${quantity}</span>
              </li>
            `;
          })
          .join('');

        return `
          <article class="clean-main-cart__hamper" data-clean-cart-page-hamper="${escapeCleanCartPageHtml(
            group.id,
          )}" data-clean-cart-page-hamper-quantity="${hostQuantity}">
            <div class="clean-main-cart__hamper-top">
              ${hostMedia}
              <div class="clean-main-cart__hamper-main">
                <div class="clean-main-cart__hamper-heading">
                  <div>
                    <h3 class="clean-main-cart__hamper-title">${escapeCleanCartPageHtml(title)}</h3>
                    <p class="clean-main-cart__hamper-sub">${itemCount} item(s)</p>
                    <strong class="clean-main-cart__hamper-total" ${cleanCartPageMoneyAttributes(
                      total,
                      cartPage.dataset.cleanCartMoneyFormat,
                    )}>${escapeCleanCartPageHtml(
                      cleanCartPageFormatMoney(total, cartPage.dataset.cleanCartMoneyFormat),
                    )}</strong>
                    <button type="button" class="clean-main-cart__hamper-details" data-clean-cart-page-hamper-details aria-expanded="false">View details</button>
                  </div>
                  <div class="clean-main-cart__hamper-meta">
                    <div class="clean-main-cart__hamper-actions">
                      <a class="clean-main-cart__hamper-edit" href="/pages/make-your-own-hamper">Edit</a>
                      <button type="button" class="clean-main-cart__hamper-remove" data-clean-cart-page-hamper-remove>Remove</button>
                    </div>
                  </div>
                </div>
                <div class="clean-main-cart__hamper-quantity">
                  <button type="button" aria-label="Decrease hamper quantity" data-clean-cart-page-hamper-decrease${
                    hostQuantity <= 1 ? ' disabled' : ''
                  }>-</button>
                  <input type="number" min="1" step="1" value="${hostQuantity}" inputmode="numeric" aria-label="Hamper quantity" data-clean-cart-page-hamper-input>
                  <button type="button" aria-label="Increase hamper quantity" data-clean-cart-page-hamper-increase>+</button>
                </div>
              </div>
            </div>
            <ul class="clean-main-cart__hamper-lines" data-clean-cart-page-hamper-lines hidden>${lines}</ul>
          </article>
        `;
      };
      const renderItem = (item) => {
        const linePrice = cleanCartPageLinePrice(item);
        const compareLinePrice = Number(item.original_line_price || 0);
        const isAddOnItem = isCleanCartPageAddOnItem(item);
        const minimumQuantity = getCleanCartPageMinimumQuantity(item);
        const itemQuantity = cleanCartPageQuantity(item.quantity);
        const decreaseDisabled = minimumQuantity > 0 && itemQuantity <= minimumQuantity ? ' disabled' : '';
        const increaseDisabled =
          minimumQuantity > 0 && itemQuantity >= cleanCartPageMaximumBulkQuantity ? ' disabled' : '';
        const maximumAttribute = minimumQuantity ? ` max="${cleanCartPageMaximumBulkQuantity}"` : '';
        const imageMarkup = item.image
          ? `<img class="clean-main-cart__image" src="${escapeCleanCartPageHtml(
              getCleanCartPageImageUrl(item.image),
            )}" alt="${escapeCleanCartPageHtml(
              item.product_title || item.title,
            )}" width="110" height="110" loading="lazy">`
          : '<span class="clean-main-cart__image clean-main-cart__image--placeholder" aria-hidden="true"></span>';
        const compareMarkup =
          compareLinePrice > linePrice
            ? `<s class="clean-main-cart__compare-price" ${cleanCartPageMoneyAttributes(
                compareLinePrice,
                cartPage.dataset.cleanCartMoneyFormat,
              )}>${escapeCleanCartPageHtml(
                cleanCartPageFormatMoney(compareLinePrice, cartPage.dataset.cleanCartMoneyFormat),
              )}</s>`
            : '';

        return `
            <article class="clean-main-cart__item${
              isAddOnItem ? ' clean-main-cart__item--add-on' : ''
            }" data-clean-cart-page-item="${escapeCleanCartPageHtml(
              item.key,
            )}" data-clean-cart-page-minimum-quantity="${minimumQuantity}">
              <a class="clean-main-cart__image-link" href="${escapeCleanCartPageHtml(
                item.url || '#',
              )}" aria-label="${escapeCleanCartPageHtml(item.title)}">
                ${imageMarkup}
              </a>
              <div class="clean-main-cart__item-body">
                <a class="clean-main-cart__item-title" href="${escapeCleanCartPageHtml(item.url || '#')}">
                  ${escapeCleanCartPageHtml(item.product_title || item.title)}
                </a>
                ${renderCleanCartPageVariantOptions(item)}
                ${renderCleanCartPageProperties(item.properties, item)}
                ${renderCleanWaCustomizeButton(item, waPersonalizableIds)}
                <div class="clean-main-cart__prices">
                  ${compareMarkup}
                  <span class="clean-main-cart__price" ${cleanCartPageMoneyAttributes(
                    linePrice,
                    cartPage.dataset.cleanCartMoneyFormat,
                  )}>${escapeCleanCartPageHtml(
                    cleanCartPageFormatMoney(linePrice, cartPage.dataset.cleanCartMoneyFormat),
                  )}</span>
                  ${compareLinePrice > linePrice ? `<small class="clean-main-cart__discount">${Math.round((compareLinePrice - linePrice) * 100 / compareLinePrice)}% off</small>` : ''}
                </div>
                <div class="clean-main-cart__quantity" data-clean-cart-page-quantity>
                  <button type="button" aria-label="Decrease quantity" data-clean-cart-page-quantity-decrease${decreaseDisabled}>-</button>
                  <input
                    type="number"
                    min="${minimumQuantity || 0}"
                    ${maximumAttribute}
                    step="1"
                    value="${itemQuantity}"
                    inputmode="numeric"
                    aria-label="Quantity for ${escapeCleanCartPageHtml(item.product_title || item.title)}"
                    data-clean-cart-page-quantity-input
                  >
                  <button type="button" aria-label="Increase quantity" data-clean-cart-page-quantity-increase${increaseDisabled}>+</button>
                </div>
              </div>
              <button class="clean-main-cart__remove" type="button" aria-label="Remove ${escapeCleanCartPageHtml(
                item.product_title || item.title,
              )}" data-clean-cart-page-remove>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3"></path>
                </svg>
              </button>
            </article>
          `;
      };
      const addOnMarkup = addOnItems.map(renderItem).join('');

      itemsTarget.innerHTML = `
        ${hamperGroups.map(renderHamper).join('')}
        ${nonHamper.map(renderItem).join('')}
        ${
          addOnItems.length
            ? `
              <details class="clean-main-cart__add-ons" data-clean-cart-page-add-ons${addOnsWereOpen ? ' open' : ''}>
                <summary class="clean-main-cart__add-ons-summary">
                  <span>Add-ons</span>
                  <span class="clean-main-cart__add-ons-count">${addOnQuantity}</span>
                </summary>
                <div class="clean-main-cart__add-ons-items">
                  ${addOnMarkup}
                </div>
              </details>
            `
            : ''
        }
      `;
      revealCleanWaCustomizeButtons();
    };

    const fetchCleanCartPage = async (cartPage) => {
      const cartUrl = cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUrl, '/cart');
      const loadCart = async () => {
        const response = await cleanCartPageRequest(cartUrl);
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      };
      let cart = window.CleanCartState?.refresh ? await window.CleanCartState.refresh(loadCart) : await loadCart();
      if (window.HadiyahDeliveryCharge?.sync) cart = await window.HadiyahDeliveryCharge.sync(cart);
      await window.CleanBulkDiscounts?.refresh(cart);
      window.CleanCartState?.publish?.(cart);
      window.cart = cart;
      return cart;
    };

    const repriceUnexpectedZeroCartItems = async (cartPage, cart) => {
      if (!cart || cartPage.dataset.cleanCartZeroPriceRepairAttempted === 'true') return cart;

      const zeroPriceItems = (cart.items || []).filter(
        (item) => !isCleanCartPageDeliveryChargeItem(item) && cleanCartPageHasUnexpectedZeroPrice(item),
      );
      if (!zeroPriceItems.length) return cart;

      cartPage.dataset.cleanCartZeroPriceRepairAttempted = 'true';
      const updates = Object.fromEntries(
        zeroPriceItems
          .map((item) => [String(item.key || '').trim(), cleanCartPageQuantity(item.quantity)])
          .filter(([key, quantity]) => key && quantity > 0),
      );
      if (!Object.keys(updates).length) return cart;

      const response = await cleanCartPageRequest(
        cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        },
      );
      if (!response.ok) return cart;

      let repricedCart = await response.json();
      if (window.HadiyahDeliveryCharge?.sync) {
        repricedCart = await window.HadiyahDeliveryCharge.sync(repricedCart);
      }
      await window.CleanBulkDiscounts?.refresh(repricedCart);
      window.CleanCartState?.publish?.(repricedCart);
      window.cart = repricedCart;
      return repricedCart;
    };

    const changeCleanCartPageItem = async (
      cartPage,
      key,
      quantity,
      { signal, allowRemoval = false } = {},
    ) => {
      const cleanQuantity = cleanCartPageQuantity(quantity);

      const cartDrawer = document.querySelector('[data-clean-cart-drawer]');
      const drawerChangeItem = window.CleanCart?.changeItem;
      if (cartDrawer && typeof drawerChangeItem === 'function') {
        return drawerChangeItem(cartDrawer, key, cleanQuantity, { allowRemoval });
      }

      const commerce = window['clean-commerce'];
      const cleanBefore = commerce?.snapshot(window.cart);
      const cleanLine = window.cart?.items?.find(item => item.key === key);
      const parent = cleanQuantity === 0
        ? (window.cart?.items || []).find((item) => item.key === key)
        : null;
      const group = String(parent?.properties?.['_Clean add-on group'] || '').trim();
      const linkedAddOns = group && !isCleanCartPageAddOnItem(parent)
        ? (window.cart?.items || []).filter((item) =>
            item.properties?.['_Clean add-on group'] === group && isCleanCartPageAddOnItem(item),
          )
        : [];
      const removeGroup = linkedAddOns.length > 0;
      const mutationUrl = removeGroup
        ? cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUpdateUrl, '/cart/update')
        : cleanCartPageAjaxUrl(cartPage.dataset.cleanCartChangeUrl, '/cart/change');
      const mutationBody = removeGroup
        ? { updates: Object.fromEntries([key, ...linkedAddOns.map((item) => item.key)].map((lineKey) => [lineKey, 0])) }
        : { id: key, quantity: cleanQuantity };

      const response = await cleanCartPageRequest(
        mutationUrl,
        {
          method: 'POST',
          signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(mutationBody),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      let cart = await response.json();
      commerce?.changed(cleanBefore, cart, 'legacy-cart', undefined, [cleanLine, ...linkedAddOns].map(line => line?.variant_id || line?.id));
      if (window.HadiyahDeliveryCharge?.sync) cart = await window.HadiyahDeliveryCharge.sync(cart);
      await window.CleanBulkDiscounts?.refresh(cart);
      window.CleanCartState?.publish?.(cart);
      document.dispatchEvent(new CustomEvent('clean:cart:updated', { detail: { cart, origin: 'clean-main-cart' } }));
      return cart;
    };

    const setCleanCartPageItemBusy = (item, isBusy) => {
      if (!item) return;
      item.toggleAttribute('aria-busy', isBusy);
      item.dataset.cleanCartPageItemBusy = isBusy ? 'true' : 'false';
      item.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isBusy;
      });

      if (!isBusy) syncCleanCartPageItemQuantityControls(item);
    };

    const restoreCleanCartPageItemQuantity = (item) => {
      const key = item?.dataset.cleanCartPageItem;
      const currentItem = (window.cart?.items || []).find(
        (cartItem) => String(cartItem?.key || '') === String(key || ''),
      );
      const input = item?.querySelector('[data-clean-cart-page-quantity-input]');
      if (!input) return;
      input.value = currentItem ? String(currentItem.quantity || 0) : input.defaultValue;
      syncCleanCartPageItemQuantityControls(item);
    };

    const queueCleanCartPageMutation = (
      cartPage,
      mutationState,
      item,
      quantity,
      { allowRemoval = false } = {},
    ) => {
      const key = item?.dataset.cleanCartPageItem;
      if (!key || item.dataset.cleanCartPageItemBusy === 'true' || mutationState.destroyed) {
        return Promise.resolve(null);
      }

      setCleanCartPageItemBusy(item, true);
      const cleanQuantity = cleanCartPageLineQuantity(item, quantity, { allowRemoval });
      const operation = mutationState.queue.then(() =>
        changeCleanCartPageItem(cartPage, key, cleanQuantity, {
          signal: mutationState.signal,
          allowRemoval,
        }),
      );
      mutationState.queue = operation.catch(() => {});

      return operation.finally(() => {
        if (item.isConnected) setCleanCartPageItemBusy(item, false);
      });
    };

    const initCleanCartPage = (root = document) => {
      root.querySelectorAll('[data-clean-cart-page]').forEach((cartPage) => {
        if (cartPage.dataset.cleanCartPageReady === 'true') return;
        cartPage.dataset.cleanCartPageReady = 'true';
        const lifecycle = new AbortController();
        const mutationState = {
          destroyed: false,
          queue: Promise.resolve(),
          signal: lifecycle.signal,
        };
        cartPage.cleanCartPageLifecycle = lifecycle;
        cartPage.cleanCartPageMutationState = mutationState;
        initCleanCartPageTools(cartPage, lifecycle);
        updateCleanCartPageRewards(cartPage, {
          total_price: cleanCartPageNormalizePrice(cartPage.dataset.cleanCartTotalCents),
        });

        window.CleanGokwik.syncScope(cartPage, { detect: true, prepare: true }).catch(() => {});

        cartPage.querySelectorAll('[data-clean-gokwik-checkout]').forEach((button) => {
          button.addEventListener(
            'click',
            async (event) => {
              event.preventDefault();

              if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

              window['clean-commerce']?.checkout(window.cart, 'legacy-cart');
              button.disabled = true;
              setCleanCartPageStatus(cartPage);

              try {
                await fetchCleanCartPage(cartPage);
                await window.CleanGokwik.checkout(button, cartPage);
              } catch (error) {
                setCleanCartPageStatus(cartPage, error?.message || 'Unable to start GoKwik checkout.');
                window.CleanGokwik.fallbackToShopify(cartPage, 'cart_refresh_failed');
              } finally {
                button.disabled = false;
              }
            },
            { signal: lifecycle.signal },
          );
        });

        cartPage.querySelectorAll('[data-clean-shopify-checkout]').forEach((link) => {
          link.addEventListener(
            'click',
            async (event) => {
              event.preventDefault();
              if (link.getAttribute('aria-disabled') === 'true') return;
              window['clean-commerce']?.checkout(window.cart, 'legacy-cart');

              try {
                await fetchCleanCartPage(cartPage);
                await window.CleanGokwik.routeCheckout(link, cartPage, {
                  checkoutUrl: link.href,
                  source: 'cart_shopify_control',
                });
              } catch (error) {
                setCleanCartPageStatus(cartPage, error?.message || 'Unable to prepare checkout.');
              }
            },
            { signal: lifecycle.signal },
          );
        });

        cartPage.addEventListener(
          'click',
          async (event) => {
            const hamper = event.target.closest('[data-clean-cart-page-hamper]');
            if (hamper && cartPage.contains(hamper)) {
              const hamperId = hamper.dataset.cleanCartPageHamper;
              const currentQuantity = cleanCartPageQuantity(
                hamper.dataset.cleanCartPageHamperQuantity || 1,
              );

              if (event.target.closest('[data-clean-cart-page-hamper-details]')) {
                event.preventDefault();
                const lines = hamper.querySelector('[data-clean-cart-page-hamper-lines]');
                const toggle = event.target.closest('[data-clean-cart-page-hamper-details]');
                if (!lines || !toggle) return;
                const wasOpen = !lines.hidden;
                lines.hidden = wasOpen;
                toggle.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
                toggle.textContent = wasOpen ? 'View details' : 'Hide details';
                return;
              }

              let nextQuantity = null;
              if (event.target.closest('[data-clean-cart-page-hamper-remove]')) {
                nextQuantity = 0;
              } else if (event.target.closest('[data-clean-cart-page-hamper-decrease]')) {
                if (currentQuantity <= 1) return;
                nextQuantity = currentQuantity - 1;
              } else if (event.target.closest('[data-clean-cart-page-hamper-increase]')) {
                nextQuantity = currentQuantity + 1;
              }

              if (nextQuantity !== null) {
                event.preventDefault();
                hamper.classList.add('clean-main-cart__hamper--loading');
                try {
                  await updateCleanCartPageHamper(cartPage, hamperId, nextQuantity);
                } catch (error) {
                  hamper.classList.remove('clean-main-cart__hamper--loading');
                  setCleanCartPageStatus(cartPage, error?.message || 'Unable to update hamper.');
                }
                return;
              }
            }

            const item = event.target.closest('[data-clean-cart-page-item]');
            if (!item || !cartPage.contains(item)) return;

            const quantityInput = item.querySelector('[data-clean-cart-page-quantity-input]');
            let quantity = null;
            let allowRemoval = false;

            if (event.target.closest('[data-clean-cart-page-remove]')) {
              quantity = 0;
              allowRemoval = true;
            } else if (event.target.closest('[data-clean-cart-page-quantity-decrease]')) {
              const minimum = getCleanCartPageElementMinimumQuantity(item);
              const currentQuantity = cleanCartPageQuantity(quantityInput?.value);
              if (minimum && currentQuantity <= minimum) {
                quantityInput.value = String(minimum);
                syncCleanCartPageItemQuantityControls(item);
                setCleanCartPageStatus(cartPage, `Minimum order quantity is ${minimum}.`);
                return;
              }
              quantity = currentQuantity - 1;
            } else if (event.target.closest('[data-clean-cart-page-quantity-increase]')) {
              const minimum = getCleanCartPageElementMinimumQuantity(item);
              const currentQuantity = cleanCartPageQuantity(quantityInput?.value);
              if (minimum && currentQuantity >= cleanCartPageMaximumBulkQuantity) {
                quantityInput.value = String(cleanCartPageMaximumBulkQuantity);
                syncCleanCartPageItemQuantityControls(item);
                setCleanCartPageStatus(cartPage, `Maximum quantity is ${cleanCartPageMaximumBulkQuantity}.`);
                return;
              }
              quantity = currentQuantity + 1;
            }

            if (quantity === null) return;

            event.preventDefault();
            setCleanCartPageStatus(cartPage);

            try {
              await queueCleanCartPageMutation(cartPage, mutationState, item, quantity, { allowRemoval });
            } catch (error) {
              restoreCleanCartPageItemQuantity(item);
              setCleanCartPageStatus(cartPage, error?.message || 'Unable to update cart.');
            }
          },
          { signal: lifecycle.signal },
        );

        cartPage.addEventListener(
          'change',
          async (event) => {
            const hamperInput = event.target.closest('[data-clean-cart-page-hamper-input]');
            if (hamperInput && cartPage.contains(hamperInput)) {
              const hamper = hamperInput.closest('[data-clean-cart-page-hamper]');
              if (!hamper) return;
              const quantity = Math.max(1, cleanCartPageQuantity(hamperInput.value));
              hamperInput.value = String(quantity);
              hamper.classList.add('clean-main-cart__hamper--loading');
              try {
                await updateCleanCartPageHamper(
                  cartPage,
                  hamper.dataset.cleanCartPageHamper,
                  quantity,
                );
              } catch (error) {
                hamper.classList.remove('clean-main-cart__hamper--loading');
                setCleanCartPageStatus(cartPage, error?.message || 'Unable to update hamper.');
              }
              return;
            }

            const input = event.target.closest('[data-clean-cart-page-quantity-input]');
            if (!input || !cartPage.contains(input)) return;

            const item = input.closest('[data-clean-cart-page-item]');
            if (!item) return;

            const minimum = getCleanCartPageElementMinimumQuantity(item);
            const requestedQuantity = cleanCartPageQuantity(input.value);
            const cleanQuantity = minimum
              ? Math.min(cleanCartPageMaximumBulkQuantity, Math.max(minimum, requestedQuantity))
              : requestedQuantity;

            if (cleanQuantity !== requestedQuantity) {
              input.value = String(cleanQuantity);
              syncCleanCartPageItemQuantityControls(item);
              setCleanCartPageStatus(
                cartPage,
                requestedQuantity < minimum
                  ? `Minimum order quantity is ${minimum}.`
                  : `Maximum quantity is ${cleanCartPageMaximumBulkQuantity}.`,
              );
            } else {
              setCleanCartPageStatus(cartPage);
            }

            try {
              await queueCleanCartPageMutation(cartPage, mutationState, item, cleanQuantity);
            } catch (error) {
              restoreCleanCartPageItemQuantity(item);
              setCleanCartPageStatus(cartPage, error?.message || 'Unable to update cart.');
            }
          },
          { signal: lifecycle.signal },
        );

        document.addEventListener(
          'clean:cart:updated',
          (event) => {
            if (event.detail?.cart) {
              updateCleanCartPageTools(cartPage, event.detail.cart);
              renderCleanCartPage(cartPage, event.detail.cart);
            }
          },
          { signal: lifecycle.signal },
        );

        mutationState.queue = fetchCleanCartPage(cartPage)
          .then((cart) => repriceUnexpectedZeroCartItems(cartPage, cart))
          .then((cart) => {
            updateCleanCartPageTools(cartPage, cart);
            renderCleanCartPage(cartPage, cart);
            window['clean-commerce']?.viewCart(cart, 'legacy-cart');
            return cart;
          })
          .catch(() => {});
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCartPage(), { once: true });
    } else {
      initCleanCartPage();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCartPage(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.('[data-clean-cart-page]').forEach((cartPage) => {
        if (cartPage.cleanCartPageMutationState) cartPage.cleanCartPageMutationState.destroyed = true;
        cartPage.cleanCartPageLifecycle?.abort();
        delete cartPage.dataset.cleanCartPageReady;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'clean-main-collection';
    const cleanWishlistStorageKey = 'clean:wishlist:v1';
    const cleanLegacyWishlistStorageKey = 'wishlistItem';
    const cleanDisplayCurrencyStorageKey = 'clean:display-currency:v1';
    const cleanPriceOptionValue = 'clean-price-range';
    const cleanPriceCurrencySymbols = {
      INR: '₹',
      GBP: '£',
      USD: '$',
      AED: 'AED',
      AUD: 'AUD',
      SAR: 'SAR',
      CAD: 'CAD',
      EUR: '€',
    };

    if (customElements.get(elementName)) return;

    const cleanNormalizeWishlist = (handles) =>
      [...new Set(handles.filter((handle) => typeof handle === 'string' && handle.trim()).map((handle) => handle.trim()))];

    const cleanParseWishlist = (value, objectFormat = false) => {
      if (value === null) return null;

      try {
        const parsed = JSON.parse(value);
        const handles = objectFormat ? parsed?.handles : parsed;
        return Array.isArray(handles) ? cleanNormalizeWishlist(handles) : null;
      } catch {
        return null;
      }
    };

    const cleanReadWishlist = () => {
      try {
        const legacyHandles = cleanParseWishlist(localStorage.getItem(cleanLegacyWishlistStorageKey));
        if (legacyHandles !== null) return { available: true, handles: legacyHandles };

        const cleanHandles = cleanParseWishlist(localStorage.getItem(cleanWishlistStorageKey), true);
        return { available: true, handles: cleanHandles || [] };
      } catch {
        return { available: false, handles: [] };
      }
    };

    const cleanWriteWishlist = (handles) => {
      const normalizedHandles = cleanNormalizeWishlist(handles);
      let didWrite = false;

      try {
        localStorage.setItem(cleanWishlistStorageKey, JSON.stringify({ version: 1, handles: normalizedHandles }));
        didWrite = true;
      } catch {
        // The temporary legacy bridge may remain writable in a constrained context.
      }

      try {
        localStorage.setItem(cleanLegacyWishlistStorageKey, JSON.stringify(normalizedHandles));
        didWrite = true;
      } catch {
        // The Clean key above remains sufficient for Clean cards.
      }

      return didWrite;
    };

    class CleanMainCollection extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;
        const wishlistState = cleanReadWishlist();

        this.cleanInitializeCollectionNavigation(signal);
        this.cleanInitializeCuratedFilters(signal);
        this.cleanInitializeSort(signal);
        this.cleanInitializePriceDialog(signal);
        this.cleanInitializeEyelets(signal);
        this.cleanInitializeViewMore(signal);
        this.addEventListener('click', (event) => this.cleanHandleWishlistClick(event), { signal });
        window.addEventListener('storage', (event) => this.cleanHandleWishlistStorage(event), { signal });
        window.addEventListener('clean:wishlist-change', () => this.cleanSyncWishlistButtons(), { signal });

        if (wishlistState.available) {
          this.setAttribute('data-clean-main-collection-enhanced', 'true');
          this.cleanSyncWishlistButtons(wishlistState);
        }
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanCollectionNavigationController?.abort();
        this.cleanViewMoreObserver?.disconnect();
        this.cleanEyeletResizeObserver?.disconnect();
        this.cleanStopPriceDialogPositioning();
        if (this.cleanPriceCloseTimer) window.clearTimeout(this.cleanPriceCloseTimer);
        this.cleanConnected = false;
      }

      cleanInitializeCollectionNavigation(signal) {
        if (window.Shopify?.designMode || !this.dataset.cleanSectionId || !this.dataset.cleanCollectionUrl) return;

        const currentState = history.state && typeof history.state === 'object' ? history.state : {};
        if (!currentState.cleanCollectionNavigation) {
          try {
            history.replaceState({ ...currentState, cleanCollectionNavigation: true }, '', window.location.href);
          } catch {
            return;
          }
        }

        this.addEventListener('click', (event) => this.cleanHandleCollectionNavigationClick(event), { signal });
        window.addEventListener(
          'popstate',
          (event) => {
            if (!event.state?.cleanCollectionNavigation) return;
            void this.cleanNavigateCollection(new URL(window.location.href), {
              historyMode: 'none',
              focusSelector: '',
            });
          },
          { signal },
        );
      }

      cleanHandleCollectionNavigationClick(event) {
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          !(event.target instanceof Element)
        ) {
          return;
        }

        const link = event.target.closest('[data-clean-collection-curated-filters] a[href]');
        if (!link || !this.contains(link) || link.hasAttribute('download') || link.target) return;

        const destination = new URL(link.href, window.location.href);
        if (destination.origin !== window.location.origin) return;

        event.preventDefault();
        if (destination.href === window.location.href) return;
        void this.cleanNavigateCollection(destination, {
          historyMode: 'push',
          focusSelector: '.clean-main-collection__curated-filter-pill[aria-current="true"]',
        });
      }

      cleanCollectionNoindexRequired(root, destination) {
        const collectionUrl = new URL(root.dataset.cleanCollectionUrl || destination.pathname, window.location.origin);
        const normalizePath = (path) => path.replace(/\/+$/, '') || '/';
        const hasTagPath = normalizePath(destination.pathname) !== normalizePath(collectionUrl.pathname);
        const hasNativeFilter = Array.from(destination.searchParams.keys()).some((name) => name.startsWith('filter.'));
        const selectedSort = destination.searchParams.get('sort_by');
        const defaultSort = root.dataset.cleanCollectionDefaultSort || '';
        const excludedCollection = ['all', 'end-of-season-sale'].includes(root.dataset.cleanCollectionHandle || '');

        return (
          excludedCollection ||
          hasTagPath ||
          hasNativeFilter ||
          Boolean(selectedSort && selectedSort !== defaultSort)
        );
      }

      cleanSyncCollectionRobots(root, destination) {
        let robots = document.head.querySelector('meta[data-clean-collection-robots]');
        if (this.cleanCollectionNoindexRequired(root, destination)) {
          if (!robots) {
            robots = document.createElement('meta');
            robots.name = 'robots';
            robots.dataset.cleanCollectionRobots = '';
            document.head.append(robots);
          }
          robots.content = 'noindex,follow';
        } else {
          robots?.remove();
        }
      }

      async cleanNavigateCollection(destination, { historyMode = 'push', focusSelector = '' } = {}) {
        const sectionId = this.dataset.cleanSectionId;
        const fallbackUrl = destination.href;
        const requestUrl = new URL(fallbackUrl);
        const collectionUrl = new URL(this.dataset.cleanCollectionUrl, window.location.origin);
        const normalizedCollectionPath = collectionUrl.pathname.replace(/\/+$/, '');
        const normalizedDestinationPath = destination.pathname.replace(/\/+$/, '');
        const isCollectionPath =
          normalizedDestinationPath === normalizedCollectionPath ||
          normalizedDestinationPath.startsWith(`${normalizedCollectionPath}/`);

        if (!sectionId || destination.origin !== window.location.origin || !isCollectionPath) {
          window.location.assign(fallbackUrl);
          return;
        }

        this.cleanCollectionNavigationController?.abort();
        const requestController = new AbortController();
        this.cleanCollectionNavigationController = requestController;
        this.dataset.cleanCollectionNavigationLoading = 'true';
        this.setAttribute('aria-busy', 'true');
        const currentStatus = this.querySelector('[data-clean-collection-navigation-status]');
        if (currentStatus) currentStatus.textContent = 'Updating products…';
        requestUrl.searchParams.set('section_id', sectionId);

        try {
          const response = await fetch(requestUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
            signal: requestController.signal,
          });
          if (!response.ok) throw new Error(`Collection filter request failed: ${response.status}`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseRoot = Array.from(responseDocument.querySelectorAll('[data-clean-main-collection]')).find(
            (candidate) =>
              candidate.dataset.cleanSectionId === sectionId &&
              candidate.querySelector('.clean-main-collection__title'),
          );
          if (!(responseRoot instanceof HTMLElement)) throw new Error('Clean collection response markup was missing.');

          if (historyMode === 'push') {
            const currentState = history.state && typeof history.state === 'object' ? history.state : {};
            history.pushState({ ...currentState, cleanCollectionNavigation: true }, '', fallbackUrl);
          }

          this.cleanSyncCollectionRobots(responseRoot, destination);
          this.replaceWith(responseRoot);
          window.CleanDisplayCurrencyBootstrap?.refresh(responseRoot);

          window.requestAnimationFrame(() => {
            const nextStatus = responseRoot.querySelector('[data-clean-collection-navigation-status]');
            const count = responseRoot
              .querySelector('.clean-main-collection__heading-count')
              ?.textContent.replace(/[()]/g, '')
              .replace(/\s+/g, ' ')
              .trim();
            if (nextStatus) nextStatus.textContent = count ? `Filters updated. ${count}.` : 'Filters updated.';

            if (focusSelector) {
              const focusTarget =
                responseRoot.querySelector(focusSelector) ||
                responseRoot.querySelector('[data-clean-collection-curated-filter-viewport]');
              focusTarget?.focus({ preventScroll: true });
            }
          });

          if (historyMode === 'push' && typeof window.Shopify?.analytics?.publish === 'function') {
            try {
              const analyticsResult = window.Shopify.analytics.publish('hadiyah:collection_filter_changed', {
                collection_handle: responseRoot.dataset.cleanCollectionHandle || '',
                url: `${destination.pathname}${destination.search}`,
              });
              analyticsResult?.catch?.(() => {});
            } catch {
              // Filtering remains authoritative when analytics is unavailable.
            }
          }
        } catch (error) {
          if (error?.name === 'AbortError') return;
          if (historyMode === 'none') window.location.reload();
          else window.location.assign(fallbackUrl);
        } finally {
          if (this.cleanCollectionNavigationController === requestController) {
            this.cleanCollectionNavigationController = null;
            delete this.dataset.cleanCollectionNavigationLoading;
            this.removeAttribute('aria-busy');
          }
        }
      }

      cleanInitializeCuratedFilters(signal) {
        const colourSelect = this.querySelector('[data-clean-collection-colour-select]');
        if (!(colourSelect instanceof HTMLSelectElement)) return;

        colourSelect.hidden = false;
        colourSelect.disabled = false;
        colourSelect.addEventListener(
          'change',
          () => {
            if (!colourSelect.value) return;
            const destination = new URL(colourSelect.value, window.location.href);
            if (destination.origin !== window.location.origin) return;
            destination.searchParams.delete('page');
            void this.cleanNavigateCollection(destination, {
              historyMode: 'push',
              focusSelector: '[data-clean-collection-colour-select]',
            });
          },
          { signal },
        );
      }

      cleanInitializeSort(signal) {
        this.cleanSortSelect = this.querySelector('[data-clean-collection-sort]');
        this.cleanPriceOption = this.cleanSortSelect?.querySelector('[data-clean-collection-price-option]');
        if (!this.cleanSortSelect) return;

        this.cleanSelectedSort = this.cleanSortSelect.value;
        this.cleanSortSelect.addEventListener(
          'change',
          () => {
            if (this.cleanSortSelect.value === cleanPriceOptionValue) {
              this.cleanSortSelect.value = this.cleanSelectedSort;
              void this.cleanOpenPriceDialog();
              return;
            }
            this.cleanSortSelect.form?.requestSubmit();
          },
          { signal },
        );
      }

      cleanInitializePriceDialog(signal) {
        this.cleanPriceDialog = this.querySelector('[data-clean-collection-price-dialog]');
        if (!(this.cleanPriceDialog instanceof HTMLDialogElement) || typeof this.cleanPriceDialog.showModal !== 'function') {
          return;
        }

        this.cleanPriceDialogSurface = this.cleanPriceDialog.querySelector('[data-clean-collection-price-dialog-surface]');
        this.cleanPriceForm = this.cleanPriceDialog.querySelector('[data-clean-collection-price-form]');
        this.cleanPriceMin = this.cleanPriceDialog.querySelector('[data-clean-collection-price-min]');
        this.cleanPriceMax = this.cleanPriceDialog.querySelector('[data-clean-collection-price-max]');
        this.cleanPriceError = this.cleanPriceDialog.querySelector('[data-clean-collection-price-error]');
        this.cleanPriceNote = this.cleanPriceDialog.querySelector('[data-clean-collection-price-note]');
        this.cleanPriceAvailableRange = this.cleanPriceDialog.querySelector(
          '[data-clean-collection-price-available-range]',
        );
        this.cleanPriceDesktop = window.matchMedia('(min-width: 990px)');
        this.cleanPriceReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.cleanQueuePriceDialogPosition = this.cleanQueuePriceDialogPosition.bind(this);
        if (this.cleanPriceOption) this.cleanPriceOption.disabled = false;

        this.cleanPriceDialog.querySelector('[data-clean-collection-price-close]')?.addEventListener(
          'click',
          () => this.cleanClosePriceDialog(),
          { signal },
        );
        this.cleanPriceDialog.querySelector('[data-clean-collection-price-clear]')?.addEventListener(
          'click',
          () => this.cleanClearPrice(),
          { signal },
        );
        this.cleanPriceForm?.addEventListener('submit', (event) => this.cleanApplyPrice(event), { signal });
        this.cleanPriceDialog.addEventListener('cancel', (event) => this.cleanCancelPriceDialog(event), { signal });
        this.cleanPriceDialog.addEventListener('click', (event) => this.cleanHandlePriceBackdrop(event), { signal });
        this.cleanPriceDialog.addEventListener('close', () => this.cleanHandlePriceDialogClosed(), { signal });
        window.addEventListener(
          'storage',
          (event) => {
            if (event.key === null || event.key === cleanDisplayCurrencyStorageKey) void this.cleanSyncPriceCurrency();
          },
          { signal },
        );
        document.addEventListener(
          'clean:display-currency-change',
          () => void this.cleanSyncPriceCurrency(false),
          { signal },
        );

        void this.cleanSyncPriceCurrency();
      }

      cleanPriceNumber(value, fallback = 0) {
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) ? parsed : fallback;
      }

      cleanPriceDecimal(value) {
        return String(Math.round(value * 100) / 100);
      }

      cleanConvertPrice(value, fromCurrency, toCurrency) {
        if (fromCurrency === toCurrency) return value;
        const fromRate = Number(this.cleanPriceRates?.[fromCurrency]);
        const toRate = Number(this.cleanPriceRates?.[toCurrency]);
        if (!Number.isFinite(fromRate) || !Number.isFinite(toRate) || fromRate <= 0 || toRate <= 0) return null;
        return value * (fromRate / toRate);
      }

      cleanFormatPrice(value, currency) {
        const symbol = cleanPriceCurrencySymbols[currency] || currency;
        const spacing = ['AED', 'AUD', 'SAR', 'CAD'].includes(currency) ? '\u00a0' : '';
        try {
          const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }).format(value);
          return `${symbol}${spacing}${amount}`;
        } catch {
          return `${symbol}${spacing}${this.cleanPriceDecimal(value)}`;
        }
      }

      cleanPriceIsActive() {
        if (!this.cleanPriceDialog) return false;
        const rangeMin = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceRangeMin);
        const rangeMax = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceRangeMax, rangeMin);
        const currentMin = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceCurrentMin, rangeMin);
        const currentMax = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceCurrentMax, rangeMax);
        return currentMin > rangeMin + 0.005 || currentMax < rangeMax - 0.005;
      }

      async cleanSyncPriceCurrency(synchronizePreference = true) {
        if (!this.cleanPriceDialog || !this.cleanPriceMin || !this.cleanPriceMax) return;

        const sourceCurrency = String(
          this.cleanPriceDialog.dataset.cleanCollectionPriceSourceCurrency || 'INR',
        ).toUpperCase();
        const bootstrap = window.CleanDisplayCurrencyBootstrap;
        const preference = bootstrap?.getPreference?.();
        let displayCurrency = String(window.CleanDisplayCurrency?.currency || preference?.currency || sourceCurrency).toUpperCase();
        this.cleanPriceRates = undefined;

        if (displayCurrency !== sourceCurrency && bootstrap?.load) {
          try {
            const controller = await bootstrap.load();
            if (synchronizePreference && preference && controller?.currency !== displayCurrency) {
              await controller.applyPreference(preference);
            }
            displayCurrency = String(controller?.currency || sourceCurrency).toUpperCase();
            if (displayCurrency !== sourceCurrency) this.cleanPriceRates = await controller.loadRates();
          } catch {
            displayCurrency = sourceCurrency;
          }
        }

        const rangeMin = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceRangeMin);
        const rangeMax = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceRangeMax, rangeMin);
        const currentMin = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceCurrentMin, rangeMin);
        const currentMax = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceCurrentMax, rangeMax);
        const displayValues = [rangeMin, rangeMax, currentMin, currentMax].map((value) =>
          this.cleanConvertPrice(value, sourceCurrency, displayCurrency),
        );
        const canConvert = displayValues.every((value) => value !== null);
        const [displayMin, displayMax, displayCurrentMin, displayCurrentMax] = canConvert
          ? displayValues
          : [rangeMin, rangeMax, currentMin, currentMax];
        if (!canConvert) displayCurrency = sourceCurrency;

        this.cleanPriceDisplayCurrency = displayCurrency;
        this.cleanPriceDialog.querySelectorAll('[data-clean-collection-price-currency]').forEach((currency) => {
          currency.textContent = cleanPriceCurrencySymbols[displayCurrency] || displayCurrency;
        });
        this.cleanPriceMin.min = this.cleanPriceDecimal(displayMin);
        this.cleanPriceMin.max = this.cleanPriceDecimal(displayMax);
        this.cleanPriceMax.min = this.cleanPriceDecimal(displayMin);
        this.cleanPriceMax.max = this.cleanPriceDecimal(displayMax);
        this.cleanPriceMin.value = this.cleanPriceDecimal(displayCurrentMin);
        this.cleanPriceMax.value = this.cleanPriceDecimal(displayCurrentMax);
        if (this.cleanPriceAvailableRange) {
          this.cleanPriceAvailableRange.textContent = `${this.cleanFormatPrice(
            displayMin,
            displayCurrency,
          )}–${this.cleanFormatPrice(displayMax, displayCurrency)}`;
        }
        if (this.cleanPriceNote) {
          this.cleanPriceNote.textContent =
            displayCurrency === sourceCurrency
              ? `Shopify applies this filter in ${sourceCurrency}.`
              : `Prices shown in ${displayCurrency} are approximate. Shopify applies this filter in ${sourceCurrency}.`;
        }
        this.cleanSyncPriceOption(displayCurrentMin, displayCurrentMax, displayCurrency);
      }

      cleanSyncPriceOption(currentMin, currentMax, currency) {
        if (!this.cleanPriceOption || !this.cleanSortSelect) return;
        const active = this.cleanPriceIsActive();
        this.cleanPriceOption.textContent = active
          ? `Price: ${this.cleanFormatPrice(currentMin, currency)}–${this.cleanFormatPrice(currentMax, currency)}`
          : 'Price';
        this.cleanSortSelect.value = this.cleanSelectedSort;
      }

      async cleanOpenPriceDialog() {
        if (!this.cleanPriceDialog || this.cleanPriceDialog.open) return;
        this.cleanPriceOpener = this.cleanSortSelect;
        await this.cleanSyncPriceCurrency();
        delete this.cleanPriceDialog.dataset.cleanCollectionPriceClosing;
        this.cleanShowPriceError('');
        this.cleanPriceDialog.showModal();
        document.body.classList.add('clean-main-collection-price-open');
        this.cleanStartPriceDialogPositioning();
        window.requestAnimationFrame(() => this.cleanPriceMin?.focus({ preventScroll: true }));
      }

      cleanClosePriceDialog() {
        if (!this.cleanPriceDialog?.open || this.cleanPriceDialog.dataset.cleanCollectionPriceClosing === 'true') return;
        if (this.cleanPriceReducedMotion?.matches) {
          this.cleanFinishPriceDialogClose();
          return;
        }

        this.cleanPriceDialog.dataset.cleanCollectionPriceClosing = 'true';
        this.cleanPriceAnimationEnd = (event) => {
          if (
            event.target === this.cleanPriceDialog &&
            ['clean-main-collection-price-drawer-exit', 'clean-main-collection-price-dialog-exit'].includes(
              event.animationName,
            )
          ) {
            this.cleanFinishPriceDialogClose();
          }
        };
        this.cleanPriceDialog.addEventListener('animationend', this.cleanPriceAnimationEnd);
        this.cleanPriceCloseTimer = window.setTimeout(() => this.cleanFinishPriceDialogClose(), 240);
      }

      cleanFinishPriceDialogClose() {
        if (this.cleanPriceCloseTimer) window.clearTimeout(this.cleanPriceCloseTimer);
        this.cleanPriceCloseTimer = undefined;
        if (this.cleanPriceAnimationEnd) {
          this.cleanPriceDialog?.removeEventListener('animationend', this.cleanPriceAnimationEnd);
          this.cleanPriceAnimationEnd = undefined;
        }
        if (this.cleanPriceDialog) delete this.cleanPriceDialog.dataset.cleanCollectionPriceClosing;
        if (this.cleanPriceDialog?.open) this.cleanPriceDialog.close();
      }

      cleanHandlePriceDialogClosed() {
        this.cleanStopPriceDialogPositioning();
        document.body.classList.remove('clean-main-collection-price-open');
        this.cleanShowPriceError('');
        void this.cleanSyncPriceCurrency();
        this.cleanPriceOpener?.focus();
      }

      cleanCancelPriceDialog(event) {
        event.preventDefault();
        this.cleanClosePriceDialog();
      }

      cleanHandlePriceBackdrop(event) {
        if (event.target !== this.cleanPriceDialog || !this.cleanPriceDialogSurface) return;
        const rect = this.cleanPriceDialogSurface.getBoundingClientRect();
        const outside =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;
        if (outside) this.cleanClosePriceDialog();
      }

      cleanShowPriceError(message) {
        if (!this.cleanPriceError) return;
        this.cleanPriceError.textContent = message;
        this.cleanPriceError.hidden = !message;
      }

      cleanSetPriceLoading(loading) {
        if (!this.cleanPriceDialog) return;
        this.cleanPriceDialog.dataset.cleanCollectionPriceLoading = String(loading);
        this.cleanPriceDialog.querySelectorAll('button, input').forEach((control) => {
          control.disabled = loading;
        });
      }

      cleanClearPrice() {
        if (!this.cleanPriceDialog) return;
        const clearUrl = new URL(window.location.href);
        const minParam = this.cleanPriceDialog.dataset.cleanCollectionPriceMinParam;
        const maxParam = this.cleanPriceDialog.dataset.cleanCollectionPriceMaxParam;
        if (minParam) clearUrl.searchParams.delete(minParam);
        if (maxParam) clearUrl.searchParams.delete(maxParam);
        clearUrl.searchParams.delete('page');
        this.cleanSetPriceLoading(true);
        window.location.assign(clearUrl.href);
      }

      cleanApplyPrice(event) {
        event.preventDefault();
        if (!this.cleanPriceDialog || !this.cleanPriceMin || !this.cleanPriceMax) return;

        const enteredMin = Number.parseFloat(this.cleanPriceMin.value);
        const enteredMax = Number.parseFloat(this.cleanPriceMax.value);
        const allowedMin = this.cleanPriceNumber(this.cleanPriceMin.min);
        const allowedMax = this.cleanPriceNumber(this.cleanPriceMax.max, allowedMin);
        if (!Number.isFinite(enteredMin) || !Number.isFinite(enteredMax)) {
          this.cleanShowPriceError('Enter both a minimum and maximum price.');
          return;
        }
        if (enteredMin < allowedMin || enteredMax > allowedMax) {
          this.cleanShowPriceError(
            `Enter prices between ${this.cleanFormatPrice(allowedMin, this.cleanPriceDisplayCurrency)} and ${this.cleanFormatPrice(
              allowedMax,
              this.cleanPriceDisplayCurrency,
            )}.`,
          );
          return;
        }
        if (enteredMin > enteredMax) {
          this.cleanShowPriceError('The minimum price must be less than the maximum price.');
          return;
        }

        const sourceCurrency = String(
          this.cleanPriceDialog.dataset.cleanCollectionPriceSourceCurrency || 'INR',
        ).toUpperCase();
        const displayCurrency = this.cleanPriceDisplayCurrency || sourceCurrency;
        const sourceMin = this.cleanConvertPrice(enteredMin, displayCurrency, sourceCurrency);
        const sourceMax = this.cleanConvertPrice(enteredMax, displayCurrency, sourceCurrency);
        if (sourceMin === null || sourceMax === null) {
          this.cleanShowPriceError('Currency conversion is still loading. Please try again.');
          return;
        }

        const rangeMin = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceRangeMin);
        const rangeMax = this.cleanPriceNumber(this.cleanPriceDialog.dataset.cleanCollectionPriceRangeMax, rangeMin);
        const minParam = this.cleanPriceDialog.dataset.cleanCollectionPriceMinParam;
        const maxParam = this.cleanPriceDialog.dataset.cleanCollectionPriceMaxParam;
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (url.searchParams.get('view') === 'clean') url.searchParams.delete('view');
        if (Math.abs(enteredMin - allowedMin) < 0.005) url.searchParams.delete(minParam);
        else url.searchParams.set(minParam, this.cleanPriceDecimal(Math.min(Math.max(sourceMin, rangeMin), rangeMax)));
        if (Math.abs(enteredMax - allowedMax) < 0.005) url.searchParams.delete(maxParam);
        else url.searchParams.set(maxParam, this.cleanPriceDecimal(Math.min(Math.max(sourceMax, rangeMin), rangeMax)));

        this.cleanShowPriceError('');
        this.cleanSetPriceLoading(true);
        window.location.assign(url.toString());
      }

      cleanPositionPriceDialog() {
        if (!this.cleanPriceDialog?.open) return;
        if (this.cleanPriceDesktop.matches) {
          this.cleanPriceDialog.style.removeProperty('--clean-main-collection-price-drawer-bottom');
          this.cleanPriceDialog.style.removeProperty('max-height');
          return;
        }

        const visualViewport = window.visualViewport;
        const viewportHeight = visualViewport?.height || window.innerHeight;
        const viewportOffsetTop = visualViewport?.offsetTop || 0;
        const keyboardInset = Math.max(0, window.innerHeight - viewportHeight - viewportOffsetTop);
        this.cleanPriceDialog.style.setProperty('--clean-main-collection-price-drawer-bottom', `${keyboardInset}px`);
        this.cleanPriceDialog.style.maxHeight = `${Math.max(160, viewportHeight - 16)}px`;
      }

      cleanKeepPriceDialogFocusVisible() {
        if (this.cleanPriceDesktop.matches || !this.cleanPriceDialog?.open) return;
        const activeElement = document.activeElement;
        if (!(activeElement instanceof HTMLElement) || !this.cleanPriceDialog.contains(activeElement)) return;
        const visualViewport = window.visualViewport;
        const viewportTop = visualViewport?.offsetTop || 0;
        const viewportBottom = viewportTop + (visualViewport?.height || window.innerHeight);
        const rect = activeElement.getBoundingClientRect();
        if (rect.top < viewportTop + 16 || rect.bottom > viewportBottom - 16) {
          activeElement.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
        }
      }

      cleanQueuePriceDialogPosition() {
        if (this.cleanPricePositionFrame) window.cancelAnimationFrame(this.cleanPricePositionFrame);
        this.cleanPricePositionFrame = window.requestAnimationFrame(() => {
          this.cleanPricePositionFrame = undefined;
          this.cleanPositionPriceDialog();
          this.cleanKeepPriceDialogFocusVisible();
        });
      }

      cleanStartPriceDialogPositioning() {
        this.cleanQueuePriceDialogPosition();
        window.addEventListener('resize', this.cleanQueuePriceDialogPosition, { passive: true });
        window.visualViewport?.addEventListener('resize', this.cleanQueuePriceDialogPosition, { passive: true });
        window.visualViewport?.addEventListener('scroll', this.cleanQueuePriceDialogPosition, { passive: true });
        this.cleanPriceDialog.addEventListener('focusin', this.cleanQueuePriceDialogPosition);
      }

      cleanStopPriceDialogPositioning() {
        if (!this.cleanQueuePriceDialogPosition) return;
        window.removeEventListener('resize', this.cleanQueuePriceDialogPosition);
        window.visualViewport?.removeEventListener('resize', this.cleanQueuePriceDialogPosition);
        window.visualViewport?.removeEventListener('scroll', this.cleanQueuePriceDialogPosition);
        this.cleanPriceDialog?.removeEventListener('focusin', this.cleanQueuePriceDialogPosition);
        if (this.cleanPricePositionFrame) window.cancelAnimationFrame(this.cleanPricePositionFrame);
        this.cleanPricePositionFrame = undefined;
        this.cleanPriceDialog?.style.removeProperty('--clean-main-collection-price-drawer-bottom');
        this.cleanPriceDialog?.style.removeProperty('max-height');
      }

      cleanInitializeEyelets(signal) {
        this.cleanEyeletSelects = Array.from(this.querySelectorAll('[data-clean-collection-eyelet-select]'));
        const resetSelects = () => {
          this.cleanEyeletSelects.forEach((select) => {
            select.selectedIndex = 0;
          });
        };

        resetSelects();
        window.addEventListener('pageshow', resetSelects, { signal });

        this.cleanEyeletSelects.forEach((select) => {
          select.hidden = false;
          select.disabled = false;
          select.addEventListener(
            'change',
            () => {
              const selectedDestination = select.value;
              select.selectedIndex = 0;
              if (!selectedDestination) return;
              const destination = new URL(selectedDestination, window.location.href);
              if (destination.origin === window.location.origin) window.location.assign(destination.href);
            },
            { signal },
          );
        });

        this.cleanEyeletViewport = this.querySelector('[data-clean-collection-eyelet-viewport]');
        this.cleanEyeletControls = this.querySelector('[data-clean-collection-eyelet-controls]');
        if (!this.cleanEyeletViewport || !this.cleanEyeletControls) return;

        this.cleanEyeletPrevious = this.querySelector('[data-clean-collection-eyelet-previous]');
        this.cleanEyeletNext = this.querySelector('[data-clean-collection-eyelet-next]');
        this.cleanEyeletRail = this.cleanEyeletViewport.closest('.clean-main-collection__eyelet-rail');
        this.cleanEyeletDesktopMedia = window.matchMedia('(min-width: 990px)');

        const update = () => {
          if (this.cleanEyeletDesktopMedia.matches && this.cleanEyeletRail) {
            const viewportWidth = this.cleanEyeletViewport.clientWidth;
            const minimumEyeletSize = 120;
            const eyeletGap = 32;
            const visibleCount = Math.max(
              1,
              Math.floor((viewportWidth + eyeletGap) / (minimumEyeletSize + eyeletGap)),
            );
            const fittedEyeletSize = Math.max(
              minimumEyeletSize,
              (viewportWidth - eyeletGap * (visibleCount - 1)) / visibleCount,
            );
            const fittedEyeletValue = `${fittedEyeletSize.toFixed(3)}px`;
            if (
              this.cleanEyeletRail.style.getPropertyValue('--clean-main-collection-eyelet-desktop-size') !==
              fittedEyeletValue
            ) {
              this.cleanEyeletRail.style.setProperty(
                '--clean-main-collection-eyelet-desktop-size',
                fittedEyeletValue,
              );
            }
          } else {
            this.cleanEyeletRail?.style.removeProperty('--clean-main-collection-eyelet-desktop-size');
          }

          const hasOverflow = this.cleanEyeletViewport.scrollWidth > this.cleanEyeletViewport.clientWidth + 1;
          const showControls = this.cleanEyeletDesktopMedia.matches && hasOverflow;
          this.cleanEyeletRail?.toggleAttribute('data-clean-collection-eyelet-overflow', showControls);
          this.cleanEyeletControls.hidden = !showControls;
          this.cleanEyeletPrevious.disabled = this.cleanEyeletViewport.scrollLeft <= 1;
          this.cleanEyeletNext.disabled =
            this.cleanEyeletViewport.scrollLeft + this.cleanEyeletViewport.clientWidth >=
            this.cleanEyeletViewport.scrollWidth - 1;
        };

        this.cleanEyeletViewport.addEventListener('scroll', update, { signal, passive: true });
        this.cleanEyeletDesktopMedia.addEventListener('change', update, { signal });
        this.cleanEyeletPrevious?.addEventListener('click', () => this.cleanScrollEyelets(-1), { signal });
        this.cleanEyeletNext?.addEventListener('click', () => this.cleanScrollEyelets(1), { signal });

        if ('ResizeObserver' in window) {
          this.cleanEyeletResizeObserver = new ResizeObserver(update);
          this.cleanEyeletResizeObserver.observe(this.cleanEyeletViewport);
          const list = this.cleanEyeletViewport.firstElementChild;
          if (list) this.cleanEyeletResizeObserver.observe(list);
        }
        update();
      }

      cleanScrollEyelets(direction) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.cleanEyeletViewport?.scrollBy({
          left: direction * this.cleanEyeletViewport.clientWidth * 0.75,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      cleanInitializeViewMore(signal) {
        this.cleanProductGrid = this.querySelector('[data-clean-collection-product-grid]');
        this.cleanViewMoreWrap = this.querySelector('[data-clean-collection-view-more-wrap]');
        this.cleanLoadStatus = this.querySelector('[data-clean-collection-load-status]');
        this.cleanAutomaticViewMoreLoads = 0;
        if (!this.cleanProductGrid || !this.cleanViewMoreWrap) return;

        this.addEventListener('click', (event) => this.cleanHandleViewMoreClick(event), { signal });
        if (!('IntersectionObserver' in window) || navigator.connection?.saveData) return;

        this.cleanViewMoreObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries.find((candidate) => candidate.isIntersecting);
            if (!entry || this.cleanViewMoreLoading || this.cleanAutomaticViewMoreLoads >= 2) return;

            this.cleanAutomaticViewMoreLoads += 1;
            if (this.cleanAutomaticViewMoreLoads >= 2) this.cleanViewMoreObserver.disconnect();
            else this.cleanViewMoreObserver.unobserve(entry.target);
            void this.cleanLoadMore(entry.target, true);
          },
          { rootMargin: '0px', threshold: 0.01 },
        );

        const link = this.querySelector('[data-clean-collection-view-more]');
        if (link) this.cleanViewMoreObserver.observe(link);
      }

      cleanHandleViewMoreClick(event) {
        const link = event.target.closest('[data-clean-collection-view-more]');
        if (!link || !this.contains(link)) return;

        event.preventDefault();
        if (!this.cleanViewMoreLoading) void this.cleanLoadMore(link, false);
      }

      async cleanLoadMore(link, automatic) {
        if (this.cleanViewMoreLoading || !link?.href || !this.cleanProductGrid) return;

        const requestUrl = new URL(link.href, window.location.href);
        if (requestUrl.origin !== window.location.origin) {
          if (!automatic) window.location.assign(link.href);
          return;
        }

        this.cleanViewMoreLoading = true;
        this.cleanViewMoreObserver?.unobserve(link);
        this.cleanViewMoreWrap?.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        link.textContent = 'Loading…';
        requestUrl.searchParams.set('section_id', this.dataset.cleanSectionId);

        try {
          const response = await fetch(requestUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.cleanAbortController.signal,
          });
          if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseRoot = Array.from(responseDocument.querySelectorAll('[data-clean-main-collection]')).find(
            (candidate) => candidate.dataset.cleanSectionId === this.dataset.cleanSectionId,
          );
          const responseGrid = responseRoot?.querySelector('[data-clean-collection-product-grid]');
          const responseItems = responseGrid
            ? Array.from(responseGrid.children).filter(
                (item) =>
                  item.matches('.clean-main-collection__product-item') &&
                  item.querySelector(':scope > .clean-product-card'),
              )
            : [];
          if (!responseItems.length) throw new Error('Clean collection product markup was missing.');

          const fragment = document.createDocumentFragment();
          responseItems.forEach((item) => fragment.append(item));
          this.cleanProductGrid.append(fragment);
          window.CleanDisplayCurrencyBootstrap?.refresh(this.cleanProductGrid);
          this.cleanSyncWishlistButtons();

          if (this.cleanLoadStatus) {
            this.cleanLoadStatus.textContent = `${responseItems.length} more ${
              responseItems.length === 1 ? 'product' : 'products'
            } loaded.`;
          }

          const responseLink = responseRoot?.querySelector('[data-clean-collection-view-more]');
          const nextUrl = responseLink?.getAttribute('href');
          if (nextUrl) {
            link.href = nextUrl;
            link.textContent = 'View more';
            link.removeAttribute('aria-disabled');
            if (automatic && this.cleanAutomaticViewMoreLoads < 2) this.cleanViewMoreObserver?.observe(link);
          } else {
            link.remove();
            if (this.cleanLoadStatus) this.cleanLoadStatus.textContent = 'All products are loaded.';
          }
        } catch (error) {
          if (error?.name === 'AbortError') return;

          link.textContent = 'View more';
          link.removeAttribute('aria-disabled');
          if (automatic) {
            this.cleanViewMoreObserver?.disconnect();
            if (this.cleanLoadStatus) {
              this.cleanLoadStatus.textContent = 'Automatic loading stopped. Select View more to continue.';
            }
          } else {
            window.location.assign(link.href);
          }
        } finally {
          this.cleanViewMoreLoading = false;
          this.cleanViewMoreWrap?.setAttribute('aria-busy', 'false');
        }
      }

      cleanSyncWishlistButtons(state = cleanReadWishlist()) {
        const selectedHandles = new Set(state.handles);
        this.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
          const handle = button.dataset.cleanProductWishlistHandle?.trim();
          const title = button.dataset.cleanProductWishlistTitle?.trim() || 'this product';
          const isSelected = Boolean(handle && selectedHandles.has(handle));
          button.disabled = !state.available || !handle;
          button.setAttribute('aria-pressed', String(isSelected));
          button.setAttribute('aria-label', `${isSelected ? 'Remove' : 'Add'} ${title} ${
            isSelected ? 'from' : 'to'
          } wishlist`);
        });
      }

      cleanHandleWishlistClick(event) {
        const button = event.target.closest('[data-clean-product-wishlist]');
        if (!button || !this.contains(button) || button.disabled) return;

        const handle = button.dataset.cleanProductWishlistHandle?.trim();
        const state = cleanReadWishlist();
        if (!handle || !state.available) return;

        const nextHandles = new Set(state.handles);
        if (nextHandles.has(handle)) nextHandles.delete(handle);
        else nextHandles.add(handle);

        if (!cleanWriteWishlist([...nextHandles])) {
          this.removeAttribute('data-clean-main-collection-enhanced');
          button.disabled = true;
          return;
        }

        const nextState = { available: true, handles: [...nextHandles] };
        this.cleanSyncWishlistButtons(nextState);
        window.dispatchEvent(new CustomEvent('clean:wishlist-change', { detail: { handles: nextState.handles } }));
      }

      cleanHandleWishlistStorage(event) {
        if (
          event.key === null ||
          event.key === cleanWishlistStorageKey ||
          event.key === cleanLegacyWishlistStorageKey
        ) {
          const state = cleanReadWishlist();
          if (state.available) this.setAttribute('data-clean-main-collection-enhanced', 'true');
          else this.removeAttribute('data-clean-main-collection-enhanced');
          this.cleanSyncWishlistButtons(state);
        }
      }
    }

    customElements.define(elementName, CleanMainCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-product"]) return;
  try {
    
  (() => {
    const initializeCleanUnitsSold = (root) => {
      const units = root.querySelector('[data-clean-units-sold]');
      const count = units?.querySelector('[data-clean-units-count]');
      const hours = units?.querySelector('[data-clean-units-hours]');
      if (!units || !count || !hours) return;

      const readValues = (value) =>
        value
          .split(',')
          .map((item) => Number(item.trim()))
          .filter((item) => Number.isFinite(item) && item > 0);
      const counts = readValues(units.dataset.cleanUnitsCounts || '');
      const periods = readValues(units.dataset.cleanUnitsPeriods || '');
      if (counts.length) {
        const selected = counts[Math.floor(Math.random() * counts.length)];
        const multiplier = Math.max(1, Number(units.dataset.cleanUnitsMultiplier) || 1);
        count.textContent = String(selected * multiplier);
      }
      if (periods.length) {
        hours.textContent = String(periods[Math.floor(Math.random() * periods.length)]);
      }
    };

    const initializeCoins = (root) => {
      root.cleanDisposeCoins?.();
      const trigger = root.querySelector('[data-clean-coins-trigger]');
      const dialog = root.querySelector('[data-clean-coins-dialog]');
      const closeButton = dialog?.querySelector('[data-clean-coins-close]');
      const amount = root.querySelector('[data-clean-coins-value]');
      const earned = dialog?.querySelector('[data-clean-coins-modal-earn]');
      if (!trigger || !dialog || !closeButton || !amount || !earned || typeof dialog.showModal !== 'function') return;
      const bulkQuantity = root.querySelector('[data-clean-bulk-quantity]');
      if (bulkQuantity) trigger.addEventListener('pointerdown', (event) => event.preventDefault());

      let returnFocus;
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (dialog.open) return;
        bulkQuantity?.dispatchEvent(new Event('change', { bubbles: true }));
        returnFocus = trigger;
        earned.textContent = root.querySelector('[data-clean-bulk-price]')
          ? `Earn up to ${amount.textContent.trim()} HG Coins with this order. Final rewards depend on your order total.`
          : `This product earns you ${amount.textContent.trim()} HG Coins.`;
        dialog.showModal();
        closeButton.focus();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = [
          ...dialog.querySelectorAll(
            'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])',
          ),
        ].filter((control) => !control.hidden && control.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (root.isConnected && returnFocus?.isConnected) returnFocus.focus();
        returnFocus = null;
      });
      const unload = (event) => {
        if (!event.target.contains(root)) return;
        returnFocus = null;
        if (dialog.open) dialog.close();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      root.cleanDisposeCoins = () => unload({ target: root });
    };
    const initializeVideo = (root) => {
      const trigger = root.querySelector('[data-clean-product-video-preview]');
      const dialog = root.querySelector('[data-clean-product-video-dialog]');
      if (!trigger || !dialog) return;
      const frame = dialog.querySelector('[data-clean-video-frame]');
      const video = dialog.querySelector('[data-clean-video-media]');
      const spinner = dialog.querySelector('[data-clean-video-loading]');
      const toggle = dialog.querySelector('[data-clean-video-toggle]');
      const progress = dialog.querySelector('[data-clean-video-progress]');
      const error = dialog.querySelector('[data-clean-video-error]');
      const railPoster = dialog.querySelector('[data-clean-video-rail-poster]');
      const abort = new AbortController();
      const signal = abort.signal;
      let swipe;
      let suppressClick = false;
      let loadVersion = 0;
      let scrubPointer = null;
      let seekTarget = null;
      const setState = (state) => {
        frame.dataset.cleanVideoState = state;
        toggle.setAttribute('aria-label', state === 'playing' ? 'Pause video' : 'Play video');
      };
      const setBusy = (busy, label = 'Loading video') => {
        spinner.hidden = !busy;
        spinner.setAttribute('aria-label', label);
        if (busy) setState('loading');
        else setState(video.paused ? 'paused' : 'playing');
      };
      const showError = () => {
        spinner.hidden = true;
        error.hidden = false;
        progress.disabled = true;
        setState('error');
      };
      const startPlayback = () => {
        const version = ++loadVersion;
        error.hidden = true;
        progress.disabled = true;
        setBusy(true);
        const hls = dialog.dataset.cleanVideoHls;
        const canPlayHls = hls && (video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL'));
        video.src = canPlayHls ? hls : dialog.dataset.cleanVideoSource;
        if (dialog.dataset.cleanVideoPoster) {
          video.poster = dialog.dataset.cleanVideoPoster;
          railPoster.src = dialog.dataset.cleanVideoPoster;
        }
        video.load();
        video.play().catch((reason) => {
          if (version !== loadVersion || !dialog.open) return;
          if (reason?.name === 'NotAllowedError') setBusy(false);
          else showError();
        });
      };
      const togglePlayback = () => {
        if (frame.dataset.cleanVideoState === 'error') return;
        if (video.paused) {
          setBusy(true, 'Buffering video');
          video.play().catch((reason) => {
            if (!dialog.open) return;
            if (reason?.name === 'NotAllowedError') setBusy(false);
            else showError();
          });
        } else video.pause();
      };
      trigger.addEventListener(
        'click',
        () => {
          if (typeof dialog.showModal !== 'function') {
            root.querySelector('[data-clean-utility-status]').textContent =
              'Video player is unavailable in this browser.';
            return;
          }
          dialog.showModal();
          dialog.querySelector('[data-clean-video-close]').focus({ preventScroll: true });
          startPlayback();
        },
        { signal },
      );
      dialog.querySelector('[data-clean-video-close]').addEventListener('click', () => dialog.close(), { signal });
      dialog.querySelector('[data-clean-video-retry]').addEventListener('click', startPlayback, { signal });
      toggle.addEventListener('click', togglePlayback, { signal });
      frame.addEventListener(
        'click',
        (event) => {
          if (suppressClick) {
            suppressClick = false;
            return;
          }
          if (event.target === frame || event.target === video) togglePlayback();
        },
        { signal },
      );
      video.addEventListener('playing', () => setBusy(false), { signal });
      // HLS downloads can stall while buffered playback continues; waiting owns buffering UI.
      video.addEventListener(
        'waiting',
        () => {
          if (!video.paused) setBusy(true, 'Buffering video');
        },
        { signal },
      );
      video.addEventListener(
        'canplay',
        () => {
          if (dialog.open) setBusy(false);
        },
        { signal },
      );
      video.addEventListener(
        'pause',
        () => {
          if (dialog.open) setBusy(false);
        },
        { signal },
      );
      video.addEventListener('ended', () => setState('paused'), { signal });
      video.addEventListener(
        'error',
        () => {
          if (dialog.open) showError();
        },
        { signal },
      );
      const paintProgress = () => {
        if (!Number.isFinite(video.duration) || video.duration <= 0) return;
        progress.style.setProperty('--clean-video-played', `${Number(progress.value) / 10}%`);
        progress.setAttribute(
          'aria-valuetext',
          `${Math.round((Number(progress.value) / 1000) * video.duration)} of ${Math.round(video.duration)} seconds`,
        );
      };
      const updateProgress = () => {
        if (!Number.isFinite(video.duration) || video.duration <= 0 || scrubPointer !== null) return;
        progress.value = String(Math.round(((seekTarget ?? video.currentTime) / video.duration) * 1000));
        paintProgress();
      };
      video.addEventListener('timeupdate', updateProgress, { signal });
      video.addEventListener(
        'loadedmetadata',
        () => {
          progress.disabled = false;
          updateProgress();
        },
        { signal },
      );
      const valueAtPointer = (clientX) => {
        const bounds = progress.getBoundingClientRect();
        const fraction = (clientX - bounds.left - 6) / Math.max(1, bounds.width - 12);
        return Math.round(Math.max(0, Math.min(1, fraction)) * 1000);
      };
      const commitSeek = (value) => {
        if (!Number.isFinite(video.duration) || video.duration <= 0) return;
        progress.value = String(value);
        seekTarget = (value / 1000) * video.duration;
        video.currentTime = seekTarget;
        paintProgress();
      };
      progress.addEventListener(
        'pointerdown',
        (event) => {
          if (progress.disabled || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          event.preventDefault();
          progress.focus({ preventScroll: true });
          scrubPointer = event.pointerId;
          progress.setPointerCapture(event.pointerId);
          progress.value = String(valueAtPointer(event.clientX));
          paintProgress();
        },
        { signal },
      );
      progress.addEventListener(
        'pointermove',
        (event) => {
          if (event.pointerId !== scrubPointer) return;
          event.preventDefault();
          progress.value = String(valueAtPointer(event.clientX));
          paintProgress();
        },
        { signal },
      );
      progress.addEventListener(
        'pointerup',
        (event) => {
          if (event.pointerId !== scrubPointer) return;
          event.preventDefault();
          const value = valueAtPointer(event.clientX);
          scrubPointer = null;
          commitSeek(value);
          if (progress.hasPointerCapture(event.pointerId)) progress.releasePointerCapture(event.pointerId);
        },
        { signal },
      );
      progress.addEventListener(
        'pointercancel',
        (event) => {
          if (event.pointerId !== scrubPointer) return;
          scrubPointer = null;
          updateProgress();
        },
        { signal },
      );
      progress.addEventListener(
        'input',
        () => {
          if (scrubPointer !== null) return;
          commitSeek(Number(progress.value));
        },
        { signal },
      );
      video.addEventListener(
        'seeking',
        () => {
          if (!video.paused) setBusy(true, 'Buffering video');
        },
        { signal },
      );
      video.addEventListener(
        'seeked',
        () => {
          if (seekTarget !== null && Math.abs(video.currentTime - seekTarget) < 0.5) seekTarget = null;
          updateProgress();
          setBusy(false);
        },
        { signal },
      );
      frame.addEventListener(
        'pointerdown',
        (event) => {
          if (
            !['touch', 'pen'].includes(event.pointerType) ||
            !event.isPrimary ||
            event.target.closest('button, input')
          )
            return;
          swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
          frame.setPointerCapture(event.pointerId);
        },
        { signal },
      );
      frame.addEventListener(
        'pointermove',
        (event) => {
          if (!swipe || event.pointerId !== swipe.id) return;
          const dy = event.clientY - swipe.y;
          if (Math.abs(dy) < 8) return;
          frame.style.transform = `translateY(${Math.max(-240, Math.min(240, dy))}px)`;
        },
        { signal },
      );
      const finishSwipe = (event) => {
        if (!swipe || event.pointerId !== swipe.id) return;
        const dy = event.clientY - swipe.y;
        const dx = event.clientX - swipe.x;
        swipe = null;
        frame.style.removeProperty('transform');
        if (Math.abs(dy) >= 100 && Math.abs(dy) > Math.abs(dx) * 1.3) {
          suppressClick = true;
          dialog.close();
        } else if (Math.abs(dy) > 8) suppressClick = true;
      };
      frame.addEventListener('pointerup', finishSwipe, { signal });
      frame.addEventListener('pointercancel', finishSwipe, { signal });
      dialog.addEventListener('close', () => {
        loadVersion++;
        video.pause();
        video.removeAttribute('src');
        video.removeAttribute('poster');
        railPoster.removeAttribute('src');
        video.load();
        progress.value = '0';
        progress.style.setProperty('--clean-video-played', '0%');
        progress.disabled = true;
        scrubPointer = null;
        seekTarget = null;
        error.hidden = true;
        spinner.hidden = false;
        setState('loading');
        frame.style.removeProperty('transform');
        if (root.isConnected) trigger.focus({ preventScroll: true });
      }, { signal });
      const unload = (event) => {
        if (!event.target.contains(root)) return;
        if (dialog.open) dialog.close();
        abort.abort();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    };
    const initializeGallery = (root) => {
      const hero = root.querySelector('[data-clean-gallery-hero]');
      if (!hero) return;
      const gallery = hero.parentElement;
      const rail = gallery.querySelector('[data-clean-gallery-rail]');
      const railControls = gallery.querySelector('[data-clean-gallery-controls]');
      const previousControl = railControls?.querySelector('[data-clean-gallery-previous]');
      const nextControl = railControls?.querySelector('[data-clean-gallery-next]');
      const viewer = gallery.querySelector('[data-clean-gallery-viewer]');
      const zoom = viewer.querySelector('[data-clean-gallery-zoom]');
      const breakpoint = window.matchMedia('(min-width: 750px)');
      const desktop = window.matchMedia('(min-width: 990px)');
      const header = document.querySelector('.clean-header-stack');
      let galleryFrame;
      let railFrame;
      let railObserver;
      const positionGallery = () => {
        if (!desktop.matches || !root.isConnected || viewer.open) return;
        const headerHeight = header?.getBoundingClientRect().height || 0;
        root.style.setProperty('--clean-gallery-top', `${Math.ceil(headerHeight + 16)}px`);
      };
      const scheduleGalleryFit = () => {
        cancelAnimationFrame(galleryFrame);
        galleryFrame = requestAnimationFrame(positionGallery);
      };
      const galleryObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleGalleryFit) : null;
      [header].filter(Boolean).forEach((element) => galleryObserver?.observe(element));
      const syncRailControls = () => {
        if (!rail || !previousControl || !nextControl) return;
        const thumbnails = rail.querySelectorAll('[data-clean-gallery-thumbnail]');
        const first = thumbnails[0];
        const last = thumbnails[thumbnails.length - 1];
        if (!first || !last) return;
        const railBounds = rail.getBoundingClientRect();
        const firstBounds = first.getBoundingClientRect();
        const lastBounds = last.getBoundingClientRect();
        const rtl = getComputedStyle(rail).direction === 'rtl';
        const atInlineStart = rtl ? firstBounds.right <= railBounds.right + 1 : firstBounds.left >= railBounds.left - 1;
        const atInlineEnd = rtl ? lastBounds.left >= railBounds.left - 1 : lastBounds.right <= railBounds.right + 1;
        previousControl.disabled = atInlineStart;
        nextControl.disabled = atInlineEnd;
      };
      const scheduleRailControlSync = () => {
        cancelAnimationFrame(railFrame);
        railFrame = requestAnimationFrame(syncRailControls);
      };
      window.addEventListener('resize', scheduleRailControlSync);
      desktop.addEventListener('change', scheduleRailControlSync);
      if (railControls && rail) {
        railControls.hidden = false;
        railControls.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || button.disabled) return;
          const thumbnail = rail.querySelector('[data-clean-gallery-thumbnail]');
          const styles = getComputedStyle(rail);
          const step =
            (thumbnail?.getBoundingClientRect().width || 0) + (parseFloat(styles.columnGap || styles.gap) || 0);
          const direction = styles.direction === 'rtl' ? -1 : 1;
          const towardEnd = button === nextControl ? 1 : -1;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollBy({ left: step * direction * towardEnd, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
        rail.addEventListener('scroll', scheduleRailControlSync, { passive: true });
        rail.querySelectorAll('[data-clean-gallery-thumbnail]').forEach((thumbnail) => {
          thumbnail.addEventListener('focus', syncRailControls);
        });
        if (typeof ResizeObserver === 'function') {
          railObserver = new ResizeObserver(scheduleRailControlSync);
          railObserver.observe(rail);
          const firstThumbnail = rail.querySelector('[data-clean-gallery-thumbnail]');
          if (firstThumbnail) railObserver.observe(firstThumbnail);
        }
        syncRailControls();
      }
      window.addEventListener('resize', scheduleGalleryFit);
      desktop.addEventListener('change', scheduleGalleryFit);
      const statuses = gallery.querySelectorAll('[role="status"]');
      let selectionVersion = 0;
      let zoomVersion = 0;
      let selected = rail?.querySelector('[aria-current]')?.dataset.cleanGalleryThumbnail;
      let modalRail;
      const report = (message, failed = false) => {
        viewer.toggleAttribute('data-clean-loading', message === 'Loading image…');
        statuses.forEach((status) => {
          status.textContent = message;
          status.classList.toggle('clean-product__sr', !failed);
        });
      };
      const ordinaryClick = (event) =>
        !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0;
      const load = (image) =>
        new Promise((resolve, reject) => {
          const finish = (error) => {
            clearTimeout(timeout);
            image.onload = null;
            image.onerror = null;
            if (error) reject(error);
            else resolve(image);
          };
          const timeout = setTimeout(() => finish(new Error('Image load timed out')), 15000);
          image.onload = () => finish();
          image.onerror = () => finish(new Error('Image unavailable'));
          if (image.complete) finish(image.naturalWidth ? null : new Error('Image unavailable'));
        });
      let drag;
      let suppressClick = false;
      let panX = 0;
      let panY = 0;
      const fitViewerImage = () => {
        if (!viewer.open || !desktop.matches) return;
        const image = zoom.querySelector('img');
        if (!image?.naturalWidth) return;
        const ratio = image.naturalWidth / image.naturalHeight;
        const height = Math.min(viewer.clientHeight - 72, (viewer.clientWidth - 258) / ratio);
        zoom.style.setProperty('--clean-viewer-width', `${height * ratio}px`);
        zoom.style.setProperty('--clean-viewer-height', `${height}px`);
      };
      const applyPan = () => {
        const image = zoom.querySelector('img');
        if (!image) return;
        const [x, y] = image.style.transformOrigin.split(' ').map(parseFloat);
        panX = Math.max(-zoom.clientWidth * (1 - x / 100), Math.min((zoom.clientWidth * x) / 100, panX));
        panY = Math.max(-zoom.clientHeight * (1 - y / 100), Math.min((zoom.clientHeight * y) / 100, panY));
        image.style.transform = `translate(${panX}px, ${panY}px) scale(2)`;
      };
      const resetZoom = () => {
        viewer.removeAttribute('data-clean-loading');
        zoomVersion++;
        zoom.setAttribute('aria-pressed', 'false');
        zoom.setAttribute('aria-label', 'Zoom in on product image');
        const image = zoom.querySelector('img');
        if (image) {
          image.style.transformOrigin = '';
          image.style.transform = '';
        }
        if (drag && zoom.hasPointerCapture(drag.id)) zoom.releasePointerCapture(drag.id);
        drag = undefined;
        suppressClick = false;
        panX = panY = 0;
        zoom.removeAttribute('data-clean-dragging');
      };
      const showModalImage = () => {
        resetZoom();
        const image = hero.querySelector('img').cloneNode();
        image.loading = 'eager';
        image.draggable = false;
        image.fetchPriority = 'auto';
        image.removeAttribute('srcset');
        image.src = hero.querySelector('img').currentSrc || image.src;
        zoom.replaceChildren(image);
        zoom.disabled = true;
        report('Loading image…');
        load(image)
          .then(() => {
            if (zoom.firstElementChild !== image || !viewer.open) return;
            fitViewerImage();
            zoom.disabled = false;
            report('');
          })
          .catch(() => {
            if (zoom.firstElementChild !== image || !viewer.open) return;
            report('The viewer image could not load. Close and reopen to retry.', true);
          });
      };
      const revealSelection = (element) => {
        const current = element?.querySelector('[aria-current]');
        if (!current || !element.clientWidth) return;
        const railBounds = element.getBoundingClientRect();
        const bounds = current.getBoundingClientRect();
        if (bounds.left < railBounds.left + 6) element.scrollLeft += bounds.left - railBounds.left - 6;
        else if (bounds.right > railBounds.right - 6) element.scrollLeft += bounds.right - railBounds.right + 6;
        if (element === modalRail && desktop.matches) {
          if (bounds.top < railBounds.top + 6) element.scrollTop += bounds.top - railBounds.top - 6;
          else if (bounds.bottom > railBounds.bottom - 6) element.scrollTop += bounds.bottom - railBounds.bottom + 6;
        }
        if (element === rail) scheduleRailControlSync();
      };
      const updateViewerCount = () => {
        const links = [...(rail?.querySelectorAll('[data-clean-gallery-thumbnail]') || [])];
        const index = links.findIndex((link) => link.dataset.cleanGalleryThumbnail === selected);
        viewer.querySelector('[data-clean-gallery-count]').textContent = `${Math.max(0, index) + 1}/${Math.max(1, links.length)}`;
        viewer.querySelectorAll('[data-clean-gallery-step]').forEach((button) => { button.hidden = links.length < 2; });
      };
      const stepImage = (delta) => {
        const links = [...(rail?.querySelectorAll('[data-clean-gallery-thumbnail]') || [])];
        if (links.length < 2) return;
        const index = links.findIndex((link) => link.dataset.cleanGalleryThumbnail === selected);
        selectImage(links[(index + delta + links.length) % links.length]);
      };
      viewer.querySelectorAll('[data-clean-gallery-step]').forEach((button) => {
        button.addEventListener('click', () => stepImage(Number(button.dataset.cleanGalleryStep)));
      });
      const markSelection = () => {
        updateViewerCount();
        gallery.querySelectorAll('[data-clean-gallery-thumbnail]').forEach((link) => {
          if (link.dataset.cleanGalleryThumbnail === selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        revealSelection(rail);
        revealSelection(modalRail);
      };
      const selectImage = async (link) => {
        const version = ++selectionVersion;
        if (link.dataset.cleanGalleryThumbnail === selected) {
          gallery.removeAttribute('aria-busy');
          if (viewer.open) resetZoom();
          report('');
          return;
        }
        const thumbnail = link.querySelector('img');
        const image = hero.querySelector('img').cloneNode();
        image.width = Number(thumbnail.getAttribute('width'));
        image.height = Number(thumbnail.getAttribute('height'));
        image.alt = thumbnail.alt;
        image.loading = 'eager';
        image.fetchPriority = 'auto';
        image.srcset = link.dataset.cleanGallerySrcset;
        image.src = link.dataset.cleanGallerySrc;
        gallery.setAttribute('aria-busy', 'true');
        report('Loading image…');
        try {
          await load(image);
          if (version !== selectionVersion || !root.isConnected) return;
          hero.replaceChildren(image);
          hero.href = link.href;
          selected = link.dataset.cleanGalleryThumbnail;
          markSelection();
          report(link.getAttribute('aria-label').replace(/^View /, '') + ' selected.');
          if (viewer.open) showModalImage();
        } catch {
          if (version === selectionVersion && root.isConnected)
            report('This image could not load. Select the thumbnail to retry.', true);
        } finally {
          if (version === selectionVersion) gallery.removeAttribute('aria-busy');
        }
      };
      root.addEventListener('clean:variant-pending', () => {
        selectionVersion++;
        if (gallery.hasAttribute('aria-busy')) {
          gallery.removeAttribute('aria-busy');
          report('');
        }
      });
      root.addEventListener('clean:variant-media', (event) => {
        const links = [...(rail?.querySelectorAll('[data-clean-gallery-thumbnail]') || [])];
        const link =
          links.find((item) => item.dataset.cleanGalleryThumbnail === event.detail?.mediaId) ||
          links.find((item) => item.dataset.cleanGalleryThumbnail === root.dataset.cleanFeaturedMedia);
        if (link) selectImage(link);
      });
      const wireRail = (element) => {
        element.addEventListener('click', (event) => {
          const link = event.target.closest('[data-clean-gallery-thumbnail]');
          if (!link || !ordinaryClick(event)) return;
          event.preventDefault();
          selectImage(link);
        });
        element.addEventListener('keydown', (event) => {
          const links = [...element.querySelectorAll('[data-clean-gallery-thumbnail]')];
          const index = links.indexOf(document.activeElement);
          if (index < 0 || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next =
            event.key === 'Home'
              ? 0
              : event.key === 'End'
                ? links.length - 1
                : (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + links.length) % links.length;
          links[next].focus();
          selectImage(links[next]);
        });
      };
      if (rail) wireRail(rail);
      revealSelection(rail);
      positionGallery();
      const syncBreakpoint = () => {
        const enabled = breakpoint.matches && typeof viewer.showModal === 'function';
        if (enabled) {
          hero.setAttribute('aria-haspopup', 'dialog');
          hero.setAttribute('aria-controls', viewer.id);
          hero.setAttribute('aria-label', 'Open product image viewer');
        } else {
          hero.removeAttribute('aria-haspopup');
          hero.removeAttribute('aria-controls');
          hero.setAttribute('aria-label', 'Open full-size product image');
          if (viewer.open) viewer.close();
        }
      };
      hero.addEventListener('click', (event) => {
        if (!breakpoint.matches) {
          event.preventDefault();
          return;
        }
        if (typeof viewer.showModal !== 'function' || !ordinaryClick(event)) return;
        event.preventDefault();
        if (!modalRail && rail) {
          modalRail = rail.cloneNode(true);
          modalRail.removeAttribute('data-clean-gallery-rail');
          modalRail.setAttribute('aria-label', 'Image viewer thumbnails');
          wireRail(modalRail);
          viewer.append(modalRail);
        }
        updateViewerCount();
        viewer.showModal();
        showModalImage();
        revealSelection(modalRail);
      });
      let swipeStart;
      hero.addEventListener('pointerdown', (event) => {
        if (breakpoint.matches || !event.isPrimary || !['touch', 'pen'].includes(event.pointerType)) return;
        swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
      });
      hero.addEventListener('pointercancel', () => {
        swipeStart = undefined;
      });
      hero.addEventListener('pointerup', (event) => {
        if (!swipeStart || event.pointerId !== swipeStart.id || breakpoint.matches) return;
        const start = swipeStart;
        swipeStart = undefined;
        const deltaX = event.clientX - start.x;
        const deltaY = event.clientY - start.y;
        if (Math.abs(deltaX) < 32 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        const links = [...rail.querySelectorAll('[data-clean-gallery-thumbnail]')];
        const index = links.findIndex((link) => link.dataset.cleanGalleryThumbnail === selected);
        const next = index + (deltaX < 0 ? 1 : -1);
        if (index >= 0 && next >= 0 && next < links.length) selectImage(links[next]);
      });
      viewer.querySelector('[data-clean-gallery-close]').addEventListener('click', () => viewer.close());
      viewer.addEventListener('click', (event) => {
        if (event.target !== viewer) return;
        const rect = viewer.getBoundingClientRect();
        if (
          desktop.matches ||
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        )
          viewer.close();
      });
      viewer.addEventListener('close', () => {
        resetZoom();
        selectionVersion++;
        gallery.removeAttribute('aria-busy');
        report('');
        zoom.replaceChildren();
        scheduleGalleryFit();
        if (root.isConnected) hero.focus({ preventScroll: true });
      });
      zoom.addEventListener('pointerdown', (event) => {
        suppressClick = false;
        if (!desktop.matches || zoom.getAttribute('aria-pressed') !== 'true' || !event.isPrimary || event.button !== 0) return;
        drag = { id: event.pointerId, x: event.clientX, y: event.clientY, panX, panY, moved: false };
        zoom.setPointerCapture(event.pointerId);
      });
      zoom.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved && Math.hypot(dx, dy) < 5) return;
        drag.moved = true;
        zoom.setAttribute('data-clean-dragging', '');
        panX = drag.panX + dx;
        panY = drag.panY + dy;
        applyPan();
      });
      const endPan = (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        suppressClick = drag.moved;
        drag = undefined;
        zoom.removeAttribute('data-clean-dragging');
        if (zoom.hasPointerCapture(event.pointerId)) zoom.releasePointerCapture(event.pointerId);
      };
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => zoom.addEventListener(name, endPan));
      zoom.addEventListener('keydown', (event) => {
        if (!desktop.matches || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        if (zoom.getAttribute('aria-pressed') !== 'true') {
          stepImage(['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1);
          return;
        }
        panX += event.key === 'ArrowLeft' ? 40 : event.key === 'ArrowRight' ? -40 : 0;
        panY += event.key === 'ArrowUp' ? 40 : event.key === 'ArrowDown' ? -40 : 0;
        applyPan();
      });
      const resizeViewer = () => {
        if (!viewer.open) return;
        resetZoom();
        fitViewerImage();
      };
      window.addEventListener('resize', resizeViewer);
      zoom.addEventListener('click', async (event) => {
        if (suppressClick && event.detail) { suppressClick = false; return; }
        report('');
        if (zoom.getAttribute('aria-pressed') === 'true') {
          resetZoom();
          return;
        }
        const image = zoom.querySelector('img');
        if (!image) return;
        const rect = zoom.getBoundingClientRect();
        const x = event.detail ? ((event.clientX - rect.left) / rect.width) * 100 : 50;
        const y = event.detail ? ((event.clientY - rect.top) / rect.height) * 100 : 50;
        image.style.transformOrigin = `${x}% ${y}%`;
        zoom.setAttribute('aria-pressed', 'true');
        zoom.setAttribute('aria-label', 'Zoom out of product image');
        const version = ++zoomVersion;
        const enlarged = new Image();
        const url = new URL(hero.href);
        url.searchParams.set('width', Math.min(Number(image.getAttribute('width')), 3200));
        enlarged.src = url.href;
        report('Loading image…');
        try {
          await load(enlarged);
          if (version !== zoomVersion || !viewer.open || !root.isConnected) return;
          image.removeAttribute('srcset');
          image.src = enlarged.src;
          report('');
        } catch {
          if (version === zoomVersion && viewer.open)
            report(
              'The detailed image could not load. The current preview is still available; zoom out and try again.',
              true,
            );
        }
      });
      breakpoint.addEventListener('change', syncBreakpoint);
      syncBreakpoint();
      const unload = (event) => {
        if (!event.target.contains(root)) return;
        selectionVersion++;
        zoomVersion++;
        if (viewer.open) viewer.close();
        breakpoint.removeEventListener('change', syncBreakpoint);
        desktop.removeEventListener('change', scheduleGalleryFit);
        desktop.removeEventListener('change', scheduleRailControlSync);
        window.removeEventListener('resize', resizeViewer);
        window.removeEventListener('resize', scheduleGalleryFit);
        window.removeEventListener('resize', scheduleRailControlSync);
        galleryObserver?.disconnect();
        railObserver?.disconnect();
        cancelAnimationFrame(galleryFrame);
        cancelAnimationFrame(railFrame);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    };
    // Shopify resolves pricing, stock rules and SKU designs. Keep the form and app hosts alive.
    const initializeVariants = (root) => {
      const form = root.querySelector('.clean-product__form');
      const status = root.querySelector('[data-clean-variant-status]');
      let request,
        version = 0,
        disabledControls,
        pendingOption;
      const selectedValues = () =>
        new Map(
          [...root.querySelectorAll('[data-clean-option-value][aria-current]')].map((link) => [
            Number(link.dataset.cleanOptionPosition),
            link.dataset.cleanOptionValue,
          ]),
        );
      let selections = selectedValues();
      const clearOptionLoading = () => {
        pendingOption?.removeAttribute('aria-busy');
        pendingOption?.querySelector('[data-clean-option-spinner]')?.remove();
        pendingOption = null;
      };
      const unlock = () => {
        clearOptionLoading();
        delete root.dataset.cleanVariantPending;
        root.removeAttribute('aria-busy');
        disabledControls?.forEach(([control, disabled]) => {
          if (control.isConnected) control.disabled = disabled;
        });
        if (root.dataset.cleanCustomizationUnavailable) {
          const buy = form.querySelector('[name="add"]');
          buy.disabled = buy.dataset.cleanBuyable !== 'true';
        }
        disabledControls = null;
      };
      root.addEventListener('click', async (event) => {
        const link = event.target.closest('[data-clean-option-value], [data-clean-selling-plan]');
        if (
          !link ||
          !root.contains(link) ||
          event.button !== 0 ||
          event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          event.altKey ||
          link.target ||
          link.hasAttribute('download')
        )
          return;
        const destination = new URL(link.href, location.href);
        // Combined-listing sibling products retain their native routing and complete app initialization.
        if (destination.origin !== location.origin || destination.pathname !== root.dataset.cleanProductUrl)
          return;
        event.preventDefault();
        if (
          form.dataset.cleanPurchasePending ||
          (form.dataset.cleanSubmitted && !form.dataset.cleanPurchaseConfirmed)
        ) {
          status.textContent = 'Please finish the current cart attempt before changing options.';
          return;
        }
        if (!request && link.hasAttribute('aria-current')) return;
        const url = new URL(location.href);
        if (root.dataset.cleanProductRequiresView === 'true') url.searchParams.set('view', 'clean');
        else url.searchParams.delete('view');
        url.searchParams.delete('section_id');
        url.searchParams.delete('sections');
        if (link.hasAttribute('data-clean-option-value')) {
          selections.set(Number(link.dataset.cleanOptionPosition), link.dataset.cleanOptionValue);
          url.searchParams.set(
            'option_values',
            [...selections]
              .sort(([a], [b]) => a - b)
              .map(([, value]) => value)
              .join(','),
          );
          url.searchParams.delete('variant');
          url.searchParams.delete('selling_plan');
        } else {
          const plan = link.dataset.cleanSellingPlan;
          if (plan) url.searchParams.set('selling_plan', plan);
          else url.searchParams.delete('selling_plan');
        }
        request?.abort();
        const controller = new AbortController();
        request = controller;
        const current = ++version;
        root.dispatchEvent(new Event('clean:variant-pending'));
        const focusKey = link.hasAttribute('data-clean-option-value')
          ? ['cleanOptionValue', link.dataset.cleanOptionValue]
          : ['cleanSellingPlan', link.dataset.cleanSellingPlan];
        if (!disabledControls)
          disabledControls = [...form.querySelectorAll('[name="add"], [data-clean-customize]')].map((control) => [
            control,
            control.disabled,
          ]);
        disabledControls.forEach(([control]) => {
          control.disabled = true;
        });
        root.dataset.cleanVariantPending = 'true';
        root.setAttribute('aria-busy', 'true');
        status.textContent = '';
        clearOptionLoading();
        pendingOption = link;
        link.setAttribute('aria-busy', 'true');
        const spinner = document.createElement('span');
        spinner.className = 'clean-product__option-spinner';
        spinner.dataset.cleanOptionSpinner = '';
        spinner.setAttribute('aria-hidden', 'true');
        (link.querySelector('.clean-product__choice-label') || link).append(spinner);
        try {
          const sectionUrl = new URL(url);
          sectionUrl.searchParams.set('section_id', root.dataset.cleanSection);
          const response = await fetch(sectionUrl, {
            signal: AbortSignal.any([controller.signal, AbortSignal.timeout(15000)]),
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Variant request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (current !== version || controller.signal.aborted || !root.isConnected) return;
          // DOMParser treats noscript styles as active nodes. They belong only to native navigation.
          html.querySelectorAll('noscript').forEach((node) => node.remove());
          const next = html.querySelector('[data-clean-product]');
          const nextForm = next?.querySelector('.clean-product__form');
          const nextIdentity = nextForm?.querySelector('[name="id"]');
          const nextBuy = nextForm?.querySelector('[name="add"]');
          const regions = ['summary', 'options', 'plan', 'design', 'purchase', 'coins'].map((name) => {
            const selector = `[data-clean-variant-${name}]`;
            return [root.querySelector(selector), next?.querySelector(selector)];
          });
          const structured = root.parentElement.querySelector('[data-clean-product-structured]');
          const nextStructured = html.querySelector('[data-clean-product-structured]');
          if (
            !nextForm ||
            !nextIdentity ||
            !nextBuy ||
            next.dataset.cleanSection !== root.dataset.cleanSection ||
            next.dataset.cleanProductUrl !== root.dataset.cleanProductUrl ||
            regions.some(([before, after]) => !before || !after) ||
            !structured ||
            !nextStructured
          )
            throw new Error('Incomplete variant response');
          const quantity =
            root.querySelector('[data-clean-bulk-quantity]') || form.querySelector('[name="quantity"]');
          const count = Number(quantity?.value);
          const buy = form.querySelector('[name="add"]');
          const oldDesign = root.querySelector('[data-clean-personalization]');
          const nextDesign = next.querySelector('[data-clean-personalization]');
          const sameDesign =
            oldDesign &&
            nextDesign &&
            oldDesign.querySelector('[data-clean-design]').textContent ===
              nextDesign.querySelector('[data-clean-design]').textContent;
          if (sameDesign) {
            const fields = [...oldDesign.querySelectorAll('[data-clean-field]')];
            nextDesign.querySelectorAll('[data-clean-field]').forEach((input) => {
              const previous = fields.find((field) => field.name === input.name && field.type === input.type);
              if (previous) {
                input.value = previous.value;
                input.checked = previous.checked;
              }
            });
          }
          root.cleanDisposePersonalization?.();
          root.cleanDisposePersonalization = null;
          root.cleanDisposeCoins?.();
          // Vendor observers hold this exact variant input and submit button. Update their attributes too.
          for (const attribute of ['hidden', 'disabled', 'data-clean-buyable']) {
            if (nextBuy.hasAttribute(attribute)) buy.setAttribute(attribute, nextBuy.getAttribute(attribute));
            else buy.removeAttribute(attribute);
          }
          [...buy.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE).forEach((node) => node.remove());
          buy.prepend(document.createTextNode(nextBuy.textContent.trim()));
          nextBuy.replaceWith(buy);
          for (const [before, after] of regions) before.replaceChildren(...after.childNodes);
          structured.replaceChildren(...nextStructured.childNodes);
          form.setAttribute('action', nextForm.getAttribute('action'));
          const bulkQuantity = form.querySelector('[data-clean-bulk-form-quantity]');
          if (nextForm.querySelector('[data-clean-bulk-form-quantity]')) {
            if (!bulkQuantity) form.prepend(nextForm.querySelector('[data-clean-bulk-form-quantity]'));
          } else bulkQuantity?.remove();
          form
            .querySelectorAll('[data-clean-saved-property], [data-clean-preserved-property], [data-customeow-property="true"]')
            .forEach((input) => input.remove());
          delete form.dataset.cleanPersonalizationReady;
          delete form.dataset.cleanSubmitted;
          delete form.dataset.cleanPurchaseConfirmed;
          root.dataset.cleanCustomeow = next.dataset.cleanCustomeow;
          delete root.dataset.cleanCustomizationUnavailable;
          for (const key of ['cleanProvider', 'cleanSku', 'cleanVariantTitle', 'cleanProductId', 'cleanCustomizationInvalid'])
            root.dataset[key] = next.dataset[key];
          root.dataset.cleanFeaturedMedia = next.dataset.cleanFeaturedMedia;
          const delivery = form.querySelector('[data-clean-product-delivery]');
          const nextDelivery = nextForm.querySelector('[data-clean-product-delivery]');
          if (delivery && nextDelivery) delivery.dataset.cleanPrice = nextDelivery.dataset.cleanPrice;
          const newQuantity =
            root.querySelector('[data-clean-bulk-quantity]') || form.querySelector('[name="quantity"]');
          if (newQuantity && Number.isFinite(count)) {
            const minimum = Number(newQuantity.min || 1),
              step = Number(newQuantity.step || 1);
            const maximum = Number(newQuantity.max || 9999);
            const highest = minimum + Math.floor((maximum - minimum) / step) * step;
            newQuantity.value = String(
              Math.max(minimum, Math.min(highest, minimum + Math.ceil((count - minimum) / step) * step)),
            );
          }
          // Commit URL and identity together before notifying Shopify/app input observers.
          const identity = form.querySelector('[name="id"]');
          identity.value = nextIdentity.value;
          identity.setAttribute('value', nextIdentity.value);
          if (nextIdentity.value) {
            url.searchParams.set('variant', nextIdentity.value);
            url.searchParams.delete('option_values');
          }
          const sellingPlan = form.querySelector('[name="selling_plan"]')?.value;
          if (sellingPlan) url.searchParams.set('selling_plan', sellingPlan);
          else url.searchParams.delete('selling_plan');
          history.replaceState(history.state, '', url);
          disabledControls = null;
          unlock();
          initializeVariantQuantity(root);
          initializeCoins(root);
          initializePersonalization(root);
          initializeCustomizationProvider(root);
          if (root.dataset.cleanCustomizationInvalid === 'true') root.cleanCustomizationUnavailable();
          if (
            root.dataset.cleanCustomeow === 'true' &&
            delivery?.dataset.cleanCountry !== 'IN' &&
            buy.dataset.cleanBuyable === 'true'
          )
            buy.disabled = false;
          identity.dispatchEvent(new Event('change', { bubbles: true }));
          const selectedOption =
            focusKey[0] === 'cleanOptionValue'
              ? [...root.querySelectorAll('[data-clean-option-value][aria-current]')].find(
                  (item) => item.dataset.cleanOptionValue === focusKey[1],
                )
              : null;
          root.dispatchEvent(
            new CustomEvent('clean:variant-media', {
              detail: { mediaId: selectedOption?.dataset.cleanOptionMedia },
            }),
          );
          window['clean-commerce']?.viewProduct(root);
          window.CleanDisplayCurrency?.refresh?.(root);
          // Installed Customeow watches the input value attribute; no theme-owned vendor runtime is loaded.
          selections = selectedValues();
          status.textContent = '';
          const focused = [...root.querySelectorAll('[data-clean-option-value], [data-clean-selling-plan]')].find(
            (item) => item.dataset[focusKey[0]] === focusKey[1],
          );
          focused?.focus({ preventScroll: true });
        } catch (error) {
          if (current !== version || !root.isConnected) return;
          unlock();
          selections = selectedValues();
          status.textContent =
            'Could not update product options. Your previous selection is unchanged. Please try again.';
        } finally {
          if (current === version) request = null;
        }
      });
      const unload = (event) => {
        if (!event.target.contains(root)) return;
        version++;
        request?.abort();
        clearOptionLoading();
        root.cleanDisposePersonalization?.();
        root.cleanDisposeProvider?.();
        root.cleanQuantityController?.abort();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    };
    const initializePersonalization = (root) => {
      const design = root.querySelector('[data-clean-personalization]');
      if (design) {
        const controller = new AbortController();
        const signal = controller.signal;
        root.cleanDisposePersonalization = () => {
          controller.abort();
          design.dispatchEvent(new Event('clean:personalization-dispose'));
        };
        let loading,
          retries = 0;
        const load = () => {
          if (!loading)
            loading = import(design.dataset.cleanModule + (retries ? `?clean-retry=${retries}` : ''))
              .then((module) => {
                if (design.isConnected && !signal.aborted) module.initialize(design);
              })
              .catch((error) => {
                if (signal.aborted) return;
                loading = null;
                retries++;
                root.cleanCustomizationUnavailable({ cleanCustomization: { code: 'MODULE_LOAD' }, cause: error });
              });
          return loading;
        };
        const opener = root.querySelector('[data-clean-customize]');
        opener.addEventListener(
          'click',
          async () => {
            await load();
            if (!signal.aborted && form.dataset.cleanPersonalizationReady === 'true')
              design.dispatchEvent(new Event('clean:open'));
          },
          { signal },
        );
        design.addEventListener('focusin', load, { signal });
        design.addEventListener('pointerdown', load, { signal });
        const form = design.closest('form');
        form.addEventListener(
          'submit',
          async (event) => {
            if (form.dataset.cleanPersonalizationReady === 'true') return;
            event.preventDefault();
            await load();
            if (!signal.aborted && form.dataset.cleanPersonalizationReady === 'true') form.requestSubmit();
          },
          { signal },
        );
      }
    };
    // A customization outage must never turn an otherwise buyable variant into
    // an unbuyable one. Restore the existing submit control; never replay a click
    // or a cart request after a failed customization attempt.
    const initializeCustomizationFallback = (root) => {
      root.cleanCustomizationUnavailable = (error) => {
        if (!root.isConnected) return;
        const form = root.querySelector('.clean-product__form');
        if (form.dataset.cleanSubmitted || root.dataset.cleanCustomizationUnavailable) return;
        root.dataset.cleanCustomizationUnavailable = 'true';
        root.cleanDisposeProvider?.();
        const design = root.querySelector('[data-clean-personalization]');
        // Capture answers before disposal aborts formdata and removes the drawer.
        // This work is best-effort and must never interrupt the purchase fallback.
        let answers = [];
        if (design) {
          try {
            answers = root.cleanPreservePersonalization?.() ||
              [...design.querySelectorAll('[data-clean-field][name]')]
                .filter((input) => input.value.trim())
                .map((input) => ({ key: input.name.slice(11, -1), value: input.value }));
          } catch {}
        }
        const buy = form.querySelector('[name="add"]');
        const opener = form.querySelector('[data-clean-customize]');
        // The native editor moves this exact button into its dialog. Move it
        // home before disposing/removing fields so quantity and delivery survive.
        if (opener) opener.replaceWith(buy);
        root.cleanDisposePersonalization?.();
        root.cleanDisposePersonalization = null;
        if (design?.open) design.close();
        design?.remove();
        form.querySelectorAll('[data-clean-saved-property], [data-customeow-property="true"]').forEach((input) => input.remove());
        if (design) {
          const detail = error?.cleanCustomization || {};
          const code = /^[A-Z_]{1,32}$/.test(detail.code || '') ? detail.code : 'NATIVE_UNAVAILABLE';
          const context = ['step', 'status', 'bytes'].filter((key) => Number.isSafeInteger(detail[key]) && detail[key] >= 0)
            .map((key) => `${key}=${detail[key]}`);
          const note = `Preview unavailable (native-v1/${code}${context.length ? '; ' + context.join('; ') : ''}); entered answers retained=${answers.length}.`;
          for (const field of [...answers, { key: '_Clean customization error', value: note }]) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${field.key}]`;
            input.value = field.value;
            input.dataset.cleanPreservedProperty = '';
            form.append(input);
          }
        }
        delete form.dataset.cleanPersonalizationReady;
        delete form.dataset.cleanPurchasePending;
        delete root.dataset.cleanProviderPending;
        root.dataset.cleanCustomeow = 'false';
        root.dataset.cleanProvider = 'ordinary';
        buy.hidden = false;
        buy.disabled = buy.dataset.cleanBuyable !== 'true' || Boolean(root.dataset.cleanVariantPending);
        initializeCustomizationProvider(root);
        root.querySelector('[data-clean-utility-status]').textContent = '';
        console.warn('[Clean product] Customization unavailable; using Add to Cart.',
          error || 'Published customization configuration is invalid.');
        if (design) buy.focus({ preventScroll: true });
      };
    };
    // The installed app owns its launcher and save. Clean reads its public SKU
    // assignment and preserves the exact form/input/button nodes the embed observes.
    const initializeCustomizationProvider = (root) => {
      root.cleanDisposeProvider?.();
      const controller = new AbortController();
      const { signal } = controller;
      const form = root.querySelector('.clean-product__form');
      // Cached sections can retain the previous native exclusion suffix. Repair
      // it before the installed deferred embed snapshots its product form.
      const action = new URL(form.action);
      if (action.searchParams.get('clean_native') === '1') {
        action.searchParams.delete('clean_native');
        form.setAttribute('action', action.pathname + action.search);
      }
      const buy = form.querySelector('[name="add"]');
      const status = root.querySelector('[data-clean-utility-status]');
      const identity = form.querySelector('[name="id"]').value;
      let launchIdentity = '',
        loading,
        launching = false;
      root.cleanVendorComplete = () =>
        launchIdentity === identity &&
        form.querySelector('[name="id"]').value === identity &&
        [...form.querySelectorAll('[data-customeow-property="true"]')].some(
          (input) => input.name === 'properties[_customInfoId]' && input.value.trim(),
        );
      root.cleanDisposeProvider = () => {
        controller.abort();
        delete root.dataset.cleanProviderPending;
        root.cleanVendorComplete = null;
      };
      form.addEventListener(
        'submit',
        (event) => {
          const properties = form.querySelectorAll('[data-customeow-property="true"]');
          if (!properties.length || root.dataset.cleanCustomeow === 'true') return;
          properties.forEach((input) => input.remove());
          if (root.dataset.cleanCustomizationUnavailable) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          status.textContent = 'Your previous customization was cleared. Please try again for this option.';
        },
        { capture: true, signal },
      );
      // The installed app can initialize on any starting SKU. Clean retains
      // ownership of native readiness and CTA while the embed loads/relabels.
      const nonVendorLabel = buy.dataset.cleanBuyable === 'true' ? 'ADD TO CART' : buy.textContent.trim();
      const synchronizeAppForm = () => {
        if (signal.aborted) return;
        if (
          (root.dataset.cleanProvider === 'published-studio' || root.dataset.cleanCustomizationUnavailable) &&
          form.classList.contains('customeow-form-disabled')
        )
          form.classList.remove('customeow-form-disabled');
        if (root.dataset.cleanProvider === 'customeow') return;
        const texts = [...buy.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE);
        if (
          texts
            .map((node) => node.textContent)
            .join('')
            .trim() === nonVendorLabel
        )
          return;
        // Text edits avoid retriggering the embed's child-list rebinding loop.
        if (texts.length) {
          texts[0].textContent = nonVendorLabel;
          texts.slice(1).forEach((node) => {
            node.textContent = '';
          });
        } else buy.prepend(document.createTextNode(nonVendorLabel));
      };
      const appFormObserver = new MutationObserver(synchronizeAppForm);
      appFormObserver.observe(form, { attributes: true, attributeFilter: ['class'] });
      appFormObserver.observe(buy, { childList: true, characterData: true, subtree: true });
      signal.addEventListener('abort', () => appFormObserver.disconnect(), { once: true });
      synchronizeAppForm();
      if (root.dataset.cleanCustomizationUnavailable) {
        // Keep late vendor button/overlay listeners from reopening a broken app.
        // Submit this user click through the existing delivery/cart guards.
        form.addEventListener('click', (event) => {
          if (!event.target.closest('[name="add"]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!buy.disabled && buy.dataset.cleanBuyable === 'true') form.requestSubmit(buy);
        }, { capture: true, signal });
        return;
      }
      if (root.dataset.cleanProvider === 'published-studio' || !identity) return;
      let config;
      try {
        config = window.getCustomeowFuns?.('serverConfig');
      } catch {}
      if (!config && typeof window.getCustomeowFuns !== 'function' && root.dataset.cleanCustomeow !== 'true')
        return;
      const setProvider = (connected) => {
        if (signal.aborted) return;
        root.dataset.cleanCustomeow = String(connected);
        root.dataset.cleanProvider = connected ? 'customeow' : 'ordinary';
        delete root.dataset.cleanProviderPending;
        if (buy.dataset.cleanBuyable === 'true') {
          [...buy.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE).forEach((node) => node.remove());
          buy.prepend(document.createTextNode(connected ? 'CUSTOMIZE NOW' : 'ADD TO CART'));
          form.querySelector('[name="id"]').dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      const waitForVendor = async (read) => {
        const deadline = Date.now() + 10000;
        while (!signal.aborted) {
          const result = read();
          if (result) return result;
          if (Date.now() >= deadline) throw new Error('Customization is still loading. Please try again.');
          await new Promise((resolve, reject) => {
            const cancelled = () => {
              clearTimeout(timer);
              reject(new DOMException('Cancelled', 'AbortError'));
            };
            const timer = setTimeout(() => {
              signal.removeEventListener('abort', cancelled);
              resolve();
            }, 100);
            signal.addEventListener('abort', cancelled, { once: true });
          });
        }
        throw new DOMException('Cancelled', 'AbortError');
      };
      const resolve = () => {
        if (loading) return loading;
        root.dataset.cleanProviderPending = 'true';
        if (buy.dataset.cleanBuyable === 'true' && root.dataset.cleanCustomeow === 'true') {
          [...buy.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE).forEach((node) => node.remove());
          buy.prepend(document.createTextNode('CUSTOMIZE NOW'));
        }
        loading = (async () => {
          const builder = await waitForVendor(() => {
            config ||= window.getCustomeowFuns?.('serverConfig');
            return config && window.getCustomeowFuns?.('getCustomeowIntegrated');
          });
          const variant = config?.product?.variants?.find((item) => String(item.id) === identity);
          if (
            !variant ||
            String(config.product.id) !== root.dataset.cleanProductId ||
            variant.sku !== root.dataset.cleanSku
          )
            throw new Error('Customization is unavailable. Please reload and try again.');
          // Only SKU integration has a verified per-variant contract here. POD
          // and product-wide assignments cannot prove this selected SKU applies.
          if (config.isPod || config.productMetafields?.productIntegrationType === 1)
            throw new Error('Please use the original product page to customize this option.');
          if (!variant.sku) throw new Error('Customization is unavailable. Please try again.');
          const url = new URL(
            builder({
              platform: config.platform,
              sku: variant.sku,
              shopId: config.shopId,
              env: config.shopConfig?.env === 'production' ? 'prod' : config.shopConfig?.env,
              storeVersion: config.shopConfig?.storeVersion,
              productVersion: config.productMetafields?.productVersion,
              productIntegrationType: config.productMetafields?.productIntegrationType,
              productId: config.product.id,
            }),
          );
          if (
            url.protocol !== 'https:' ||
            url.hostname !== 'json.staticmeow.com' ||
            url.pathname !==
              `/customeow/app/shopify/${encodeURIComponent(config.shopId)}/${encodeURIComponent(variant.sku)}.json`
          )
            throw new Error('Customization configuration could not be verified.');
          const response = await fetch(url, { signal: AbortSignal.any([signal, AbortSignal.timeout(10000)]) });
          if (response.status === 404) {
            setProvider(false);
            return;
          }
          if (!response.ok) throw new Error('Customization could not load. Please try again.');
          const data = await response.json();
          const connected =
            data &&
            !Array.isArray(data) &&
            data.enabled !== false &&
            data.published !== false &&
            Boolean(String(data.customizerId || '').trim() && String(data.customizerVersion || '').trim());
          setProvider(connected);
        })().catch((error) => {
          if (signal.aborted) return;
          root.cleanCustomizationUnavailable(error);
        });
        return loading;
      };
      form.addEventListener(
        'submit',
        (event) => {
          if (!root.dataset.cleanProviderPending) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          resolve();
        },
        { capture: true, signal },
      );
      form.addEventListener(
        'click',
        async (event) => {
          const overlay = event.target.closest('[data-type="customeowApp"]');
          const target = event.target.closest('[name="add"]');
          if (!overlay && !target) return;
          if (root.dataset.cleanProviderPending) {
            event.preventDefault();
            event.stopImmediatePropagation();
            await resolve();
            if (signal.aborted || root.dataset.cleanProviderPending) return;
          }
          if (root.dataset.cleanCustomeow !== 'true') return;
          if (buy.dataset.cleanBuyable !== 'true') {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          if (root.cleanVendorComplete()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (launching) return;
          launching = true;
          status.textContent = 'Opening customization…';
          form.querySelectorAll('[data-customeow-property="true"]').forEach((input) => input.remove());
          // Installed selectors/overlays can be absent or rebinding after an
          // in-place update. Launch the verified app instance directly instead.
          // This is the embed's own designClickEvent -> refApp.current.open path.
          waitForVendor(() => {
            const vendor = window._customeowDebug?.customeowDesign;
            const selected = vendor?.getVariant?.();
            return vendor?.$form === form &&
              vendor.refApp?.current &&
              !vendor.isShowLoading &&
              String(selected?.id) === identity &&
              selected?.sku === root.dataset.cleanSku &&
              typeof vendor.designClickEvent === 'function'
              ? vendor
              : null;
          })
            .then((vendor) => {
              if (
                signal.aborted ||
                root.dataset.cleanVariantPending ||
                form.querySelector('[name="id"]').value !== identity
              )
                return;
              launchIdentity = identity;
              vendor.designClickEvent('addToCart');
              status.textContent = '';
            })
            .catch((error) => {
              if (signal.aborted) return;
              launchIdentity = '';
              root.cleanCustomizationUnavailable(error);
            })
            .finally(() => {
              launching = false;
            });
        },
        { capture: true, signal },
      );
      // Do not request assignments for a selected published studio design.
      resolve();
    };
    const initializeVariantQuantity = (root) => {
      root.cleanQuantityController?.abort();
      const controller = new AbortController();
      root.cleanQuantityController = controller;
      const signal = controller.signal;
      const bulk = root.querySelector('[data-clean-bulk-price]');
      if (bulk) {
        const form = root.querySelector('.clean-product__form');
        const quantity = bulk.querySelector('[data-clean-bulk-quantity]');
        const formQuantity = root.querySelector('[data-clean-bulk-form-quantity]');
        const control = bulk.querySelector('.clean-product__bulk-quantity');
        const decrease = bulk.querySelector('[data-clean-bulk-decrease]');
        const increase = bulk.querySelector('[data-clean-bulk-increase]');
        const original = bulk.querySelector('[data-clean-bulk-original]');
        const unit = bulk.querySelector('[data-clean-bulk-unit]');
        const savings = bulk.querySelector('[data-clean-bulk-savings]');
        const updateBulk = () => {
          if (!quantity.checkValidity()) return;
          const count = Number(quantity.value);
          formQuantity.value = String(count);
          const base = Number(bulk.dataset.cleanBasePrice);
          const minimum = Number(quantity.min);
          const maximum = quantity.max ? Number(quantity.max) : Infinity;
          decrease.disabled = count <= minimum;
          increase.disabled = count + Number(quantity.step || 1) > maximum;
          const eligible = bulk.dataset.cleanBulkEligible === 'true';
          const cartQuantity = window.CleanBulkDiscounts?.quantity() ?? Number(bulk.dataset.cleanBulkCartQuantity || 0);
          const tiers = JSON.parse(bulk.dataset.cleanBulkTiers);
          const savingsPercent = eligible
            ? (window.CleanBulkDiscounts?.percent(count + cartQuantity) ??
              tiers.reduce((rate, tier) => (count + cartQuantity >= tier.minimum ? tier.percent : rate), 0))
            : 0;
          const estimated = Math.round((base * (100 - savingsPercent)) / 100);
          bulk.dataset.cleanSubtotalPaise = String(estimated * count);
          const discounted = estimated < base;
          original.hidden = !discounted;
          unit.classList.toggle('clean-product__bulk-unit--discounted', discounted);
          savings.hidden = !discounted;
          savings.textContent = savingsPercent > 0 ? `Save ${savingsPercent}% per item` : '';
          for (const [selector, amount] of [
            ['[data-clean-bulk-unit]', estimated],
            ['[data-clean-bulk-subtotal]', estimated * count],
          ]) {
            const money = bulk.querySelector(`${selector} [data-clean-money]`);
            const source = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: money.dataset.cleanMoneyCurrency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(amount / 100);
            money.dataset.cleanMoneyMinor = String(amount);
            money.dataset.cleanMoneySourceText = source;
            money.textContent = source;
          }
          const coins = bulk.querySelector('[data-clean-coins-value]');
          if (coins) coins.textContent = String(Math.floor((estimated * count * 5) / 10000));
          window.CleanDisplayCurrency?.refresh?.(bulk);
        };
        const stepQuantity = (direction) => {
          const minimum = Number(quantity.min);
          quantity.value = String(
            Math.min(9999, Math.max(minimum, Number(quantity.value) + direction * Number(quantity.step || 1))),
          );
          quantity.dispatchEvent(new Event('input', { bubbles: true }));
        };
        const normalizedBulkQuantity = () => {
          const minimum = Number(quantity.min);
          const maximum = quantity.max ? Number(quantity.max) : Infinity;
          const step = Number(quantity.step || 1);
          const entered = Number(quantity.value);
          const requested = Number.isFinite(entered) ? entered : minimum;
          let normalized = minimum + Math.ceil((Math.max(minimum, requested) - minimum) / step) * step;
          if (Number.isFinite(maximum) && maximum >= minimum) {
            normalized = Math.min(normalized, minimum + Math.floor((maximum - minimum) / step) * step);
          }
          return normalized;
        };
        const normalizeBulkQuantity = () => {
          quantity.value = String(normalizedBulkQuantity());
          updateBulk();
        };
        const bindQuantityStepper = (button, direction) => {
          let repeatTimer;
          const stop = () => {
            clearTimeout(repeatTimer);
            repeatTimer = undefined;
          };
          signal.addEventListener('abort', stop, { once: true });
          const repeat = () => {
            if (button.disabled) return stop();
            stepQuantity(direction);
            repeatTimer = setTimeout(repeat, 80);
          };
          button.addEventListener('pointerdown', (event) => {
            if (event.button !== 0 || button.disabled) return;
            event.preventDefault();
            button.setPointerCapture(event.pointerId);
            stepQuantity(direction);
            repeatTimer = setTimeout(repeat, 350);
          });
          button.addEventListener('pointerup', stop);
          button.addEventListener('pointercancel', stop);
          button.addEventListener('lostpointercapture', stop);
          button.addEventListener('click', (event) => {
            if (event.detail > 0) return;
            stepQuantity(direction);
          });
        };
        bindQuantityStepper(decrease, -1);
        bindQuantityStepper(increase, 1);
        quantity.addEventListener('input', () => {
          if (quantity.value.replace(/\D/g, '').length > 4 || Number(quantity.value) > 9999) {
            quantity.value = String(Math.min(9999, Math.trunc(Number(quantity.value) || 0)));
          }
          updateBulk();
        });
        quantity.addEventListener('change', normalizeBulkQuantity);
        form.addEventListener('submit', normalizeBulkQuantity, { capture: true, signal });
        form.addEventListener(
          'formdata',
          (event) => {
            event.formData.set('quantity', String(normalizedBulkQuantity()));
            event.formData.set('properties[_minimum_quantity]', String(bulk.dataset.cleanMinimum));
          },
          { signal },
        );
        formQuantity.name = 'quantity';
        quantity.removeAttribute('name');
        control.dataset.cleanBulkReady = 'true';
        document.addEventListener('clean:bulk-discounts:updated', updateBulk, { signal });
        updateBulk();
      }
      const quantityControl = root.querySelector('[data-clean-quantity-control]');
      if (quantityControl) {
        const quantity = quantityControl.querySelector('[name="quantity"]');
        const decrease = quantityControl.querySelector('[data-clean-quantity-decrease]');
        const increase = quantityControl.querySelector('[data-clean-quantity-increase]');
        const nextQuantity = (direction) => {
          const minimum = Number(quantity.min);
          const step = Number(quantity.step || 1);
          const maximum = quantity.max ? Number(quantity.max) : Infinity;
          const highest = Number.isFinite(maximum) ? minimum + Math.floor((maximum - minimum) / step) * step : Infinity;
          if (highest < minimum) return null;
          const current = quantity.valueAsNumber;
          if (!Number.isFinite(current)) return direction > 0 ? minimum : null;
          const offset = (current - minimum) / step;
          const next = minimum + (direction > 0 ? Math.floor(offset) + 1 : Math.ceil(offset) - 1) * step;
          return Math.max(minimum, Math.min(highest, next));
        };
        const updateQuantity = () => {
          const current = quantity.valueAsNumber;
          const lower = nextQuantity(-1);
          const upper = nextQuantity(1);
          decrease.disabled = lower === null || !Number.isFinite(current) || lower >= current;
          increase.disabled = upper === null || (Number.isFinite(current) && upper <= current);
        };
        const stepQuantity = (direction) => {
          const next = nextQuantity(direction);
          if (next === null || next === quantity.valueAsNumber) return;
          quantity.value = String(next);
          quantity.dispatchEvent(new Event('input', { bubbles: true }));
        };
        decrease.addEventListener('click', () => stepQuantity(-1));
        increase.addEventListener('click', () => stepQuantity(1));
        quantity.addEventListener('input', () => {
          if (quantity.valueAsNumber > 999) {
            const minimum = Number(quantity.min);
            const step = Number(quantity.step || 1);
            const maximum = Math.min(999, Number(quantity.max || 999));
            quantity.value = String(minimum + Math.floor((maximum - minimum) / step) * step);
          }
          updateQuantity();
        });
        quantity.addEventListener('change', updateQuantity);
        quantityControl.dataset.cleanQuantityReady = 'true';
        updateQuantity();
      }
    };
    const initialize = (scope) => {
      scope.querySelectorAll('[data-clean-product]').forEach((root) => {
        if (root.dataset.cleanReady) return;
        root.dataset.cleanReady = 'true';
        initializeCleanUnitsSold(root);
        initializeCoins(root);
        initializeGallery(root);
        initializeVideo(root);
        root.querySelectorAll('.clean-product__choices--media').forEach((rail) => {
          const selected = rail.querySelector('[aria-current="true"]');
          if (!selected) return;
          const railBounds = rail.getBoundingClientRect();
          const selectedBounds = selected.getBoundingClientRect();
          if (selectedBounds.right > railBounds.right || selectedBounds.left < railBounds.left) {
            rail.scrollLeft += selectedBounds.left - railBounds.left - 2;
          }
        });
        const wishlist = root.querySelector('[data-clean-product-save]');
        const share = root.querySelector('[data-clean-product-share]');
        const shareToast = root.querySelector('[data-clean-share-toast]');
        let shareToastTimer;
        const utilityStatus = root.querySelector('[data-clean-utility-status]');
        const readWishlist = () => {
          const legacy = localStorage.getItem('wishlistItem');
          const stored =
            legacy === null
              ? JSON.parse(localStorage.getItem('clean:wishlist:v1') || '{}').handles
              : JSON.parse(legacy);
          return [
            ...new Set(
              (Array.isArray(stored) ? stored : []).filter(
                (value) => typeof value === 'string' && /^[a-z0-9-]+$/.test(value),
              ),
            ),
          ];
        };
        const updateWishlist = () => {
          try {
            const selected = readWishlist().includes(wishlist.dataset.cleanProductSave);
            const title = wishlist.dataset.cleanProductSaveTitle || 'this product';
            wishlist.setAttribute('aria-pressed', String(selected));
            wishlist.setAttribute(
              'aria-label',
              `${selected ? 'Remove' : 'Add'} ${title} ${selected ? 'from' : 'to'} wishlist`,
            );
            wishlist.disabled = false;
          } catch {
            wishlist.disabled = true;
            utilityStatus.textContent = 'Wishlist storage is unavailable in this browser.';
          }
        };
        wishlist.addEventListener('click', () => {
          try {
            const handles = new Set(readWishlist()),
              handle = wishlist.dataset.cleanProductSave;
            if (handles.has(handle)) handles.delete(handle);
            else handles.add(handle);
            localStorage.setItem('wishlistItem', JSON.stringify([...handles]));
            localStorage.setItem('clean:wishlist:v1', JSON.stringify({ version: 1, handles: [...handles] }));
            window.dispatchEvent(new CustomEvent('clean:wishlist-change', { detail: { handles: [...handles] } }));
            updateWishlist();
          } catch {
            utilityStatus.textContent = 'Could not save your wishlist. Please check browser storage.';
          }
        });
        window.addEventListener('storage', updateWishlist);
        window.addEventListener('clean:wishlist-change', updateWishlist);
        updateWishlist();
        share.addEventListener('click', async () => {
          window.clearTimeout(shareToastTimer);
          if (shareToast) shareToast.hidden = true;
          try {
            await navigator.clipboard.writeText(share.dataset.cleanProductShare);
            if (window.matchMedia('(min-width: 990px)').matches && shareToast) {
              utilityStatus.textContent = '';
              shareToast.hidden = false;
              shareToastTimer = window.setTimeout(() => {
                shareToast.hidden = true;
              }, 2000);
            } else {
              utilityStatus.textContent = 'Product link copied.';
            }
          } catch {
            utilityStatus.textContent = 'Could not copy the product link. Please allow clipboard access and try again.';
          }
        });
        root.addEventListener('click', async (event) => {
          const skuCopy = event.target.closest('[data-clean-product-sku-copy]');
          const skuFeedback = root.querySelector('[data-clean-product-sku-feedback]');
          if (skuCopy && skuFeedback) {
            skuCopy.disabled = true;
            skuFeedback.textContent = '';
            skuFeedback.classList.remove('clean-product__sku-feedback--error');
            try {
              await navigator.clipboard.writeText(skuCopy.dataset.cleanProductSkuCopy);
              skuFeedback.textContent = 'Copied';
            } catch {
              skuFeedback.classList.add('clean-product__sku-feedback--error');
              skuFeedback.textContent = 'Could not copy. Please try again.';
            } finally {
              skuCopy.disabled = false;
            }
          }
        });
        const loadAnalytics = () => {
          const synchronizeConsent = () => {
            const privacy = window.Shopify?.customerPrivacy;
            if (!privacy) return;
            const analytics = privacy.analyticsProcessingAllowed();
            if (!analytics && !window.clarity) return;
            if (!window.clarity) {
              window.clarity = function () {
                (window.clarity.q ||= []).push(arguments);
              };
              const script = document.createElement('script');
              script.src = 'https://www.clarity.ms/tag/ql3mvo7dpf';
              script.async = true;
              script.dataset.cleanProductAnalytics = '';
              document.head.append(script);
            }
            window.clarity('consentv2', {
              analytics_Storage: analytics ? 'granted' : 'denied',
              ad_Storage: privacy.marketingAllowed() ? 'granted' : 'denied',
            });
          };
          document.addEventListener('visitorConsentCollected', synchronizeConsent);
          if (window.Shopify?.customerPrivacy) synchronizeConsent();
          else
            window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
              if (!error) synchronizeConsent();
            });
        };
        const scheduleAnalytics = () => {
          if ('requestIdleCallback' in window) requestIdleCallback(loadAnalytics, { timeout: 8000 });
          else setTimeout(loadAnalytics, 4000);
        };
        if (document.readyState === 'complete') scheduleAnalytics();
        else window.addEventListener('load', scheduleAnalytics, { once: true });
        initializeVariantQuantity(root);
        root.querySelectorAll('[data-clean-product-media]').forEach((details) => {
          details.addEventListener('toggle', () => {
            if (!details.open) {
              details.querySelectorAll('video').forEach((video) => video.pause());
              return;
            }
            const template = details.querySelector('template');
            if (template) {
              details.append(template.content.cloneNode(true));
              template.remove();
            }
            const model = details.querySelector('model-viewer');
            if (model && !model.dataset.cleanInitialized && !model.dataset.cleanLoading) {
              let settled = false;
              const timeout = setTimeout(() => failed(), 10000);
              model.dataset.cleanLoading = 'true';
              const failed = () => {
                if (settled) return;
                settled = true;
                clearTimeout(timeout);
                delete model.dataset.cleanLoading;
                const message = document.createElement('p');
                message.className = 'clean-product__media-error';
                message.textContent = 'The 3D viewer could not load. Close and reopen to try again.';
                details.append(message);
              };
              details.querySelector('.clean-product__media-error')?.remove();
              if (!window.Shopify?.loadFeatures) {
                failed();
                return;
              }
              window.Shopify.loadFeatures([
                {
                  name: 'model-viewer-ui',
                  version: '1.0',
                  onLoad: (error) => {
                    if (settled) return;
                    if (error || !window.Shopify.ModelViewerUI) {
                      failed();
                      return;
                    }
                    try {
                      new window.Shopify.ModelViewerUI(model);
                    } catch {
                      failed();
                      return;
                    }
                    settled = true;
                    clearTimeout(timeout);
                    delete model.dataset.cleanLoading;
                    model.dataset.cleanInitialized = 'true';
                  },
                },
              ]);
            }
          });
        });
        const recipient = root.querySelector('[data-clean-recipient-toggle]');
        recipient?.addEventListener('change', () => {
          root.querySelector('[data-clean-recipient-email]').required = recipient.checked;
        });
        const delivery = root.querySelector('[data-clean-product-delivery]');
        const guardVariantPurchase = (event) => {
          if (!root.dataset.cleanVariantPending) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        };
        root.addEventListener('submit', guardVariantPurchase, true);
        root.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('[data-clean-customize], [name="add"], [data-type="customeowApp"]'))
              guardVariantPurchase(event);
          },
          true,
        );
        if (delivery) initializeDelivery(delivery);
        const purchaseForm = root.querySelector('.clean-product__form');
        if (root.dataset.cleanCustomeow === 'true' && delivery?.dataset.cleanCountry !== 'IN') {
          const buy = purchaseForm.querySelector('[name="add"]');
          if (buy.dataset.cleanBuyable === 'true') buy.disabled = false;
        }
        purchaseForm.addEventListener('submit', async (event) => {
          if (purchaseForm.dataset.cleanSubmitted) {
            event.preventDefault();
            return;
          }
          if (event.defaultPrevented || root.querySelector('[data-clean-personalization]')) return;
          if (root.dataset.cleanCustomeow === 'true' && !root.cleanVendorComplete?.()) {
            event.preventDefault();
            utilityStatus.textContent = 'Finish customizing this product before adding it to cart.';
            return;
          }
          const cartDrawer = document.querySelector('clean-product-cart');
          if (!cartDrawer) return;
          event.preventDefault();
          purchaseForm.dataset.cleanSubmitted = 'true';
          const buy = purchaseForm.querySelector('[name="add"]');
          buy.disabled = true;
          utilityStatus.textContent = 'Adding to cart…';
          const result = await cartDrawer.addProductForm(purchaseForm, {
            showPending: root.dataset.cleanCustomeow === 'true',
          });
          utilityStatus.textContent = result.ok ? '' : result.message;
          if (!result.uncertain) {
            delete purchaseForm.dataset.cleanSubmitted;
            buy.disabled = false;
          }
        });
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) location.reload();
        });
        initializeCustomizationFallback(root);
        initializePersonalization(root);
        initializeCustomizationProvider(root);
        if (root.dataset.cleanCustomizationInvalid === 'true') root.cleanCustomizationUnavailable();
        initializeVariants(root);
      });
    };
    function initializeDelivery(delivery) {
      const form = delivery.closest('form');
      const pending = new AbortController();
      let loading;
      const guard = (event) => {
        if (
          event.type === 'click' &&
          !event.target.closest(
            '[data-clean-customize], [name="add"], [data-type="customeowApp"], [data-clean-check-delivery]',
          )
        ) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        delivery.querySelector('[data-clean-date-status]').textContent = 'Loading delivery options…';
        load();
      };
      form.addEventListener('submit', guard, { capture: true, signal: pending.signal });
      form.addEventListener('click', guard, { capture: true, signal: pending.signal });
      const guarded = new WeakSet();
      const bindOverlays = () => {
        form.querySelectorAll('[data-type="customeowApp"]').forEach((overlay) => {
          if (guarded.has(overlay)) return;
          guarded.add(overlay);
          overlay.addEventListener('click', guard, { capture: true, signal: pending.signal });
        });
      };
      const observer = new MutationObserver(bindOverlays);
      observer.observe(form, { childList: true, subtree: true });
      bindOverlays();
      pending.signal.addEventListener('abort', () => observer.disconnect(), { once: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(delivery)) pending.abort();
      }, { signal: pending.signal });
      const load = () => loading ||= import(delivery.dataset.cleanPickerModule)
        .then(({ cleanInitializeDelivery }) => {
          if (!delivery.isConnected || pending.signal.aborted) return;
          cleanInitializeDelivery(delivery);
          pending.abort();
        })
        .catch(() => {
          loading = null;
          delivery.querySelector('[data-clean-date-status]').textContent = 'Could not load delivery options. Try again.';
        });
      load();
    }
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-search"]) return;
  try {
    
  (() => {
    const elementName = 'clean-main-search';
    const cleanWishlistStorageKey = 'clean:wishlist:v1';
    const legacyWishlistStorageKey = 'wishlistItem';

    if (customElements.get(elementName)) return;

    const cleanNormalizeWishlist = (handles) =>
      [...new Set(handles.filter((handle) => typeof handle === 'string' && handle.trim()).map((handle) => handle.trim()))];

    const cleanParseWishlist = (value, objectFormat = false) => {
      if (value === null) return null;

      try {
        const parsed = JSON.parse(value);
        const handles = objectFormat ? parsed?.handles : parsed;
        return Array.isArray(handles) ? cleanNormalizeWishlist(handles) : null;
      } catch {
        return null;
      }
    };

    const cleanReadWishlist = () => {
      try {
        const legacyHandles = cleanParseWishlist(localStorage.getItem(legacyWishlistStorageKey));
        if (legacyHandles !== null) return { available: true, handles: legacyHandles };

        const cleanHandles = cleanParseWishlist(localStorage.getItem(cleanWishlistStorageKey), true);
        return { available: true, handles: cleanHandles || [] };
      } catch {
        return { available: false, handles: [] };
      }
    };

    const cleanWriteWishlist = (handles) => {
      const normalizedHandles = cleanNormalizeWishlist(handles);
      let didWrite = false;

      try {
        localStorage.setItem(cleanWishlistStorageKey, JSON.stringify({ version: 1, handles: normalizedHandles }));
        didWrite = true;
      } catch {
        // The temporary legacy key may remain writable in a constrained context.
      }

      try {
        localStorage.setItem(legacyWishlistStorageKey, JSON.stringify(normalizedHandles));
        didWrite = true;
      } catch {
        // The Clean key above remains sufficient for Clean product cards.
      }

      return didWrite;
    };

    class CleanMainSearch extends HTMLElement {
      connectedCallback() {
        if (this.cleanConnected) return;

        this.cleanConnected = true;
        this.cleanAbortController = new AbortController();
        const { signal } = this.cleanAbortController;
        const wishlistState = cleanReadWishlist();

        this.cleanSuggestionCache = new Map();
        this.cleanInitializeSort(signal);
        this.cleanInitializeSuggestions(signal);
        this.cleanInitializeViewMore(signal);
        this.addEventListener('click', (event) => this.cleanHandleWishlistClick(event), { signal });
        window.addEventListener('storage', (event) => this.cleanHandleWishlistStorage(event), { signal });
        window.addEventListener('clean:wishlist-change', () => this.cleanSyncWishlistButtons(), { signal });

        if (wishlistState.available) {
          this.setAttribute('data-clean-main-search-enhanced', 'true');
          this.cleanSyncWishlistButtons(wishlistState);
        }
      }

      disconnectedCallback() {
        this.cleanAbortController?.abort();
        this.cleanCancelSuggestionRequest();
        this.cleanViewMoreObserver?.disconnect();
        this.cleanConnected = false;
      }

      cleanInitializeSort(signal) {
        const sortSelect = this.querySelector('[data-clean-main-search-sort]');
        if (!sortSelect) return;

        sortSelect.addEventListener('change', () => sortSelect.form?.requestSubmit(), { signal });
      }

      cleanInitializeViewMore(signal) {
        this.cleanResultGrid = this.querySelector('[data-clean-main-search-result-grid]');
        this.cleanViewMoreWrap = this.querySelector('[data-clean-main-search-view-more-wrap]');
        this.cleanLoadStatus = this.querySelector('[data-clean-main-search-load-status]');
        this.cleanAutomaticViewMoreLoads = 0;

        if (!this.cleanResultGrid || !this.cleanViewMoreWrap) return;

        this.addEventListener('click', (event) => this.cleanHandleViewMoreClick(event), { signal });

        if (!('IntersectionObserver' in window) || navigator.connection?.saveData) return;

        this.cleanViewMoreObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries.find((candidate) => candidate.isIntersecting);
            if (!entry || this.cleanViewMoreLoading || this.cleanAutomaticViewMoreLoads >= 2) return;

            this.cleanAutomaticViewMoreLoads += 1;
            if (this.cleanAutomaticViewMoreLoads >= 2) this.cleanViewMoreObserver.disconnect();
            else this.cleanViewMoreObserver.unobserve(entry.target);
            void this.cleanLoadMore(entry.target, true);
          },
          { rootMargin: '0px', threshold: 0.01 },
        );

        const link = this.querySelector('[data-clean-main-search-view-more]');
        if (link) this.cleanViewMoreObserver.observe(link);
      }

      cleanHandleViewMoreClick(event) {
        const link = event.target.closest('[data-clean-main-search-view-more]');
        if (!link || !this.contains(link)) return;

        event.preventDefault();
        if (!this.cleanViewMoreLoading) void this.cleanLoadMore(link, false);
      }

      async cleanLoadMore(link, automatic) {
        if (this.cleanViewMoreLoading || !link?.href || !this.cleanResultGrid) return;

        this.cleanViewMoreLoading = true;
        this.cleanViewMoreObserver?.unobserve(link);
        this.cleanViewMoreWrap?.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        link.textContent = 'Loading…';

        const requestUrl = new URL(link.href, window.location.origin);
        requestUrl.searchParams.set('section_id', this.dataset.cleanSectionId);

        try {
          const response = await fetch(requestUrl, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.cleanAbortController.signal,
          });
          if (!response.ok) throw new Error(`Search page request failed: ${response.status}`);

          const responseDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseGrid = responseDocument.querySelector('[data-clean-main-search-result-grid]');
          const responseItems = responseGrid
            ? Array.from(responseGrid.children).filter((item) => item.matches('.clean-main-search__result-item'))
            : [];
          if (!responseItems.length) throw new Error('Search result markup was missing.');

          const fragment = document.createDocumentFragment();
          responseItems.forEach((item) => fragment.append(item));
          this.cleanResultGrid.append(fragment);
          window.CleanDisplayCurrencyBootstrap?.refresh(this.cleanResultGrid);
          this.cleanSyncWishlistButtons();

          if (this.cleanLoadStatus) {
            this.cleanLoadStatus.textContent = `${responseItems.length} more ${
              responseItems.length === 1 ? 'product' : 'products'
            } loaded.`;
          }

          const responseLink = responseDocument.querySelector('[data-clean-main-search-view-more]');
          const nextUrl = responseLink?.getAttribute('href');
          if (nextUrl) {
            link.href = nextUrl;
            link.textContent = 'View more';
            link.removeAttribute('aria-disabled');
            if (automatic && this.cleanAutomaticViewMoreLoads < 2) this.cleanViewMoreObserver?.observe(link);
          } else {
            link.remove();
            if (this.cleanLoadStatus) this.cleanLoadStatus.textContent = 'All products are loaded.';
          }
        } catch (error) {
          if (error?.name === 'AbortError') return;

          link.textContent = 'View more';
          link.removeAttribute('aria-disabled');
          if (automatic) {
            this.cleanViewMoreObserver?.disconnect();
            if (this.cleanLoadStatus) {
              this.cleanLoadStatus.textContent = 'Automatic loading stopped. Select View more to continue.';
            }
          } else {
            window.location.assign(link.href);
          }
        } finally {
          this.cleanViewMoreLoading = false;
          this.cleanViewMoreWrap?.setAttribute('aria-busy', 'false');
        }
      }

      cleanInitializeSuggestions(signal) {
        this.cleanSearchForm = this.querySelector('form[role="search"]');
        this.cleanSearchInput = this.cleanSearchForm?.querySelector('input[type="search"][name="q"]');
        this.cleanSuggestionPanel = this.querySelector('[data-clean-main-search-suggestions]');
        this.cleanSuggestionHeading = this.querySelector('[data-clean-main-search-suggestions-heading]');
        this.cleanSuggestionResults = this.querySelector('[data-clean-main-search-suggestion-results]');
        this.cleanSuggestionViewAll = this.querySelector('[data-clean-main-search-view-all]');

        if (
          !this.cleanSearchForm ||
          !this.cleanSearchInput ||
          !this.cleanSuggestionPanel ||
          !this.cleanSuggestionHeading ||
          !this.cleanSuggestionResults ||
          !this.cleanSuggestionViewAll ||
          !this.dataset.cleanPredictiveSearchUrl
        ) {
          return;
        }

        this.cleanInitialSuggestionMarkup = this.cleanSuggestionResults.innerHTML;
        this.cleanInitialSuggestionHeading = this.cleanSuggestionHeading.textContent.trim();
        this.cleanInitialSuggestionsVisible = !this.cleanSuggestionPanel.hidden;
        this.cleanSuggestionSequence = 0;

        this.cleanSearchInput.addEventListener('input', () => this.cleanHandleSuggestionInput(), { signal });
        this.cleanSearchInput.addEventListener('keydown', (event) => this.cleanHandleSuggestionKeydown(event), {
          signal,
        });
        this.cleanSearchForm.addEventListener('submit', () => this.cleanCancelSuggestionRequest(), { signal });
      }

      cleanCancelSuggestionRequest() {
        this.cleanSuggestionSequence = (this.cleanSuggestionSequence || 0) + 1;
        window.clearTimeout(this.cleanSuggestionTimer);
        this.cleanSuggestionTimer = undefined;
        this.cleanSuggestionRequest?.abort();
        this.cleanSuggestionRequest = undefined;
        this.cleanSuggestionResults?.setAttribute('aria-busy', 'false');
      }

      cleanSetSuggestionsOpen(open) {
        if (!this.cleanSuggestionPanel || !this.cleanSearchInput) return;
        this.cleanSuggestionPanel.hidden = !open;
        this.cleanSearchInput.setAttribute('aria-expanded', String(open));
      }

      cleanRestoreInitialSuggestions() {
        this.cleanCancelSuggestionRequest();
        if (!this.cleanSuggestionResults || !this.cleanSuggestionHeading || !this.cleanSuggestionViewAll) return;

        this.cleanSuggestionHeading.textContent = this.cleanInitialSuggestionHeading;
        this.cleanSuggestionResults.innerHTML = this.cleanInitialSuggestionMarkup;
        this.cleanSuggestionViewAll.hidden = true;
        this.cleanSetSuggestionsOpen(this.cleanInitialSuggestionsVisible);
        window.CleanDisplayCurrencyBootstrap?.refresh(this.cleanSuggestionResults);
      }

      cleanSetSuggestionMessage(message) {
        const status = document.createElement('p');
        status.className = 'clean-header__search-message';
        status.textContent = message;
        this.cleanSuggestionResults.replaceChildren(status);
      }

      cleanSetSuggestionViewAll(query) {
        const searchUrl = new URL(this.cleanSearchForm.action, window.location.origin);
        searchUrl.searchParams.set('q', query);
        searchUrl.searchParams.set('type', 'product');
        searchUrl.searchParams.set('options[prefix]', 'last');
        this.cleanSuggestionViewAll.href = searchUrl.toString();
        this.cleanSuggestionViewAll.hidden = false;
      }

      cleanResponseMarkup(text) {
        const responseDocument = new DOMParser().parseFromString(text, 'text/html');
        const response = responseDocument.querySelector('[data-clean-search-response]');
        if (!response) throw new Error('Search response markup was missing.');
        return response.innerHTML;
      }

      cleanRenderSuggestionMarkup(query, markup) {
        this.cleanSuggestionHeading.textContent = 'Search results';
        this.cleanSuggestionResults.innerHTML = markup;

        const responseGrid = this.cleanSuggestionResults.querySelector('.clean-header__search-grid');
        if (responseGrid) {
          const list = document.createElement('ul');
          list.className = 'clean-main-search__popular-list';
          list.setAttribute('role', 'list');

          Array.from(responseGrid.querySelectorAll(':scope > [data-clean-search-option]')).forEach((card) => {
            const item = document.createElement('li');
            item.className = 'clean-main-search__popular-item';
            item.append(card);
            list.append(item);
          });
          responseGrid.replaceWith(list);
        }

        this.cleanSetSuggestionViewAll(query);
        this.cleanSuggestionResults.setAttribute('aria-busy', 'false');
        this.cleanSetSuggestionsOpen(true);
        window.CleanDisplayCurrencyBootstrap?.refresh(this.cleanSuggestionResults);
      }

      cleanHandleSuggestionInput() {
        const query = this.cleanSearchInput.value.trim();
        if (!query) {
          this.cleanRestoreInitialSuggestions();
          return;
        }

        this.cleanCancelSuggestionRequest();
        const requestId = this.cleanSuggestionSequence;
        const normalizedQuery = query.toLocaleLowerCase();

        this.cleanSuggestionTimer = window.setTimeout(async () => {
          if (requestId !== this.cleanSuggestionSequence) return;

          if (this.cleanSuggestionCache.has(normalizedQuery)) {
            this.cleanRenderSuggestionMarkup(query, this.cleanSuggestionCache.get(normalizedQuery));
            return;
          }

          this.cleanSuggestionHeading.textContent = 'Search results';
          this.cleanSuggestionViewAll.hidden = true;
          this.cleanSuggestionResults.setAttribute('aria-busy', 'true');
          this.cleanSetSuggestionMessage('Searching…');
          this.cleanSetSuggestionsOpen(true);
          this.cleanSuggestionRequest = new AbortController();

          const url = new URL(this.dataset.cleanPredictiveSearchUrl, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[limit_scope]', 'each');
          url.searchParams.set('section_id', 'clean-header-search-results');

          try {
            const response = await fetch(url, {
              credentials: 'same-origin',
              headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
              signal: this.cleanSuggestionRequest.signal,
            });
            if (!response.ok) throw new Error(`Search request failed: ${response.status}`);

            const markup = this.cleanResponseMarkup(await response.text());
            if (this.cleanSuggestionCache.size >= 12) {
              this.cleanSuggestionCache.delete(this.cleanSuggestionCache.keys().next().value);
            }
            this.cleanSuggestionCache.set(normalizedQuery, markup);

            if (
              requestId === this.cleanSuggestionSequence &&
              this.cleanSearchInput.value.trim().toLocaleLowerCase() === normalizedQuery
            ) {
              this.cleanRenderSuggestionMarkup(this.cleanSearchInput.value.trim(), markup);
            }
          } catch (error) {
            if (error?.name !== 'AbortError' && requestId === this.cleanSuggestionSequence) {
              this.cleanSuggestionHeading.textContent = 'Search results';
              this.cleanSetSuggestionMessage('Suggestions are temporarily unavailable.');
              this.cleanSuggestionResults.setAttribute('aria-busy', 'false');
              this.cleanSetSuggestionViewAll(this.cleanSearchInput.value.trim());
              this.cleanSetSuggestionsOpen(true);
            }
          } finally {
            if (requestId === this.cleanSuggestionSequence) this.cleanSuggestionRequest = undefined;
          }
        }, 300);
      }

      cleanHandleSuggestionKeydown(event) {
        if (event.key === 'Escape' && !this.cleanSuggestionPanel.hidden) {
          event.preventDefault();
          this.cleanCancelSuggestionRequest();
          this.cleanSetSuggestionsOpen(false);
          return;
        }

        if (event.key !== 'ArrowDown' || this.cleanSuggestionPanel.hidden) return;
        const firstSuggestion = this.cleanSuggestionResults.querySelector('[data-clean-search-option]');
        if (!firstSuggestion) return;
        event.preventDefault();
        firstSuggestion.focus();
      }

      cleanSyncWishlistButtons(state = cleanReadWishlist()) {
        const selectedHandles = new Set(state.handles);

        this.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
          const handle = button.dataset.cleanProductWishlistHandle?.trim();
          const title = button.dataset.cleanProductWishlistTitle?.trim() || 'this product';
          const isSelected = Boolean(handle && selectedHandles.has(handle));
          const isDisabled = !state.available || !handle;

          button.disabled = isDisabled;
          button.setAttribute('aria-pressed', String(isSelected));
          button.setAttribute('aria-label', `${isSelected ? 'Remove' : 'Add'} ${title} ${isSelected ? 'from' : 'to'} wishlist`);
        });
      }

      cleanHandleWishlistClick(event) {
        const button = event.target.closest('[data-clean-product-wishlist]');
        if (!button || !this.contains(button) || button.disabled) return;

        const handle = button.dataset.cleanProductWishlistHandle?.trim();
        const state = cleanReadWishlist();
        if (!handle || !state.available) return;

        const nextHandles = new Set(state.handles);
        if (nextHandles.has(handle)) nextHandles.delete(handle);
        else nextHandles.add(handle);

        if (!cleanWriteWishlist([...nextHandles])) {
          this.removeAttribute('data-clean-main-search-enhanced');
          button.disabled = true;
          return;
        }

        const nextState = { available: true, handles: [...nextHandles] };
        this.cleanSyncWishlistButtons(nextState);
        window.dispatchEvent(new CustomEvent('clean:wishlist-change', { detail: { handles: nextState.handles } }));
      }

      cleanHandleWishlistStorage(event) {
        if (event.key === null || event.key === cleanWishlistStorageKey || event.key === legacyWishlistStorageKey) {
          const state = cleanReadWishlist();
          if (state.available) this.setAttribute('data-clean-main-search-enhanced', 'true');
          else this.removeAttribute('data-clean-main-search-enhanced');
          this.cleanSyncWishlistButtons(state);
        }
      }
    }

    customElements.define(elementName, CleanMainSearch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-product-addons"]) return;
  try {
    
  (() => {
    if (customElements.get('clean-product-addons')) return;
    customElements.define(
      'clean-product-addons',
      class extends HTMLElement {
        connectedCallback() {
          if (this.lifecycle) return;
          this.lifecycle = new AbortController();
          this.dialog = this.querySelector('.clean-addons');
          if (!this.dialog) return;
          this.body = this.querySelector('[data-clean-addon-body]');
          this.tabs = this.querySelector('.clean-addon-tabs');
          this.message = this.querySelector('[data-clean-addon-status]');
          this.cart = document.querySelector('clean-product-cart');
          this.footer = this.querySelector('.clean-addon-footer button');
          this.customizer = this.querySelector('.clean-addon-customizer');
          this.customForm = this.querySelector('[data-clean-addon-form]');
          this.fieldList = this.querySelector('[data-clean-addon-field-list]');
          this.datePicker = this.querySelector('[data-clean-addon-date-picker]');
          this.customizations = new Map();
          this.selections = new Map();
          this.personalizationDrafts = new Map();
          const listen = (target, type, handler) =>
            target?.addEventListener(type, handler, { signal: this.lifecycle.signal });
          this.customDesktop = matchMedia('(min-width: 750px)');
          listen(this.customDesktop, 'change', () => {
            if (this.customizer.open) this.personalizationLayout();
          });
          const product = document.querySelector('.clean-product__form');
          for (const type of ['pointerover', 'pointerdown', 'focusin']) listen(product, type, () => this.load());
          listen(this, 'click', (event) => this.click(event));
          listen(this, 'focusin', (event) => {
            if (event.target.matches('[data-clean-addon-quantity]')) event.target.select();
          });
          listen(this, 'input', (event) => {
            if (!event.target.matches('[data-clean-addon-quantity]')) return;
            event.target.dataset.cleanAddonEditing = '';
            this.updatePrices();
          });
          listen(this, 'change', (event) => {
            if (event.target.matches('[data-clean-addon-quantity]')) this.editQuantity(event.target);
          });
          listen(this, 'keydown', (event) => {
            if (event.key === 'Enter' && event.target.matches('[data-clean-addon-quantity]')) {
              event.preventDefault();
              this.editQuantity(event.target);
            }
          });
          listen(document, 'clean:bulk-discounts:updated', () => this.updatePrices());
          listen(document, 'clean:cart:updated', () => this.updatePrices());
          listen(this.customForm, 'input', () => this.progress());
          listen(this.datePicker, 'change', () => {
            if (!this.dateField?.isConnected) return;
            this.dateField.value = this.datePicker.value.split('-').reverse().join('-');
            this.dateField.dispatchEvent(new Event('input', { bubbles: true }));
            this.dateField.focus({ preventScroll: true });
          });
          listen(this.customForm, 'submit', (event) => this.submitPersonalization(event));
          listen(this.querySelector('[data-clean-addon-previous]'), 'click', () => {
            if (!this.customBusy && !this.cart.uncertain) this.mobileField(this.customIndex - 1, true);
          });
          listen(this.customizer, 'cancel', (event) => {
            event.preventDefault();
            this.closePersonalization();
          });
          listen(this.customizer, 'click', (event) => {
            const rect = this.customizer.getBoundingClientRect();
            if (event.target === this.customizer &&
              (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom))
              this.closePersonalization();
          });
          listen(this.customizer, 'keydown', (event) => {
            if (event.key !== 'Tab') return;
            const controls = [...this.customizer.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href]')]
              .filter((node) => node.getClientRects().length);
            const first = controls[0], last = controls.at(-1);
            if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
              event.preventDefault();
              (event.shiftKey ? last : first)?.focus();
            }
          });
          listen(this.dialog, 'cancel', (event) => {
            event.preventDefault();
            this.finish();
          });
          listen(this.dialog, 'click', (event) => {
            const rect = this.dialog.getBoundingClientRect();
            if (
              event.target === this.dialog &&
              (event.clientX < rect.left ||
                event.clientX > rect.right ||
                event.clientY < rect.top ||
                event.clientY > rect.bottom)
            )
              this.finish();
          });
          listen(this.dialog, 'keydown', (event) => {
            if (event.key !== 'Tab') return;
            const controls = [...this.dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), [tabindex="0"]')].filter(
              (node) => node.getClientRects().length,
            );
            const first = controls[0],
              last = controls.at(-1);
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          });
          listen(this.body, 'scroll', () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = 0;
              if (this.pillSelection) return;
              const top = this.body.getBoundingClientRect().top;
              const rows = [...this.body.querySelectorAll('[data-clean-addon-category]')];
              const last = rows.at(-1);
              const previousHeading = rows.at(-2)?.querySelector('h3');
              const current =
                last && previousHeading?.getBoundingClientRect().bottom <= top
                  ? last
                  : rows.find((row) => row.getBoundingClientRect().bottom > top + 60);
              if (current) this.selectCategory(current.dataset.cleanAddonCategory);
            });
          });
          for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
            listen(this.body, type, () => {
              this.pillSelection = null;
            });
          }
          listen(window, 'pageshow', (event) => {
            if (event.persisted) this.catalogKey = null;
          });
        }
        disconnectedCallback() {
          this.parentReady = false;
          this.resolvePurchase?.(false);
          clearTimeout(this.queueTimer);
          this.lifecycle?.abort();
          this.lifecycle = null;
          this.images?.disconnect();
          this.resize?.disconnect();
          cancelAnimationFrame(this.scrollFrame);
          this.dialog?.close();
          this.customizer?.close();
          this.customRead?.abort();
        }
        status(message = '') {
          this.message.textContent = message;
          this.message.hidden = !message;
        }
        async load(retry = false) {
          const key = `${this.dataset.cleanAddonContext}:${this.dataset.cleanAddonUrl}`;
          if (this.catalogKey === key && !(retry && this.catalogFailed)) return;
          if (this.catalogPromise) return this.catalogPromise;
          this.catalogPromise = (async () => {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 10000);
            try {
              const url = new URL(this.dataset.cleanAddonUrl, location.origin);
              url.searchParams.set('section_id', this.dataset.cleanAddonSection);
              const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
              if (!response.ok) throw new Error('Recommendations unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const catalog = doc.querySelector('[data-clean-addon-catalog]');
              if (!catalog) throw new Error('Recommendations unavailable');
              this.body.replaceChildren(catalog);
              this.tabs.replaceChildren();
              catalog.querySelectorAll('[data-clean-addon-category]').forEach((row) => {
                if (!row.querySelector('[data-clean-addon-variant]')) {
                  row.remove();
                  return;
                }
                const button = document.createElement('button');
                button.type = 'button';
                button.dataset.cleanAddonTab = row.dataset.cleanAddonCategory;
                button.textContent = row.querySelector('h3').textContent;
                button.setAttribute('aria-pressed', String(!this.tabs.children.length));
                this.tabs.append(button);
              });
              this.tabs.hidden = !this.tabs.children.length;
              this.tabs.removeAttribute('data-clean-addon-centered');
              this.tabs.scrollTo({ left: 0, behavior: 'instant' });
              this.selectCategory(this.tabs.firstElementChild?.dataset.cleanAddonTab);
              this.catalogKey = key;
              this.catalogFailed = false;
              if (!catalog.querySelector('[data-clean-addon-variant]'))
                this.body.textContent = 'Continue to view your cart.';
              window.CleanDisplayCurrencyBootstrap?.refresh(this.body);
              this.enhance();
              this.updatePrices();
              if (this.purchasing || this.selectionMode) this.purchaseControls(!!this.purchasing);
              if (this.selectionMode) this.sync();
            } catch {
              this.catalogKey = key;
              this.catalogFailed = true;
              this.tabs.replaceChildren();
              this.tabs.hidden = true;
              this.body.textContent = 'Gift add-ons are unavailable. Continue to view your cart.';
            } finally {
              clearTimeout(timeout);
              this.catalogPromise = null;
            }
          })();
          return this.catalogPromise;
        }
        enhance() {
          this.images?.disconnect();
          if ('IntersectionObserver' in window) {
            this.images = new IntersectionObserver(
              (entries) => {
                for (const entry of entries)
                  if (entry.isIntersecting) {
                    entry.target.src = entry.target.dataset.cleanAddonSrc;
                    this.images.unobserve(entry.target);
                  }
              },
              { root: this.body, rootMargin: '120px 40px' },
            );
            this.body
              .querySelectorAll('img[data-clean-addon-src]:not([src])')
              .forEach((img) => this.images.observe(img));
          } else
            this.body.querySelectorAll('img[data-clean-addon-src]').forEach((img) => {
              img.src = img.dataset.cleanAddonSrc;
            });
          this.resize?.disconnect();
          const tracks = [...this.body.querySelectorAll('.clean-addon-track')];
          const update = (track) => {
            const buttons = track.parentElement.querySelectorAll('[data-clean-addon-scroll]');
            const overflow = track.scrollWidth - track.clientWidth;
            buttons.forEach((button) => {
              button.hidden = matchMedia('(min-width: 750px)').matches || overflow <= 1;
              button.disabled =
                button.dataset.cleanAddonScroll === '-1' ? track.scrollLeft < 1 : track.scrollLeft >= overflow - 1;
            });
          };
          // One observer handles geometry changes; scrolling only reads its own rail.
          this.resize = new ResizeObserver((entries) => entries.forEach((entry) => update(entry.target)));
          tracks.forEach((track) => {
            this.resize.observe(track);
            track.addEventListener('scroll', () => update(track), { passive: true, signal: this.lifecycle.signal });
          });
        }
        purchaseControls(pending) {
          this.purchasing = pending;
          this.dialog.toggleAttribute('data-clean-purchasing', pending);
          this.querySelectorAll('[data-clean-addon-finish], [data-clean-addon-delta], [data-clean-addon-quantity]').forEach((button) => {
            button.disabled = !!this.finishing || (pending && !this.selectionMode);
          });
        }
        purchaseStatus(message) {
          if (!this.purchasing) return;
          this.status(message);
          if (!this.selectionMode) this.footer.textContent = message;
        }
        pending(message = 'Adding your gift…', { owner } = {}) {
          if (!this.purchasing) {
            const resume = owner && this.selectionOwner === owner && this.selectionMode && !this.parentReady;
            this.selectionMode = !!owner;
            this.selectionOwner = owner;
            if (!resume) {
              this.selections.clear();
              this.customizations.clear();
              this.personalizationDrafts.clear();
            }
            this.parentReady = false;
            this.queueBlocked = false;
            this.finishing = false;
            this.purchaseReady = new Promise((resolve) => {
              this.resolvePurchase = resolve;
            });
            this.baseline = null;
            this.groupId = '';
            this.pillSelection = null;
            this.body.scrollTop = 0;
            this.body.querySelectorAll('.clean-addon-track').forEach((track) => {
              track.scrollLeft = 0;
            });
            this.tabs.removeAttribute('data-clean-addon-centered');
            this.tabs.scrollTo({ left: 0, behavior: 'instant' });
            this.selectCategory(this.tabs.firstElementChild?.dataset.cleanAddonTab);
          }
          this.purchaseControls(true);
          this.sync();
          this.purchaseStatus(message);
          if (!this.dialog.open) this.dialog.showModal();
          this.querySelector('#clean-addon-title').focus({ preventScroll: true });
          this.load();
        }
        cancelPending() {
          if (!this.purchasing) return;
          this.parentReady = false;
          this.resolvePurchase?.(false);
          this.finishing = false;
          clearTimeout(this.queueTimer);
          this.purchaseControls(false);
          this.status();
          if (this.customizer.open && this.customCard) {
            const fields = [...this.fieldList.querySelectorAll('input')];
            if (fields.length)
              this.personalizationDrafts.set(
                this.customizationKey(this.customCard),
                Object.fromEntries(fields.map((input) => [input.name.slice(11, -1), input.value])),
              );
          }
          this.customRead?.abort();
          if (this.customizer.open) this.customizer.close();
          this.dialog.close();
          this.sync();
        }
        discardSelections(owner) {
          if (this.selectionOwner !== owner || this.parentReady) return;
          this.cancelPending();
          this.selections.clear();
          this.customizations.clear();
          this.personalizationDrafts.clear();
          this.selectionOwner = null;
          this.selectionMode = false;
        }
        open() {
          const wasPending = this.purchasing && this.dialog.open;
          if (!wasPending) {
            this.selectionMode = false;
            this.selectionOwner = null;
            this.selections.clear();
            this.personalizationDrafts.clear();
          }
          this.purchaseControls(false);
          if (!wasPending) this.finishing = false;
          this.footer.disabled = !!this.finishing;
          this.baseline = this.cart.uncertain ? null : this.captureBaseline();
          if (!this.selectionMode) this.customizations.clear();
          if (!wasPending) {
            this.pillSelection = null;
            this.body.scrollTop = 0;
            this.body.querySelectorAll('.clean-addon-track').forEach((track) => {
              track.scrollLeft = 0;
            });
            this.tabs.removeAttribute('data-clean-addon-centered');
            this.tabs.scrollTo({ left: 0, behavior: 'instant' });
            this.selectCategory(this.tabs.firstElementChild?.dataset.cleanAddonTab);
          }
          this.status(this.finishing && this.selectionMode ? 'Finishing your gift…' : '');
          if (!this.dialog.open) this.dialog.showModal();
          if (!this.customizer.open && (!wasPending || !this.dialog.contains(document.activeElement)))
            this.querySelector('.clean-addon-close').focus({ preventScroll: true });
          this.sync();
          this.load(true).then(() => this.sync());
          if (this.selectionMode) {
            // The main add's finally must release the cart before add-on writes.
            const ready = this.resolvePurchase;
            this.queueTimer = setTimeout(() => {
              if (!this.isConnected || ready !== this.resolvePurchase) return;
              this.parentReady = true;
              ready?.(true);
              this.queueFlush();
            }, 0);
          }
        }
        selectCategory(category, center = false) {
          let selected;
          this.tabs.querySelectorAll('[data-clean-addon-tab]').forEach((button) => {
            const active = button.dataset.cleanAddonTab === category;
            button.setAttribute('aria-pressed', String(active));
            if (active) selected = button;
          });
          if (selected && center && this.dialog.open && matchMedia('(max-width: 749px)').matches) {
            this.tabs.setAttribute('data-clean-addon-centered', '');
            const pill = selected.getBoundingClientRect();
            const tabs = this.tabs.getBoundingClientRect();
            this.tabs.scrollTo({
              left: this.tabs.scrollLeft + pill.left + pill.width / 2 - tabs.left - this.tabs.clientWidth / 2,
              behavior: this.motion(),
            });
          }
        }
        properties(card) {
          return {
            ...this.customizations.get(this.customizationKey(card)),
            ...(Number(card.dataset.cleanAddonMinimum) > 1
              ? { _minimum_quantity: card.dataset.cleanAddonMinimum }
              : {}),
            '_Add-on upsell': 'Yes',
            '_Add-on source': 'Post add-to-cart drawer',
            '_Add-on category': card.closest('[data-clean-addon-category]').dataset.cleanAddonCategory,
            '_Clean add-on group': this.groupId,
          };
        }
        line(card) {
          const properties = this.properties(card);
          return this.cart.lines?.find(
            (line) =>
              String(line.variant_id || line.id) === card.dataset.cleanAddonVariant &&
              Object.keys(line.properties || {}).length === Object.keys(properties).length &&
              Object.entries(properties).every(([key, value]) => line.properties[key] === value) &&
              !line.selling_plan_allocation,
          );
        }
        captureBaseline() {
          return new Map((this.cart.lines || []).map((line) => [this.identity(line), line.quantity]));
        }
        identity(line) {
          if (!line) return '';
          return JSON.stringify([
            line.variant_id || line.id,
            Object.entries(line.properties || {}).sort(([a], [b]) => a.localeCompare(b)),
            line.selling_plan_allocation?.selling_plan?.id || null,
          ]);
        }
        count(card) {
          if (this.selectionMode) return this.selections.get(this.customizationKey(card))?.quantity || 0;
          if (!this.baseline) return 0;
          const line = this.line(card);
          return Math.max(0, (line?.quantity || 0) - (this.baseline?.get(this.identity(line)) || 0));
        }
        nextQuantity(card, delta) {
          const quantity = this.count(card);
          const minimum = Number(card.dataset.cleanAddonMinimum || 1);
          const increment = Number(card.dataset.cleanAddonIncrement || 1);
          if (delta > 0) return this.normalizeQuantity(card, quantity ? quantity + increment : minimum);
          return quantity - increment < minimum ? 0 : quantity - increment;
        }
        normalizeQuantity(card, requested) {
          const minimum = Number(card.dataset.cleanAddonMinimum || 1);
          const increment = Number(card.dataset.cleanAddonIncrement || 1);
          const highest = minimum + Math.floor((9999 - minimum) / increment) * increment;
          const value = Number.isFinite(requested) ? requested : minimum;
          return Math.min(highest, minimum + Math.ceil((Math.max(minimum, value) - minimum) / increment) * increment);
        }
        editQuantity(input) {
          if (this.operation || this.finishing || (this.purchasing && !this.selectionMode)) return;
          const card = input.closest('[data-clean-addon-variant]');
          const quantity = this.normalizeQuantity(card, input.valueAsNumber);
          delete input.dataset.cleanAddonEditing;
          input.value = String(quantity);
          if (quantity === this.count(card)) return this.updatePrices();
          // Defer the write until the operation guard is installed: disabling
          // the focused number input can synchronously fire another change.
          this.operation = Promise.resolve()
            .then(() => this.change(card, 0, false, quantity))
            .finally(() => {
              this.operation = null;
            });
        }
        updatePrices() {
          const catalog = this.body?.querySelector('[data-clean-addon-catalog]');
          if (!catalog) return;
          const cards = [...catalog.querySelectorAll('[data-clean-addon-variant]')];
          let cartQuantity = window.CleanBulkDiscounts?.quantity() ?? Number(catalog.dataset.cleanAddonCartQuantity || 0);
          // Native choices can be staged or partly written. Count each desired
          // eligible unit once, subtracting the group's confirmed cart units.
          if (this.selectionMode) {
            const seen = new Set();
            for (const card of cards) {
              const key = this.customizationKey(card);
              if (card.dataset.cleanAddonBulkEligible !== 'true' || seen.has(key)) continue;
              seen.add(key);
              cartQuantity += this.count(card) - (this.line(card)?.quantity || 0);
            }
          }
          const draft = catalog.querySelector('[data-clean-addon-editing]');
          const draftCard = draft?.closest('[data-clean-addon-variant]');
          if (draft?.checkValidity() && draftCard.dataset.cleanAddonBulkEligible === 'true')
            cartQuantity += draft.valueAsNumber - this.count(draftCard);
          const tiers = JSON.parse(catalog.dataset.cleanAddonTiers);
          for (const card of cards) {
            const base = Number(card.dataset.cleanAddonBasePrice);
            const quantity = cartQuantity + (this.count(card) ? 0 : Number(card.dataset.cleanAddonMinimum || 1));
            const percent =
              card.dataset.cleanAddonBulkEligible === 'true'
                ? (window.CleanBulkDiscounts?.percent(quantity) ??
                  tiers.reduce((rate, tier) => (quantity >= tier.minimum ? tier.percent : rate), 0))
                : 0;
            const amount = Math.round((base * (100 - percent)) / 100);
            const unit = card.querySelector('[data-clean-addon-unit]');
            const money = unit.querySelector('[data-clean-money]');
            card.querySelector('[data-clean-addon-original]').hidden = amount >= base;
            unit.classList.toggle('clean-addon-discounted', amount < base);
            if (Number(money.dataset.cleanMoneyMinor) === amount) continue;
            const source = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: money.dataset.cleanMoneyCurrency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(amount / 100);
            money.dataset.cleanMoneyMinor = String(amount);
            money.dataset.cleanMoneySourceText = source;
            money.textContent = source;
          }
          window.CleanDisplayCurrency?.refresh?.(catalog);
        }
        sync() {
          if (!this.purchasing && !this.baseline && !this.cart.uncertain) this.baseline = this.captureBaseline();
          const seen = new Set();
          this.total = 0;
          this.querySelectorAll('[data-clean-addon-variant]').forEach((card) => {
            const quantity = this.count(card);
            const line = this.line(card);
            if (this.selectionMode && !seen.has(this.customizationKey(card))) {
              this.total += quantity;
              seen.add(this.customizationKey(card));
            } else if (!this.selectionMode && line && !seen.has(line.key)) {
              this.total += quantity;
              seen.add(line.key);
            }
            const add = card.querySelector('.clean-addon-add'),
              stepper = card.querySelector('.clean-addon-quantity');
            const active = card.contains(document.activeElement);
            add.hidden = quantity > 0;
            stepper.hidden = quantity === 0;
            const input = stepper.querySelector('input');
            if (!input.hasAttribute('data-clean-addon-editing')) input.value = String(quantity);
            if (active && !document.activeElement.getClientRects().length)
              (quantity ? stepper.querySelector('button') : add).focus({ preventScroll: true });
          });
          if (!this.purchasing || this.selectionMode)
            this.footer.textContent = this.total ? `Continue with add-ons (${this.total})` : 'Continue without add-ons';
          this.updatePrices();
        }
        click(event) {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-clean-addon-customizer-close')) return this.closePersonalization();
          if (button.hasAttribute('data-clean-addon-finish')) return this.finish();
          if (button.hasAttribute('data-clean-addon-tab')) {
            const row = [...this.body.querySelectorAll('[data-clean-addon-category]')].find(
              (row) => row.dataset.cleanAddonCategory === button.dataset.cleanAddonTab,
            );
            this.pillSelection = button.dataset.cleanAddonTab;
            if (row) this.body.scrollTo({ top: row.offsetTop - this.body.offsetTop - 12, behavior: this.motion() });
            this.selectCategory(button.dataset.cleanAddonTab, true);
          }
          if (button.hasAttribute('data-clean-addon-scroll')) {
            const track = button.parentElement.querySelector('.clean-addon-track');
            track.scrollBy({
              left:
                Number(button.dataset.cleanAddonScroll) *
                (innerWidth < 750 ? track.firstElementChild.getBoundingClientRect().width : track.clientWidth - 44),
              behavior: this.motion(),
            });
          }
          if (
            button.hasAttribute('data-clean-addon-delta') &&
            !this.operation &&
            !this.finishing &&
            (!this.purchasing || this.selectionMode)
          ) {
            this.operation = this.change(
              button.closest('[data-clean-addon-variant]'),
              Number(button.dataset.cleanAddonDelta),
            ).finally(() => {
              this.operation = null;
            });
          }
        }
        motion() {
          return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        }
        customizationKey(card) {
          return `${card.dataset.cleanAddonVariant}:${card.closest('[data-clean-addon-category]').dataset.cleanAddonCategory}`;
        }
        customStatus(message = '') {
          const status = this.querySelector('[data-clean-addon-customizer-status]');
          status.textContent = message;
          status.hidden = !message;
        }
        closePersonalization() {
          if (this.customBusy) return;
          this.customRead?.abort();
          this.customizer.close();
          this.customCard?.querySelector(this.count(this.customCard) ? '.clean-addon-quantity button' : '.clean-addon-add')
            ?.focus({ preventScroll: true });
        }
        dateISO(value) {
          const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(value);
          if (!match || Number(match[3]) === 0) return '';
          const iso = `${match[3]}-${match[2]}-${match[1]}`;
          const date = new Date(`${iso}T00:00:00Z`);
          return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === iso ? iso : '';
        }
        dateFieldSetup(input, value, label) {
          input.type = 'text';
          input.dataset.cleanAddonDate = '';
          input.placeholder = 'DD-MM-YYYY';
          input.pattern = '[0-9]{2}-[0-9]{2}-[0-9]{4}';
          input.title = 'Use DD-MM-YYYY, for example 03-10-2026.';
          // Native date controls ignored text limits; retain that behavior.
          input.removeAttribute('maxlength');
          input.removeAttribute('minlength');
          input.value = /^\d{4}-\d{2}-\d{2}$/.test(value) ? value.split('-').reverse().join('-') : value;
          if (typeof this.datePicker.showPicker !== 'function') return;
          const wrapper = document.createElement('span'), button = document.createElement('button');
          wrapper.className = 'clean-addon-date';
          button.type = 'button';
          button.setAttribute('aria-label', `Choose date for ${label}`);
          button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 2v6m8-6v6"/></svg>';
          button.addEventListener('click', () => {
            this.dateField = input;
            this.datePicker.value = this.dateISO(input.value);
            this.datePicker.showPicker();
          });
          const fieldLabel = input.closest('label');
          fieldLabel.before(wrapper);
          wrapper.append(fieldLabel, button);
        }
        progress() {
          const fields = [...this.fieldList.querySelectorAll('input')];
          fields.forEach((field) => {
            field.setCustomValidity(field.value && !field.value.trim() ? 'Please enter your details.' :
              field.hasAttribute('data-clean-addon-date') && field.value && !this.dateISO(field.value) ? 'Enter a valid date in DD-MM-YYYY format.' :
              field.maxLength > 0 && field.value.length > field.maxLength ? `Use ${field.maxLength} characters or fewer.` : '');
          });
          const required = fields.filter((field) => field.required);
          const counted = required.length ? required : fields;
          const completed = counted.filter((field) => field.value.trim() && field.validity.valid).length;
          const bar = this.querySelector('[data-clean-addon-progress]');
          bar.max = counted.length || 1;
          bar.value = completed;
          this.querySelector('[data-clean-addon-progress-text]').textContent = `${completed} of ${counted.length} details completed`;
        }
        personalizationLayout() {
          const progress = this.querySelector('.clean-addon-progress');
          const legend = this.fieldList.querySelector('fieldset legend');
          if (this.customDesktop.matches && legend) legend.after(progress);
          else this.fieldList.before(progress);
          const media = this.querySelector('.clean-addon-customizer-media');
          const picture = this.customCard?.querySelector('.clean-addon-media img');
          media.hidden = !picture;
          media.setAttribute('aria-hidden', String(!this.customDesktop.matches));
          if (!media.hidden && !media.firstElementChild) {
            // Reuse the selected variant's bounded catalogue rendition and cache.
            // Mobile uses this same photo as a dim, decorative backdrop.
            // No modal image URL is activated before Add intent.
            const image = document.createElement('img');
            image.width = 320;
            image.height = 320;
            image.alt = picture.alt;
            image.decoding = 'async';
            image.src = picture.currentSrc || picture.dataset.cleanAddonSrc;
            media.append(image);
          }
          const fields = [...this.fieldList.querySelectorAll('input')];
          const focused = fields.findIndex((field) => field === document.activeElement || field.closest('.clean-addon-date')?.contains(document.activeElement));
          this.mobileField(focused < 0 ? this.customIndex : focused);
        }
        mobileField(index = 0, focus = false) {
          const fields = [...this.fieldList.querySelectorAll('input')];
          const groups = [...this.fieldList.querySelectorAll('fieldset')].filter((group) => group.querySelector('input'));
          this.customIndex = Math.max(0, Math.min(index || 0, fields.length - 1));
          const active = fields[this.customIndex];
          const group = active?.closest('fieldset');
          const mobile = !this.customDesktop.matches;
          this.customForm.noValidate = mobile;
          this.fieldList.querySelectorAll('fieldset').forEach((node) => { node.hidden = mobile && node !== group; });
          fields.forEach((input) => { (input.closest('.clean-addon-date') || input.closest('label')).hidden = mobile && input !== active; });
          this.querySelector('.clean-addon-mobile-counts').hidden = !mobile || !active;
          const previous = this.querySelector('[data-clean-addon-previous]');
          previous.hidden = !mobile || !active || !this.customIndex;
          previous.disabled = this.customBusy || this.cart.uncertain;
          if (active) {
            const stepFields = [...group.querySelectorAll('input')];
            this.querySelector('[data-clean-addon-step-count]').textContent = `Step ${groups.indexOf(group) + 1}/${groups.length}`;
            this.querySelector('[data-clean-addon-field-count]').textContent = `Field ${stepFields.indexOf(active) + 1}/${stepFields.length}`;
          }
          this.customForm.querySelector('[type="submit"]').textContent =
            this.cart.uncertain && !this.selectionMode
              ? 'Check cart'
              : mobile && this.customIndex < fields.length - 1
                ? 'NEXT'
                : 'ADD';
          if (focus) active?.focus({ preventScroll: true });
        }
        async personalize(card) {
          const template = card.querySelector('[data-clean-addon-fields]');
          this.customCard = card;
          this.dateField = null;
          this.customIndex = 0;
          this.customStatus();
          this.querySelector('[data-clean-addon-customizer-link]').hidden = true;
          this.fieldList.before(this.querySelector('.clean-addon-progress'));
          this.fieldList.replaceChildren();
          this.querySelector('.clean-addon-customizer-media').replaceChildren();
          this.querySelector('[data-clean-addon-customizer-product]').textContent =
            card.querySelector('.clean-addon-name').textContent;
          this.personalizationLayout();
          const submit = this.customForm.querySelector('[type="submit"]');
          submit.textContent = 'ADD';
          submit.disabled = true;
          this.progress();
          this.customizer.showModal();
          this.customizer.querySelector('[data-clean-addon-customizer-close]').focus();
          if (template.hasAttribute('data-clean-addon-invalid')) {
            this.customStatus('Personalization is unavailable for this variant. Cancel and visit the product page.');
            return true;
          }
          if (template.dataset.cleanAddonAssignment) {
            this.customRead = new AbortController();
            this.customStatus('Loading personalization details…');
            try {
              const url = new URL(template.dataset.cleanAddonAssignment);
              if (
                url.protocol !== 'https:' ||
                url.hostname !== 'json.staticmeow.com' ||
                !/^\/customeow\/app\/shopify\/\d+\/[^/]+\.json$/.test(url.pathname)
              )
                throw new Error();
              const response = await fetch(url, {
                signal: AbortSignal.any([this.lifecycle.signal, this.customRead.signal, AbortSignal.timeout(10000)]),
              });
              // A verified missing/disabled assignment has no active customization.
              if (response.status === 404) {
                this.closePersonalization();
                return false;
              }
              if (!response.ok) throw new Error();
              const config = await response.json();
              if (!config || Array.isArray(config)) throw new Error();
              if (config.enabled === false || config.published === false) {
                this.closePersonalization();
                return false;
              }
              if (!config.customizerId || !config.customizerVersion) throw new Error();
              const fragment = document.createDocumentFragment();
              const translate = (text) => config.locals?.[text]?.en_US || text;
              for (const [step, layer] of (config.customData?.layers || []).entries()) {
                if (layer.conditions?.length) throw new Error();
                const group = document.createElement('fieldset');
                const legend = document.createElement('legend');
                legend.textContent = translate(layer.title) || 'Your details';
                group.append(legend);
                for (const module of layer.modules || []) {
                  if (module.type === 'preview_template') continue;
                  const settings = module.config || {};
                  if (!['text', 'datetime'].includes(module.type) || settings.enableCondition) throw new Error();
                  const label = document.createElement('label'), input = document.createElement('input');
                  const title = translate(settings.label);
                  if (typeof title !== 'string' || !title.trim()) throw new Error();
                  label.append(document.createTextNode(title));
                  input.type = module.type === 'datetime' ? 'date' : 'text';
                  input.dataset.cleanStep = String(step);
                  input.name = `properties[${title.trim()}]`;
                  input.required = settings.validate?.required === true;
                  if (settings.validate?.maxLength > 0) input.maxLength = settings.validate.maxLength;
                  if (settings.validate?.minLength > 0) input.minLength = settings.validate.minLength;
                  label.append(input);
                  group.append(label);
                }
                fragment.append(group);
              }
              if (!fragment.querySelector('input')) throw new Error();
              // Cache only successfully verified fields in this deferred catalogue.
              template.content.replaceChildren(fragment);
              delete template.dataset.cleanAddonAssignment;
            } catch {
              if (this.customizer.open && this.customCard === card) {
                this.customStatus('Personalization could not load. Cancel and try again, or visit the product page.');
                const link = this.querySelector('[data-clean-addon-customizer-link]');
                link.href = card.querySelector('.clean-addon-media').dataset.cleanAddonProductUrl;
                link.hidden = false;
              }
              return true;
            }
          }
          if (!this.customizer.open || this.customCard !== card || !card.isConnected) return true;
          this.fieldList.replaceChildren(template.content.cloneNode(true));
          const fields = [...this.fieldList.querySelectorAll('input')];
          const names = fields.map((input) => input.name.slice(11, -1));
          const used = new Set();
          fields.forEach((input, index) => {
            const label = names[index];
            let key = names.filter((name) => name === label).length > 1 ? `${label} (Step ${Number(input.dataset.cleanStep) + 1})` : label;
            if (used.has(key)) key += ` (${index + 1})`;
            used.add(key);
            input.name = `properties[${key}]`;
            const value =
              this.personalizationDrafts.get(this.customizationKey(card))?.[key] ??
              this.customizations.get(this.customizationKey(card))?.[key] ??
              '';
            if (input.type === 'date') this.dateFieldSetup(input, value, key);
            else input.value = value;
          });
          this.customStatus();
          submit.disabled = !fields.length;
          this.progress();
          this.personalizationLayout();
          fields[0]?.focus({ preventScroll: true });
          return true;
        }
        submitPersonalization(event) {
          event.preventDefault();
          if (this.operation || this.customBusy || !this.customCard?.isConnected) return;
          const fields = [...this.fieldList.querySelectorAll('input')];
          if (!fields.length) return;
          this.progress();
          if (!this.cart.uncertain || this.selectionMode) {
            if (!this.customDesktop.matches) {
              const current = fields[this.customIndex];
              if (!current.reportValidity()) return;
              if (this.customIndex < fields.length - 1) {
                this.mobileField(this.customIndex + 1, true);
                return;
              }
              const invalid = fields.findIndex((input) => !input.validity.valid);
              if (invalid >= 0) {
                this.mobileField(invalid, true);
                fields[invalid].reportValidity();
                return;
              }
            } else if (!this.customForm.reportValidity()) return;
          }
          const card = this.customCard;
          if (!this.cart.uncertain || this.selectionMode)
            this.customizations.set(
              this.customizationKey(card),
              Object.fromEntries(fields.map((input) => [input.name.slice(11, -1), input.value.trim()])),
            );
          if (this.selectionMode) this.personalizationDrafts.delete(this.customizationKey(card));
          this.customBusy = true;
          this.customStatus(this.cart.uncertain ? 'Checking your cart…' : 'Adding your personalized item…');
          this.customForm.querySelectorAll('button, input').forEach((node) => {
            node.disabled = true;
          });
          this.operation = this.change(card, 1, true)
            .then((ok) => {
              if (ok || (!this.cart.uncertain && this.count(card) > 0)) {
                this.customBusy = false;
                this.closePersonalization();
              } else this.customStatus(this.message.textContent || 'Your item could not be added. Please try again.');
            })
            .finally(() => {
              this.operation = null;
              this.customBusy = false;
              this.customForm.querySelectorAll('button, input').forEach((node) => {
                node.disabled = false;
              });
              if (this.customizer.open && this.cart.uncertain)
                fields.forEach((input) => {
                  input.disabled = true;
                });
              this.mobileField(this.customIndex);
            });
        }
        async change(card, delta, personalized = false, requested = null) {
          if (this.selectionMode) {
            const quantity = this.count(card);
            if (delta > 0 && !quantity && !personalized && card.querySelector('[data-clean-addon-fields]')) {
              if (await this.personalize(card)) return;
            }
            this.selections.set(this.customizationKey(card), {
              variantId: Number(card.dataset.cleanAddonVariant),
              quantity: requested ?? this.nextQuantity(card, delta),
              properties: this.properties(card),
            });
            this.selectionRevision = (this.selectionRevision || 0) + 1;
            this.sync();
            this.queueFlush(true);
            if (!this.customizer.open)
              card
                .querySelector(this.count(card) ? (requested === null ? '.clean-addon-quantity button' : '[data-clean-addon-quantity]') : '.clean-addon-add')
                ?.focus({ preventScroll: true });
            return true;
          }
          const restoreFocus = card.contains(document.activeElement);
          this.status();
          this.querySelectorAll('[data-clean-addon-delta], [data-clean-addon-quantity]').forEach((button) => {
            button.disabled = true;
          });
          try {
            // A failed/ambiguous write is read back before any new write is admitted.
            if (this.cart.uncertain) {
              await this.cart.refresh();
              this.sync();
              this.status(
                this.cart.uncertain
                  ? 'Your cart could not be confirmed. Continue to review it.'
                  : 'Cart checked. Review the quantities before changing them.',
              );
              return;
            }
            const line = this.line(card),
              quantity = this.count(card);
            if (delta < 0 && !quantity) return;
            if (delta > 0 && !quantity && !personalized && card.querySelector('[data-clean-addon-fields]')) {
              if (await this.personalize(card)) return;
            }
            const ok = await this.cart.mutate(
              quantity > 0 ? 'change' : 'add',
              quantity > 0
                ? { id: line.key, quantity: line.quantity - quantity + (requested ?? this.nextQuantity(card, delta)) }
                : {
                    items: [
                      { id: Number(card.dataset.cleanAddonVariant), quantity: this.nextQuantity(card, delta), properties: this.properties(card) },
                    ],
                  },
            );
            if (!ok)
              this.status(
                this.cart.message.textContent || 'Your change could not be confirmed. Continue to review your cart.',
              );
            this.sync();
            return ok;
          } finally {
            this.querySelectorAll('[data-clean-addon-delta], [data-clean-addon-quantity]').forEach((button) => {
              button.disabled = false;
            });
            if (restoreFocus && !this.finishing && !this.customizer.open)
              card
                .querySelector(this.count(card) ? (requested === null ? '.clean-addon-quantity button' : '[data-clean-addon-quantity]') : '.clean-addon-add')
                .focus({ preventScroll: true });
          }
        }
        queueFlush(retry = false) {
          if (!this.selectionMode || !this.parentReady || this.finishing) return;
          clearTimeout(this.queueTimer);
          this.queueTimer = setTimeout(() => this.flushSelections(retry), 0);
        }
        flushSelections(retry = false) {
          if (this.flushPromise) return this.flushPromise;
          if (!this.parentReady || !this.groupId || (this.queueBlocked && !retry)) return Promise.resolve(false);
          this.queueBlocked = false;
          this.flushPromise = Promise.resolve().then(async () => {
            try {
              if (this.cart.uncertain) await this.cart.refresh();
              if (this.cart.uncertain || this.cart.busy)
                throw new Error('Your cart could not be confirmed. Continue to check it again.');
              const attempted = new Set();
              while (this.parentReady && this.isConnected) {
                const desired = [...this.selections.values()].map((entry) => ({
                  ...entry,
                  properties: { ...entry.properties, '_Clean add-on group': this.groupId },
                }));
                const matches = (line, entry) =>
                  Number(line.variant_id || line.id) === entry.variantId &&
                  !line.selling_plan_allocation &&
                  Object.entries(entry.properties).every(([key, value]) => (line.properties?.[key] ?? '') === value);
                const updates = {},
                  additions = [];
                for (const line of this.cart.lines || []) {
                  if (
                    line.properties?.['_Clean add-on group'] !== this.groupId ||
                    line.properties?.['_Add-on upsell'] !== 'Yes'
                  )
                    continue;
                  const entry = desired.find((entry) => matches(line, entry));
                  const quantity = entry?.quantity || 0;
                  if (quantity !== line.quantity) updates[line.key] = quantity;
                }
                for (const entry of desired) {
                  if (entry.quantity && !this.cart.lines?.some((line) => matches(line, entry)))
                    additions.push({ id: entry.variantId, quantity: entry.quantity, properties: entry.properties });
                }
                if (!Object.keys(updates).length && !additions.length) {
                  this.status();
                  return true;
                }
                if (
                  !this.cart.lines?.some(
                    (line) =>
                      line.properties?.['_Clean add-on group'] === this.groupId &&
                      line.properties?.['_Add-on upsell'] !== 'Yes',
                  )
                )
                  throw new Error('Your main gift could not be confirmed. Review your cart before adding extras.');
                const mismatch = JSON.stringify({
                  revision: this.selectionRevision,
                  desired,
                  actual: (this.cart.lines || []).map((line) => [this.identity(line), line.quantity]),
                });
                // An unchanged acknowledgement must never replay a confirmed add.
                if (attempted.has(mismatch))
                  throw new Error('Your add-ons could not be confirmed. Continue to check your cart.');
                attempted.add(mismatch);
                const updating = Object.keys(updates).length > 0;
                const ok = updating
                  ? await this.cart.mutate('update', { updates })
                  : await this.cart.mutate('add', { items: additions });
                if (!ok)
                  throw new Error(
                    this.cart.message.textContent ||
                      'Your add-ons could not be confirmed. Continue to check your cart.',
                  );
                if (
                  !updating &&
                  additions.some(
                    (entry) =>
                      !this.cart.lines?.some((line) =>
                        matches(line, { variantId: entry.id, properties: entry.properties }),
                      ),
                  )
                )
                  throw new Error('Your add-ons could not be confirmed. Continue to check your cart.');
                // Re-read desired quantities after each response; edits remain usable.
              }
              return false;
            } catch (error) {
              this.queueBlocked = true;
              // A batch may have partially applied even when its response failed.
              // Explicit retry always reads the cart before computing a new diff.
              this.cart.uncertain = true;
              this.cart.lastRead = 0;
              this.status(error.message);
              return false;
            } finally {
              this.flushPromise = null;
              this.sync();
            }
          });
          return this.flushPromise;
        }
        async finish() {
          if ((this.purchasing && !this.selectionMode) || this.finishing || this.customizer.open) return;
          this.finishing = true;
          if (this.selectionMode) {
            this.purchaseControls(!!this.purchasing);
            this.status(this.purchasing ? 'Finishing your gift…' : 'Saving your add-ons…');
            const ready = this.parentReady || (await this.purchaseReady);
            if (ready) this.status('Saving your add-ons…');
            // Let a local personalization submit release its own operation first.
            await this.operation;
            const ok = ready && (await this.flushSelections(true));
            if (!ok) {
              this.finishing = false;
              this.purchaseControls(!!this.purchasing);
              return;
            }
          }
          this.footer.disabled = true;
          this.status('Preparing your cart…');
          await this.operation;
          if (this.cart.uncertain) await this.cart.refresh();
          this.sync();
          if (this.total && !this.cart.uncertain)
            await this.cart.mutate('update', {
              attributes: { '_Add-on drawer used': `Yes (${this.total} item${this.total === 1 ? '' : 's'})` },
            });
          if (this.motion() !== 'instant') {
            await this.dialog.animate(
              [
                { transform: 'translate(0)' },
                { transform: innerWidth < 750 ? 'translateY(100%)' : 'translateX(100%)' },
              ],
              { duration: 360, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' },
            ).finished;
          }
          // Show the confirmed cart before removing this top-layer dialog. No empty frame.
          const uncertain = this.cart.uncertain;
          if (this.cart.pendingHTML) {
            this.cart.render(this.cart.pendingHTML);
            this.cart.pendingHTML = null;
          }
          this.cart.uncertain = uncertain;
          await this.cart.open({ current: true });
          this.dialog.close();
          this.dialog.getAnimations().forEach((animation) => animation.cancel());
          this.cart.querySelector('[data-clean-cart-close]')?.focus({ preventScroll: true });
          this.finishing = false;
          this.footer.disabled = false;
        }
      },
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-product-cart"]) return;
  try {
    
  (() => {
    if (customElements.get('clean-product-cart')) return;
    class CleanProductCart extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.lifecycle = new AbortController();
        this.dialog = this.querySelector('[data-clean-cart-dialog]');
        if (!this.dialog) return;
        this.content = this.querySelector('[data-clean-cart-content]');
        this.message = this.querySelector('[data-clean-cart-message]');
        this.loading = this.querySelector('[data-clean-cart-loading]');
        this.recovery = this.querySelector('[data-clean-cart-recovery]');
        this.section = this.dataset.cleanCartSection;
        this.cartURL = new URL(this.dataset.cleanCartUrl, location.origin);
        this.lastRead = 0;
        const listen = (target, name, callback) =>
          target?.addEventListener(name, callback, { signal: this.lifecycle.signal });
        const header = document.querySelector('[data-clean-header]');
        listen(header, 'click', (event) => {
          const trigger = event.target.closest('[data-clean-header-cart]');
          if (
            !trigger ||
            event.defaultPrevented ||
            event.button !== 0 ||
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
          )
            return;
          event.preventDefault();
          this.trigger = trigger;
          this.open();
        });
        listen(this, 'click', (event) => this.click(event));
        listen(this, 'submit', (event) => this.submit(event));
        listen(this, 'keydown', (event) => {
          if (event.key !== 'Tab' || !this.dialog.open) return;
          const modal = this.sheet || this.dialog;
          const controls = [
            ...modal.querySelectorAll(
              'a[href], button:not(:disabled), input:not(:disabled), textarea:not(:disabled), summary, [tabindex="0"]',
            ),
          ].filter((element) => element.getClientRects().length && element.type !== 'hidden');
          const first = controls[0],
            last = controls.at(-1);
          if (!first) {
            event.preventDefault();
            modal.focus();
            return;
          }
          if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
            event.preventDefault();
            first.focus();
          }
        });
        this.addEventListener(
          'cancel',
          (event) => {
            if (event.target === this.dialog || event.target.matches('[data-clean-cart-sheet]')) {
              event.preventDefault();
              event.target === this.dialog ? this.close() : this.closeSheet();
            }
          },
          { capture: true, signal: this.lifecycle.signal },
        );
        listen(this, 'change', (event) => {
          if (event.target.matches('[data-clean-cart-quantity]')) this.quantity(event.target);
        });
        listen(this.dialog, 'click', (event) => {
          const bounds = this.dialog.getBoundingClientRect();
          if (
            event.target === this.dialog &&
            (event.clientX < bounds.left ||
              event.clientX > bounds.right ||
              event.clientY < bounds.top ||
              event.clientY > bounds.bottom)
          )
            this.close();
        });
        listen(window, 'pageshow', (event) => {
          if (event.persisted) this.lastRead = 0;
        });
        listen(document, 'visibilitychange', () => {
          if (!document.hidden && this.dialog.open && !this.busy && !this.sheet) this.refresh();
        });
        listen(document, 'clean:cart:updated', (event) => {
          if (event.detail?.origin !== 'clean-product-cart') {
            this.lastRead = 0;
            if (document.querySelector('clean-product-addons')?.dialog.open) this.uncertain = true;
          }
        });
        listen(document, 'clean:visitor-country-detected', (event) => {
          this.visitorCountry = event.detail?.country;
          this.syncCheckout();
        });
        listen(document, 'gokwikLoaded', () => this.syncCheckout());
        listen(window, 'gokwikLoaded', () => this.syncCheckout());
        this.dialog.addEventListener('close', () => this.releaseViewport(), { signal: this.lifecycle.signal });
      }
      disconnectedCallback() {
        this.readController?.abort();
        this.lifecycle?.abort();
        this.releaseViewport();
        clearTimeout(this.closeTimer);
        this.dialog?.close();
        document.body.classList.remove('clean-pcart-open');
        this.lifecycle = null;
        this.deliveryDates = null;
      }
      status(text = '') {
        this.message.textContent = text;
        this.message.hidden = !text;
      }
      async addProductForm(form, { showPending = false } = {}) {
        if (this.busy || this.uncertain) {
          return { ok: false, uncertain: this.uncertain, message: 'Refresh your cart before adding another item.' };
        }
        const addons = document.querySelector('clean-product-addons');
        addons?.load();
        this.deferPresentation = !!addons;
        this.trigger = form.querySelector('[data-clean-customize]') || form.querySelector('[name="add"]');
        this.busy = true;
        // Do not let an older header-cart read overwrite the purchase response.
        this.readController?.abort();
        await this.readPromise;
        if (showPending) addons?.pending();
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        let accepted = false;
        try {
          const body = new FormData(form);
          body.delete('return_to');
          if (body.get('properties[Delivery Date]'))
            body.set('properties[_Clean delivery date anchor]', new Intl.DateTimeFormat('en-CA', {
              timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit',
            }).format(new Date()));
          const addonGroup = addons ? crypto.randomUUID() : '';
          if (addonGroup) body.set('properties[_Clean add-on group]', addonGroup);
          body.set('sections', this.section);
          body.set('sections_url', this.cartURL.pathname);
          const response = await fetch(`${this.cartURL.pathname}/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body,
            signal: controller.signal,
          });
          accepted = response.ok;
          const result = await response.json();
          if (response.status >= 500 || response.status === 408) throw new TypeError('The add could not be confirmed.');
          if (!response.ok) {
            addons?.cancelPending();
            return { ok: false, message: result.description || result.message || 'This item could not be added.' };
          }
          window['clean-commerce']?.added(result, [{ id: body.get('id'), quantity: body.get('quantity') || 1 }], 'clean-product-cart');
          this.uncertain = true;
          if (typeof result.sections?.[this.section] === 'string') {
            try {
              this.receive(result.sections[this.section]);
            } catch {
              this.lastRead = 0;
            }
          }
          this.busy = false;
          // A confirmed write is never repeated because section rendering failed.
          if (this.uncertain) await this.refresh();
          if (addons) {
            addons.groupId = addonGroup;
            await addons.open();
          } else await this.open({ current: true });
          return { ok: true };
        } catch (error) {
          this.uncertain =
            accepted || error instanceof TypeError || error.name === 'AbortError' || error instanceof SyntaxError;
          if (this.uncertain) {
            this.lastRead = 0;
            this.busy = false;
            await this.refresh();
            const unresolved = this.uncertain;
            if (this.pendingHTML) {
              this.render(this.pendingHTML);
              this.pendingHTML = null;
            }
            this.uncertain = unresolved;
            await this.open({ current: true });
            addons?.cancelPending();
          }
          // This attempt remains locked even if the read succeeds: an interrupted
          // product add cannot safely be replayed without reviewing its contents.
          return {
            ok: false,
            uncertain: true,
            message: 'The add may have succeeded. Review your cart before trying again.',
          };
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.deferPresentation = false;
          addons?.cancelPending();
        }
      }
      receive(html) {
        const addons = document.querySelector('clean-product-addons');
        if (!this.deferPresentation && !addons?.dialog.open) return this.render(html);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const snapshot = doc.querySelector('[data-clean-cart-snapshot]');
        const cart = JSON.parse(snapshot?.querySelector('[data-clean-cart-state]')?.textContent || 'null');
        if (!Array.isArray(cart?.items)) throw new Error('Your cart could not load.');
        window.CleanBulkDiscounts?.adopt(doc);
        this.lines = cart.items;
        this.pendingHTML = html;
        this.lastRead = Date.now();
        this.uncertain = false;
        this.recovery.hidden = true;
        document.dispatchEvent(
          new CustomEvent('clean:cart:updated', {
            detail: { origin: 'clean-product-cart', cart, item_count: Number(snapshot.dataset.cleanCartCount) },
          }),
        );
      }
      async open({ current = false } = {}) {
        const opening = !this.dialog.open;
        clearTimeout(this.closeTimer);
        this.dialog.classList.remove('clean-pcart-closing');
        if (!this.dialog.open) this.dialog.showModal();
        document.body.classList.add('clean-pcart-open');
        if (!this.content.firstElementChild) this.loading.hidden = !!this.uncertain;
        if (this.uncertain) {
          this.status('Refresh your cart to confirm its current contents before checkout.');
          this.recovery.hidden = false;
        }
        if (!this.busy && !current && Date.now() - this.lastRead > 2000) await this.refresh();
        await this.refreshDeliveryDates();
        if (opening && this.dialog.open && !this.uncertain && Array.isArray(this.lines))
          window['clean-commerce']?.viewCart({ items: this.lines }, 'clean-product-cart');
        if (this.dialog.open && !this.sheet)
          this.querySelector('[data-clean-cart-close]')?.focus({ preventScroll: true });
      }
      close(restoreFocus = true, immediate = false) {
        if (this.sheet) {
          this.closeSheet();
          return;
        }
        this.readController?.abort();
        this.dialog.classList.add('clean-pcart-closing');
        const finish = () => {
          this.dialog.close();
          this.dialog.classList.remove('clean-pcart-closing');
          document.body.classList.remove('clean-pcart-open');
          if (restoreFocus) this.trigger?.focus({ preventScroll: true });
        };
        clearTimeout(this.closeTimer);
        if (immediate || matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
        else this.closeTimer = setTimeout(finish, 170);
      }
      async refresh() {
        if (this.readPromise) {
          if (!this.readController?.signal.aborted) return this.readPromise;
          await this.readPromise;
        }
        this.readController = new AbortController();
        const signal = this.readController.signal;
        const timeout = setTimeout(() => this.readController?.abort(), 15000);
        const url = new URL(this.cartURL);
        url.searchParams.set('section_id', this.section);
        this.status();
        this.recovery.hidden = true;
        this.readPromise = (async () => {
          try {
            const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
            if (!response.ok) throw new Error('Your cart could not load. Please try again.');
            const html = await response.text();
            if (!signal.aborted && this.isConnected) this.receive(html);
          } catch (error) {
            if (
              this.deferPresentation ||
              document.querySelector('clean-product-addons')?.dialog.open ||
              (this.dialog.open && !this.dialog.classList.contains('clean-pcart-closing'))
            ) {
              this.status(
                error.name === 'AbortError' ? 'Your cart took too long to load. Please try again.' : error.message,
              );
              this.recovery.hidden = false;
            }
          } finally {
            clearTimeout(timeout);
            this.loading.hidden = true;
            this.readPromise = null;
          }
        })();
        return this.readPromise;
      }
      render(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const next = parsed.querySelector('[data-clean-cart-snapshot]');
        if (!next) throw new Error('Your cart could not load. Use View cart or try again.');
        const cart = JSON.parse(next.querySelector('[data-clean-cart-state]').textContent);
        if (!Array.isArray(cart.items)) throw new Error('Your cart could not load.');
        window.CleanBulkDiscounts?.adopt(parsed);
        this.lines = cart.items;
        // This one vendor-required global is already an audited layout boundary.
        if (this.dataset.cleanCartGokwik === 'true') window.cart = cart;
        const old = this.content.firstElementChild;
        const active = document.activeElement;
        const activeKey = active?.closest('[data-clean-cart-line]')?.dataset.cleanCartLine;
        const activeQuantity = active?.matches('[data-clean-cart-quantity]');
        const activeTool = active?.dataset.cleanCartTool;
        const activeWasInside = this.content.contains(active);
        const summaryOpen =
          old?.querySelector('[data-clean-cart-summary-toggle]')?.getAttribute('aria-expanded') === 'true';
        if (old) {
          const oldItems = old.querySelector('[data-clean-cart-items]');
          const newItems = next.querySelector('[data-clean-cart-items]');
          if (oldItems && newItems && old.dataset.cleanCartCount !== '0' && next.dataset.cleanCartCount !== '0') {
            this.patchItems(oldItems, newItems);
            newItems.replaceWith(oldItems);
          }
        }
        this.content.replaceChildren(next);
        this.content.hidden = false;
        if (summaryOpen) this.toggleSummary(true);
        if (activeKey) {
          const row = [...this.querySelectorAll('[data-clean-cart-line]')].find(
            (row) => row.dataset.cleanCartLine === activeKey,
          );
          (
            row?.querySelector(activeQuantity ? '[data-clean-cart-quantity]' : 'button') ||
            this.querySelector('[data-clean-cart-close]')
          )?.focus({ preventScroll: true });
        } else if (activeWasInside && this.dialog.open) {
          const tool = [...this.querySelectorAll('[data-clean-cart-tool]')].find(
            (button) => button.dataset.cleanCartTool === activeTool,
          );
          (tool || this.querySelector('[data-clean-cart-close]'))?.focus({ preventScroll: true });
        }
        this.lastRead = Date.now();
        this.uncertain = false;
        this.loading.hidden = true;
        this.recovery.hidden = true;
        window.CleanDisplayCurrencyBootstrap?.refresh(next);
        this.syncCheckout();
        queueMicrotask(() => this.refreshDeliveryDates());
        document.dispatchEvent(
          new CustomEvent('clean:cart:updated', {
            detail: { origin: 'clean-product-cart', cart, item_count: Number(next.dataset.cleanCartCount) },
          }),
        );
      }
      patchItems(old, next) {
        const key = (node) =>
          node.dataset.cleanCartLine ||
          node.dataset.cleanCartGroup ||
          (node.matches('[data-clean-cart-addons]') ? 'addons' : 'empty');
        const saved = new Map([...old.children].map((node) => [key(node), node]));
        const result = [];
        for (const fresh of [...next.children]) {
          const prior = saved.get(key(fresh));
          if (prior && fresh.matches('[data-clean-cart-addons]')) {
            this.patchItems(prior.lastElementChild, fresh.lastElementChild);
            fresh.lastElementChild.replaceWith(prior.lastElementChild);
            fresh.open = prior.open;
          }
          // Reuse unchanged lines and their image nodes. Only changed lines reflow.
          result.push(prior?.outerHTML === fresh.outerHTML ? prior : fresh);
        }
        const top = old.scrollTop;
        old.replaceChildren(...result);
        old.scrollTop = top;
      }
      toggleSummary(open) {
        const toggle = this.querySelector('[data-clean-cart-summary-toggle]');
        const summary = this.querySelector('[data-clean-cart-summary]');
        if (!toggle || !summary) return;
        const visible = open ?? summary.hidden;
        summary.hidden = !visible;
        toggle.setAttribute('aria-expanded', String(visible));
      }
      openSheet(name) {
        const sheet = [...this.querySelectorAll('[data-clean-cart-sheet]')].find(
          (element) => element.dataset.cleanCartSheet === name,
        );
        if (!sheet || this.busy) return;
        this.sheet = sheet;
        this.sheetTrigger = document.activeElement;
        this.sheetTrigger?.setAttribute('aria-expanded', 'true');
        sheet.showModal();
        this.viewportLifecycle = new AbortController();
        const schedule = () => {
          if (this.viewportFrame) return;
          this.viewportFrame = requestAnimationFrame(() => {
            this.viewportFrame = 0;
            if (!this.sheet) return;
            const viewport = window.visualViewport;
            const height = viewport?.height || innerHeight;
            this.sheet.style.setProperty('--clean-cart-visible', `${Math.max(0, height - 16)}px`);
            this.sheet.style.setProperty(
              '--clean-cart-keyboard',
              `${Math.max(0, innerHeight - height - (viewport?.offsetTop || 0))}px`,
            );
            if (this.sheet.contains(document.activeElement))
              document.activeElement.scrollIntoView({ block: 'nearest' });
          });
        };
        for (const [target, events] of [
          [window, ['resize']],
          [window.visualViewport, ['resize', 'scroll']],
          [sheet, ['focusin']],
        ]) {
          events.forEach((event) =>
            target?.addEventListener(event, schedule, { signal: this.viewportLifecycle.signal }),
          );
        }
        schedule();
      }
      releaseViewport() {
        this.viewportLifecycle?.abort();
        cancelAnimationFrame(this.viewportFrame);
        this.viewportFrame = 0;
        this.sheet?.style.removeProperty('--clean-cart-visible');
        this.sheet?.style.removeProperty('--clean-cart-keyboard');
      }
      closeSheet() {
        if (!this.sheet) return;
        this.releaseViewport();
        this.sheet.close();
        if (this.sheet.dataset.cleanCartSheet === 'preview') this.sheet.remove();
        this.sheet = null;
        this.sheetTrigger?.setAttribute('aria-expanded', 'false');
        this.sheetTrigger?.focus({ preventScroll: true });
      }
      async mutate(endpoint, payload, row) {
        if (this.busy || document.querySelector('clean-product-addons')?.purchasing) return false;
        if (this.uncertain) {
          this.status('Refresh your cart before making another change.');
          this.recovery.hidden = false;
          return false;
        }
        if (endpoint === 'change' && Number(payload.quantity) === 0) {
          const parent = this.lines?.find((line) => line.key === payload.id);
          const group = String(parent?.properties?.['_Clean add-on group'] || '').trim();
          if (group && parent?.properties?.['_Add-on upsell'] !== 'Yes') {
            const updates = Object.fromEntries(
              this.lines
                .filter(
                  (line) =>
                    line.key === payload.id ||
                    (line.properties?.['_Clean add-on group'] === group &&
                      line.properties?.['_Add-on upsell'] === 'Yes'),
                )
                .map((line) => [line.key, 0]),
            );
            endpoint = 'update';
            payload = { updates };
          }
        }
        this.busy = true;
        this.status();
        this.readController?.abort();
        await this.readPromise;
        row?.setAttribute('aria-busy', 'true');
        this.querySelector('[data-clean-cart-checkout]')?.setAttribute('aria-disabled', 'true');
        const controls = [
          ...this.querySelectorAll('button:not([data-clean-cart-close]):not([data-clean-cart-sheet-close]), input'),
        ];
        const focusBefore = document.activeElement;
        const disabled = controls.map((control) => control.disabled);
        const restoreControls = () =>
          controls.forEach((control, index) => {
            control.disabled = disabled[index];
          });
        controls.forEach((control) => {
          control.disabled = true;
        });
        let accepted = false;
        const mutationController = new AbortController();
        const mutationTimeout = setTimeout(() => mutationController.abort(), 20000);
        const commerce = window['clean-commerce'];
        const before = commerce?.snapshot({ items: this.lines });
        const affected = (this.lines || []).filter(line => endpoint === 'change'
          ? line.key === payload.id : Object.hasOwn(payload.updates || {}, line.key)).map(line => line.variant_id || line.id);
        try {
          const response = await fetch(`${this.cartURL.pathname}/${endpoint}.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            signal: mutationController.signal,
            body: JSON.stringify({ ...payload, sections: [this.section], sections_url: this.cartURL.pathname }),
          });
          accepted = response.ok;
          const data = await response.json();
          if (response.status >= 500 || response.status === 408)
            throw new TypeError('The change could not be confirmed.');
          if (!response.ok) throw new Error(data.description || data.message || 'Your cart could not be updated.');
          if (endpoint === 'add') commerce?.added(data, payload.items || [{ id: payload.id, quantity: payload.quantity || 1 }], 'clean-product-cart');
          else commerce?.changed(before, data, 'clean-product-cart', undefined, affected);
          accepted = true;
          this.uncertain = true;
          restoreControls();
          if (!this.sheet && this.dialog.open && focusBefore?.isConnected) focusBefore.focus({ preventScroll: true });
          this.closeSheet();
          if (!this.isConnected) return true;
          row?.removeAttribute('aria-busy');
          if (typeof data.sections?.[this.section] === 'string') this.receive(data.sections[this.section]);
          else {
            this.lastRead = 0;
            await this.refresh();
          }
          return !this.uncertain;
        } catch (error) {
          if (!this.isConnected) return accepted;
          this.uncertain =
            accepted || error instanceof TypeError || error.name === 'AbortError' || error instanceof SyntaxError;
          const message = accepted
            ? 'Your change was saved, but the cart could not refresh. Use View cart to check it.'
            : error instanceof TypeError || error.name === 'AbortError'
              ? 'The connection was interrupted. Refresh your cart before trying again.'
              : error.message;
          const target = this.sheet?.querySelector('[data-clean-cart-sheet-error]');
          if (target) {
            target.textContent = message;
            target.hidden = false;
          } else this.status(message);
          if (row?.hasAttribute('data-clean-cart-line')) {
            const input = row.querySelector('[data-clean-cart-quantity]');
            const line = this.lines.find((line) => line.key === row.dataset.cleanCartLine);
            if (input && line) input.value = String(line.quantity);
          }
          this.recovery.hidden = false;
          this.lastRead = 0;
          return false;
        } finally {
          clearTimeout(mutationTimeout);
          this.busy = false;
          row?.removeAttribute('aria-busy');
          restoreControls();
          this.querySelector('[data-clean-cart-checkout]')?.setAttribute('aria-disabled', String(!!this.uncertain));
        }
      }
      quantity(input) {
        if (this.busy) return;
        const minimum = Number(input.min || 0);
        if (minimum > 0 && (!Number.isFinite(input.valueAsNumber) || input.valueAsNumber < minimum))
          input.value = String(minimum);
        if (!input.checkValidity() || !Number.isSafeInteger(input.valueAsNumber)) {
          input.reportValidity();
          return;
        }
        const row = input.closest('[data-clean-cart-line], [data-clean-cart-group]');
        if (!row) return;
        if (input.valueAsNumber === Number(input.defaultValue)) return;
        if (row.hasAttribute('data-clean-cart-group')) {
          const groupLines = [...row.querySelectorAll('[data-clean-cart-group-key]')];
          const previous = Number(input.defaultValue);
          const updates = Object.fromEntries(
            groupLines.map((line) => [
              line.dataset.cleanCartGroupKey,
              Math.max(1, Math.round((Number(line.dataset.cleanCartGroupQuantity) * input.valueAsNumber) / previous)),
            ]),
          );
          this.mutate('update', { updates }, row);
        } else this.mutate('change', { id: row.dataset.cleanCartLine, quantity: input.valueAsNumber }, row);
      }
      click(event) {
        const target = event.target.closest('button, a');
        if (!target) return;
        if (target.hasAttribute('data-clean-cart-close')) {
          this.close();
          return;
        }
        if (target.hasAttribute('data-clean-cart-sheet-close')) {
          this.closeSheet();
          return;
        }
        if (this.busy) {
          event.preventDefault();
          return;
        }
        if (target.hasAttribute('data-clean-cart-retry')) {
          this.refresh();
          return;
        }
        if (target.hasAttribute('data-clean-cart-tool')) this.openSheet(target.dataset.cleanCartTool);
        if (target.hasAttribute('data-clean-cart-summary-toggle')) this.toggleSummary();
        const row = target.closest('[data-clean-cart-line], [data-clean-cart-group]');
        if (target.hasAttribute('data-clean-cart-step')) {
          const input = row?.querySelector('[data-clean-cart-quantity]');
          if (input) {
            Number(target.dataset.cleanCartStep) > 0 ? input.stepUp() : input.stepDown();
            this.quantity(input);
          }
        }
        if (target.hasAttribute('data-clean-cart-remove'))
          this.mutate('change', { id: row.dataset.cleanCartLine, quantity: 0 }, row);
        if (target.hasAttribute('data-clean-cart-group-remove'))
          this.mutate(
            'update',
            {
              updates: Object.fromEntries(
                [...row.querySelectorAll('[data-clean-cart-group-key]')].map((line) => [
                  line.dataset.cleanCartGroupKey,
                  0,
                ]),
              ),
            },
            row,
          );
        if (target.hasAttribute('data-clean-cart-group-details')) {
          const lines = row.querySelector('[data-clean-cart-group-lines]');
          lines.hidden = !lines.hidden;
          target.setAttribute('aria-expanded', String(!lines.hidden));
        }
        if (target.hasAttribute('data-clean-cart-name-edit') || target.hasAttribute('data-clean-cart-name-cancel')) {
          const form = row.querySelector('[data-clean-cart-name-form]');
          form.hidden = target.hasAttribute('data-clean-cart-name-cancel');
          row.querySelector('[data-clean-cart-name-view]').hidden = !form.hidden;
          if (!form.hidden) form.elements.cake.focus();
        }
        if (target.hasAttribute('data-clean-cart-preview')) this.preview(target);
        if (
          target.hasAttribute('data-clean-cart-checkout') &&
          !event.ctrlKey &&
          !event.metaKey &&
          !event.shiftKey &&
          !event.altKey
        ) {
          event.preventDefault();
          this.checkout(target);
        }
      }
      submit(event) {
        const form = event.target;
        if (!form.matches('[data-clean-cart-tool-form], [data-clean-cart-name-form]')) return;
        event.preventDefault();
        if (this.busy) return;
        const values = Object.fromEntries(new FormData(form));
        if (form.hasAttribute('data-clean-cart-name-form')) {
          const row = form.closest('[data-clean-cart-line]');
          const line = this.lines.find((line) => line.key === row.dataset.cleanCartLine);
          if (line)
            this.mutate(
              'change',
              {
                id: line.key,
                quantity: line.quantity,
                properties: { ...line.properties, 'Name On Cake': values.cake },
              },
              row,
            );
        } else {
          const tool = form.dataset.cleanCartToolForm;
          if (tool === 'gift') {
            const id = Number(this.content.firstElementChild.dataset.cleanCartGiftId);
            if (id > 0)
              this.mutate('add', {
                items: [{ id, quantity: 1, properties: { '_Hadiyah delivery exempt': 'Gift Wrap' } }],
              });
          } else this.mutate('update', tool === 'note' ? { note: values.note } : { attributes: values });
        }
      }
      preview(trigger) {
        const urls = (trigger.dataset.cleanCartPreview.match(/https?:\/\/[^\s,|]+/g) || []).filter((value) => {
          try {
            return new URL(value).protocol === 'https:';
          } catch {
            return false;
          }
        });
        if (!urls.length) {
          this.status('The preview is unavailable.');
          return;
        }
        const sheet = document.createElement('dialog');
        sheet.className = 'clean-pcart-preview';
        sheet.dataset.cleanCartSheet = 'preview';
        sheet.setAttribute('aria-label', 'Customization preview');
        const row = trigger.closest('[data-clean-cart-line]');
        const line = this.lines.find((item) => item.key === row?.dataset.cleanCartLine);
        // Static UI only; product data is assigned through textContent and URL.
        sheet.innerHTML = `<header><span class="clean-pcart-preview-gift" aria-hidden="true"></span><div><h2></h2><p>✦ Customization Preview ✦</p></div><button type="button" class="clean-pcart-preview-close" data-clean-cart-sheet-close aria-label="Close preview">×</button></header><div class="clean-pcart-preview-body"><div class="clean-pcart-preview-carousel"><button type="button" aria-label="Previous preview">✦</button><div class="clean-pcart-preview-frame"></div><button type="button" aria-label="Next preview">✦</button></div><div class="clean-pcart-preview-dots"></div></div><footer><a>Edit Customization</a></footer>`;
        const gift = this.querySelector('[data-clean-cart-tool="gift"] svg');
        if (gift) sheet.querySelector('.clean-pcart-preview-gift').append(gift.cloneNode(true));
        sheet.querySelector('h2').textContent = line?.product_title || line?.title || 'Customization preview';
        const edit = sheet.querySelector('footer a');
        const product = row?.querySelector('.clean-pcart-name');
        if (product) {
          const url = new URL(product.href);
          url.searchParams.set('line_item_key', line.key);
          url.searchParams.set('edit_customization', '1');
          edit.href = url.href;
        } else edit.parentElement.hidden = true;
        const frame = sheet.querySelector('.clean-pcart-preview-frame');
        const dots = sheet.querySelector('.clean-pcart-preview-dots');
        let selected = 0;
        const show = (index) => {
          selected = (index + urls.length) % urls.length;
          const image = new Image();
          image.src = urls[selected];
          image.alt = `Customization preview ${selected + 1}`;
          image.decoding = 'async';
          image.referrerPolicy = 'no-referrer';
          frame.replaceChildren(image);
          [...dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === selected)));
        };
        urls.forEach((url, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Show preview ${index + 1}`);
          dot.addEventListener('click', () => show(index));
          dots.append(dot);
        });
        dots.hidden = urls.length < 2;
        const arrows = sheet.querySelectorAll('.clean-pcart-preview-carousel > button');
        arrows[0].addEventListener('click', () => show(selected - 1));
        arrows[1].addEventListener('click', () => show(selected + 1));
        show(0);
        this.dialog.append(sheet);
        this.openSheet('preview');
      }
      visitor() {
        let country = this.visitorCountry || '';
        try {
          country ||=
            sessionStorage.getItem('clean:delivery-country-detected:v1') ||
            sessionStorage.getItem('hadiyah:visitor-country-code') ||
            '';
        } catch {}
        country = String(country).trim().toUpperCase();
        return /^[A-Z]{2}$/.test(country) ? country : '';
      }
      async confirmVisitorCountry() {
        if (this.visitor()) return;
        const lifecycle = this.lifecycle.signal;
        try {
          // Recover only a missing header signal; never infer visitor location
          // from the delivery country or replace a known international signal.
          const url = new URL('browsing_context_suggestions.json', this.cartURL);
          url.searchParams.set('country[enabled]', 'true');
          const response = await fetch(url, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: AbortSignal.any([lifecycle, AbortSignal.timeout(4000)]),
          });
          if (!response.ok) return;
          const data = await response.json();
          const detected = data?.detected_values;
          const country = String(
            detected?.country?.handle || detected?.country?.iso_code || detected?.country_code || '',
          )
            .trim()
            .toUpperCase();
          if (!/^[A-Z]{2}$/.test(country) || this.visitor() || lifecycle.aborted || !this.isConnected) return;
          this.visitorCountry = country;
          try {
            sessionStorage.setItem('clean:delivery-country-detected:v1', country);
            sessionStorage.setItem('hadiyah:visitor-country-code', country);
          } catch {}
          document.dispatchEvent(new CustomEvent('clean:visitor-country-detected', { detail: { country } }));
        } catch {
          // An unconfirmed location retains Shopify checkout.
        }
      }
      syncCheckout() {
        const link = this.querySelector('[data-clean-cart-checkout]');
        if (!link) return;
        // Attribution SDK is already owned by the Clean layout. No script loader,
        // legacy router or readiness polling is installed here.
        const domestic = this.content.firstElementChild.dataset.cleanCartCountry === 'IN' && this.visitor() === 'IN';
        link.dataset.cleanCartUseGokwik = String(
          this.dataset.cleanCartGokwik === 'true' && domestic && typeof window.onCheckoutClick === 'function',
        );
        const label = this.querySelector('[data-clean-cart-payment-label]');
        if (link.dataset.cleanCartUseGokwik === 'true' && label && !link.classList.contains('clean-pcart-payment')) {
          link.replaceChildren(label.content.cloneNode(true));
          link.classList.add('clean-pcart-payment');
        }
      }
      async refreshDeliveryDates(checkout = false) {
        if (!this.isConnected || !this.lifecycle || this.lifecycle.signal.aborted) return false;
        if (!this.lines?.some((line) => line.properties?.['Delivery Date'])) return true;
        const lifecycle = this.lifecycle;
        try {
          this.deliveryModule ||= import(this.dataset.cleanCartDeliveryModule).catch((error) => {
            this.deliveryModule = null;
            throw error;
          });
          const { cleanCreateDeliveryDates } = await this.deliveryModule;
          if (lifecycle !== this.lifecycle || lifecycle.signal.aborted) return false;
          this.deliveryDates ||= cleanCreateDeliveryDates({
            signal: lifecycle.signal,
            snapshot: () => ({
              items: this.lines,
              metadata: JSON.parse(this.querySelector('[data-clean-cart-delivery-dates]')?.textContent || 'null'),
            }),
            ready: (internal) => this.dialog.open && !this.busy && !this.sheet && !this.uncertain &&
              !this.deferPresentation && (!this.checkoutPending || internal) &&
              !document.querySelector('clean-product-addons')?.dialog.open,
            change: (line, properties) => this.mutate('change', { id: line.key, quantity: line.quantity, properties }),
            status: (message) => this.status(message),
          });
          return await this.deliveryDates.refresh({ checkout });
        } catch {
          this.status('Your cart could not be updated. Refresh your cart and try again.');
          return false;
        }
      }
      async checkout(link) {
        // Confirm delivery properties and reconcile fees before checkout.
        const addons = document.querySelector('clean-product-addons');
        if (
          this.checkoutPending ||
          this.busy ||
          this.uncertain ||
          addons?.purchasing ||
          (addons?.selectionMode && addons.dialog.open)
        ) {
          if (this.uncertain) {
            this.status('Refresh your cart before checking out.');
            this.recovery.hidden = false;
          }
          return;
        }
        this.checkoutPending = true;
        window['clean-commerce']?.checkout({ items: this.lines }, 'clean-product-cart');
        try {
          if (!(await this.refreshDeliveryDates(true))) return;
          if (
            this.dataset.cleanCartGokwik === 'true' &&
            this.content.firstElementChild.dataset.cleanCartCountry === 'IN' &&
            !this.visitor()
          ) {
            this.status('Checking checkout options…');
            await this.confirmVisitorCountry();
            this.status();
            if (
              !this.isConnected ||
              this.lifecycle?.signal.aborted ||
              this.busy ||
              this.uncertain ||
              addons?.purchasing ||
              (addons?.selectionMode && addons.dialog.open)
            )
              return;
          }
          const state = this.content.firstElementChild;
          const fees = JSON.parse(state.querySelector('[data-clean-cart-delivery-fees]').textContent);
          const desired = new Map(fees.variantIds.map((id) => [id, 0]));
          fees.requirements.forEach(({ id, quantity }) => desired.set(id, (desired.get(id) || 0) + quantity));
          const updates = {},
            additions = [];
          for (const [id, quantity] of desired) {
            const existing = this.lines.filter((line) => Number(line.variant_id || line.id) === id);
            if (!existing.length && quantity)
              additions.push({
                id,
                quantity,
                properties: { '_Hadiyah delivery charge': id === 51050538893559 ? 'standard' : 'express' },
              });
            existing.forEach((line, index) => {
              if (line.quantity !== (index ? 0 : quantity)) updates[line.key] = index ? 0 : quantity;
            });
          }
          this.lines.forEach((line) => {
            if (
              Number(line.product_id || line.product?.id) === 10059690017015 &&
              !desired.has(Number(line.variant_id || line.id))
            )
              updates[line.key] = 0;
          });
          if (Object.keys(updates).length && !(await this.mutate('update', { updates }))) return;
          if (additions.length && !(await this.mutate('add', { items: additions }))) return;
          this.syncCheckout();
          const current = this.querySelector('[data-clean-cart-checkout]');
          if (current?.dataset.cleanCartUseGokwik === 'true') {
            try {
              window.onCheckoutClick(current);
              this.close(false, true);
              return;
            } catch {
              /* Native checkout remains available. */
            }
          }
          location.assign(link.href);
        } finally {
          this.checkoutPending = false;
        }
      }
    }
    customElements.define('clean-product-cart', CleanProductCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-product-content"]) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('.clean-product-content').forEach((root) => {
        if (root.dataset.cleanReady) return;
        root.dataset.cleanReady = 'true';
        const reviews = root.querySelector('.clean-product-content__reviews');
        if (reviews) {
          let observer;
          const activate = () => {
            reviews.dataset.cleanReviewsActive = 'true';
            observer?.disconnect();
            reviews.removeEventListener('focusin', activate);
            reviews.removeEventListener('pointerover', activate);
          };
          reviews.addEventListener('focusin', activate);
          reviews.addEventListener('pointerover', activate);
          if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) activate();
              },
              { rootMargin: '600px' },
            );
            observer.observe(reviews);
          } else activate();
        }
        const recent = root.querySelector('[data-clean-recent]');
        const recentKey = 'clean:recent-products:v1';
        const productPath = /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?products\/([a-z0-9-]+)$/;
        // Store a bounded canonical DOM description, never executable HTML. Rebuild
        // only allowlisted elements/attributes; storage is not a trusted renderer.
        const encodeCard = (node) => {
          if (node.nodeType === Node.TEXT_NODE) return node.textContent;
          return [
            node.localName,
            Object.fromEntries([...node.attributes].map((a) => [a.name, a.value])),
            [...node.childNodes]
              .filter(
                (child) =>
                  child.nodeType === Node.ELEMENT_NODE ||
                  (child.nodeType === Node.TEXT_NODE && child.textContent.trim()),
              )
              .map(encodeCard),
          ];
        };
        const safeImage = (value) => {
          const url = new URL(value, location.origin);
          return (
            url.protocol === 'https:' &&
            !url.username &&
            !url.password &&
            ((url.origin === location.origin && url.pathname.startsWith('/cdn/shop/')) ||
              (url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/s/files/'))) &&
            Number(url.searchParams.get('width')) > 0 &&
            Number(url.searchParams.get('width')) <= 520
          );
        };
        const decodeCard = (entry) => {
          if (
            !entry ||
            typeof entry.url !== 'string' ||
            !productPath.test(entry.url) ||
            typeof entry.handle !== 'string' ||
            productPath.exec(entry.url)[1] !== entry.handle ||
            JSON.stringify(entry).length > 32000
          )
            throw new Error('Invalid recent card');
          let nodes = 0;
          const attributes = {
            article: [],
            a: ['href'],
            span: [
              'data-clean-money',
              'data-clean-money-minor',
              'data-clean-money-currency',
              'data-clean-money-source-text',
            ],
            div: [],
            h3: [],
            s: [],
            img: ['src', 'srcset', 'sizes', 'width', 'height', 'loading', 'fetchpriority', 'decoding', 'alt'],
            button: [
              'type',
              'aria-label',
              'aria-pressed',
              'data-clean-product-wishlist',
              'data-clean-product-wishlist-handle',
              'data-clean-product-wishlist-title',
            ],
            svg: ['viewBox', 'viewbox', 'fill', 'aria-hidden', 'focusable', 'xmlns'],
            path: ['d', 'fill', 'stroke', 'stroke-linecap', 'stroke-linejoin', 'stroke-width'],
            circle: ['cx', 'cy', 'r', 'fill'],
          };
          const build = (tree, depth = 0) => {
            if (++nodes > 180 || depth > 14) throw new Error('Oversized recent card');
            if (typeof tree === 'string') {
              if (tree.length > 1000) throw new Error('Oversized text');
              return document.createTextNode(tree);
            }
            if (!Array.isArray(tree) || tree.length !== 3) throw new Error('Invalid node');
            const [tag, attrs, children] = tree;
            if (
              !Object.hasOwn(attributes, tag) ||
              !attrs ||
              typeof attrs !== 'object' ||
              Array.isArray(attrs) ||
              !Array.isArray(children)
            )
              throw new Error('Invalid element');
            const node = ['svg', 'path', 'circle'].includes(tag)
              ? document.createElementNS('http://www.w3.org/2000/svg', tag)
              : document.createElement(tag);
            if (tag === 'img') node.loading = 'lazy';
            for (const [name, value] of Object.entries(attrs)) {
              if (
                typeof value !== 'string' ||
                value.length > 8000 ||
                (name !== 'class' && !attributes[tag].includes(name))
              )
                throw new Error('Invalid attribute');
              if (
                name === 'class' &&
                !/^clean-product-card(?:__[a-z-]+)?(?:\s+clean-product-card(?:__[a-z-]+)?)*$/.test(value)
              )
                throw new Error('Invalid class');
              if (name === 'href' && value !== entry.url) throw new Error('Invalid link');
              if (name === 'src' && !safeImage(value)) throw new Error('Invalid image');
              if (
                name === 'srcset' &&
                !value.split(',').every((candidate) => {
                  const parts = candidate.trim().split(/\s+/);
                  return (
                    parts.length === 2 &&
                    /^\d+w$/.test(parts[1]) &&
                    parseInt(parts[1], 10) <= 520 &&
                    safeImage(parts[0])
                  );
                })
              )
                throw new Error('Invalid image candidates');
              if (['width', 'height', 'data-clean-money-minor'].includes(name) && !/^\d{1,12}$/.test(value))
                throw new Error('Invalid number');
              if (name === 'data-clean-money-currency' && !/^[A-Z]{3}$/.test(value))
                throw new Error('Invalid currency');
              if (['fill', 'stroke'].includes(name) && !/^(none|currentColor|#[a-fA-F0-9]{3,8})$/.test(value))
                throw new Error('Invalid paint');
              if (name === 'd' && !/^[MmZzLlHhVvCcSsQqTtAaEe0-9.,\s+-]+$/.test(value)) throw new Error('Invalid path');
              if (tag === 'img' && ['loading', 'fetchpriority', 'sizes'].includes(name)) continue;
              node.setAttribute(name === 'viewbox' ? 'viewBox' : name, value);
            }
            if (tag === 'button') {
              node.type = 'button';
              node.dataset.cleanProductWishlistHandle = entry.handle;
            }
            if (tag === 'img') {
              node.loading = 'lazy';
              node.setAttribute('fetchpriority', 'low');
              node.setAttribute('sizes', root.dataset.cleanCardSizes);
              if (!node.hasAttribute('width') || !node.hasAttribute('height')) throw new Error('Missing dimensions');
            }
            children.forEach((child) => node.append(build(child, depth + 1)));
            return node;
          };
          const card = build(entry.card);
          if (
            !card.matches?.('article.clean-product-card') ||
            card.querySelectorAll('a').length !== 1 ||
            card.querySelector('a')?.getAttribute('href') !== entry.url ||
            !card.querySelector('.clean-product-card__title') ||
            !card.querySelector('[data-clean-money]')
          )
            throw new Error('Incomplete card');
          return card;
        };
        let recentInitialized = false;
        const synchronizeRecent = () => {
          if (!root.isConnected) return;
          recentInitialized = true;
          recent.hidden = true;
          const previous = root.querySelector('[data-clean-recent-items]');
          const list = previous.cloneNode(false);
          previous.replaceWith(list);
          try {
            if (!window.Shopify?.customerPrivacy?.preferencesProcessingAllowed()) {
              sessionStorage.removeItem(recentKey);
              return;
            }
            const raw = sessionStorage.getItem(recentKey);
            let stored;
            try {
              stored = raw && raw.length <= 170000 ? JSON.parse(raw) : null;
            } catch {
              /* Reset malformed or old records below. */
            }
            const entries =
              stored?.version === 2 &&
              stored.context === root.dataset.cleanRecentContext &&
              Array.isArray(stored.entries)
                ? stored.entries.slice(0, 5)
                : [];
            const seen = new Set([root.dataset.cleanProductHandle]);
            const retained = [],
              cards = [];
            for (const entry of entries) {
              if (!entry || seen.has(entry.handle) || cards.length === 4) continue;
              try {
                const card = decodeCard(entry);
                seen.add(entry.handle);
                cards.push(card);
                retained.push({ handle: entry.handle, url: entry.url, card: encodeCard(card) });
              } catch {
                /* Discard invalid snapshots without parsing stored HTML. */
              }
            }
            const current = {
              handle: root.dataset.cleanProductHandle,
              url: root.dataset.cleanProductUrl,
              card: encodeCard(root.querySelector('[data-clean-recent-card]').content.firstElementChild),
            };
            decodeCard(current);
            sessionStorage.setItem(
              recentKey,
              JSON.stringify({ version: 2, context: root.dataset.cleanRecentContext, entries: [current, ...retained] }),
            );
            // Populate while detached so the canonical group's connected callback sees its cards.
            const populated = list.cloneNode(false);
            populated.append(...cards);
            list.replaceWith(populated);
            recent.hidden = cards.length === 0;
            if (cards.length) window.CleanDisplayCurrency?.refresh?.(recent);
          } catch {
            /* Storage unavailable: the entire section stays hidden. */
          }
        };
        document.addEventListener('visitorConsentCollected', synchronizeRecent);
        const initializeRecent = () => {
          if (recentInitialized) return;
          if (window.Shopify?.customerPrivacy) synchronizeRecent();
          else
            window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
              if (!error && !recentInitialized) synchronizeRecent();
            });
        };
        const scheduleRecent = () => {
          if ('requestIdleCallback' in window) requestIdleCallback(initializeRecent, { timeout: 8000 });
          else setTimeout(initializeRecent, 4000);
        };
        if (document.readyState === 'complete') scheduleRecent();
        else window.addEventListener('load', scheduleRecent, { once: true });
        const host = root.querySelector('[data-clean-recommendations]');
        if (!host || !('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver(
          async (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            try {
              const response = await fetch(host.dataset.cleanUrl);
              if (!response.ok) return;
              const document = new DOMParser().parseFromString(await response.text(), 'text/html');
              const items = document.querySelector('[data-clean-recommendation-items]');
              if (items) host.querySelector('[data-clean-recommendation-items]').replaceWith(items);
              window.CleanDisplayCurrency?.refresh?.(host);
            } catch {
              /* Leave the recommendation region empty when the request fails. */
            }
          },
          { rootMargin: '0px' },
        );
        observer.observe(host);
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hadiyah-delivery-localization"]) return;
  try {
    
  (() => {
    if (window.hadiyahDeliveryLocationReady) return;

    const modal = document.querySelector('[data-hadiyah-delivery-modal]');
    if (!modal) return;

    window.hadiyahDeliveryLocationReady = true;

    const storageKey = 'hadiyah:pdp-pincode';
    const cleanPincodeStorageKey = 'clean:delivery-pincode:v1';
    const cityStorageKey = 'hadiyah:pdp-pincode-city';
    const deliveryCountryCodeKey = 'hadiyah:delivery-country-code';
    const deliveryCountryNameKey = 'hadiyah:delivery-country-name';
    const deliveryCountrySourceKey = 'hadiyah:delivery-country-source';
    const cleanDeliveryCountryKey = 'clean:delivery-country-manual:v1';
    const getLocalizationState = () => window.HadiyahLocalization;
    const defaultTitle = 'Where should we deliver?';
    const gateTitle = 'Set delivery location';
    const form = modal.querySelector('#hadiyah-delivery-localization-form');
    const input = modal.querySelector('[data-hadiyah-pincode-input]');
    const status = modal.querySelector('[data-hadiyah-delivery-status]');
    const applyButton = modal.querySelector('[data-hadiyah-delivery-apply]');
    const clearButton = modal.querySelector('[data-hadiyah-pincode-clear]');
    const removeButton = modal.querySelector('[data-hadiyah-pincode-remove]');
    const titleElement = modal.querySelector('[data-hadiyah-delivery-title]');
    const countryCodeInput = modal.querySelector('[data-hadiyah-country-code-input]');
    const countryToggle = modal.querySelector('[data-hadiyah-country-toggle]');
    const countryPicker = modal.querySelector('[data-hadiyah-country-picker]');
    const countrySearch = modal.querySelector('[data-hadiyah-country-search]');
    const countryOptions = [...modal.querySelectorAll('[data-hadiyah-country-option]')];
    const countryGroupLabels = [...modal.querySelectorAll('[data-hadiyah-country-group-label]')];
    const countryEmpty = modal.querySelector('[data-hadiyah-country-empty]');
    const locationField = modal.querySelector('[data-hadiyah-location]');
    const orSection = modal.querySelector('[data-hadiyah-delivery-or]');
    const pincodeHelpButton = modal.querySelector('[data-hadiyah-pincode-help]');
    const selectedCountryCodeElement = modal.querySelector('[data-hadiyah-selected-country-code]');
    const selectedCountryNameElement = modal.querySelector('[data-hadiyah-selected-country-name]');
    const summaryCountryElement = modal.querySelector('[data-hadiyah-summary-country]');
    const summaryFlagElement = modal.querySelector('[data-hadiyah-summary-flag]');
    const summaryChangeButton = modal.querySelector('[data-hadiyah-summary-change]');
    const countryBackButton = modal.querySelector('[data-hadiyah-country-back]');
    const returnToInput = form.elements.namedItem('return_to');
    const defaultApplyLabel = applyButton.textContent.trim() || 'Apply';
    const currentCountryCode = modal.dataset.hadiyahCurrentCountryCode || 'IN';
    const currentCountryName = String(modal.dataset.hadiyahCurrentCountryName || 'India')
      .replace(/&amp;/gi, '&')
      .trim() || 'India';
    let selectedCountryCode = currentCountryCode;
    let selectedCountryName = currentCountryName;
    let bitset = '';
    let indexRequest;
    let opener;
    let busy = false;
    let modalOpenedThisPage = false;
    let closeTimer;
    let gateReopenTimer;
    let gateDismissedThisPage = false;
    let lockedScrollY = 0;
    let bridgeStorageTimer;
    let bridgePincodeChanged = false;

    const syncIndiaOnlyFields = () => {
      const isIndia = selectedCountryCode === 'IN';
      modal.classList.toggle('hadiyah-delivery-modal--international', !isIndia);

      if (orSection) {
        orSection.hidden = !isIndia;
        orSection.setAttribute('aria-hidden', String(!isIndia));
      }

      if (locationField) {
        locationField.hidden = !isIndia;
        locationField.dataset.international = String(!isIndia);
      }

      if (pincodeHelpButton && !isIndia) {
        pincodeHelpButton.hidden = true;
      }

      if (!isIndia) {
        input.value = '';
        clearButton.hidden = true;
      }
    };

    const lockPageScroll = () => {
      if (document.body.classList.contains('hadiyah-delivery-modal-open')) return;

      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('hadiyah-delivery-modal-open');
      document.body.classList.add('hadiyah-delivery-modal-open');
      document.body.style.top = `-${lockedScrollY}px`;
    };

    const unlockPageScroll = () => {
      if (!document.body.classList.contains('hadiyah-delivery-modal-open')) return;

      document.documentElement.classList.remove('hadiyah-delivery-modal-open');
      document.body.classList.remove('hadiyah-delivery-modal-open');
      document.body.style.removeProperty('top');
      window.scrollTo(0, lockedScrollY);
    };

    const setTriggerExpanded = (expanded) => {
      document.querySelectorAll('[data-hadiyah-location-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    };

    const openDeliveryDialog = (forceModal = false) => {
      if (typeof modal.showModal !== 'function') {
        modal.setAttribute('open', '');
        modal.setAttribute('aria-modal', forceModal ? 'true' : 'false');
        return;
      }

      const wantsModal = forceModal;
      const isModalOpen = modal.open && modal.matches(':modal');

      if (modal.open && isModalOpen !== wantsModal) {
        modal.close();
      }

      if (!modal.open) {
        if (wantsModal) {
          modal.showModal();
        } else {
          modal.show();
        }
      }

      modal.setAttribute('aria-modal', wantsModal ? 'true' : 'false');
    };

    const normalizePincode = (value) =>
      String(value || '')
        .replace(/\D/g, '')
        .slice(0, 6);

    const isCompletePincode = (value) => /^\d{6}$/.test(value);

    const normalizeCountryName = (value, fallback = '') =>
      String(value || fallback)
        .replace(/&amp;/gi, '&')
        .trim() || String(fallback || '').trim();

    const countryDisplayCodes = {
      IN: 'IND',
      US: 'USA',
      AE: 'UAE',
      GB: 'GBR',
      CA: 'CAN',
      AU: 'AUS',
      SA: 'SAU',
    };

    const getCountryDisplayCode = (countryCode) => {
      const normalizedCode = String(countryCode || '').toUpperCase();
      return countryDisplayCodes[normalizedCode] || normalizedCode;
    };

    const countryFlagUrl = (countryCode) => {
      const normalizedCode = String(countryCode || '').toUpperCase();
      const template = modal.dataset.hadiyahCountryFlagUrlTemplate || '';
      if (!/^[A-Z]{2}$/.test(normalizedCode) || !template) return '';

      return template.replace('__country_code__', normalizedCode.toLowerCase());
    };

    const renderCountryFlag = (flag, countryCode) => {
      if (!flag) return;

      const normalizedCode = String(countryCode || '').toUpperCase();
      const source = countryFlagUrl(normalizedCode);
      flag.dataset.countryCode = normalizedCode;

      if (!source) {
        flag.textContent = normalizedCode;
        return;
      }

      const image = flag.querySelector('img') || document.createElement('img');
      image.alt = '';
      image.width = 30;
      image.height = 22;
      image.decoding = 'async';
      if (flag.matches('.hadiyah-delivery-modal__country-option-flag')) image.loading = 'lazy';
      image.addEventListener(
        'error',
        () => {
          if (image.parentElement === flag) flag.textContent = normalizedCode;
        },
        { once: true },
      );
      if (image.getAttribute('src') !== source) image.src = source;
      if (image.parentElement !== flag || flag.childElementCount !== 1) flag.replaceChildren(image);
    };

    const syncCountryFlags = (root = document) => {
      root.querySelectorAll('[data-hadiyah-country-flag]').forEach((flag) => {
        renderCountryFlag(flag, flag.dataset.countryCode);
      });
    };

    const readSavedPincode = () => {
      try {
        const legacyPincode = normalizePincode(window.localStorage.getItem(storageKey));
        const cleanPincode = normalizePincode(window.localStorage.getItem(cleanPincodeStorageKey));
        const pincode = isCompletePincode(legacyPincode)
          ? legacyPincode
          : isCompletePincode(cleanPincode)
            ? cleanPincode
            : '';
        if (pincode && legacyPincode !== pincode) window.localStorage.setItem(storageKey, pincode);
        if (pincode && cleanPincode !== pincode) window.localStorage.setItem(cleanPincodeStorageKey, pincode);
        return isCompletePincode(pincode) ? pincode : '';
      } catch (error) {
        return '';
      }
    };

    const writeSavedPincode = (pincode) => {
      try {
        if (pincode) {
          const previousPincode = normalizePincode(window.localStorage.getItem(storageKey));
          window.localStorage.setItem(storageKey, pincode);
          window.localStorage.setItem(cleanPincodeStorageKey, pincode);
          if (previousPincode !== pincode) window.localStorage.removeItem(cityStorageKey);
        } else {
          window.localStorage.removeItem(storageKey);
          window.localStorage.removeItem(cleanPincodeStorageKey);
          window.localStorage.removeItem(cityStorageKey);
        }
      } catch (error) {}
    };

    const readSavedCity = () => {
      try {
        return String(window.localStorage.getItem(cityStorageKey) || '').trim();
      } catch (error) {
        return '';
      }
    };

    const writeSavedCity = (city) => {
      try {
        if (city) {
          window.localStorage.setItem(cityStorageKey, city);
        } else {
          window.localStorage.removeItem(cityStorageKey);
        }
      } catch (error) {}
    };

    const readSavedDeliveryCountry = () => {
      const sharedState = getLocalizationState()?.getState?.();
      if (sharedState?.deliveryCountry) {
        return {
          code: sharedState.deliveryCountry,
          name: sharedState.deliveryCountryName || sharedState.deliveryCountry,
          source: sharedState.deliverySource || 'auto',
        };
      }

      try {
        const code = String(window.localStorage.getItem(deliveryCountryCodeKey) || '')
          .trim()
          .toUpperCase();
        if (!/^[A-Z]{2}$/.test(code)) {
          return { code: '', name: '', source: '' };
        }
        const name = normalizeCountryName(window.localStorage.getItem(deliveryCountryNameKey), code);
        return { code, name, source: 'manual' };
      } catch (error) {
        return { code: '', name: '', source: '' };
      }
    };

    const writeSavedDeliveryCountry = (countryCode, countryName, { source = 'manual' } = {}) => {
      const localizationState = getLocalizationState();
      if (typeof localizationState?.setDeliveryCountry === 'function') {
        const nextState = localizationState.setDeliveryCountry(countryCode, countryName, { source });
        if (nextState?.deliveryCountry) {
          document.dispatchEvent(
            new CustomEvent('hadiyah:delivery-country:saved', {
              detail: {
                code: nextState.deliveryCountry,
                name: nextState.deliveryCountryName || nextState.deliveryCountry,
              },
            }),
          );
        }
        return;
      }

      try {
        const code = String(countryCode || '')
          .trim()
          .toUpperCase();
        if (!/^[A-Z]{2}$/.test(code)) {
          window.localStorage.removeItem(deliveryCountryCodeKey);
          window.localStorage.removeItem(deliveryCountryNameKey);
          window.localStorage.removeItem(deliveryCountrySourceKey);
          window.localStorage.removeItem(cleanDeliveryCountryKey);
          return;
        }
        window.localStorage.setItem(deliveryCountryCodeKey, code);
        window.localStorage.setItem(
          deliveryCountryNameKey,
          normalizeCountryName(countryName, code),
        );
        window.localStorage.setItem(deliveryCountrySourceKey, source === 'auto' ? 'auto' : 'manual');
        if (source === 'auto') window.localStorage.removeItem(cleanDeliveryCountryKey);
        else window.localStorage.setItem(cleanDeliveryCountryKey, code);
        document.dispatchEvent(
          new CustomEvent('hadiyah:delivery-country:saved', {
            detail: { code, name: normalizeCountryName(countryName, code) },
          }),
        );
      } catch (error) {}
    };

    const hasDeliveryLocationSet = () => {
      const destination = readSavedDeliveryCountry();
      if (destination.source === 'auto') return false;
      if (destination.code && destination.code !== 'IN') return true;
      return Boolean(readSavedPincode());
    };

    const titleCaseCity = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .replace(/\bSuburban\b/gi, '')
        .replace(/\s+/g, ' ')
        .trim();

    const resolveCityForPincode = async (pincode) => {
      if (!isCompletePincode(pincode)) return '';

      try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
        if (!response.ok) return '';

        const payload = await response.json();
        const entry = Array.isArray(payload) ? payload[0] : payload;
        if (!entry || entry.Status !== 'Success' || !Array.isArray(entry.PostOffice) || !entry.PostOffice.length) {
          return '';
        }

        const office =
          entry.PostOffice.find((item) => String(item.DeliveryStatus || '').toLowerCase() === 'delivery') ||
          entry.PostOffice[0];

        return titleCaseCity(office.District || office.Block || office.Division || office.Name || '');
      } catch (error) {
        return '';
      }
    };

    const ensureCityForPincode = async (pincode) => {
      if (!isCompletePincode(pincode)) {
        writeSavedCity('');
        return '';
      }

      const cachedCity = readSavedCity();
      if (cachedCity) return cachedCity;

      const city = await resolveCityForPincode(pincode);
      if (city) writeSavedCity(city);
      return city;
    };

    const enrichSavedCity = (pincode) => {
      ensureCityForPincode(pincode)
        .then((city) => {
          // The postal API is optional enrichment. Do not overwrite the UI if the
          // customer changed their delivery location while the request was running.
          if (!city || readSavedPincode() !== pincode) return;
          syncTriggers(pincode);
        })
        .catch(() => {});
    };

    const homeGateEnabled =
      modal.dataset.hadiyahHomeGate === 'true' ||
      document.body.classList.contains('template-index') ||
      window.location.pathname === '/' ||
      window.location.pathname === '';

    // Homepage gate is about delivery destination, not currency.
    // India needs a pincode; other destinations unlock browsing without switching ₹.
    const isGateLocked = () => homeGateEnabled && !hasDeliveryLocationSet();

    const isVisibleGateAnchor = (candidate) => {
      if (!(candidate instanceof HTMLElement) || !candidate.isConnected) return false;
      if (candidate.hidden || candidate.closest('[hidden], [inert]')) return false;

      const rect = candidate.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && candidate.getClientRects().length > 0;
    };

    const getGateAnchor = (preferred) => {
      if (isVisibleGateAnchor(preferred)) return preferred;

      const triggerSelectors = [
        '.hadiyah-delivery-header-slot [data-hadiyah-location-trigger]',
        '.mobile-delivery-row [data-hadiyah-location-trigger]',
        '[data-hadiyah-location-trigger]',
      ];

      for (const selector of triggerSelectors) {
        const trigger = [...document.querySelectorAll(selector)].find(isVisibleGateAnchor);
        if (trigger) return trigger;
      }

      return null;
    };

    const isMobileSheet = () => window.matchMedia('(max-width: 768px)').matches;

    const clearPopoverPosition = () => {
      modal.classList.remove('hadiyah-delivery-modal--popover');
      modal.classList.remove('hadiyah-delivery-modal--sheet');
      [
        'position',
        'inset',
        'top',
        'left',
        'right',
        'bottom',
        'margin',
        'transform',
        'width',
        'maxWidth',
        'maxHeight',
        'borderRadius',
      ].forEach((prop) => {
        modal.style.removeProperty(prop);
      });
      modal.style.removeProperty('--hadiyah-gate-top');
      modal.style.removeProperty('--hadiyah-gate-left');
      modal.style.removeProperty('--hadiyah-gate-caret');
    };

    const positionMobileSheet = () => {
      modal.classList.add('hadiyah-delivery-modal--popover');
      modal.classList.add('hadiyah-delivery-modal--sheet');
      modal.style.setProperty('position', 'fixed', 'important');
      modal.style.setProperty('inset', 'auto 0 0 0', 'important');
      modal.style.setProperty('top', 'auto', 'important');
      modal.style.setProperty('left', '0', 'important');
      modal.style.setProperty('right', '0', 'important');
      modal.style.setProperty('bottom', '0', 'important');
      modal.style.setProperty('margin', '0', 'important');
      modal.style.setProperty('transform', 'none', 'important');
      modal.style.setProperty('width', '100%', 'important');
      modal.style.setProperty('max-width', '100%', 'important');
      modal.style.setProperty('max-height', 'min(85dvh, 560px)', 'important');
      modal.style.setProperty('border-radius', '16px 16px 0 0', 'important');
      modal.style.removeProperty('--hadiyah-gate-top');
      modal.style.removeProperty('--hadiyah-gate-left');
      modal.style.removeProperty('--hadiyah-gate-caret');
      return true;
    };

    const positionGatePopover = (preferredAnchor) => {
      if (isMobileSheet()) {
        return positionMobileSheet();
      }

      modal.classList.remove('hadiyah-delivery-modal--sheet');

      const anchor = getGateAnchor(preferredAnchor);
      if (!anchor) {
        clearPopoverPosition();
        return false;
      }

      const panelWidth = Math.min(420, window.innerWidth - 24);
      const rect = anchor.getBoundingClientRect();
      let top = Math.round(rect.bottom + 12);
      let left = Math.round(rect.left);

      if (left + panelWidth > window.innerWidth - 12) {
        left = Math.max(12, Math.round(window.innerWidth - panelWidth - 12));
      }
      if (left < 12) left = 12;

      let caret = Math.round(rect.left + rect.width / 2 - left);
      caret = Math.max(18, Math.min(panelWidth - 18, caret));

      modal.classList.add('hadiyah-delivery-modal--popover');
      modal.style.setProperty('position', 'fixed', 'important');
      modal.style.setProperty('inset', 'unset', 'important');
      modal.style.setProperty('top', `${top}px`, 'important');
      modal.style.setProperty('left', `${left}px`, 'important');
      modal.style.setProperty('right', 'auto', 'important');
      modal.style.setProperty('bottom', 'auto', 'important');
      modal.style.setProperty('margin', '0', 'important');
      modal.style.setProperty('transform', 'none', 'important');
      modal.style.setProperty('width', `${panelWidth}px`, 'important');
      modal.style.setProperty('max-width', 'calc(100vw - 24px)', 'important');
      modal.style.removeProperty('border-radius');
      modal.style.setProperty('--hadiyah-gate-top', `${top}px`);
      modal.style.setProperty('--hadiyah-gate-left', `${left}px`);
      modal.style.setProperty('--hadiyah-gate-caret', `${caret}px`);
      return true;
    };

    const syncGateMode = (preferredAnchor) => {
      const locked = isGateLocked();
      modal.classList.toggle('hadiyah-delivery-modal--gate', locked);
      if (titleElement) {
        titleElement.textContent = locked || modal.classList.contains('hadiyah-delivery-modal--popover')
          ? gateTitle
          : defaultTitle;
      }
      positionGatePopover(preferredAnchor);
      if (titleElement && modal.classList.contains('hadiyah-delivery-modal--popover')) {
        titleElement.textContent = gateTitle;
      }
      return locked;
    };

    const resolveDeliveryDisplay = (pincode = readSavedPincode()) => {
      const savedDestination = readSavedDeliveryCountry();
      const code = savedDestination.code || currentCountryCode;
      const option = countryOptions.find((item) => item.dataset.countryCode === code);
      const name = savedDestination.name || option?.dataset.countryName || currentCountryName;
      return { code, name, pincode };
    };

    const submitLocalizationForm = () => {
      const isLocalPreview = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

      if (isLocalPreview) {
        const localizationUrl = new URL(modal.dataset.hadiyahLocalizationUrl);
        const returnToUrl = new URL(window.location.href);
        const previewThemeId = String(window.Shopify?.theme?.id || '');

        if (localizationUrl.protocol === 'https:') form.action = localizationUrl.href;

        if (returnToInput instanceof HTMLInputElement) {
          if (/^\d+$/.test(previewThemeId)) returnToUrl.searchParams.set('preview_theme_id', previewThemeId);
          returnToInput.value = `${returnToUrl.pathname}${returnToUrl.search}`;
        }
      }

      HTMLFormElement.prototype.submit.call(form);
    };

    const syncTriggers = (pincode = readSavedPincode()) => {
      const display = resolveDeliveryDisplay(pincode);
      const isIndia = display.code === 'IN';
      const savedCity = readSavedCity();

      document.querySelectorAll('[data-hadiyah-delivery-summary-country]').forEach((el) => {
        el.textContent = display.name;
      });

      document
        .querySelectorAll(
          '[data-hadiyah-delivery-summary] [data-hadiyah-country-flag], .hadiyah-delivery__summary-flag[data-hadiyah-country-flag]',
        )
        .forEach((flag) => {
          renderCountryFlag(flag, display.code);
        });

      // Also refresh any PDP picker summary UI that manages its own flag rendering.
      document.querySelectorAll('hadiyah-delivery-picker').forEach((picker) => {
        if (typeof picker.syncSummaryLocation === 'function') picker.syncSummaryLocation();
        else if (typeof picker.renderSummaryFlag === 'function') picker.renderSummaryFlag(display.code);
      });

      document.querySelectorAll('[data-hadiyah-location-trigger]').forEach((trigger) => {
        const hasLocation = true;
        const isMobileTrigger = trigger.dataset.hadiyahTriggerVariant === 'mobile';
        const isProductTrigger = trigger.dataset.hadiyahTriggerVariant === 'product';
        const isPickerCountryTrigger = trigger.dataset.hadiyahTriggerVariant === 'picker-country';
        const isPickerSummaryTrigger = trigger.dataset.hadiyahTriggerVariant === 'picker-summary';
        let deliveryValue = display.name;
        let productLabel = display.name;

        if (isIndia) {
          if (display.pincode) {
            productLabel = savedCity ? `${savedCity} ${display.pincode}` : display.pincode;
            // Header / mobile pill: "Delivering to 400008" (pincode only).
            deliveryValue = display.pincode;
          } else {
            productLabel = 'Add pincode';
          }
        }

        const flag = trigger.querySelector('[data-hadiyah-country-flag]');
        const prompt = trigger.querySelector('[data-hadiyah-delivery-prompt]');
        const saved = trigger.querySelector('[data-hadiyah-delivery-saved]');
        const value = trigger.querySelector('[data-hadiyah-delivery-value]');
        const code = trigger.querySelector('[data-hadiyah-delivery-code]');

        renderCountryFlag(flag, display.code);

        if (code) {
          if (isPickerCountryTrigger) {
            code.textContent = getCountryDisplayCode(display.code);
          } else {
            code.textContent = isProductTrigger ? productLabel : getCountryDisplayCode(display.code);
          }
          code.dataset.countryCode = display.code;
        }

        if (prompt) prompt.hidden = hasLocation;
        if (saved) saved.hidden = !hasLocation;
        if (value) value.textContent = isProductTrigger ? productLabel : deliveryValue;

        const ariaLabel = isPickerSummaryTrigger || isPickerCountryTrigger
          ? display.name
          : isProductTrigger
            ? productLabel
            : deliveryValue;
        trigger.dataset.hasLocation = String(hasLocation);
        trigger.setAttribute(
          'aria-label',
          hasLocation ? `Delivery location ${ariaLabel}. Change delivery location.` : 'Choose delivery location',
        );

        if (isIndia && trigger.dataset.hadiyahIndexPrefetchReady !== 'true') {
          trigger.dataset.hadiyahIndexPrefetchReady = 'true';
          trigger.addEventListener('pointerenter', () => loadIndex().catch(() => {}), {
            once: true,
            passive: true,
          });
          trigger.addEventListener('focus', () => loadIndex().catch(() => {}), { once: true });
        }
      });
    };

    const setStatus = (message = '', type = '') => {
      status.textContent = message;
      status.classList.toggle('hadiyah-delivery-modal__status--error', type === 'error');
      status.classList.toggle('hadiyah-delivery-modal__status--success', type === 'success');
    };

    const closeCountryPicker = ({ restoreFocus = false } = {}) => {
      countryPicker.hidden = true;
      modal.classList.remove('hadiyah-delivery-modal--picking-country');
      countryToggle.setAttribute('aria-expanded', 'false');
      countrySearch.value = '';
      countryOptions.forEach((option) => {
        option.hidden = false;
      });
      countryGroupLabels.forEach((label) => {
        label.hidden = false;
      });
      countryEmpty.hidden = true;
      if (restoreFocus) {
        if (summaryChangeButton) summaryChangeButton.focus();
        else countryToggle.focus();
      }
    };

    const setCountryPickerOpen = (open) => {
      if (!open) {
        closeCountryPicker();
        return;
      }

      countryPicker.hidden = false;
      modal.classList.add('hadiyah-delivery-modal--picking-country');
      countryToggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => countrySearch.focus());
    };

    const updateControls = () => {
      const pincode = normalizePincode(input.value);
      if (input.value !== pincode) input.value = pincode;

      const isIndia = selectedCountryCode === 'IN';
      const revealApplyOnValid =
        modal.classList.contains('hadiyah-delivery-modal--popover') ||
        modal.classList.contains('hadiyah-delivery-modal--gate');

      input.disabled = busy || !isIndia;
      clearButton.hidden = !isIndia || !pincode;
      removeButton.hidden = !isIndia || !readSavedPincode();
      applyButton.hidden = false;

      if (!revealApplyOnValid) {
        applyButton.disabled = busy || (isIndia && Boolean(pincode) && !isCompletePincode(pincode));
        return;
      }

      if (!isIndia) {
        // International: Apply is always available (no Indian pincode required).
        applyButton.disabled = busy;
        return;
      }

      if (!isCompletePincode(pincode) || busy) {
        applyButton.disabled = true;
        return;
      }

      applyButton.disabled = true;

      loadIndex()
        .then(() => {
          if (normalizePincode(input.value) !== pincode) return;

          const valid = isKnownPincode(pincode);
          applyButton.disabled = busy || !valid;

          if (!valid) {
            setStatus('Enter a valid Indian pincode.', 'error');
          } else if (status.classList.contains('hadiyah-delivery-modal__status--error')) {
            setStatus();
          }
        })
        .catch(() => {
          if (normalizePincode(input.value) !== pincode) return;
          applyButton.disabled = true;
          setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
        });
    };

    const selectCountry = (countryCode, countryName, { closePicker = true, prefetchIndex = true } = {}) => {
      countryName = normalizeCountryName(countryName, countryCode);
      selectedCountryCode = countryCode;
      selectedCountryName = countryName;
      countryCodeInput.value = countryCode;
      selectedCountryCodeElement.textContent = countryCode;
      selectedCountryNameElement.textContent = countryName;
      if (summaryCountryElement) summaryCountryElement.textContent = countryName;

      const selectedFlag = countryToggle.querySelector('[data-hadiyah-country-flag]');
      renderCountryFlag(selectedFlag, countryCode);
      renderCountryFlag(summaryFlagElement, countryCode);

      countryOptions.forEach((option) => {
        option.setAttribute('aria-selected', String(option.dataset.countryCode === countryCode));
      });

      syncIndiaOnlyFields();

      if (countryCode === 'IN') {
        input.value = readSavedPincode();
        if (prefetchIndex) {
          loadIndex().catch(() => {
            setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
          });
        }
      } else {
        setStatus();
      }

      if (closePicker) closeCountryPicker();
      updateControls();
    };

    const setBusy = (nextBusy) => {
      busy = nextBusy;
      clearButton.disabled = busy;
      removeButton.disabled = busy;
      countryToggle.disabled = busy;
      countrySearch.disabled = busy;
      countryOptions.forEach((option) => {
        option.disabled = busy;
      });
      applyButton.textContent = busy ? 'Applying...' : defaultApplyLabel;
      updateControls();
    };

    const consumeIndex = () => {
      const payload = window.HadiyahPincodeIndex;

      if (!payload || payload.version !== 1 || payload.bitCount !== 1_000_000 || typeof payload.data !== 'string') {
        throw new Error('The pincode index payload is invalid.');
      }

      bitset = window.atob(payload.data);
      if (bitset.length * 8 !== payload.bitCount) {
        bitset = '';
        throw new Error('The pincode index size is invalid.');
      }

      return bitset;
    };

    const loadIndex = () => {
      if (bitset) return Promise.resolve(bitset);
      if (indexRequest) return indexRequest;

      if (window.HadiyahPincodeIndex) {
        try {
          return Promise.resolve(consumeIndex());
        } catch (error) {
          window.HadiyahPincodeIndex = undefined;
        }
      }

      indexRequest = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = modal.dataset.hadiyahPincodeIndexUrl;
        script.async = true;
        script.dataset.hadiyahPincodeIndexLoader = 'true';
        script.addEventListener(
          'load',
          () => {
            try {
              resolve(consumeIndex());
            } catch (error) {
              reject(error);
            }
          },
          { once: true },
        );
        script.addEventListener('error', () => reject(new Error('The pincode index could not be loaded.')), {
          once: true,
        });
        document.head.append(script);
      }).catch((error) => {
        indexRequest = undefined;
        document.querySelector('[data-hadiyah-pincode-index-loader]')?.remove();
        throw error;
      });

      return indexRequest;
    };

    const isKnownPincode = (pincode) => {
      if (!bitset || !isCompletePincode(pincode)) return false;

      const numericPincode = Number(pincode);
      const byte = bitset.charCodeAt(numericPincode >> 3);
      return Boolean(byte & (1 << (numericPincode & 7)));
    };

    const dispatchSavedPincode = (pincode) => {
      document.dispatchEvent(
        new CustomEvent('hadiyah:pincode:saved', {
          detail: { pincode, source: 'delivery-location' },
        }),
      );

      document.querySelectorAll('[data-hadiyah-delivery-postcode-input]').forEach((pickerInput) => {
        pickerInput.value = pincode;
        pickerInput.dispatchEvent(new Event('input', { bubbles: true }));

        if (pincode) {
          pickerInput
            .closest('hadiyah-delivery-picker')
            ?.querySelector('[data-hadiyah-delivery-postcode-check]')
            ?.click();
        }
      });
    };

    const closeModal = ({ force = false } = {}) => {
      window.clearTimeout(closeTimer);
      window.clearTimeout(gateReopenTimer);
      closeCountryPicker();

      // Homepage gate can be dismissed; users can reopen from the header trigger anytime.
      if (isGateLocked()) {
        gateDismissedThisPage = true;
      }

      syncGateMode();
      setTriggerExpanded(false);
      unlockPageScroll();

      if (typeof modal.close === 'function') {
        if (modal.open) modal.close();
      } else {
        modal.removeAttribute('open');
        opener?.focus();
      }
    };

    const openModal = (trigger, { prefetchIndex = true, focusInput = true } = {}) => {
      window.clearTimeout(closeTimer);
      window.clearTimeout(gateReopenTimer);
      modalOpenedThisPage = true;
      gateDismissedThisPage = false;
      opener = trigger;
      input.value = readSavedPincode();
      setStatus();
      const locked = syncGateMode(trigger);
      const savedDestination = readSavedDeliveryCountry();
      const openCountryCode = savedDestination.code || currentCountryCode;
      const openCountryOption = countryOptions.find((option) => option.dataset.countryCode === openCountryCode);
      const openCountryName =
        savedDestination.name ||
        openCountryOption?.dataset.countryName ||
        (openCountryCode === 'IN' ? 'India' : currentCountryName);
      selectCountry(openCountryCode, openCountryName, {
        prefetchIndex: openCountryCode === 'IN' && (locked || prefetchIndex),
      });
      setBusy(false);

      openDeliveryDialog(locked);
      setTriggerExpanded(true);

      if (locked) {
        lockPageScroll();
      } else {
        unlockPageScroll();
      }

      positionGatePopover(trigger);
      window.requestAnimationFrame(() => positionGatePopover(trigger));

      if (focusInput) {
        window.requestAnimationFrame(() => {
          if (selectedCountryCode === 'IN' || locked) {
            input.focus();
            input.select();
          } else {
            countryToggle.focus();
          }
        });
      }
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-hadiyah-location-trigger]');
      if (trigger) {
        if (modal.open && opener === trigger) {
          closeModal({ force: true });
          return;
        }
        openModal(trigger);
        return;
      }

      if (event.target.closest('[data-hadiyah-delivery-close]')) {
        closeModal({ force: true });
        return;
      }

      const countryOption = event.target.closest('[data-hadiyah-country-option]');
      if (countryOption) {
        selectCountry(countryOption.dataset.countryCode, countryOption.dataset.countryName);
        return;
      }

      if (event.target.closest('[data-hadiyah-delivery-postcode-check]')) {
        syncTriggers();
      }

      if (
        modal.open &&
        !modal.contains(event.target) &&
        !event.target.closest('[data-hadiyah-location-trigger]')
      ) {
        closeModal({ force: true });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('[data-hadiyah-delivery-postcode-input]')) {
        window.setTimeout(() => syncTriggers());
      }
    });

    countryToggle.addEventListener('click', (event) => {
      // Keep this click from the modal outside-click handler (below).
      event.stopPropagation();
      setCountryPickerOpen(countryPicker.hidden);
    });

    summaryChangeButton?.addEventListener('click', (event) => {
      // Change used to open the list then the same bubbled click closed it immediately.
      event.preventDefault();
      event.stopPropagation();
      setCountryPickerOpen(true);
      window.requestAnimationFrame(() => {
        countrySearch?.focus();
        countryPicker.scrollIntoView?.({ block: 'nearest', behavior: 'smooth' });
      });
    });

    countryBackButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeCountryPicker({ restoreFocus: true });
    });

    countrySearch.addEventListener('input', () => {
      const query = countrySearch.value.trim().toLocaleLowerCase();
      let visibleOptions = 0;

      countryOptions.forEach((option) => {
        const searchableValue =
          `${option.dataset.countryName} ${option.dataset.countryCode} ${option.dataset.currencyCode}`.toLocaleLowerCase();
        option.hidden = Boolean(query) && !searchableValue.includes(query);
        if (!option.hidden) visibleOptions += 1;
      });

      countryGroupLabels.forEach((label) => {
        label.hidden = Boolean(query);
      });
      countryEmpty.hidden = visibleOptions !== 0;
    });

    input.addEventListener('input', () => {
      input.value = normalizePincode(input.value);
      setStatus();
      updateControls();
    });

    clearButton.addEventListener('click', () => {
      input.value = '';
      setStatus();
      updateControls();
      input.focus();
    });

    removeButton.addEventListener('click', () => {
      writeSavedPincode('');
      input.value = '';
      syncTriggers('');
      dispatchSavedPincode('');
      syncGateMode();
      setStatus('Saved pincode removed.', 'success');
      updateControls();
      input.focus();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const gateLocked = isGateLocked();

      countryCodeInput.value = selectedCountryCode;
      writeSavedDeliveryCountry(selectedCountryCode, selectedCountryName);

      if (selectedCountryCode !== 'IN') {
        writeSavedPincode('');
        writeSavedCity('');
        dispatchSavedPincode('');
        syncGateMode();

        if (selectedCountryCode !== currentCountryCode) {
          setBusy(true);
          setStatus(`Updating prices for delivery to ${selectedCountryName}...`);
          submitLocalizationForm();
          return;
        }

        syncTriggers('');
        setStatus(`Delivery set to ${selectedCountryName}.`, 'success');
        closeTimer = window.setTimeout(() => closeModal({ force: true }), 350);
        return;
      }

      const pincode = normalizePincode(input.value);

      if (!pincode) {
        if (gateLocked) {
          setStatus('Enter a valid Indian pincode to continue.', 'error');
          input.focus();
          return;
        }

        writeSavedPincode('');
        writeSavedCity('');
        dispatchSavedPincode('');
        syncGateMode();

        if (selectedCountryCode !== currentCountryCode) {
          setBusy(true);
          setStatus('Updating prices for delivery within India...');
          submitLocalizationForm();
          return;
        }

        syncTriggers('');
        setStatus('Delivery country set to India.', 'success');
        closeTimer = window.setTimeout(() => closeModal({ force: true }), 350);
        return;
      }

      if (!isCompletePincode(pincode)) {
        setStatus('Enter a six-digit Indian pincode.', 'error');
        updateControls();
        input.focus();
        return;
      }

      setBusy(true);
      setStatus('Checking pincode...');

      try {
        await loadIndex();

        if (!isKnownPincode(pincode)) {
          setStatus('Enter a valid Indian pincode.', 'error');
          return;
        }

        writeSavedPincode(pincode);
        dispatchSavedPincode(pincode);
        const city = readSavedCity();
        writeSavedDeliveryCountry('IN', 'India');
        syncGateMode();

        if (selectedCountryCode !== currentCountryCode) {
          setStatus('Updating prices for delivery within India...');
          submitLocalizationForm();
          return;
        }

        syncTriggers(pincode);
        setStatus(
          city ? `Delivery location set to ${city} ${pincode}.` : `Delivery location set to ${pincode}.`,
          'success',
        );
        enrichSavedCity(pincode);
        closeTimer = window.setTimeout(() => closeModal({ force: true }), 450);
      } catch (error) {
        setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
      } finally {
        setBusy(false);
      }
    });

    modal.addEventListener('click', (event) => {
      const clickedChange = event.target.closest?.('[data-hadiyah-summary-change]');
      if (
        !countryPicker.hidden &&
        !countryPicker.contains(event.target) &&
        !countryToggle.contains(event.target) &&
        !clickedChange
      ) {
        closeCountryPicker();
      }

      if (event.target === modal) closeModal();
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !countryPicker.hidden) {
        event.preventDefault();
        event.stopPropagation();
        closeCountryPicker({ restoreFocus: true });
      }
    });

    modal.addEventListener('cancel', (event) => {
      if (!countryPicker.hidden) {
        event.preventDefault();
        closeCountryPicker({ restoreFocus: true });
        return;
      }

      // Allow Escape to dismiss the homepage gate.
      gateDismissedThisPage = true;
      unlockPageScroll();
    });

    modal.addEventListener('close', () => {
      setTriggerExpanded(false);
      window.clearTimeout(gateReopenTimer);
      unlockPageScroll();
      setStatus();
      opener?.focus();
      clearPopoverPosition();
      syncGateMode();
    });

    window.addEventListener('pageshow', () => {
      syncTriggers();
      syncGateMode();
    });
    window.addEventListener('resize', () => {
      if (modal.open) positionGatePopover(opener);
    });
    window.addEventListener(
      'scroll',
      () => {
        if (modal.open) positionGatePopover(opener);
      },
      true,
    );
    window.addEventListener('storage', (event) => {
      const pincodeChanged = event.key === storageKey || event.key === cleanPincodeStorageKey;
      const deliveryChanged =
        pincodeChanged ||
        event.key === deliveryCountryCodeKey ||
        event.key === deliveryCountryNameKey ||
        event.key === deliveryCountrySourceKey ||
        event.key === cleanDeliveryCountryKey ||
        event.key === cityStorageKey;
      if (deliveryChanged) {
        bridgePincodeChanged ||= pincodeChanged;
        window.clearTimeout(bridgeStorageTimer);
        bridgeStorageTimer = window.setTimeout(() => {
          const pincode = readSavedPincode();
          const shouldDispatchPincode = bridgePincodeChanged;
          bridgePincodeChanged = false;
          if (shouldDispatchPincode) dispatchSavedPincode(pincode);
          syncTriggers(pincode);
          syncGateMode();
        });
      }
    });

    document.addEventListener('hadiyah:localization:changed', (event) => {
      const nextState = event.detail?.state || getLocalizationState()?.getState?.();
      const nextCountryCode = String(nextState?.deliveryCountry || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(nextCountryCode)) return;

      const nextCountryName =
        String(nextState?.deliveryCountryName || '').trim() ||
        countryOptions.find((option) => option.dataset.countryCode === nextCountryCode)?.dataset.countryName ||
        nextCountryCode;

      if (selectedCountryCode !== nextCountryCode || selectedCountryName !== nextCountryName) {
        selectCountry(nextCountryCode, nextCountryName, {
          closePicker: !modal.open,
          prefetchIndex: nextCountryCode === 'IN' && modal.open,
        });
      }
      syncTriggers();
      syncGateMode(opener);
    });

    document.addEventListener('shopify:section:load', () => {
      syncTriggers();
      syncGateMode();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.requestAnimationFrame(() => syncTriggers());
      });
    }

    syncCountryFlags();
    syncTriggers();
    syncGateMode();

    const savedDestinationOnBoot = readSavedDeliveryCountry();
    if (savedDestinationOnBoot.code) {
      selectedCountryCode = savedDestinationOnBoot.code;
      selectedCountryName = savedDestinationOnBoot.name || savedDestinationOnBoot.code;
    }
    syncIndiaOnlyFields();

    const initialPincode = readSavedPincode();
    if (initialPincode && !readSavedCity()) {
      enrichSavedCity(initialPincode);
    }

    const openHomeGateWhenReady = () => {
      if (!isGateLocked() || gateDismissedThisPage) return;

      const revealGate = () => {
        if (!isGateLocked() || gateDismissedThisPage || document.hidden || modal.open || modalOpenedThisPage) {
          return;
        }
        openModal(getGateAnchor() || undefined, { prefetchIndex: true, focusInput: true });
      };

      const scheduleReveal = () => {
        window.setTimeout(() => {
          if ('requestAnimationFrame' in window) {
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(revealGate);
            });
          } else {
            revealGate();
          }
        }, 700);
      };

      if (document.readyState === 'complete') {
        scheduleReveal();
      } else {
        window.addEventListener('load', scheduleReveal, { once: true });
      }
    };

    const startHomeGateAfterLocalization = () => {
      const localizationState = getLocalizationState();
      if (!localizationState?.ready?.then) return false;
      localizationState.ready.then(openHomeGateWhenReady, openHomeGateWhenReady);
      return true;
    };

    if (!startHomeGateAfterLocalization()) {
      document.addEventListener(
        'hadiyah:localization:changed',
        () => {
          if (!startHomeGateAfterLocalization()) openHomeGateWhenReady();
        },
        { once: true },
      );
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
